/**
 * Swedish Translations
 * Svenska översättningar för DQFleet
 */

export const translationsSv: Record<string, any> = {
  reportGenerator: {
    title: 'Rapportgenerator',
    intro: 'Välj en datamodell som kunden har fått, kryssa i fält och spara en mall. Utskick är CSV.',
    organization: 'Organisation',
    templates: 'Mallar',
    noTemplates: 'Inga mallar för den här organisationen.',
    newTemplate: 'Ny mall',
    name: 'Namn',
    model: 'Datamodell',
    noModels: 'Kunden har inga datamodeller. Tilldela dem på organisationens toppnod.',
    fields: {
      title: 'Fält',
      registrationNumber: 'Regnr',
      brand: 'Märke',
      model: 'Modell',
      year: 'Årsmodell',
      color: 'Färg',
      systemStatus: 'Systemstatus',
      fuelType: 'Drivmedel',
      engine: 'Motor',
      transmission: 'Växellåda',
      horsepower: 'Effekt',
      vehicleType: 'Fordonstyp',
      category: 'Fordonskategori',
      usageStatus: 'Fordonsstatus',
      ownership: 'Ägandeform',
      vin: 'VIN',
      replacesVehicle: 'Ersätter fordon',
      flinkey: 'Flinkey',
      registeredDate: 'Registrerad',
      manufacturedDate: 'Tillverkad',
      stolen: 'Stulen',
      emergencyVehicle: 'Utryckningsfordon',
      drivingBan: 'Körförbud',
      parentGroup: 'Huvudgrupp',
      group: 'Grupp',
      referenceNumber: 'Referensnummer',
      costCenter: 'Kostnadsställe',
      businessResponsibility: 'Affärsansvar',
      assignedUser: 'Tilldelad förare',
      leasingCompany: 'Leasingbolag',
      rentStart: 'Avtalsstart',
      rentEnd: 'Avtalsslut',
      monthlyCost: 'Månadskostnad',
      kmCap: 'Km-tak',
      odometer: 'Nuvarande mätarställning',
      initialOdometer: 'Startmätarställning',
      drivenKm: 'Körd sträcka',
      nextInspection: 'Nästa besiktning',
      imei: 'IMEI',
      lastSeen: 'Senast ansluten',
      distanceKm: 'Körda km',
      tripCount: 'Antal resor',
    },
    groups: {
      vehicle: 'Fordon',
      organization: 'Organisation',
      contract: 'Avtal',
      current: 'Nuläge',
      period: 'Period',
    },
    activeOnly: 'Endast aktiva fordon',
    dataWindow: 'Dataperiod',
    snapshot: 'Nuläge',
    previousWeek: 'Föregående vecka',
    previousMonth: 'Föregående kalendermånad',
    previousQuarter: 'Föregående kvartal',
    previousTertial: 'Föregående tertial',
    previousYear: 'Föregående kalenderår',
    schedule: 'Schema',
    manual: 'Bara manuell körning',
    monthly: 'Varje månad',
    yearly: 'Varje år',
    day: 'Dag',
    month: 'Månad',
    scheduleHelp: 'Schemalagda rapporter skickas kl 06:15. Dag 1–28.',
    recipients: 'Mottagare',
    noRecipients: 'Inga användare med e-post i organisationen.',
    save: 'Spara mall',
    saved: 'Mallen är sparad',
    deleted: 'Mallen är borttagen',
    run: 'Ladda ner CSV',
    preview: 'Förhandsvisa',
    previewCount: 'Visar de första raderna av',
    cancel: 'Avbryt',
    edit: 'Ändra',
    delete: 'Ta bort',
    lockedField: 'Alltid med',
    models: { vehicleFleet: 'Fordonsrapport' },
  },
  // Common
  common: {
    save: 'Spara',
    selectTime: 'Välj tid',
    cancel: 'Avbryt',
    delete: 'Ta bort',
    edit: 'Redigera',
    create: 'Skapa',
    add: 'Lägg till',
    remove: 'Ta bort',
    module: 'Modul',
    type: 'Typ',
    description: 'Beskrivning',
    saveChanges: 'Spara ändringar',
    saving: 'Sparar...',
    update: 'Uppdatera',
    search: 'Sök',
    clear: 'Rensa',
    filter: 'Filtrera',
    allOrganizations: 'Alla organisationer',
    allRoles: 'Alla roller',
    clearFilters: 'Rensa filter',
    refresh: 'Uppdatera',
    loading: 'Laddar...',
    error: 'Fel',
    tryAgain: 'Försök igen',
    success: 'Lyckades',
    confirm: 'Bekräfta',
    confirmDelete: 'Vill du verkligen ta bort detta?',
    yes: 'Ja',
    no: 'Nej',
    close: 'Stäng',
    back: 'Tillbaka',
    pageErrorTitle: 'Sidan kunde inte visas',
    pageErrorDescription: 'Ett oväntat fel uppstod. Gå tillbaka till föregående sida.',
    next: 'Nästa',
    previous: 'Föregående',
    actions: 'Åtgärder',
    status: 'Status',
    notes: 'Anteckningar',
    open: 'Öppna',
    view: 'Visa',
    hide: 'Dölj',
    notFound: 'Hittades inte',
    unknown: 'Okänd',
    comingSoon: 'Kommer snart',
    plannedFeatures: 'Planerade funktioner',
    underDevelopment: 'Denna funktion är under utveckling',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    activate: 'Aktivera',
    deactivate: 'Inaktivera',
    suspended: 'Suspenderad',
    overview: 'Översikt',
    organizations: 'Organisationer',
    vehicles: 'Fordon',
    vehicle: 'Fordon',
    trend: 'Trend',
    trips: 'Resor',
    distance: 'Distans',
    organization: 'Organisation',
    fromDate: 'Från datum',
    toDate: 'Till datum',
    from: 'Från',
    to: 'Till',
    startDate: 'Startdatum',
    endDate: 'Slutdatum',
    all: 'Alla',
    export: 'Exportera',
    exportCsv: 'Exportera CSV',
    saveError: 'Kunde inte spara',
    deleteError: 'Kunde inte radera',
    activateError: 'Kunde inte aktivera',
    loadDataError: 'Kunde inte ladda data',
    updateStatusError: 'Kunde inte uppdatera status',
    changeLanguageError: 'Kunde inte ändra språk',
    copiedToClipboard: 'Kopierat till urklipp',
    week: 'Vecka',
    month: 'Månad',
    day: 'Dag',
    quarter: 'Kvartal',
    selected: 'Vald',
    noResults: 'Inga resultat hittades',
    select: 'Välj...',
    selectOrganization: 'Välj organisation',
    selectLanguage: 'Välj språk',
    searchOrSelect: 'Sök eller välj',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    fleet: 'Fordonsflotta',
    liveTracking: 'Realtidskarta',
    reports: 'Rapporter',
    statistics: 'Statistik',
    vehicles: 'Fordon',
    profile: 'Profil',
    administration: 'Administration',
    sysAdmin: 'SysAdmin',
    crm: 'CRM',
    logout: 'Logga ut',
    organization: 'Organisation',
  },

  // Auth
  auth: {
    login: 'Logga in',
    signup: 'Registrera',
    email: 'E-post',
    password: 'Lösenord',
    forgotPassword: 'Glömt lösenord?',
    rememberMe: 'Kom ihåg mig',
    loginSuccess: 'Inloggning lyckades',
    loginError: 'Inloggning misslyckades',
    logout: 'Logga ut',
    otpTitle: 'Verifieringskod',
    otpDescription: 'Vi har skickat en verifieringskod till',
    otpSent: 'Verifieringskod skickad',
    otpVerified: 'Verifiering lyckades',
    otpResent: 'Ny verifieringskod skickad',
    invalidOtp: 'Ogiltig verifieringskod',
    resend: 'Skicka igen',
    samlRequired: 'SAML-autentisering krävs för denna organisation',
    authMethodChanged: 'Autentiseringsmetod har ändrats',
    ssoRedirect: 'Omdirigerar till inloggning med företagets identitet...',
    ssoCompleting: 'Loggar in...',
    ssoCompleteError: 'Inloggningen kunde inte slutföras. Försök igen.',
    checkingSso: 'Kontrollerar inloggningsmetod...',
    ssoContinue: 'Fortsätt till {org}',
    ssoDomainSignupBlocked: 'Din organisation använder inloggning via SSO. Skapa inte ett konto – logga in med din organisationsinloggning.',
    useSsoInstead: 'Logga in via SSO',
    // SSO
    ssoLogin: 'Single Sign-On',
    chooseLoginMethod: 'Välj inloggningsmetod',
    loginWith: 'Logga in med',
    loginWithSaml: 'Logga in med SAML',
    loginWithPassword: 'Logga in med lösenord',
    backToLogin: 'Tillbaka till inloggning',
    noOrganizationId: 'Ingen organisation angiven',
    samlError: 'SAML-autentisering misslyckades',
    samlErrorTitle: 'Inloggning misslyckades',
    retryLogin: 'Försök igen',
    backToLanding: 'Tillbaka till startsidan',
    goToLogin: 'Gå till inloggning',
    contactSupport: 'Om problemet kvarstår, kontakta support.',
  },

  // Reset Password
  resetPassword: {
    title: 'Återställ lösenord',
    description: 'Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.',
    emailSentTitle: 'E-post skickad',
    emailSentMessage: 'Om en användare med denna e-postadress finns kommer ett återställningsmail att skickas. Kontrollera din inkorg och följ instruktionerna för att återställa ditt lösenord.',
    newPasswordLabel: 'Nytt lösenord',
    newPasswordPlaceholder: 'Ange nytt lösenord',
    confirmPasswordLabel: 'Bekräfta lösenord',
    confirmPasswordPlaceholder: 'Bekräfta nytt lösenord',
    sendButton: 'Skicka återställningslänk',
    resetButton: 'Återställ lösenord',
    sending: 'Skickar...',
    resetting: 'Återställer...',
    backToLogin: 'Tillbaka till inloggning',
    rememberPassword: 'Kommer du ihåg ditt lösenord?',
  },

  // Admin
  admin: {
    title: 'Administration',
    roles: 'Rollhantering',
    organizations: 'Organisationshantering',
    users: 'Användarhantering',
    deleteUserConfirm: 'Är du säker på att du vill ta bort denna användare?',
    hardDeleteUserConfirm: 'Detta tar bort {{name}} ({{email}}) helt från systemet så att SSO kan skapa kontot på nytt. Kan inte ångras.',
    translations: 'Översättningar',
    imports: 'Import Generator',
    packages: 'Prispaket',
    sysAdmin: 'Systemadministratör',
    devices: 'Enheter',
    deviceManagement: 'Enhetshantering',
  },

  // Import Generator
  packages: {
    title: 'Prispaket',
    description: 'Hantera prispaket för system och moduler',
    createNew: 'Skapa nytt paket',
    noPackages: 'Inga paket skapade',
    priceMonthly: 'Pris per månad',
    priceYearly: 'Pris per år',
    includedModules: 'Inkluderade moduler',
    maxUsers: 'Max användare',
    maxVehicles: 'Max fordon',
    features: 'Extra funktioner',
    isDefault: 'Standardpaket',
    selectPackage: 'Välj paket',
    currentPackage: 'Nuvarande paket',
    totalMonthly: 'Total månadskostnad',
    // Module pricing
    modulePrices: 'Modulpriser',
    modulePrice: 'Modulpris',
    setDefaultPrice: 'Ange standardpris',
    // Subscriptions
    addon: 'Tillägg',
    demo: 'Demo',
    trial: 'Testperiod',
    included: 'Ingår',
    startDemo: 'Starta demo',
    startTrial: 'Starta testperiod',
    upgrade: 'Uppgradera',
    upgradeToFull: 'Uppgradera till fullständig',
    daysRemaining: 'dagar kvar',
    trialDays: 'Antal dagar',
    trialPrice: 'Testpris',
    addModule: 'Lägg till modul',
    removeModule: 'Ta bort modul',
    moduleAdded: 'Modul tillagd',
    moduleRemoved: 'Modul borttagen',
    demoStarted: 'Demo startad (30 dagar)',
    trialStarted: 'Testperiod startad',
    upgraded: 'Uppgraderad till fullständig prenumeration',
    syncFromPackage: 'Synkronisera från paket',
    modulesSynced: 'Moduler synkroniserade',
    // SystemPackagesManager
    packages: 'Prispaket',
    modules: 'Moduler',
    pricePerMonth: 'Pris/mån',
    pricePerYear: 'Pris/år',
    modulePricesDescription: 'Ange standardpris för varje modul. Dessa priser används som tilläggsmoduler när kunder vill lägga till moduler utöver sitt paket.',
    packagesCount: 'paket',
    newPackage: 'Nytt paket',
    systemsWithoutPackages: 'System utan paket',
    modulesWithoutPackages: 'Moduler utan paket',
    noModulesFound: 'Inga moduler hittades',
    noSystemsFound: 'Inga system hittades',
    noModulesForSystem: 'Inga moduler tillgängliga för detta system',
    noPacketsSelected: 'Inga paket valda',
    addPacketsInSectionAbove: 'Lägg till paket i Prispaket-sektionen ovan för att se tillgängliga moduler.',
    systemsActive: 'system aktiva',
    enableModule: 'Aktivera modul',
    disableModule: 'Inaktivera modul',
    enableAction: 'Aktivera',
    disableAction: 'Inaktivera',
    noActionsForModule: 'Inga funktioner tillgängliga för modulen',
    moduleEnabledForCustomer: 'Modulen aktiverad för kunden',
    moduleDisabledForCustomer: 'Modulen inaktiverad för kunden',
    moduleToggleError: 'Kunde inte ändra modulen',
    moduleActionsLoadError: 'Kunde inte läsa modulens funktioner',
    moduleActionEnabled: 'Funktion aktiverad',
    moduleActionDisabled: 'Funktion inaktiverad',
    moduleActionToggleError: 'Kunde inte ändra funktion',
    defaultPackage: 'Standardpaket för nya kunder',
    extraFeatures: 'Extra funktioner (en per rad)',
    internalName: 'Internt namn',
    displayName: 'Visningsnamn',
    descriptionPlaceholder: 'Kort beskrivning av paketet',
    codeExample: 't.ex. standard',
    nameExample: 't.ex. Deque Standard',
    unlimited: 'Obegränsat',
    editPrice: 'Redigera pris',
    createPackage: 'Skapa paket',
    editPackage: 'Redigera paket',
    notSet: 'Ej satt',
    loadError: 'Kunde inte ladda paket',
    saveError: 'Kunde inte spara paket',
    modulePriceSaved: 'Modulpris sparat',
    modulePriceError: 'Kunde inte spara modulpris',
    packageUpdated: 'Paket uppdaterat',
    packageCreated: 'Paket skapat',
    // CustomerPackages
    packageActivatedAndSynced: 'Paket aktiverat och moduler synkroniserade',
    activateError: 'Kunde inte aktivera paket',
    addModuleError: 'Kunde inte lägga till modul',
    confirmRemoveModule: 'Ta bort modul från kund?',
    removeModuleError: 'Kunde inte ta bort modul',
    upgradeError: 'Kunde inte uppgradera',
    noPackagesAvailable: 'Inga prispaket tillgängliga',
    selectModule: 'Välj modul',
    fullFunctionFullPrice: 'Full funktion, full pris',
    demoDescription: '30 dagar, begränsad',
    trialDescription: 'Full funktion, valfri tid',
    standard: 'Standard',
    free: 'Gratis',
    perMonth: 'per månad',
  },

  imports: {
    title: 'Import Generator',
    description: 'Skapa och hantera dataimporter',
    createNew: 'Skapa ny import',
    noImports: 'Inga importer skapade ännu',
    name: 'Importnamn',
    targetTable: 'Måltabell',
    schedule: 'Schema',
    lastRun: 'Senaste körning',
    status: 'Status',
    actions: 'Åtgärder',
    run: 'Kör import',
    edit: 'Redigera',
    delete: 'Radera',
    fileLoaded: 'Fil laddad',
    missingFields: 'Fyll i alla obligatoriska fält',
    saved: 'Import sparad',
    deleted: 'Import raderad',
    loadError: 'Kunde inte ladda importer',
    confirmDelete: 'Vill du verkligen radera denna import?',
    step1: 'Grundinställningar',
    step2: 'Ladda upp fil',
    step3: 'Mappa fält',
    step4: 'Inställningar',
    sourceFields: 'Källfält',
    targetFields: 'Målfält',
    fieldsMapped: 'fält mappade',
    decimalSeparator: 'Decimalavskiljare',
    csvDelimiter: 'CSV-separator',
    hasHeader: 'Första raden är rubrik',
    duplicateAction: 'Vid dubbletter',
    skipDuplicate: 'Hoppa över (behåll befintlig)',
    updateDuplicate: 'Uppdatera befintlig',
    errorAction: 'Vid fel',
    skipErrors: 'Hoppa över felaktiga rader',
    abortOnError: 'Avbryt hela importen',
    loadForEditError: 'Kunde inte ladda import för redigering',
    importSource: 'Importkälla',
    importSourceNone: 'Ingen källa',
    selectedSource: 'Vald källa',
    lastFetchAt: 'Senaste hämtning',
    lastFetchStatus: 'Hälsostatus',
    filesInSource: 'Filer i källan',
    notFetchedYet: 'Aldrig',
    sourceHealthSuccess: 'Lyckad',
    sourceHealthFailed: 'Misslyckad',
    sourceHealthUnknown: 'Okänd',
    sourcesStatusTitle: 'Källstatus',
    sourceSyncError: 'Sync-fel',
    sourcePreviewLoading: 'Laddar senaste fil från källa...',
    sourcePreviewLoaded: 'Mallfil laddad från källa',
    sourcePreviewNotFound: 'Ingen synkad fil hittades för vald källa',
    sourcePreviewLoadError: 'Kunde inte ladda mallfil från källa',
    sourcePreviewReload: 'Ladda om från källa',
    livePreviewNeedsSample:
      'Ingen mallfil laddad – gå tillbaka till steg 2 och ladda om från källa för att se förhandsvisning.',
    runLatestSource: 'Tvinga körning från senaste källfil',
    autoMappedFields: 'fält mappades automatiskt',
    importHistoryTitle: 'Import historik',
    allDefinitions: 'Alla definitioner',
    historyUpdateBtn: 'Uppdatera',
    historyLoadingText: 'Laddar historik…',
    noRunsFound: 'Inga körningar hittades',
    showDetails: 'Visa detaljer',
    loadRunError: 'Kunde inte ladda körning',
    runDetailsTitle: 'Körningsdetaljer',
    runDetailsStatus: 'Status',
    runDetailsStarted: 'Startad',
    runDetailsEnded: 'Slut',
    runDetailsFile: 'Fil',
    runDetailsRows: 'Rader',
    runDetailsErrors: 'Fel',
    runDetailsAndMore: 'och {n} fler',
    importingFile: 'Importerar...',
    importThisFile: 'Importera denna fil',
    noFilesForSource: 'Inga filer hittades för denna källa. Synka källan först.',
    loadingFiles: 'Laddar filer...',
    filesFromSourceTitle: 'Filer från källa',
    ftpImportTitle: 'FTP-import',
    ftpPathLabel: 'Sökväg',
    ftpListBtn: 'Lista',
    ftpLoadingText: 'Laddar...',
    ftpNoFiles: 'Inga filer hittades.',
    ftpOpen: 'Öppna',
    ftpRunImport: 'Kör import',
    importingProgress: 'Importerar…',
    rowsSuffix: 'rader',
    colsSuffix: 'kol.',
    createFirstImport: 'Skapa din första import',
    importUpdated: 'Import uppdaterad',
    statusSuccess: 'Lyckad',
    statusFailed: 'Misslyckad',
    statusPartial: 'Delvis',
    statusRunning: 'Körs',
    statusQueued: 'Köad',
    statusCancelled: 'Avbruten',
    statusAll: 'Alla',
    colDefinition: 'Definition',
    colFileSource: 'Fil / Källa',
    colStarted: 'Startad',
    colRows: 'Rader',
    colErrors: 'Fel',
    colAction: 'Åtgärd',
    showingRuns: 'Visar {shown} av {total} körningar',
    noTransformsAdded: 'Inga transforms tillagda.',
    addTransform: 'Lägg till transform',
    sourceLabel: 'Källa',
    typeLabel: 'Typ',
    paramsLabel: 'Parametrar (JSON)',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ner',
    remove: 'Ta bort',
    livePreview: 'Värde som sparas',
    runDetailsDuplicates: 'Dubbletter (hoppade över)',
    downloadFailedRows: 'Ladda ner felaktiga rader (CSV)',
    downloadDuplicateRows: 'Ladda ner dubbletter (CSV)',
    artifactDownloadError: 'Kunde inte ladda ner filen',
    identifiedColumns: 'Identifierade kolumner:',
    changeFile: 'Byt fil',
    supportedFormats: 'Stödda format: Excel, CSV, JSON, XML, TXT, DAT',
    schemaMappingError: 'Schema-validering: fel i mappningarna',
    sourcePanelTitle: 'Källfält (från fil)',
    targetPanelTitle: 'Målfält',
    examplePrefix: 'Ex',
    fieldsMappedCount: '{n} fält mappade',
    addMappingInStep3: 'Lägg till minst en fältmappning i steg 3 för att konfigurera transforms.',
    scheduleLabel: 'Schemaläggning',
    scheduleExecution: 'Körning',
    scheduleManual: 'Endast manuell',
    scheduleDaily: 'Dagligen',
    scheduleWeekly: 'Veckovis',
    scheduleMonthly: 'Månadsvis',
    scheduleTimeLabel: 'Tid (HH:mm)',
    scheduleDayOfWeek: 'Veckodag (0=söndag … 6=lördag)',
    scheduleDayOfMonth: 'Dag i månaden (1–31)',
    scheduleCronLabel: 'Cron (valfritt, t.ex. 0 6 * * *)',
    fileSourcePathLabel: 'Filkälla (sökväg eller glob, t.ex. /var/imports/fuel_*.dat)',
    stableFileTitle: 'Vänta på stabil fil',
    stableCheckInterval: 'Kontrollintervall (ms)',
    stableStableFor: 'Stabil i (ms)',
    stableTimeout: 'Timeout (ms, 0 = obegränsad)',
    retryTitle: 'Retry vid fel',
    retryMaxRetries: 'Max försök',
    retryInitialDelay: 'Första väntetid (ms)',
    retryMaxDelay: 'Max väntetid (ms)',
    retryBackoff: 'Backoff-multiplikator',
    summaryTitle: 'Sammanfattning',
    summaryName: 'Namn',
    summaryTargetTable: 'Måltabell',
    summaryMappedFields: 'Mappade fält',
    summaryFileFormat: 'Filformat',
    summarySchedule: 'Schemaläggning',
    invalidJsonTransform: 'Ogiltig JSON i transform-parametrar',
    duplicateActionLabel: 'Vid dubbletter',
    updateExisting: 'Uppdatera befintlig',
    errorActionLabel: 'Vid fel',
    skipErroneousRows: 'Hoppa över felaktiga rader',
    abortEntireImport: 'Avbryt hela importen',
    wizardTitleCreate: 'Skapa ny import',
    wizardTitleEdit: 'Redigera import',
    wizardStepBasicInfo: 'Grundinfo',
    wizardStepLoadFile: 'Ladda fil',
    wizardStepMapFields: 'Mappa fält',
    wizardStepTransforms: 'Transforms',
    wizardStepSettings: 'Inställningar',
    wizardCancel: 'Avbryt',
    wizardBack: 'Tillbaka',
    wizardNext: 'Nästa',
    wizardSave: 'Spara import',
    descriptionPlaceholder: 'Valfri beskrivning...',
    presetsLabel: 'Förinställningar (valfritt)',
    clearPreset: 'Rensa förinställning',
    targetTableLabel: 'Måltabell *',
    importNameLabel: 'Importnamn *',
    descriptionLabel: 'Beskrivning',
    step1Title: 'Steg 1: Grundinställningar',
    step2Title: 'Steg 2: Ladda upp mallfil',
    step3Title: 'Steg 3: Mappa fält',
    step4Title: 'Steg 4: Transforms per fält',
    step5Title: 'Steg 5: Importinställningar',
    filenameFilterTitle: 'Filnamnsfilter',
    filenameFilterHint:
      'Vilka filer från källan denna import ska ta. Glob: *K02*, *K05*. Regex (börjar med ^): ^\\d = filnamnet måste börja med en siffra (svensk OKQ8). Tomt = alla filer.',
    filenameFilterAdd: 'Lägg till mönster',
    decimalSeparatorLabel: 'Decimalavskiljare',
    decimalComma: 'Komma (1 234,56)',
    decimalDot: 'Punkt (1,234.56)',
    csvSeparatorLabel: 'CSV-separator',
    csvSemicolon: 'Semikolon (;)',
    csvComma: 'Komma (,)',
    csvTab: 'Tabb',
    csvPipe: 'Pipe (|)',
    excelSheetNameLabel: 'Excel sheet‑namn (valfritt)',
    excelSheetNamePlaceholder: 'T.ex. Sheet1',
    excelSheetIndexLabel: 'Excel sheet‑index (0‑baserat)',
    excelSheetIndexHint: 'Om sheet‑namn anges används det före sheet‑index.',
    headerCellsTitle: 'Fakturahuvud ovanför tabellen',
    headerCellsHint: 'Klicka på en cell i raderna ovanför rubrikraden för att mappa den till ett målfält. Värdet läggs på varje importerad rad.',
    headerCellsClickToMap: 'Klicka för att mappa',
    headerCellsRemove: 'Ta bort',
    headerCellsEditorTitle: 'Mappa cell',
    headerCellsEmpty: '(tom cell)',
    headerCellsAsColumn: 'Virtuellt kolumnnamn',
    headerCellsTargetField: 'Målfält',
    headerCellsNoTarget: '— Inget målfält —',
    headerCellsUseSplit: 'Dela upp cellvärdet (t.ex. kundnr + namn)',
    headerCellsSplitPattern: 'Regex-mönster',
    headerCellsSplitHint: 'Standard: första siffror → del 1, resten → del 2 (som Qstar B3).',
    headerCellsPart1Column: 'Del 1 (grupp 1)',
    headerCellsPart2Column: 'Del 2 (grupp 2)',
    headerCellsReloadHint: 'Hoppa över rader är satt, men fakturahuvudet saknas i förhandsvisningen. Ladda om filen/källan så att raderna ovanför tabellen kan mappas.',
    runPendingSource: 'Importera alla väntande',
    runPendingSourceTitle: 'Importera alla källfiler som ännu inte importerats',
    pendingImportDone: 'Väntande import klar',
    pendingImportFailed: 'Kunde inte importera väntande källfiler',
    pendingImportRunning: 'Importerar väntande filer…',
    pageTitle: 'Import Generator',
    pageDescription: 'Skapa och hantera dataimporter utan att behöva koda',
    colName: 'Namn',
    colDate: 'Datum',
    colSize: 'Storlek',
    colTargetTable: 'Måltabell',
    colSchedule: 'Schema',
    colLastRun: 'Senaste körning',
    testImportTitle: 'Testimport ({n} rader)',
    loadingHistory: 'Laddar historik...',
    cannotSave: 'Kunde inte spara',
    importComplete: 'Import klar: {imported} importerade, {updated} uppdaterade, {failed} misslyckade',
    testImportComplete: 'Testimport klar: {processed} rader testade, {failed} misslyckade (ingen data sparad)',
    loadSourceFilesError: 'Kunde inte ladda filer från källan',
    loadHistoryError: 'Kunde inte ladda körningshistorik',
    ftpListError: 'Kunde inte lista FTP-filer',
    ftpImportFailed: 'FTP-import misslyckades',
    importFailed: 'Import misslyckades',
    latestSourceImportFailed: 'Import från senaste källfil misslyckades',
  },

  // Sysadmin
  sysadmin: {
    loadSlowQueriesError: 'Kunde inte ladda slow queries',
    clearLogError: 'Kunde inte rensa loggen',
    loadErrorLogError: 'Kunde inte ladda error log',
    loadAuditLogError: 'Kunde inte ladda audit log',
  },

  // Tracking
  tracking: {
    saveMapViewError: 'Kunde inte spara kartvy',
  },

  // Support
  support: {
    updateTicketError: 'Kunde inte uppdatera ärende',
    sendReplyError: 'Kunde inte skicka svar',
    sendBroadcastError: 'Kunde inte skicka broadcast',
    deleteBroadcastError: 'Kunde inte ta bort broadcast',
    closeTicketError: 'Kunde inte stänga ärendet',
    sendMessageError: 'Kunde inte skicka meddelande',
  },

  // Device Management
  deviceManagement: {
    title: 'Enhetshantering',
    devices: 'Enheter',
    device: 'Enhet',
    imei: 'IMEI',
    iccid: 'ICCID',
    status: 'Status',
    vehicle: 'Fordon',
    organization: 'Organisation',
    lastKnownVin: 'Senaste VIN',
    history: 'Historik',
    actions: 'Åtgärder',
    details: 'Detaljer',
    exportCsv: 'Exportera CSV',
    exportEmpty: 'Inget att exportera för valt filter',
    exportDone: 'Exporterade {{count}} enheter',
    
    // Status
    statusStock: 'Lager',
    statusCustomer: 'Hos kund',
    statusVehicle: 'I fordon',
    statusLost: 'Förlorad',
    statusDecommissioned: 'Kasserad',
    
    // Actions
    toStock: 'Till lager',
    unmountKeep: 'Demontera (kund behåller)',
    unmountStock: 'Demontera (till lager)',
    markLost: 'Markera förlorad',
    decommission: 'Kassera',
    assignOrganization: 'Tilldela organisation',
    selectOrganization: 'Välj organisation',
    organizationFollowsVehicle: 'Följer fordontilldelningen',

    obdModeTitle: 'OBD II Feature',
    obdModeHint:
      'Skickar setparam till enheten via gateway (köas om offline). OBD = personbil, ELD = tunga fordon (J1939/FMS), Non-OBD = EV/OEM (VIN auto/manual, web_connect). Anti-larm = Non-OBD + Movement Stop Delay 5 s + Ignition Averaging av + Accelerometer-tändning (ID.x/tjuvlarm). OBD-Disable = endast 40000:0 (stäng av OBD II Feature).',
    obdModeAuto: 'OBD (auto)',
    obdModeEld: 'ELD – Tunga fordon',
    obdModeNonObd: 'Non-OBD Compliant + OEM',
    obdModeAntiAlarm: 'Anti-larm',
    obdModeDisable: 'OBD-Disable',
    obdModeConfirmTitle: 'Skicka OBD-kommando',
    obdModeConfirmObdAuto:
      'Aktivera OBD (auto) på {reg}? Skickar setparam 40000:1. Om VIN finns på fordonet sätts VIN Manual (40005:1 + 40003), annars VIN Auto (40005:0). Samma som P&P för personbil/ICE.',
    obdModeConfirmEld:
      'Aktivera ELD (tunga fordon) på {reg}? Skickar setparam 40000:2 (J1939/FMS). Använd endast för lastbil/buss med FMS — inte personbil, hybrid eller EV.',
    obdModeConfirmNonObd:
      'Aktivera Non-OBD Compliant + OEM-provisionering på {reg}? Köar setparam 40000:3, VIN auto/manual och web_connect.',
    obdModeConfirmAntiAlarm:
      'Skicka anti-larm till {reg}? Köar setparam 40000:3;19002:5;50005:0;101:2 och lägger enheten på Non-OBD-listan.',
    obdModeConfirmDisable:
      'Skicka OBD-Disable till {reg}? Skickar setparam 40000:0 och sparar bilen på problemlistan så Disable återställs vid FW/cfg-uppgradering. Blockeras om enheten redan har ELD (40000:2) — det återställer displaylarm.',
    obdModeSuccess: 'OBD-kommando skickat till enheten',
    obdModePartialFail: 'Kommando skickat men enheten svarade inte på alla steg (offline/timeout?)',
    obdModeError: 'Kunde inte skicka OBD-kommando',
    obdDisableLastSent: 'Senaste Disable på denna enhet: {when} ({status}) av {user}',
    obdDisableLogShow: 'Visa Disable-logg (senaste utskick)',
    obdDisableLogHide: 'Dölj Disable-logg',
    obdDisableLogEmpty: 'Inga Disable-utskick loggade ännu.',
    obdDisableLogWhen: 'När',
    obdDisableLogDevice: 'Enhet',
    obdDisableLogStatus: 'Status',
    obdDisableLogBy: 'Av',

    obdBaselineTitle: 'OBD Plug & Play – baseline (FW + konfig)',
    obdBaselineHelp:
      'Ange exakta FOTA WEB-filnamn för FMM003 innan ni slår på P&P. Auto-körning är av tills OBD_PROVISIONING_ENABLED=true i .env.',
    obdBaselineRuntimeOn: 'P&P globalt PÅ',
    obdBaselineRuntimeOff: 'P&P globalt AV (säkert läge)',
    obdBaselineModels: 'Tillåtna modeller',
    obdBaselineAllProfiles: 'alla profiler',
    obdBaselineFw: 'Mål-firmware (FOTA-filnamn)',
    obdBaselineCfg: 'Grundconfig (FOTA-filnamn)',
    obdBaselineNote: 'Anteckning',
    obdBaselineSaved: 'Baseline sparad',
    obdBaselineLoadError: 'Kunde inte hämta baselines',
    obdBaselineSaveError: 'Kunde inte spara baseline',
    obdBaselineNeedFile: 'Ange minst firmware- eller config-filnamn',
    obdBaselineEmpty: 'Inga baselines. Kör migrering 345 eller skapa rad för FMM003.',

    obsTitle: 'OBS-lista',
    obsHint: 'Enheter som ska bänk-testas eller granskas när de kommer tillbaka.',
    obsOpenCount: '{count} öppna',
    obsEmpty: 'Inga öppna OBS-rader.',
    obsBadge: 'OBS',
    obsAdd: 'Lägg på OBS-listan',
    obsAddSelected: 'Lägg vald enhet på OBS-listan',
    obsNotePlaceholder: 'Vad ska testas när enheten kommer tillbaka?',
    obsDefaultNote: 'Ska bänk-testas när den kommer tillbaka.',
    obsAdded: 'Tillagd på OBS-listan',
    obsMarkDone: 'Testad / klar',
    obsMarkedDone: 'OBS-raden markerad som klar',
    obsCancelled: 'OBS-raden avbruten',
    obsLoadError: 'Kunde inte hämta OBS-listan',
    obsSaveError: 'Kunde inte spara OBS-raden',

    // Import
    importReturns: 'Importera returner',
    importTitle: 'Importera returnerade enheter',
    importDescription: 'Klistra in IMEI-nummer från Excel (en per rad)',
    importSettings: 'Inställningar',
    setToStock: 'Sätt status till LAGER',
    disconnectVehicle: 'Koppla bort från fordon',
    deactivateSim: 'Inaktivera SIM-kort hos Jasper',
    validImeis: 'giltiga IMEI-nummer hittade',
    importing: 'Importerar...',
    successful: 'Lyckade',
    failed: 'Misslyckade',
    manualRequired: 'Kräver manuell hantering',
    needsAttention: 'Behöver åtgärd',
    
    // History
    changeHistory: 'Ändringshistorik',
    noHistory: 'Ingen historik',
    statusChanged: 'Status ändrad',
    vehicleMounted: 'Monterad i fordon',
    vehicleUnmounted: 'Demonterad',
    vehicleTransferred: 'Flyttad till annat fordon',
    vinDetected: 'VIN detekterat',
    vehicleCreated: 'Fordon skapat',
    simActivated: 'SIM aktiverat',
    simSuspended: 'SIM inaktiverat',
    deviceCreated: 'Enhet skapad',
    deviceImported: 'Enhet importerad',
    
    // Bulk & filters
    searchPlaceholder: 'Sök IMEI (hela eller del, t.ex. sista 4), ICCID, reg.nr...',
    allStatuses: 'Alla statusar',
    total: 'Totalt',
    selectAllAvailable: 'Markera alla tillgängliga',
    selected: 'valda',
    deselectAll: 'Avmarkera alla',
    importImeiToOrg: 'Importera IMEI → Organisation',
    devicesAssigned: 'enheter tilldelade',
    deviceDetails: 'Enhetsdetaljer',
    
    // Messages
    noDevices: 'Inga enheter hittades',
    selectDevice: 'Välj en enhet för att se detaljer',
    confirmDecommission: 'Är du säker? Detta kan inte ångras.',
  },

  // Device AVL Capabilities
  deviceAvlCapabilities: {
    title: 'AVL-förmågor per enhet',
    description: 'Vilka AVL-parametrar (id + namn) varje enhet/fordon levererar. En rad per IMEI+VIN. Klicka på IMEI för att se namn och beskrivning.',
    filterImei: 'Filtrera på IMEI',
    filterRegNumber: 'Filtrera på regnr',
    filterAvlId: 'AVL-id (t.ex. 13)',
    imei: 'IMEI',
    vin: 'VIN',
    regNumber: 'Regnr',
    avlParameters: 'AVL-parametrar',
    firstSeen: 'Första gången',
    lastSeen: 'Senaste gången',
    noData: 'Inga data än. Data samlas in när enheter skickar GPS-punkter.',
    modalTitle: 'AVL-parametrar för enhet',
    parameterCountOne: 'parameter',
    parameterCount: 'parametrar',
  },

  // Roles
  roles: {
    title: 'Rollhantering',
    createRole: 'Skapa ny roll',
    editRole: 'Redigera roll',
    viewRights: 'Visa rättigheter',
    roleName: 'Namn',
    roleCode: 'Kod',
    roleDescription: 'Beskrivning',
    permissions: 'Rättigheter',
    systemRole: 'Systemroll',
    customRole: 'Anpassad roll',
    allActions: 'Alla actions',
    codePlaceholder: 't.ex. CUSTOM_ROLE',
    namePlaceholder: 't.ex. Anpassad roll',
    descriptionPlaceholder: 'Beskrivning av rollen...',
    codeCannotChange: 'Kod kan inte ändras',
    rightsAndAccess: 'Rättigheter och åtkomster',
    loadingFeatures: 'Laddar features...',
    noActionsAvailable: 'Inga actions tillgängliga',
    noAccessToFeature: 'Ingen åtkomst till denna feature',
    selectAll: 'Markera alla',
    deselectAll: 'Avmarkera alla',
    createRoleButton: 'Skapa roll',
    updateRoleButton: 'Spara ändringar',
    roleCreated: 'Roll skapad!',
    roleUpdated: 'Roll uppdaterad!',
    createRoleError: 'Kunde inte skapa roll',
    updateRoleError: 'Kunde inte uppdatera roll',
    loadRoleError: 'Kunde inte ladda roll',
    systemRoleOnlyGlobalAdmin: 'Systemroller kan endast ändras av global admin.',
    codeAndNameRequired: 'Kod och namn är obligatoriska',
    loadDataError: 'Kunde inte ladda data',
    systemRoleNote: ' (Systemroll)',
    summary: 'Sammanfattning',
    permissionsCount: 'behörigheter',
    noPermissionsSelected: 'Inga behörigheter valda',
    actions: 'actions',
    // Tvånivå-rollsystem
    systemRoles: 'Systemroller',
    customerRoles: 'Kundspecifika roller',
    visibleToAll: 'Synlig för alla kunder',
    visibleToOrganization: 'Synlig för organisation och underliggande',
    showInactive: 'Visa inaktiva roller',
    createAsSystemRole: 'Skapa som systemroll',
    customerRoleHint: 'Rollen skapas för din organisation och underliggande',
    systemTemplatesHint: 'Mallar som kopieras till nya kunder',
    templateStartingPoint: 'Utgångspunkt (mall)',
    selectTemplate: 'Välj mall...',
    templateRequired: 'Välj en systemmall som utgångspunkt',
    templateHint: 'Välj en systemmall. Du kan sedan justera moduler och funktioner inom dina tilldelade tjänster.',
    loadTemplateError: 'Kunde inte ladda mallens behörigheter',
    permissionCeilingExceeded: 'Behörigheten överskrider kundens tilldelade tjänster',
    roleActivated: 'Roll aktiverad!',
    roleDeactivated: 'Roll inaktiverad!',
    toggleError: 'Kunde inte ändra rollstatus',
    noRolesFound: 'Inga roller hittades',
    menu: 'Meny',
  },

  // Organizations
  organizations: {
    title: 'Organisationshantering',
    chart: 'Organisationsschema',
    chartDescription: 'Visa och redigera organisationshierarki grafiskt',
    managementDescription: 'Skapa och hantera organisationer',
    searchPlaceholder: 'Sök organisation...',
    selectOrganization: 'Välj organisation',
    createTopNode: 'Skapa toppnod',
    createSubOrganization: 'Skapa kund',
    organizationName: 'Namn',
    description: 'Beskrivning',
    parentOrganization: 'Föräldersorganisation',
    topNode: 'Toppnod',
    customerTopNode: 'Kundtoppnod',
    isTopNode: 'Toppnod',
    isTopNodeHint:
      'Kundtoppnod kan ligga under en partner (t.ex. Dialect) och ha egna inställningar. Kryssa i och spara för att aktivera.',
    authSettings: 'Autentiseringsinställningar',
    noOrganizations: 'Inga organisationer ännu. Skapa en toppnod för att komma igång.',
    deleteConfirm: 'Är du säker på att du vill ta bort denna organisation och alla dess underorganisationer? Om inga fordon är kopplade tas noden bort permanent, annars inaktiveras den (soft delete).',
    editOrganization: 'Redigera organisation',
    addSub: 'Lägg till kund',
    deleteOrganization: 'Ta bort',
    createButton: 'Skapa',
    updateButton: 'Uppdatera',
    customerLogo: 'Kundlogotyp',
    uploadLogo: 'Ladda upp logotyp',
    removeLogo: 'Ta bort logotyp',
    logoUploadSuccess: 'Logotyp uppladdad',
    logoDeleteSuccess: 'Logotyp borttagen',
    organizationCreated: 'Organisation skapad!',
    organizationUpdated: 'Organisation uppdaterad!',
    organizationDeleted: 'Organisation borttagen!',
    organizationDeletedHard: 'Organisation borttagen permanent!',
    organizationDeletedSoft: 'Organisation inaktiverad (soft delete) eftersom kopplade fordon finns.',
    createError: 'Kunde inte skapa organisation',
    updateError: 'Kunde inte uppdatera organisation',
    deleteError: 'Kunde inte ta bort organisation',
    loadHierarchyError: 'Kunde inte ladda hierarki',
    loadChildrenError: 'Kunde inte ladda underorganisationer',
    nameRequired: 'Namn är obligatoriskt',
    namePlaceholder: 'Organisationsnamn',
    descriptionPlaceholder: 'Beskrivning...',
    noParent: 'Ingen (skapa som toppnod)',
    status: 'Status',
    active: 'Aktiv',
    suspended: 'Suspenderad',
    inactive: 'Inaktiv',
    loginParameters: 'Inloggningsparametrar',
    authMethod: 'Autentiseringsmetod',
    passwordAuth: 'Lösenord',
    twoFactorAuth: 'Tvåfaktorsautentisering',
    samlAuth: 'SAML2',
    oidcAuth: 'OpenID Connect (t.ex. Entra ID)',
    allowedDomains: 'Tillåtna domäner',
    allowedDomainsPlaceholder: 't.ex. acme.com, intranet.acme.com',
    allowedDomainsHint: 'Separera flera domäner med komma',
    organizationIdentifier: 'Organisationsidentifierare',
    organizationIdentifierPlaceholder: 't.ex. acme',
    organizationIdentifierHint: 'Används för identifiering via query parameter (?org=)',
    additionalInfo: 'Ytterligare information',
    address: 'Adress',
    addressPlaceholder: 't.ex. Storgatan 1',
    postNr: 'Postnummer',
    postNrPlaceholder: 't.ex. 12345',
    town: 'Ort',
    townPlaceholder: 't.ex. Stockholm',
    orgNr: 'Organisationsnummer',
    orgNrPlaceholder: 't.ex. 556123-4567',
    contact: 'Kontaktperson',
    contactPlaceholder: 't.ex. Anna Andersson',
    contacttel: 'Kontakttelefon',
    contacttelPlaceholder: 't.ex. 08-123456',
    email: 'E-post',
    emailPlaceholder: 't.ex. info@example.com',
    carRental: 'Uthyrningsföretag',
    costNo: 'Kostnadsnummer',
    costNoPlaceholder: 't.ex. KST-123',
    move: 'Flytta',
    moveOrganization: 'Flytta organisation',
    moveOrganizationDescription: 'Flytta organisationen och alla dess underorganisationer till en ny föräldraorganisation. Alla inställningar behålls.',
    newParent: 'Ny föräldraorganisation',
    selectParent: 'Välj föräldraorganisation',
    moveButton: 'Flytta',
    organizationMoved: 'Organisation flyttad!',
    moveError: 'Kunde inte flytta organisation',
    loadDataError: 'Kunde inte ladda data',
    loadError: 'Kunde inte ladda organisationer',
    importError: 'Kunde inte importera filen',
    importModalTitle: 'Importera organisationer',
    importModalSubtitle: 'Under',
    importDropzone: 'Dra och släpp en Excel-fil (.xlsx) här, eller klicka för att välja fil',
    importStart: 'Importera',
    importNoFile: 'Välj en fil innan du importerar',
    importFileError: 'Kunde inte läsa filen. Kontrollera att det är en giltig Excel-fil.',
    importFileSelected: 'Vald fil',
    importPreviewTitle: 'Förhandsgranskning',
    importPreviewCount: 'rader att importera',
    importPreviewScrollHint: 'Visar upp till 20 rader i taget — scrolla för att se fler',
    importColumnName: 'Namn',
    importColumnParent: 'Föräldraorganisation',
    importColumnContact: 'Kontaktperson',
    importColumnPhone: 'Telefon',
    importColumnEmail: 'E-post',
    importColumnCostNo: 'Kostnadsnummer',
    importCreated: 'skapade organisationer',
    importErrors: 'fel',
    importRowError: 'Rad',
    importOrganizations: 'Importera organisationer',
    importOrganizationsTooltip: 'Importera underorganisationer från Excel',
    downloadTemplate: 'Ladda ner importmall',
    downloadTemplateTooltip: 'Ladda ner Excel-mall för organisationsimport',
    fuelCompanies: {
      tabTitle: 'Bränslebolag',
    },
    fuelAccounts: {
      loadError: 'Kunde inte ladda bränslekonton',
      saveError: 'Kunde inte spara bränslekonton',
      saved: 'Sparat',
      savedWithLinks: 'Sparat. {{count}} bränsletransaktioner kopplades till organisationen.',
      fillAll: 'Välj bränslebolag och ange kundnummer',
      alreadyAdded: 'Det bränslebolaget finns redan',
      empty: 'Inga bränslekonton kopplade. Lägg till bränslebolag och kundnummer nedan.',
      fuelCompany: 'Bränslebolag',
      selectCompany: 'Välj bränslebolag',
      customerNumber: 'Kundnummer',
      customerNumberPlaceholder: 't.ex. 12345',
      add: 'Lägg till',
    },
    contactRoles: {
      title: 'Ansvariga / Kontaktroller',
      noAssignment: 'Ingen tilldelad',
      addCustomRole: 'Lägg till egen roll',
      codeRequired: 'Kod krävs',
      codePlaceholder: 't.ex. regional_manager',
      roleName: 'Rollnamn',
      description: 'Beskrivning',
      createRole: 'Skapa roll',
      roleCreated: 'Roll skapad',
      roleDeleted: 'Roll borttagen',
      confirmDeleteRole: 'Ta bort denna roll?',
      attestationResponsible: 'Attestansvarig',
      manager: 'Chef',
      localVehicleResponsible: 'Lokal fordonsansvarig',
      fleetManager: 'Fleet manager',
      maintenanceResponsible: 'Underhållsansvarig',
      servicePersonnel: 'Servicepersonal',
    },
    bookingSettings: 'Bokningsinställningar',
    drivingLog: {
      tabTitle: 'Körjournalinställningar',
      title: 'Körjournal',
      intro:
        'Standardvärden för hela kundträdet. Vid koppling fordon–användare används tjänsttiderna om inget annat anges manuellt. Påminnelser och inskick hanteras utifrån dessa inställningar.',
      serviceHoursTitle: 'Standard tjänsttid (privat övrig tid)',
      serviceStart: 'Tjänst start',
      serviceEnd: 'Tjänst slut',
      serviceHoursHelp:
        'Gäller som standard för alla fordon tills något ändras per fordon eller vid koppling.',
      cutOffEnabled: 'Aktivera brytdatum för inskickning',
      cutOffEnabledHelp: 'Om avstängt används inget månadsbrytdatum i systemet för denna toppnod.',
      cutOffDay: 'Brytdatum (dag i månaden)',
      cutOffDayHelp: 'Exempel: 5 = senast den 5:e varje månad. Välj 1–28 för att undvika kort månad.',
      reminderDays: 'Påminnelse (dagar före brytdatum)',
      reminderHelp:
        'Antal dagar före brytdatum som påminnelse skickas. Push går till appen (förare och användare med körjournal). E-post går till adressen för vidarebefordran.',
      forwardingEmail: 'Standard e-post för vidarebefordran',
      forwardingEmailPlaceholder: 't.ex. ekonomi@foretag.se; hr@foretag.se',
      forwardingEmailHelp:
        'Används som förifyllt vidarebefordringsmål när körjournal skickas. Flera adresser separeras med semikolon (;).',
      lockAfterSubmit: 'Lås körjournal efter inskickning',
      lockAfterSubmitHelp:
        'Låser redigering när körjournalen skickas in manuellt, och när månadsrapporten går ut på brytdatumet. Påminnelsen (e-post/push) låser inte.',
      odometerAdjustmentLock: 'Spärra justering av mätarställning under bokslutsperiod',
      odometerAdjustmentLockHelp: 'När aktiverad kan mätarställningen inte justeras manuellt den 1–3 och 26–månadens slut (boksluts-/attestperiod). Avstängd som standard.',
    },
    reminders: {
      tabTitle: 'Prenumerationer',
      title: 'Prenumerationer',
      intro:
        'Gäller hela kundträdet under denna toppnod. Avstängd tjänst skapar varken tilldelningar eller utskick. Notifiering styr mejl och push.',
      service: 'Tjänst',
      notify: 'Notifiering',
      inspection: 'Besiktning',
      inspectionHelp: 'Påminnelse när besiktning infaller inom 40 dagar.',
      tax: 'Fordonsskatt',
      taxHelp: 'Påminnelse när skatten ska vara betald inom 45 dagar.',
      leasing: 'Leasing förfaller',
      leasingHelp: 'Visa fordon vars leasing slutar inom valt antal månader. Default 6. Gäller widget och auto-utkast.',
      monthsAhead: 'Månader framåt',
    },
    reportModels: {
      tabTitle: 'Datamodeller',
      title: 'Datamodeller',
      intro: 'Välj vilka rapportmodeller den här kunden får använda i rapportgeneratorn. Gäller hela kundträdet.',
      save: 'Spara modeller',
      saved: 'Datamodellerna är sparade',
      empty: 'Inga modeller är upplagda ännu.',
    },
    automaticService: 'Automatisk service',
    cabinetSettings: 'Skåpinställningar',
    cabinetHasCabinet: 'Kunden har nyckelskåp',
    cabinetHasCabinetHelp: 'Aktiverar skåp för toppnoden. Första gången öppnar du skåpet med KeyWins inbyggda SuperAdmin och sätter i tapparna. Därefter synkas bara tapparna i det skåpet till kundens SuperAdmin och skåpets LocalAdmin (KeyWin-användare, inte webb-administratör).',
    cabinetEnabled: 'Skåp aktiverat för kunden',
    cabinetDisabled: 'Skåp avaktiverat för kunden',
    cabinetEnableError: 'Kunde inte ändra skåpinställning',
    cabinetSuperAdminPin: 'SuperAdmin-PIN',
    cabinetSuperAdminPinHelp: '8 siffror, unik i systemet. PIN för knappsatsen efter att tapparna i skåpet synkats till SuperAdmin-användaren. Ger inte webbinloggning i KeyWin. Första insättningen av tappar görs med den inbyggda SuperAdmin-koden som alltid kan öppna alla skåp.',
    cabinetPinCopied: 'PIN kopierad',
    cabinetGeneratePin: 'Generera PIN',
    cabinetPinSync: 'Spara till KeyWin',
    cabinetPinSaved: 'SuperAdmin-PIN sparad i KeyWin',
    cabinetPinGenerated: 'Ny unik SuperAdmin-PIN skapad och sparad i KeyWin',
    cabinetPinInvalid: 'PIN måste vara exakt 8 siffror',
    cabinetPinSaveError: 'Kunde inte spara SuperAdmin-PIN',
    cabinetWebAdmin: 'Webbinlogg (KeyWin-admin)',
    cabinetUsername: 'Användarnamn',
    cabinetPassword: 'Lösenord',
    cabinetPasswordHelp: 'Används för att logga in i KeyWin-webbgränssnittet.',
    cabinetPasswordCopied: 'Lösenord kopierat',
    cabinetRegeneratePassword: 'Generera nytt lösenord',
    cabinetRegenerateConfirm: 'Vill du skapa ett nytt webb-lösenord? Det gamla slutar gälla.',
    cabinetRegenerateError: 'Kunde inte generera nytt lösenord',
    cabinetLinkedCabinets: 'Knutna skåp',
    cabinetNoLinkedCabinets: 'Inga skåp är knutna till kunden ännu. Gör det under Nyckelhantering.',
    cabinetSyncTags: 'Synka tappar',
    cabinetSyncTagsHelp: 'Kopplar bara tappar som KeyWin ser i detta skåp till LocalAdmin och toppnodens SuperAdmin. Titta i KeyWin under Users, inte Groups.',
    cabinetSyncTagsSuccess: '{{count}} tappar kopplade till SuperAdmin och LocalAdmin',
    cabinetSyncTagsEmpty: 'Inga tappar i skåpet ännu. Öppna med inbyggd SuperAdmin, sätt i tapparna och synka igen.',
    cabinetSyncTagsError: 'Kunde inte synka tappar',
    defaultTimelineView: 'Tidslinje som standardvy i Kundtjänst',
    defaultTimelineViewHelp: 'Lista är alltid standard. Kryssa i för att Tidslinje ska visas först i Kundtjänst för denna organisation. Användaren kan alltid byta vy själv.',
    maxRecurringBookings: 'Max återkommande bokningar',
    maxRecurringBookingsHelp: 'Max antal framtida bokningar per återkommande serie (t.ex. samma tid varje vecka). 0 eller tomt = ingen begränsning.',
    noBookingsBefore: 'Inga bokningar före',
    noBookingsAfter: 'Inga bokningar efter',
    noBookingsHelp: '0 eller tomt = ingen begränsning.',
    minLengthHours: 'Minsta längd (timmar)',
    maxLengthHours: 'Högsta längd (timmar)',
    lengthHelp: '0 eller tomt = ingen begränsning.',
    bookableMonthsForward: 'Bokningsbara månader framåt',
    bookableMonthsHelp: '0 eller tomt = ingen begränsning.',
    cancellationChargeHours: 'Avbokning debiteras (timmar före start)',
    cancellationChargeHelp: 'Om kunden avbokar inom denna tid före start kan bokningen debiteras men bilen frigörs. 0 eller tomt = ingen sådan regel.',
    noShowReleaseMinutes: 'No-show: frigör plats (min efter start)',
    noShowReleaseMinutesHelp: 'Om fordonet inte utcheckats inom så här många minuter efter bokningsstart frigörs platsen; bokningen kan fortfarande faktureras. 0 = inaktiverat. Nya utlämningsplatser får värdet förifyllt (kan ändras per plats).',
    bookingRestMinutes: 'Vilotid mellan bokningar (minuter)',
    bookingRestMinutesHelp: 'Minsta antal minuter efter en boknings slut innan samma fordon kan bokas igen. 0 eller tomt = ingen vilotid.',
    bookingMinLeadTimeHours: 'Minsta framförhållning (timmar)',
    bookingMinLeadTimeHoursHelp: 'Gäller endast förfrågningar (request) som går till biluthyraren. Bokningen måste starta minst så här många timmar fram i tiden. 0 eller tomt = ingen begränsning.',
    bookingPolicyHtml: 'Bokningspolicy',
    bookingPolicyHtmlHelp: 'Text som bokande måste öppna och bekräfta innan bokning (tillsammans med körkort). Lämna tom om ingen policy ska krävas.',
  },

  // User Manual
  manual: {
    title: 'Användarmanual',
    searchPlaceholder: 'Sök efter funktioner eller menyer...',
    mainMenu: 'Huvudmeny',
    tools: 'Verktyg',
    administration: 'Administration',
    path: 'Sökväg',
    availableActions: 'Tillgängliga åtgärder',
    noResults: 'Inga resultat hittades',
    icons: 'Tillgängliga ikoner',
    iconsDescription: 'Här är alla ikoner som finns tillgängliga i Heroicons-biblioteket. Du kan välja vilken ikon som helst för att använda i systemet.',
    navigationIcons: 'Navigationsikoner',
    arrowsIcons: 'Pilikoner',
    actionsIcons: 'Åtgärdsikoner',
    adminIcons: 'Administrativa ikoner',
    communicationIcons: 'Kommunikationsikoner',
    filesIcons: 'Filikoner',
    statusIcons: 'Statusikoner',
    mediaIcons: 'Mediaikoner',
    otherIcons: 'Övriga ikoner',
    guides: {
      title: 'Guider och processer',
      deviceVehicleTitle: 'Byta enhet till en annan bil',
      deviceVehicleIntro: 'Vad som händer när en GPS-enhet flyttas från en bil till en annan, och hur du gör det manuellt.',
      autoHeading: 'Vad händer automatiskt',
      autoSteps: [
        'När en enhet flyttas till en annan bil känner systemet av det själv.',
        'Enheten kopplas bort från den gamla bilen och kopplas till den nya bilen.',
        'Är det en helt ny bil skapas den automatiskt med rätt uppgifter (märke, modell, reg.nr).',
        'Fanns det en förare på den gamla bilen följer föraren med till den nya bilen.',
        'Allt loggas så att resorna hamnar på rätt bil och rätt förare.',
      ],
      manualHeading: 'Byta enhet manuellt',
      manualSteps: [
        'Gå till Administration → Enhetshantering.',
        'Sök upp enheten och välj att koppla den till den nya bilen.',
        'Har den nya bilen redan en enhet får du välja att byta plats på enheterna eller koppla bort den gamla.',
        'Bekräfta – enheten flyttas till den nya bilen och kopplas bort från den gamla.',
        'Den gamla bilen blir ledig och den nya bilen visar nu enheten.',
      ],
    },
  },

  // Icons
  icons: {
    fleet: 'Fordonsflotta',
    statistics: 'Statistik',
    trips: 'Resor',
    user: 'Användare',
    manual: 'Användarmanual',
    search: 'Sök',
    notification: 'Notifikationer',
    moon: 'Mörkt läge',
    sun: 'Ljust läge',
    arrowLeft: 'Tillbaka',
    eye: 'Visa',
    eyeSlash: 'Dölj',
    settings: 'Inställningar',
    database: 'Databas',
    sync: 'Synkronisera',
    userGroup: 'Användargrupp',
  },

  // Translations Management
  translations: {
    title: 'Översättningar',
    key: 'Nyckel',
    swedish: 'Svenska',
    english: 'Engelska',
    editTranslation: 'Redigera översättning',
    saveSuccess: 'Översättning sparad',
    saveError: 'Kunde inte spara översättning',
    searchPlaceholder: 'Sök efter nyckel eller text...',
    noTranslations: 'Inga översättningar hittades',
    noMatchSearch: 'Inga översättningar matchade sökningen',
    exportFiles: 'Exportera till filer',
    exportNoteLabel: 'Notera',
    exportNote: 'Översättningar lagras i filer (sv.ts och en.ts). Använd "Exportera till filer" för att ladda ner uppdaterade filer, eller redigera filerna direkt i koden.',
    total: 'Totalt',
    filtered: 'filtrerat från',
    updatedNote: 'Översättning uppdaterad! (Notera: Ändringar måste sparas i filerna manuellt)',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    activeVehicles: 'Aktiva Fordon',
    totalDistance: 'Total Körsträcka',
    averageSpeed: 'Genomsnittlig Hastighet',
    liveMap: 'Live Karta',
    liveTracking: 'Realtidsövervakning',
    mapComingSoon: 'OpenStreetMap integration kommer snart',
    addressUnavailable: 'Adress kunde inte hämtas',
    edit: 'Redigera',
    editDashboard: 'Redigera dashboard',
    save: 'Spara',
    cancel: 'Avbryt',
    addWidget: 'Lägg till widget',
    addFirstWidget: 'Lägg till din första widget',
    emptyDashboard: 'Din dashboard är tom',
    emptyDashboardDescription: 'Lägg till widgets för att anpassa din dashboard. Du kan välja från en mängd olika widgets som visar information om dina fordon och organisation.',
    dragHere: 'Dra widget hit',
    layoutSaved: 'Layouten sparad',
    layoutSaveFailed: 'Kunde inte spara layout',
    widgetAdded: 'Widget tillagd',
    widgetRemoved: 'Widget borttagen',
    widgetNotAvailable: 'Widget ej tillgänglig',
    widgetNoPermission: 'Du saknar behörighet för denna widget',
    saving: 'Sparar...',
    favorites: 'Favoriter',
    reorderFavorites: 'Ändra ordning på favorit',
    reorderFavoritesHint: 'dra för att ändra ordning',
  },

  // Live Tracking
  liveTracking: {
    title: 'Realtidsövervakning',
    description: 'Visa fordon i realtid på karta med trädvy för organisationer',
    search: 'Sök fordon...',
    searchHits: 'Sökträffar',
    lists: 'Listor',
    alarms: 'Larm',
    online: 'Online',
    offline: 'Offline',
    all: 'Alla',
    noVehicles: 'Inga fordon valda',
    loading: 'Laddar...',
    fitBounds: 'Anpassa kartvy',
    status: 'Status',
    regNumber: 'Reg.nr',
    name: 'Namn',
    receivedTime: 'Mottagen tid',
    location: 'Plats',
    speed: 'Hastighet',
    direction: 'Riktning',
    acc: 'ACC',
    selectAll: 'Välj alla',
    deselectAll: 'Avmarkera alla',
    live: 'Live',
    connecting: 'Ansluter…',
    liveDelayed: 'Live (fördröjd)',
    dataStaleWarning:
      'Realtidsdata har inte uppdaterats på {{minutes}} min. Kartläget kan vara inaktuellt tillfälligt (nät, enhet eller drift). Vid ihållande problem: kontakta support.',
    pollingFallback: 'Uppdaterar positioner regelbundet som reserv när Live är aktiv.',
    saveAsStartView: 'Spara denna vy som startvy',
    goToStartView: 'Gå till sparad startvy',
    exitFullscreen: 'Avsluta fullskärm',
    fullscreen: 'Fullskärm',
    driving: 'körande',
    noDataOver1h: 'Ingen data >1h',
    loadingMap: 'Laddar karta...',
    noVehiclesSelected: 'Inga fordon valda',
    regNr: 'Reg.nr',
    statusDriving: 'Kör',
    statusStationary: 'Stillastående',
    statusStaleParked: 'Parkerad, ingen data >1h',
    statusLostWhileDriving: 'Körde, saknar kontakt >1h',
    statusNoContact: 'Saknar kontakt >6h',
    markerLegendDriving: 'Kör',
    markerLegendStationary: 'Stillastående (<1h)',
    markerLegendStaleParked: 'Parkerad, ingen data >1h',
    markerLegendLostWhileDriving: 'Körde, saknar kontakt >1h',
    markerLegendNoContact: 'Saknar kontakt >6h',
    lostWhileDrivingHint: 'Körde senast — ingen data på {{minutes}} min',
    lastSeenMinutesAgo: 'Senast sedd: {{minutes}} min sedan',
    ignitionOn: 'På',
    ignitionOff: 'Av',
    mapNotReady: 'Kartan är inte redo',
    restoredToSavedView: 'Återställd till sparad vy',
    areaFilter: {
      title: 'Filtrera område',
      open: 'Områdesfilter',
      active: '{{count}} fordon i område',
      clear: 'Rensa områdesfilter',
      help: 'Rita ett område på kartan (minst 3 punkter). Välj om du vill se fordon efter placeringsort eller aktuell position.',
      modePlacement: 'Placeringsort i området',
      modeCurrent: 'Befinner sig nu i området',
      privateExcluded: 'Fordon som enligt schema är privata visas inte.',
      apply: 'Filtrera',
      resultCount: '{{count}} fordon matchar filtret',
      error: 'Kunde inte filtrera fordon i området',
      placementMarker: 'Placeringsort',
      placementClusterCount: '{{count}} fordon på samma plats',
      drawOnMapHint: 'Håll ner musknappen och dra en rektangel på kartan.',
      placementModeActive: 'Visar placeringsort (lila prickar)',
    },
  },

  // CRM
  crm: {
    title: 'CRM',
    crmModule: 'Kundhantering',
    economyModule: 'Ekonomi',
    // Dashboard-sidan
    customers: 'Kunder',
    customersDescription: 'Hantera kundkort och kontakter',
    projects: 'Projekt',
    projectsDescription: 'Pågående och planerade projekt',
    procurements: 'Upphandlingar',
    procurementsDescription: 'LOU och anbudsprocesser',
    pipeline: 'Säljpipeline',
    pipelineDescription: 'Försäljningstratt och leads',
    economyOverview: 'Ekonomisk översikt',
    economyOverviewDescription: 'Rullande 12, trender och intäkter',
    invoices: 'Fakturaunderlag',
    invoicesDescription: 'Generera och hantera fakturor',
    pricelist: 'Prislista',
    pricelistDescription: 'Tjänster, material och priser',
    scbTesting: 'SCB API Testning',
    scbTestingDescription: 'Testa SCB API endpoints och visa resultat',
    moduleCatalog: {
      title: 'Modulkatalog',
      dashboardDescription: 'Översikt över alla moduler och funktioner',
      searchPlaceholder: 'Sök modul, syfte, funktion...',
      versionFilter: 'Version',
      allVersions: 'Alla versioner',
      sync: 'Synka',
      syncDone: 'Synkat: {{inserted}} nya, {{updated}} uppdaterade',
      syncError: 'Synk misslyckades',
      addCustom: 'Lägg till egen',
      editEntry: 'Redigera modul',
      exportPdf: 'Exportera PDF',
      exportError: 'Export misslyckades',
      exportGenerated: 'Genererad {{date}}',
      exportPageOf: 'Sida {{page}} av {{pages}}',
      empty: 'Inga moduler hittades.',
      customBadge: 'Egen',
      appBadge: 'App',
      confirmDelete: 'Ta bort/inaktivera denna post?',
      systemKey: 'System (nyckel)',
      systemName: 'Systemnamn',
      name: 'Modulnamn',
      purpose: 'Syfte',
      functions: 'Funktioner',
      requirementsNotes: 'Krav-noteringar (Skall/Börkrav)',
    },
    // Kundlista
    searchCustomerPlaceholder: 'Sök kund, org.nr, stad...',
    allStatus: 'Alla status',
    totalLabel: 'Totalt',
    contactsLabel: 'Kontakter',
    notesLabel: 'Anteckningar',
    statusAndType: 'Status & typ',
    signupDomains: 'Registreringsdomän',
    signupDomainsHelp:
      'Max en domän per kund. Om en användare registrerar sig med e-post från denna domän kopplas kontot automatiskt till kundens organisation med rollen Viewer.',
    signupDomainsEmpty: 'Ingen domän tillagd',
    signupDomainsListTitle: 'Sparad registreringsdomän',
    signupDomainsAddedAt: 'Tillagd {{date}}',
    signupDomainsNoOrg:
      'Kunden behöver en kopplad organisation (aktiv kund) innan du kan lägga till registreringsdomäner.',
    signupDomainPlaceholder: 't.ex. foretag.se',
    signupDomainAdd: 'Lägg till',
    signupDomainSave: 'Spara domän',
    signupDomainSaved: 'Domän sparad',
    signupDomainRemove: 'Ta bort domän',
    signupDomainsLoadError: 'Kunde inte ladda domäner',
    signupDomainAdded: 'Domän tillagd',
    signupDomainAddError: 'Kunde inte lägga till domän',
    signupDomainRemoved: 'Domän borttagen',
    signupDomainRemoveError: 'Kunde inte ta bort domän',
    newCustomer: 'Ny kund',
    createCustomer: 'Skapa ny kund',
    editCustomer: 'Redigera kund',
    deleteCustomer: 'Ta bort kund',
    deleteCustomerConfirm: 'Är du säker på att du vill ta bort denna kund?',
    // Kontakter
    contacts: 'Kontakter',
    newContact: 'Ny kontakt',
    editContact: 'Redigera kontakt',
    deleteContact: 'Ta bort kontakt',
    // Status
    statusProspect: 'Prospekt',
    statusActive: 'Aktiv',
    statusPaused: 'Pausad',
    statusAtRisk: 'Risk',
    billingStartsOn: 'Fakturering från',
    billingStartsOnShort: 'Fakturering från',
    billingStartsOnHelp: 'Datum då kunden ska börja faktureras. Lämna tomt om det inte är bestämt.',
    billingStartsOnNotSet: 'Ej angivet',
    // Typ
    typeMunicipality: 'Kommun',
    typeRegion: 'Region',
    typePrivate: 'Privat',
    typePartner: 'Partner',
    typeCarRental: 'Biluthyrare',
    carRental: 'Biluthyrare',
    // Federation / SSO
    federation: 'Federation',
    federationDescription: 'Konfigurera Single Sign-On (SSO) för kunden',
    saml: 'SAML 2.0',
    oidc: 'OpenID Connect',
    samlConfig: 'SAML-konfiguration',
    oidcConfig: 'OIDC-konfiguration',
    entityId: 'Entity ID / Issuer',
    ssoUrl: 'SSO URL',
    sloUrl: 'SLO URL (Single Logout)',
    certificate: 'IdP Certifikat',
    nameIdFormat: 'NameID Format',
    issuerUrl: 'Issuer URL',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    scopes: 'Scopes',
    provider: 'Provider',
    activateSaml: 'Aktivera SAML 2.0',
    activateOidc: 'Aktivera OpenID Connect',
    spMetadata: 'Service Provider Metadata',
    redirectUri: 'Redirect URI',
    configuredButInactive: 'Konfigurerad men inaktiv',
    notConfigured: 'Ej konfigurerad',
    saveSaml: 'Spara SAML',
    updateSaml: 'Uppdatera SAML',
    saveOidc: 'Spara OIDC',
    updateOidc: 'Uppdatera OIDC',
    deleteSaml: 'Ta bort SAML',
    deleteOidc: 'Ta bort OIDC',
    samlCreated: 'SAML-konfiguration skapad',
    samlUpdated: 'SAML-konfiguration uppdaterad',
    samlDeleted: 'SAML-konfiguration borttagen',
    oidcCreated: 'OIDC-konfiguration skapad',
    oidcUpdated: 'OIDC-konfiguration uppdaterad',
    oidcDeleted: 'OIDC-konfiguration borttagen',
    customerMustBeActivated: 'Kunden måste aktiveras för att kunna konfigurera federation',
    // Nya översättningar för formulär
    municipality: 'Kommun',
    region: 'Region',
    privateCompany: 'Privat företag',
    partner: 'Partner',
    loadCustomerError: 'Kunde inte ladda kund',
    fetchCorporateStructureError: 'Kunde inte hämta koncernstruktur',
    customerUpdated: 'Kund uppdaterad',
    saveContactError: 'Kunde inte spara kontakt',
    ssoUrlAndCertRequired: 'SSO URL och certifikat krävs',
    saveSamlError: 'Kunde inte spara SAML-konfiguration',
    samlConfigRemoved: 'SAML-konfiguration borttagen',
    deleteSamlError: 'Kunde inte ta bort SAML-konfiguration',
    issuerAndClientIdRequired: 'Issuer URL och Client ID krävs',
    saveOidcError: 'Kunde inte spara OIDC-konfiguration',
    oidcConfigRemoved: 'OIDC-konfiguration borttagen',
    deleteOidcError: 'Kunde inte ta bort OIDC-konfiguration',
    createApiKeyError: 'Kunde inte skapa API-nyckel',
    deactivateApiKeyError: 'Kunde inte inaktivera API-nyckel',
    updateEndpointAccessError: 'Kunde inte uppdatera endpoint-access',
    loadPricelistError: 'Kunde inte ladda prislistan',
    saveProductError: 'Kunde inte spara produkt',
    duplicateProductCode: 'Produktkoden finns redan – välj en unik kod',
    deleteProductError: 'Kunde inte ta bort produkt',
    // Pricelist tabs
    tabProducts: 'Produkter & Tjänster',
    tabPackages: 'System-paket',
    // Categories
    categoriesTitle: 'Kategorier',
    allProducts: 'Alla produkter',
    // Product table headers
    colCode: 'Kod',
    colName: 'Namn',
    colType: 'Typ',
    colPricingModel: 'Prismodell',
    colPrice: 'Pris',
    colUnit: 'Enhet',
    newProduct: 'Ny produkt',
    noProductsInCategory: 'Inga produkter i denna kategori',
    // Product modal
    editProduct: 'Redigera produkt',
    // Product type labels
    productTypeService: 'Tjänst',
    productTypeMaterial: 'Material',
    productTypeBundle: 'Paket',
    // Pricing type labels
    pricingHourly: 'Per timme',
    pricingMonthly: 'Per månad',
    pricingPerVehicle: 'Per fordon',
    pricingPerUser: 'Per användare',
    pricingOneTime: 'Engångs',
    pricingCustom: 'Anpassad',
    // Product form labels
    labelCode: 'Kod',
    labelCategory: 'Kategori',
    labelName: 'Namn *',
    labelDescription: 'Beskrivning',
    labelProductType: 'Produkttyp',
    labelPricingModel: 'Prismodell',
    labelPrice: 'Pris (SEK)',
    labelUnit: 'Enhet',
    noCategory: 'Ingen kategori',
    unitPlaceholder: 'st, tim, månad...',
    productCreated: 'Produkt skapad',
    productUpdated: 'Produkt uppdaterad',
    productDeleted: 'Produkt borttagen',
    confirmDeleteProduct: 'Ta bort produkt?',
    // CustomerDetail
    customerNotFound: 'Kund hittades inte',
    backToCustomerList: '← Tillbaka till kundlistan',
    activateCustomer: 'Aktivera kund',
    activating: 'Aktiverar...',
    edit: 'Redigera',
    save: 'Spara',
    cancel: 'Avbryt',
    tabInfo: 'Kundinfo',
    tabServices: 'Tjänster',
    tabStatistics: 'Statistik',
    tabFederation: 'Federation',
    companyInfoTitle: 'Företagsinformation',
    contactsTitle: 'Kontaktpersoner',
    addContact: 'Lägg till',
    noContacts: 'Inga kontaktpersoner',
    primaryBadge: 'Primär',
    noNotes: 'Inga anteckningar',
    labelStatus: 'Status',
    labelCustomerType: 'Kundtyp',
    companyRegister: 'Företagsregister',
    loadingCheckbiz: 'Laddar data från Checkbiz...',
    noCheckbizData: 'Ingen data hittades för organisationsnummer {{orgNumber}}',
    checkbizApiNote: '(Checkbiz API kan vara okonfigurerat eller organisationsnumret finns inte i registret)',
    vehiclesInGroup: 'Fordon i koncernen ({{total}} totalt)',
    companyGroupTitle: 'Koncernstruktur ({{count}} bolag)',
    fetchAndSave: 'Hämta & Spara',
    orgNumber: 'Org.nr',
    ownerShare: 'Ägarandel',
    labelOrgNumber: 'Organisationsnummer',
    labelAddress: 'Adress',
    labelPostalCode: 'Postnummer',
    labelCity: 'Ort',
    labelWebsite: 'Webbplats',
    partnerSupportTitle: 'Supportkontakt i appen',
    partnerSupportHint: 'Visas i chattbubblan för användare hos denna kund. Inte Deques e-post. Tomma fält ärvs från överordnad partner.',
    partnerSupportShow: 'Visa partnerns e-post och telefon i appen',
    partnerSupportEmail: 'Partnerns support-e-post',
    partnerSupportPhone: 'Partnerns supporttelefon',
    labelSniCode: 'SNI-kod',
    labelSizeClass: 'Storleksklass',
    // CustomerWizard
    wizard: {
      basicInfo: 'Grundläggande information',
      addressContact: 'Adress & Kontakt',
      contactPerson: 'Kontaktperson',
      pricing: 'Prissättning',
      summary: 'Sammanfattning',
      companyName: 'Företagsnamn *',
      orgNumber: 'Organisationsnummer',
      customerType: 'Kundtyp *',
      statusLabel: 'Status *',
      statusProspect: 'Prospect',
      statusProspectNote: '(ingen organisation skapas)',
      statusActive: 'Aktiv',
      statusActiveNote: '(skapar organisation)',
      address: 'Adress',
      postalCode: 'Postnummer',
      city: 'Ort',
      website: 'Webbplats',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      email: 'E-post',
      emailRequired: 'E-post är obligatorisk för kontaktpersonen',
      phone: 'Telefon',
      mobile: 'Mobil',
      role: 'Roll',
      sendWelcomeEmail: 'Skicka välkomstmail och skapa användarkonto',
      sendWelcomeEmailDesc: 'Kontaktpersonen får ett mail med en länk för att aktivera sitt konto som Administratör i DQFleet.',
      pricingModel: 'Prismodell',
      monthlyFee: 'Månadsavgift (kr)',
      pricePerVehicle: 'Pris per fordon (kr/månad)',
      pricePerUser: 'Pris per användare (kr/månad)',
      perVehicle: 'Per fordon',
      customPricing: 'Anpassad',
      notes: 'Anteckningar',
      noOrgNumber: 'Inget org.nr',
      statusActiveLabel: '✓ Aktiv (organisation skapas)',
      pricingLabel: 'Prismodell',
      back: 'Tillbaka',
      next: 'Nästa',
      creating: 'Skapar...',
      createCustomer: 'Skapa kund',
      municipality: 'Kommun',
      region: 'Region',
      partner: 'Partner',
      carRental: 'Biluthyrare',
      roleDecisionMaker: 'Beslutsfattare',
      roleTechnical: 'Teknisk kontakt',
      roleBilling: 'Faktura',
      roleOther: 'Övrig',
    },
    loadSystemConfigError: 'Kunde inte ladda systemkonfiguration',
    changeSystemStatusError: 'Kunde inte ändra systemstatus',
    changeModuleStatusError: 'Kunde inte ändra modulstatus',
    loadCustomersError: 'Kunde inte ladda kunder',
    // Tabs
    tabs: {
      devices: 'Enheter',
      vehicleOrg: 'Org.nr Fordon',
    },
    // Org.nr för fordonshantering
    vehicleOrg: {
      title: 'Organisationsnummer för fordonshantering',
      orgNumber: 'Organisationsnummer',
      companyName: 'Företagsnamn',
      companyNamePlaceholder: 'Valfritt företagsnamn',
      source: 'Källa',
      sourceKoncern: 'Koncern',
      sourceManual: 'Manuell',
      fetchFromKoncern: 'Hämta från koncernstruktur',
      addManual: 'Lägg till manuellt',
      empty: 'Inga organisationsnummer registrerade',
      emptyHint: 'Klicka "Hämta från koncernstruktur" för att fylla i från koncernens bolag',
      alreadyExists: 'Organisationsnumret finns redan registrerat',
      totalCount: '{{count}} organisationsnummer registrerade',
    },
    // Kundenheter-flik
    customerDevices: {
      inVehicle: 'I fordon',
      customerStock: 'Kundlager',
      total: 'Totalt antal enheter',
      searchPlaceholder: 'Sök IMEI, regnr...',
      allStatuses: 'Alla statusar',
      noDevices: 'Inga enheter kopplade till denna kund',
      noMatch: 'Inga enheter matchade filtret',
      updated: 'Uppdaterad',
    },
  },

  projects: {
    devTitle: 'Produktutveckling',
    newProject: 'Nytt projekt',
    projectName: 'Projektnamn',
    selectCustomer: 'Välj kund',
    searchPlaceholder: 'Sök projekt...',
    allStatuses: 'Alla statusar',
    noProjects: 'Inga projekt hittades',
    openTasks: 'öppna uppgifter',
    addTask: 'Lägg till uppgift',
    editTask: 'Redigera uppgift',
    editProject: 'Redigera projekt',
    taskTitle: 'Uppgift',
    subtasks: 'Deluppgifter',
    subtaskPlaceholder: 'Ny deluppgift...',
    subtasksProgress: '{{done}} av {{total}} klara',
    milestone: 'Milstolpe',
    milestones: 'Milstolpar',
    milestoneName: 'Milstolpens namn',
    priority: 'Prioritet',
    plannedStart: 'Planerad start',
    plannedEnd: 'Planerat slut',
    budget: 'Budget',
    actualCost: 'Faktisk kostnad',
    billingType: 'Fakturering',
    hourlyRate: 'Timpris',
    billingTypes: {
      fixed: 'Fast pris',
      hourly: 'Per timme',
      milestone: 'Per milstolpe',
    },
    totalHours: 'Totalt timmar',
    timeTracking: 'Tidrapportering',
    hours: 'Timmar',
    logTime: 'Logga tid',
    billable: 'Fakturerbar',
    noTask: 'Ingen uppgift',
    dependsOn: 'Beror på',
    projectType: 'Projekttyp',
    manager: 'Projektledare',
    primaryContact: 'Huvudkontakt',
    primaryContactHint: 'Användare i kundens organisation (ej globala administratörer).',
    owner: 'Ägare',
    assignedTo: 'Tilldelad till',
    notAssigned: 'Ej tilldelad',
    globalAdmin: 'Global admin',
    managerCandidatesHint: 'Kundens administratörer och globala administratörer.',
    ownerCandidatesHint: 'Endast globala administratörer.',
    releaseTarget: 'Målversion',
    component: 'Komponent',
    featureCode: 'Feature-kod',
    tabs: {
      overview: 'Översikt',
      kanban: 'Kanban',
      gantt: 'Gantt',
      milestones: 'Milstolpar',
      time: 'Tid',
    },
    stats: {
      total: 'Totalt',
      active: 'Aktiva',
      myTasks: 'Mina uppgifter',
      overdue: 'Försenade',
      hoursWeek: 'Timmar denna vecka',
    },
    status: {
      planned: 'Planerad',
      active: 'Aktiv',
      on_hold: 'Pausad',
      completed: 'Slutförd',
      cancelled: 'Avbruten',
    },
    taskStatus: {
      backlog: 'Backlog',
      todo: 'Att göra',
      in_progress: 'Pågår',
      review: 'Granskning',
      done: 'Klar',
      cancelled: 'Avbruten',
    },
    priorityLevel: {
      low: 'Låg',
      normal: 'Normal',
      high: 'Hög',
      urgent: 'Akut',
    },
    types: {
      implementation: 'Implementation',
      migration: 'Migration',
      upgrade: 'Uppgradering',
      integration: 'Integration',
      consulting: 'Konsulting',
      other: 'Övrigt',
    },
    components: {
      backend: 'Backend',
      frontend: 'Frontend',
      mobile: 'Mobil',
      gateway: 'Gateway',
      infra: 'Infrastruktur',
      other: 'Övrigt',
    },
    gantt: {
      task: 'Uppgift',
      noData: 'Ingen tidsplan – lägg till datum på uppgifter',
      unassignedTasks: 'Uppgifter utan milstolpe',
      holiday: 'Röd dag',
      dependencies: 'Beroenden',
      criticalPath: 'Kritisk väg',
      tasks: 'uppgifter',
    },
  },

  // Fleet
  fleet: {
    title: 'Fordonsflottan',
    overview: 'Fordonsflotta',
    backToDeque: 'Tillbaka till Deque',
    overviewDescription: 'Visa och hantera alla fordon',
    liveTrackingDescription: 'Se fordon i realtid på kartan',
    vehicle: 'Fordon',
    status: 'Status',
    position: 'Position',
    speed: 'Hastighet',
    noVehicles: 'Inga fordon hittades',
    tryAllOrganizations: 'Prova att välja "Alla organisationer" i filtret.',
    loading: 'Laddar fordon...',
    error: 'Kunde inte ladda fordon',
    searchPlaceholder: 'Sök regnr, IMEI, märke, modell, org, bränsletyp, postnummer, ort, fordonskategori, utrustning, ägd, leasad…',
    searchPlaceholderShort: 'Sök regnr, IMEI, märke, modell, referens, utrustning, ägd eller leasad …',
    ownershipColumn: 'Ägd / leasad / leasing avslutad',
    ownershipOwned: 'Ägd',
    ownershipLeased: 'Leasad',
    ownershipLeaseEnded: 'Leasing avslutad',
    filterBarLabel: 'Filter',
    columnFilterToggle: 'Kolumnfilter',
    columnFilterToggleHint: 'Visa/dölj en sökruta per kolumn för att filtrera listan',
    showing: 'Visar',
    of: 'av',
    vehicles: 'fordon',
    page: 'Sida',
    first: 'Första',
    last: 'Sista',
    lastSeen: 'Senast sedd',
    placementCity: 'Ort',
    referenceNumber: 'Referens',
    referenceChooseOrType: 'Välj eller skriv',
    organization: 'Organisation',
    connected: 'Kopplad',
    filterAll: 'Alla',
    filterConnected: 'Kopplade',
    filterDisconnected: 'Okopplade',
    filterAllOrganizations: 'Alla organisationer',
    systemStatus: 'Systemstatus',
    filterPreset: 'Filter',
    filterPresetAll: 'Alla',
    filterPoolcars: 'Alla poolbilar',
    filterMil: 'Motorlampa lyser (MIL)',
    filterTaxDue: 'Skatt inom 45 dagar',
    filterInspectionDue: 'Besiktning inom 40 dagar',
    filterUsageStatus: 'Status',
    exportVehicleRegister: 'Fordonsbestånd',
    exportVehicleRegisterExcel: 'Excel',
    exportVehicleRegisterCsv: 'CSV',
    exportVehicleRegisterSuccess: 'Exporten har laddats ner',
    exportVehicleRegisterError: 'Kunde inte exportera fordonsbestånd',
    exportCarInfoVehicleReportExcel: 'Fordonsrapport Excel',
    exportCarInfoVehicleReportSuccess: 'Fordonsrapporten har laddats ner',
    exportCarInfoVehicleReportError: 'Kunde inte exportera fordonsrapport',
    exportFleetReport: 'Fordonsrapport',
    exportFleetReportExcel: 'Excel',
    exportFleetReportCsv: 'CSV',
    exportFleetReportSuccess: 'Fordonsrapporten har laddats ner',
    exportFleetReportError: 'Kunde inte exportera fordonsrapport',
    // Status översättningar
    statusActive: 'Aktiv',
    statusMaintenance: 'Underhåll',
    statusInactive: 'Inaktiv',
    statusRetired: 'Avställd',
    // Funktioner
    functions: 'Funktioner',
    deactivate: 'Inaktivera fordon',
    activateVehicle: 'Återaktivera fordon',
    confirmActivate:
      'Vill du återaktivera fordonet {{reg}}?\n\nStatus sätts till aktiv. Om en GPS-enhet fortfarande är kopplad öppnas ett nytt monteringsspann i enhetshistoriken så att data kan attribueras till bilen igen.',
    activatedSuccess: 'har återaktiverats',
    connectDevice: 'Koppla enhet',
    connectKey: 'Koppla nyckel',
    subscribe: 'Prenumerera på rapporter',
    milError: 'Motorfel - lampan tänd',
    milNoData: 'Data ej tillgänglig',
    milOk: 'Inga fel',
    fuelLevel: 'Bränsle(%)',
    fuelEvTooltip: 'Bränsle % (EV batteri %)',
    evRange: 'Räckvidd',
    serviceDistance: 'Km till service',
    installedTires: 'Monterade däck',
    imeiColumn: 'IMEI',
    imeiFirmware: 'Firmware',
    imeiConfig: 'Konfiguration',
    imeiUnknown: 'okänd',
    currentOdometer: 'Nuvarande mätarställning',
    flinkeyBoxColumn: 'flinkey box',
    transmissionColumn: 'Växellåda',
    pickupPlacementColumn: 'Utlämningsplats',
    businessResponsibilityColumn: 'Verksamhetsansvar',
    assignedUserColumn: 'Kopplad användare',
    vehicleCategoryColumn: 'Fordonskategori',
    alternativeFuelColumn: 'Alternativt drivmedel',
    vehicleStatusColumn: 'Status',
    noUsageStatus: 'Ingen status',
    columnSettings: {
      button: 'Kolumner',
      title: 'Tabellkolumner',
      description: 'Välj vilka kolumner som ska visas och i vilken ordning. Dra synliga rader för att ändra ordning. Inställningen sparas på ditt användarkonto.',
      fixedHint: 'Kolumnen Fordon visas alltid först och Funktioner alltid sist.',
      searchPlaceholder: 'Sök kolumn...',
      noResults: 'Inga kolumner matchar sökningen',
      visibleColumns: 'Synliga kolumner',
      hiddenColumns: 'Dolda kolumner',
      dragHint: 'Dra för att ändra ordning',
      reset: 'Återställ standard',
      saveSuccess: 'Kolumninställningar sparade',
      saveError: 'Kunde inte spara kolumninställningar',
      resetSuccess: 'Kolumner återställda till standard',
    },
    // Fordonsdetaljer
    make: 'Märke',
    model: 'Modell',
    year: 'Årsmodell',
    fuelType: 'Bränsletyp',
    sitplatser: 'Sittplatser',
    costCenter: 'Kostnadsställe',
    initialOdometer: 'Ingående mätarställning (km)',
    initialOdometerHint: 'Mätarställning vid registrering',
    isPoolcar: 'Poolbil',
    sharedCompanyCar: 'Delad företagsbil',
    sharedCompanyCarHint: 'Flera personer kan köra bilen. Appen hör GPS-enheten och visar vem som var med.',
    registrationNumber: 'Registreringsnummer',
    // Bränsletyper
    fuelTypes: {
      petrol: 'Bensin',
      diesel: 'Diesel',
      electric: 'El',
      hybrid: 'Hybrid',
      pluginHybrid: 'Laddhybrid',
      gas: 'Gas',
      ethanol: 'Etanol',
    },
    // Lägg till fordon
    addVehicle: {
      button: 'Nytt fordon',
      title: 'Registrera nytt fordon',
      fetchCarInfo: 'Hämta från Car.info',
      fetched: 'Hämtad',
      enterRegNumber: 'Ange registreringsnummer först',
      carInfoSuccess: 'Fordonsdata hämtad från Car.info',
      carInfoNotFound: 'Fordon hittades inte i Car.info',
      carInfoLoaded: 'Fordonsdata laddad från Car.info',
      stolenWarning: 'VARNING: Detta fordon är anmält stulet!',
      drivingBanWarning: 'VARNING: Detta fordon har körförbud!',
      regRequired: 'Registreringsnummer krävs',
      orgRequired: 'Välj en organisation',
      selectOrg: 'Välj organisation',
      success: 'Fordon registrerat!',
      error: 'Kunde inte skapa fordon',
      save: 'Spara fordon',
    },
  },

  // flinkey (digital nyckelhantering)
  flinkey: {
    sectionTitle: 'flinkey (digital nyckel)',
    attach: 'Koppla flinkey',
    detach: 'Ta bort koppling',
    assignKey: 'Tilldela nyckel',
    boxIdPlaceholder: 'flinkey box-id',
    assignModalTitle: 'Tilldela digital nyckel',
    assignUser: 'Användare (ID)',
    validFrom: 'Giltig från (valfritt)',
    validUntil: 'Giltig till (valfritt)',
    assign: 'Tilldela',
    selectBox: '— Välj box —',
    noBoxesForOrg: 'Inga Flinkey-boxar registrerade för organisationen',
    notLicensedForOrg: 'Inga Flinkey-boxar registrerade för organisationen',
    listLoadError: 'Kunde inte hämta Flinkey-boxar. Kontrollera nätverk eller behörighet.',
    noBoxLinked: 'Ingen Flinkey-box kopplad till fordonet',
    chooseBox: 'Välj box',
    changeBox: 'Byt box',
    orgBoxCount: '{{count}} box(ar) i organisationen (inkl. överordnade)',
    searchBoxesPlaceholder: 'Sök produkt-id, serienummer eller registreringsnummer…',
    searchNoHits: 'Inga boxar matchar sökningen',
    boxOnOtherVehicle: 'Kopplad till fordon {{reg}} — välj för att flytta till detta fordon',
    boxUnassigned: 'Ledig box (inget fordon)',
    currentBoxBadge: 'Detta fordon',
  },

  // Car.info Filter
  carInfoFilter: {
    title: 'Filter',
    addFilter: 'Lägg till filter',
    noFilters: 'Inga filter valda',
    noFiltersAdded: 'Inga filter tillagda',
    addFilterHint: 'Klicka på "Lägg till filter" för att börja',
    enterValue: 'Ange värde...',
    search: 'Sök',
    clear: 'Rensa',
    loadError: 'Kunde inte ladda filter',
    searchError: 'Sökningen misslyckades',
    vehiclesFound: 'fordon hittades',
    filterButton: 'Fordonsfilter',
    searchFields: 'Sök fält...',
    searching: 'Söker...',
    searchButton: 'Sök',
    cancel: 'Avbryt',
    noFiltersConfigured: 'Inga filter konfigurerade',
    enableFiltersHint: 'Aktivera filter i SysAdmin → Fordonsfilter',
    selectFilterValue: 'Välj minst ett filtervärde',
    vehiclesFoundCount: '{count} fordon hittades',
    resultIdsMissing: 'Sökningen hittade fordon men kunde inte visa dem i listan',
    searchFailed: 'Sökningen misslyckades',
    allOption: '-- Alla --',
    otherCategory: 'Övrigt',
    loadingValues: 'Laddar värden...',
  },

  // Car.info Filter Configuration (admin page)
  carInfoFilterConfig: {
    title: 'Car.info Filter-konfiguration',
    subtitle: 'Välj vilka Car.info-fält som ska visas i filtret i Fordonsflottan.',
    activeFilters: 'Aktiva filter',
    totalFields: 'Totalt antal fält',
    categories: 'Kategorier',
    showActiveOnly: 'Visa endast aktiva',
    expandAll: 'Expandera alla',
    collapseAll: 'Kollapsa alla',
    reload: 'Ladda om',
    fieldsCount: 'fält',
    noFieldsFound: 'Inga fält hittades',
    adjustSearch: 'Prova att ändra sökningen eller ta bort filtret',
    loadError: 'Kunde inte ladda filter-konfiguration',
    errorToggle: 'Kunde inte uppdatera fält',
    activated: 'Aktiverade',
    deactivated: 'Inaktiverade',
    fields: 'fält',
    uncategorized: 'Okategoriserat',
    examplePrefix: 'Ex',
  },

  // SMS
  sms: {
    title: 'Skicka SMS-kommando',
    message: 'Meddelande',
    send: 'Skicka',
    sending: 'Skickar...',
    sent: 'SMS skickat!',
    sentSuccess: 'SMS skickat!',
    sentDescription: 'Meddelandet har skickats till enheten.',
    hint: 'Kommandot börjar med två blanksteg för autentisering',
    noImei: 'Fordonet har ingen kopplad enhet (IMEI saknas)',
    emptyMessage: 'Meddelandet kan inte vara tomt',
    messageId: 'Meddelande-ID',
    status: 'Status',
    statusDelivered: 'Levererat',
    statusSent: 'Skickat',
    statusPending: 'Väntar',
    statusFailed: 'Misslyckades',
    statusCancelled: 'Avbrutet',
  },

  // Reports
  reports: {
    title: 'Rapporter',
    comingSoon: 'Rapporter kommer snart...',
    bookingStats: {
      title: 'Bokningsstatistik',
      description: 'Volym, beläggning, request-flöde, tidsuppskattning, aktivering till Flinkey och trend för bokningar.',
      from: 'Från',
      to: 'Till',
      granularity: 'Tidsupplösning',
      granularityDay: 'Dag',
      granularityWeek: 'Vecka',
      granularityMonth: 'Månad',
      basis: 'Beläggningsbas',
      basisCalendar: 'Kalenderdygn',
      basisWorkdays: 'Arbetsdagar',
      pickupLocation: 'Utlämningsplats',
      allPickupLocations: 'Alla platser',
      allOrganizations: 'Alla organisationer',
      refresh: 'Uppdatera',
      loadError: 'Kunde inte hämta bokningsstatistik.',
      noData: 'Ingen data för perioden.',
      totalBookings: 'Bokningar totalt',
      requestFlow: 'Request / tilldelade',
      requestSharePct: 'Andel request: {{pct}}%',
      occupancy: 'Beläggningsgrad',
      avgLength: 'Snittlängd',
      uniqueBookers: 'Unika bokare',
      uniqueBookersSub: 'Konto, RSID eller namn',
      totalKm: 'Körsträcka (km)',
      vehicleCount: 'Antal fordon',
      noShow: 'No-show',
      noShowSub: 'Auto-frigjorda (ej uthämtade i tid)',
      serviceNotUsed: 'Servicebokningar ej använda',
      serviceNotUsedSub: 'Andel av servicebokningar: {{pct}}%',
      byStatus: 'Volym per status',
      byCarClass: 'Fördelning per bilklass',
      trend: 'Trend (volym)',
      topVehicles: 'Mest bokade fordon',
      timingTitle: 'Tidsuppskattning och Flinkey',
      timingHint: 'Gäller bokningar skapade efter att originaltid började sparas. I tid = inom ±{{minutes}} min mot originaltiden.',
      timingNoSamples: 'Inga bokningar med originaltid i perioden ännu.',
      pickupVsOriginal: 'Uthämtning vs original',
      returnVsOriginal: 'Återlämning vs original',
      activateToUnlock: 'Aktivering → Flinkey-öppning',
      avgDelta: 'Snittavvikelse',
      earlier: 'Tidigare',
      onTime: 'I tid',
      later: 'Senare',
      sampleCount: '{{count}} bokningar',
      unlockAvg: 'Snitt {{minutes}} min',
      unlockUnder2: 'Under 2 min',
      unlock2to5: '2–5 min',
      unlock5to15: '5–15 min',
      unlockOver15: 'Över 15 min',
    },
    energyConsumption: {
      title: 'Energiförbrukning',
      description: 'Analysera bränsleförbrukning per organisation och fordon',
    },
    speedCompliance: {
      title: 'Hastighetsefterlevnad',
      description: 'Analysera fordonens efterlevnad av hastighetsgränser',
    },
    vehicleWear: {
      title: 'Fordonsslitage',
      description: 'Analysera hur körbeteende påverkar fordonsslitage',
    },
    underutilized: {
      title: 'Underutnyttjade fordon',
      description: 'Identifiera fordon med lågt utnyttjande',
    },
    co2: {
      title: 'CO₂-utsläpp',
      description: 'Beräkna och analysera CO₂-utsläpp',
    },
    geofenceZone: {
      title: 'Geofence Zonrapport',
      description: 'Analysera hur ofta fordon befinner sig inom zoner',
    },
    fuelAnalysis: {
      title: 'Bränsleanalys',
      description: 'Analysera bränslekostnader och förbrukning från importerade transaktioner',
      totalCost: 'Total kostnad',
      totalLiters: 'Total volym',
      costPerMil: 'Kostnad per mil',
      avgPricePerLiter: 'Snittpris',
      cost: 'Kostnad',
      liters: 'Liter',
      fuelType: 'Bränsletyp',
      costByOrg: 'Kostnad per organisation',
      byFuelType: 'Per bränsletyp',
      costTrend: 'Kostnadstrend (kr/mil)',
      costVolumeTrend: 'Kostnad och volym per månad',
    },
    fleetTco: {
      title: 'Flottkostnadsanalys (TCO)',
      description: 'Total ägandekostnad per fordon: bränsle, service, leasing och försäkring',
      totalCost: 'Total kostnad',
      costPerKm: 'Kostnad per km',
      costPerMonth: 'Kostnad per månad',
      totalDistance: 'Total körsträcka',
      fuel: 'Bränsle',
      service: 'Service',
      leasing: 'Leasing',
      insurance: 'Försäkring',
      tax: 'Skatt/malus',
      total: 'Totalt',
      breakdown: 'Kostnadsnedbrytning',
      byFuelType: 'Kostnad per fordonstyp',
      vehicle: 'Fordon',
      tabs: {
        overview: 'Översikt',
        byType: 'Per fordonstyp',
      },
    },
    executive: {
      title: 'Ledningsrapport',
      statisticsTitle: 'Statistisk översikt',
      description: 'Övergripande KPI:er för hela flottan med kostnader, utnyttjande och CO₂',
      period: 'Period',
      periodWeek: 'Vecka',
      periodMonth: 'Månad',
      periodQuarter: 'Kvartal',
      periodYear: 'År',
      totalDistance: 'Total körsträcka',
      totalFuelCost: 'Bränslekostnad',
      totalTco: 'Total ägandekostnad',
      utilization: 'Utnyttjandegrad',
      co2: 'CO₂-utsläpp',
      activeVehicles: 'Aktiva fordon',
      costTrend: 'Kostnadstrend',
      co2Trend: 'CO₂-trend',
      topDeviations: 'Topp-5 avvikelser',
      exportPdf: 'Exportera PDF',
      noDeviations: 'Inga avvikelser för perioden',
    },
    vehicleKpi: {
      title: 'Nyckeltal fordon',
      description: 'Sammanställning av nyckeltal per fordon, månad och år',
      tabs: {
        overview: 'Organisationsöversikt',
        vehicleYear: 'Årsrapport/fordon',
        vehicleMonth: 'Fordon/månad',
      },
      filters: {
        organization: 'Organisation',
        year: 'År',
        vehicle: 'Fordon',
        month: 'Månad',
      },
      summary: {
        totalVehicles: 'Antal fordon',
        totalDistance: 'Total körsträcka',
        totalFuel: 'Total bränsle',
        avgFuelPer100km: 'Snitt L/100km',
        avgElectricShare: 'Snitt elandel',
        totalCo2: 'Total CO₂',
        totalDuration: 'Total körtid',
        totalIdling: 'Total tomgångstid',
        daysDriven: 'Körda dagar',
      },
      columns: {
        registrationNumber: 'RegNr',
        organization: 'Grupp',
        make: 'Märke',
        model: 'Modell',
        period: 'Period',
        date: 'Datum',
        month: 'Månad',
        distanceKm: 'Sträcka (km)',
        fuelL: 'Bränsle (L)',
        fuelPer100km: 'Snitt (L/100km)',
        electricSharePct: 'Elandel',
        co2Kg: 'CO₂ (kg)',
        daysDriven: 'Körda dagar',
        kmPerDay: 'Km/dag',
        duration: 'Körtid',
        avgSpeed: 'Medelhast.',
        idling: 'Tomgång',
        status: 'Status',
        fuelType: 'Bränsletyp',
        trend: 'Trend',
      },
      status: {
        active: 'Aktiv',
        inactive: 'Inaktiv',
        sold: 'Såld',
      },
      breadcrumb: {
        overview: 'Översikt',
        backToOverview: 'Tillbaka till översikt',
        backToYear: 'Tillbaka till årsrapport',
      },
      export: 'Exportera CSV',
      noData: 'Ingen data hittades för vald period',
      selectOrganization: 'Välj organisation för att visa fordon',
      selectVehicleForYear: 'Årssummering per fordon. Klicka på ett fordon för månadsfördelning.',
      selectVehicleForMonth: 'Välj fordon i listan för att se dagsfördelning för vald månad.',
    },
    dtc: {
      title: 'DTC-felrapport',
      description: 'Visa och analysera diagnostiska felkoder (DTC) per fordon',
      activeDtc: 'Aktiva DTC',
      vehiclesWithDtc: 'Fordon med DTC',
      highSeverity: 'Hög/Kritisk',
      lowSeverity: 'Låg/Medium',
      byCategory: 'Per kategori',
      bySeverity: 'Per allvarlighetsgrad',
      topCodes: 'Vanligaste felkoder',
      code: 'DTC-kod',
      category: 'Kategori',
      severity: 'Allvarlighet',
      firstSeen: 'Första gång',
      lastSeen: 'Senast sedd',
      resolvedAt: 'Löst',
      active: 'Aktiv',
      resolved: 'Löst',
      codeSearch: 'DTC-sökning',
      searchTitle: 'Sök DTC-kod',
      whatDoesItMean: 'Vad betyder det?',
      symptoms: 'Symptom',
      causes: 'Möjliga orsaker',
      repairSteps: 'Diagnos & reparation',
      notAvailable: 'Uppgifter ej tillgängliga',
      notAvailableDetailed: 'DQFleet har inte dessa uppgifter tillgängliga nu. Koden finns i databasen men saknar beskrivning.',
      noDetailedInfo: 'Ingen detaljerad information tillgänglig för denna felkod.',
    },
    workTrips: {
      title: 'Arbetsresor',
      description: 'Resor med delade företagsbilar, med förare och om någon identifierades via appen',
      filtersTitle: 'Fordon och period',
      vehicleLabel: 'Fordon',
      allVehicles: 'Alla delade fordon',
      fromDate: 'Från datum',
      toDate: 'Till datum',
      identificationLabel: 'Identifiering',
      identificationAll: 'Alla resor',
      identificationIdentified: 'Identifierade via app',
      identificationUnidentified: 'Utan identifiering',
      fetch: 'Hämta resor',
      fetchError: 'Kunde inte hämta arbetsresor',
      tripCount: 'Resor',
      identifiedCount: 'Identifierade via app',
      unidentifiedCount: 'Utan identifiering',
      totalDistance: 'Körd sträcka',
      colVehicle: 'Fordon',
      colDate: 'Datum',
      colTime: 'Tid',
      colFrom: 'Från',
      colTo: 'Till',
      colDistance: 'Sträcka',
      colDuration: 'Restid',
      colDriver: 'Förare',
      colIdentification: 'Identifiering',
      colPresent: 'Med i bilen',
      colPurpose: 'Ändamål',
      presenceDriver: 'Identifierad',
      presenceNotChosen: 'Identifierad, förare ej vald',
      presenceSingleScan: 'Identifierad (en skanning)',
      presenceUnknown: 'Utan identifiering',
      presenceNone: 'Utan identifiering',
      noDriver: 'Okänd förare',
      empty: 'Inga resor i perioden',
      exportSuccess: 'CSV exporterad',
    },
    drivingLog: {
      title: 'Körjournal',
      description: 'Körjournal enligt Skatteverkets riktlinjer för skattemässig dokumentation',
      selectVehicle: 'Välj fordon',
      fetchError: 'Kunde inte hämta körjournal',
      purposeUpdateError: 'Kunde inte uppdatera ändamål',
      noteUpdateError: 'Kunde inte spara anteckning',
      noDataToSubmit: 'Det finns ingen körjournal att skicka in',
      submitConfirm:
        'Vill du skicka in körjournalen för vald period till organisationens vidarebefordringsadress? Efter inskick låses redigering.',
      submitSuccess: 'Körjournalen har skickats in och låsts.',
      submitError: 'Kunde inte skicka in körjournalen',
      noExportData: 'Ingen data att exportera',
      csvColType: 'Typ (Privat/Tjänst)',
      csvColPurposeShort: 'Ändamål (T/P)',
      csvColNote: 'Anteckning',
      business: 'Tjänst',
      private: 'Privat',
      undefined: 'Odefinierad',
      totalDistanceLabel: 'Total körd sträcka (km)',
      privateDistanceLabel: 'Körd privat (km)',
      businessDistanceLabel: 'Körd i tjänst (km)',
      undefinedDistanceLabel: 'Körd odefinierad (km)',
      undefinedDistanceShort: 'Körd odefinierad',
      csvSummaryHeading: 'SUMMERING',
      tripCountLabel: 'Antal körningar',
      periodLabel: 'Period',
      exportSuccess: 'CSV exporterad',
      filtersTitle: 'Välj fordon och period',
      vehicleLabel: 'Fordon',
      fromDate: 'Från datum',
      toDate: 'Till datum',
      fetch: 'Hämta körjournal',
      print: 'Skriv ut',
      submit: 'Skicka in',
      submitting: 'Skickar...',
      periodLockedHint: 'Denna period är inskickad och kan inte redigeras.',
      tripCountShort: 'Antal körningar',
      totalDistanceShort: 'Total körd sträcka',
      privateDistanceShort: 'Körd privat',
      businessDistanceShort: 'Körd i tjänst',
      colDate: 'Datum',
      colTime: 'Tid',
      colFrom: 'Från',
      colTo: 'Till',
      colOdoStart: 'Mätare start',
      colOdoEnd: 'Mätare slut',
      colDistance: 'Sträcka',
      colDuration: 'Restid',
      colToll: 'Tull (SEK)',
      tollSummaryTitle: 'Tull (period)',
      csvTollBusinessLabel: 'Tull tjänst (summa SEK)',
      csvTollPrivateLabel: 'Tull privat (summa SEK)',
      csvTollUndefinedLabel: 'Tull odefinierad (summa SEK)',
      tollFollowsTripPurposeHint:
        'Tullavgiften är kopplad till resan. Välj tjänst eller privat för resan — samma ändamål gäller för sträcka och tull.',
      colTripType: 'Tjänst/Privat',
      colPurpose: 'Ändamål',
      colNote: 'Syfte/anteckning',
      adjustmentPurposeDisabledTitle:
        'Mätarjustering — ändamål (tjänst/privat) gäller inte för denna rad',
      correctionPurposeLabel: 'Korrektion',
      adjustmentDistanceShort: 'Mätarjustering',
      adjustmentDistanceLabel: 'Mätarjustering (korrektion, ej körning)',
      togglePrivateTitle: 'Byt till tjänst',
      toggleBusinessTitle: 'Byt till privat',
      toggleUnsetTitle: 'Ange privat eller tjänst',
      notePlaceholder: 'Beskriv resans syfte…',
      footerSum: 'Summa sträcka',
      emptyTitle: 'Inga resor i perioden',
      emptyBody: 'Välj fordon och period och klicka på Hämta körjournal.',
      infoTitle: 'Tips för dokumentation',
      infoLine1:
        'Markera ändamål (växel) för varje körresa – kolumnen Tjänst/Privat följer och sparas. Total körd sträcka = privat + tjänst + odefinierad (endast faktisk körning; mätarjustering redovisas separat, se sista punkten).',
      infoLine2: 'Fyll i syfte i anteckningsfältet vid behov.',
      infoLine3: 'Exportera eller skriv ut underlag för bokföring.',
      infoLine4: 'Skicka in skickar till toppnodens vidarebefordringsadress och låser perioden.',
      infoLine5: 'Adresser visas när de finns tillgängliga i systemet.',
      infoLine6:
        '«Total körd sträcka» samt privat/tjänst/odefinierad summerar endast faktisk körning. Mätarjustering (korrektion) visas separat och ingår inte i dessa summor.',
    },
    odometerReport: {
      title: 'Mätarställningsrapport',
      description: 'Visa mätarställning per fordon vid specifikt datum',
    },
    rentalReport: {
      title: 'Uthyrningsrapport',
      description: 'Komplett rapport för uthyrning med resor, kostnader och status',
      tabs: {
        overview: 'Översikt',
        trips: 'Resor',
        geofences: 'Geofences',
        warnings: 'Varningar',
        environment: 'Miljö',
        status: 'Status',
      },
      vehicle: 'Fordon',
      period: 'Period',
      startDate: 'Startdatum',
      endDate: 'Slutdatum',
      fetchReport: 'Hämta rapport',
      downloadPdf: 'Ladda ner PDF',
      sendEmail: 'Skicka via e-post',
      totalDistance: 'Total körsträcka',
      totalTrips: 'Antal resor',
      totalWarnings: 'Antal varningar',
      geofenceCosts: 'Geofence-kostnader',
      fuelStatus: 'Tankstatus',
      tankFull: 'Tanken är full',
      tankMissing: 'Saknas ca',
      milAlarm: 'MIL-larm',
      noMilAlarms: 'Inga MIL-larm under perioden',
      milActive: 'MIL-larm aktivt',
      co2Emissions: 'CO₂-utsläpp',
      fuelConsumption: 'Bränsleförbrukning',
      fuel: 'Bränsle',
      fuelKinds: 'Bränsleslag',
      consumption: 'Förbrukning',
      perKm: 'Per km',
      electricShare: 'Elandel',
      electricUsed: 'Elförbrukning',
      electricPerKm: 'El per km',
      emailSent: 'Rapport skickad!',
      recipientEmail: 'E-postadress',
      recipientName: 'Mottagarens namn',
      message: 'Meddelande',
    },
    decodeBinError: 'Kunde inte decoda bin-fil',
  },

  // CO₂ Report
  co2: {
    title: 'CO₂-utsläpp',
    description: 'Beräkna och analysera CO₂-utsläpp för fordonsflottan',
    totalCO2: 'Totalt CO₂-utsläpp',
    avgPerKm: 'Snitt CO₂/km',
    electricVehicles: 'Elfordon',
    fossilVehicles: 'Fossila fordon',
    co2Saved: 'CO₂ spart (elfordon)',
    trendTitle: 'CO₂-utsläpp över tid',
    fuelTypeDistribution: 'Bränslefördelning',
    vehicleDetails: 'CO₂ per fordon',
    fuelType: 'Bränsle',
    fuelUsed: 'Förbrukat',
    totalCO2Short: 'CO₂ (kg)',
    wltpCO2: 'WLTP',
  },

  // Geofence Zone Report
  geofenceZone: {
    title: 'Geofence Zonrapport',
    description: 'Analysera hur ofta fordon befinner sig inom valda zoner',
    selectZone: 'Välj zon',
    totalZones: 'Antal zoner',
    totalVehicles: 'Fordon',
    totalVisits: 'Totalt besök',
    totalTime: 'Total tid',
    totalCost: 'Total kostnad',
    visitsOverTime: 'Besök över tid',
    zoneSummary: 'Sammanfattning per zon',
    vehicleDetails: 'Fordon per zon',
    zone: 'Zon',
    vehicles: 'Fordon',
    visits: 'Besök',
    costColumn: 'Kostnad',
    totalDuration: 'Total tid',
    avgDuration: 'Snitt/besök',
    lastVisit: 'Senaste',
    noData: 'Inga data för vald period',
    fetchError: 'Kunde inte hämta rapport',
    globalLabel: 'Global',
    filteredLabel: 'Filtrerat',
    showingRowsCount: 'Visar {{count}} av {{total}} rader',
  },

  // Underutilized Report
  underutilized: {
    title: 'Underutnyttjade fordon',
    description: 'Identifiera fordon med lågt utnyttjande och generera varningar',
    totalVehicles: 'Totalt fordon',
    activeVehicles: 'Aktiva fordon',
    underutilizedVehicles: 'Med varningar',
    avgUtilization: 'Snitt utnyttjande',
    utilizationOverview: 'Utnyttjandeöversikt',
    utilizationTrend: 'Utnyttjandetrend',
    showOnlyWarnings: 'Visa endast varningar',
    vehiclesWithWarnings: 'Fordon med varningar',
    allVehicles: 'Alla fordon',
    activeDays: 'Aktiva dagar',
    utilization: 'Utnyttjande',
    warnings: 'Varningar',
  },

  // Vehicle Wear Report
  vehicleWear: {
    title: 'Fordonsslitage',
    description: 'Analysera hur körbeteende påverkar fordonsslitage',
    totalVehicles: 'Antal fordon',
    avgWearScore: 'Snittslitage',
    worstCategory: 'Värsta kategori',
    vehiclesAtRisk: 'Fordon i riskzonen',
    wearByVehicle: 'Slitage per fordon',
    wearProfile: 'Slitageprofil',
    selectVehicle: 'Välj ett fordon för detaljer',
    clickBarToSelect: 'Klicka på ett fordon i diagrammet för att se detaljer',
    recommendations: 'Rekommendationer för',
    brakes: 'Bromsar',
    engine: 'Motor',
    tires: 'Däck',
    fuel: 'Bränsle',
    overall: 'Totalt',
  },

  // Login
  login: {
    title: 'Logga in',
    subtitle: 'Ange din e-post och ditt lösenord.',
    heroTitleLine1: 'Din fordonsflotta.',
    heroTitleLine2: 'Enklare.',
    heroBody:
      'Körjournal, bokning och nyckelhantering i ett och samma system. Logga in och se hur flottan mår just nu.',
    brandFooter: '© {year} DEVIAQ AB · Linköping',
    emailLabel: 'E-post',
    passwordLabel: 'Lösenord',
    passwordRequired: 'Lösenord krävs',
    emailPlaceholder: 'namn@foretag.se',
    passwordPlaceholder: '',
    showPassword: 'Visa',
    hidePassword: 'Dölj',
    forgotPassword: 'Glömt lösenord?',
    loggingIn: 'Loggar in...',
    loginButton: 'Logga in',
    noAccount: 'Ny användare?',
    createAccount: 'Skapa konto',
    welcomeMessage: 'Välkommen! Du är nu inloggad.',
    loginError: 'Fel email eller lösenord. Försök igen.',
    verifyEmailTitle: 'E-postadress måste verifieras',
    verifyEmailBody:
      'Du måste verifiera din e-postadress innan du kan logga in. Ett verifieringsmail har skickats.',
    verifyEmailBodyWithEmail: 'Du måste verifiera din e-postadress innan du kan logga in. Ett verifieringsmail har skickats till {email}.',
    verifyOrgLinkedNote:
      'Din domän är kopplad till en organisation. Efter verifiering får du åtkomst som läsare (Viewer) i den organisationen.',
    verifyManualOrgNote:
      'Om din organisation inte känner igen din e-postdomän kan en administratör behöva koppla ditt konto innan du ser all funktionalitet.',
    resendVerification: 'Skicka ny verifieringsmail',
    resendingVerification: 'Skickar...',
    resendVerificationSuccess: 'Ny verifieringsmail har skickats till din e-postadress.',
    resendVerificationError: 'Kunde inte skicka verifieringsmail',
  },


  // Sidebar
  sidebar: {
    user: 'Användare',
    logout: 'Logga ut',
    noFeatures: 'Inga tillgängliga funktioner',
    expandMenu: 'Expandera meny',
    collapseMenu: 'Minimera meny (endast ikoner)',
  },

  temperatureMonitoring: {
    overviewTitle: 'Temperaturövervakning',
    overviewDescription: 'Status för EYE-sensorer som tilldelats kunden och kopplats till GPS-tracker.',
    sensorsTitle: 'Sensorer & koppling',
    sensorsDescription: 'Sensorerna tilldelas från EYE-lagret. Koppla en sensor till ett fordon (slot 1–4). Intervall och mätningar skickas automatiskt till trackern.',
    configTitle: 'BLE/EYE-config (intern)',
    configDescription: 'Felsökning och manuell override. Kunder ska använda Sensorer & koppling.',
    configInternalBannerTitle: 'Intern vy — inte för kundself-service',
    configInternalBannerBody:
      'Parametrar sätts automatiskt i kod vid koppling och redigering. Den här sidan är endast för DeviaQ/support när automatisk provisionering behöver felsökas.',
    recipientsTitle: 'Larmmottagare',
    schedulesTitle: 'Rapportscheman',
    schedulesComingSoon: 'Schemalagda vecko- och månadsrapporter kommer i nästa steg.',
    reportsTitle: 'Kylkedjerapporter',
    reportsDescription: 'Välj fordon med kopplad EYE-sensor. Rapporten visar temperatur och fukt senaste 7 dagarna.',
    selectSensorForReport: 'Välj reg.nr / sensor',
    noLinkedSensorsForReport: 'Inga fordon med kopplade sensorer. Koppla sensor under Sensorer & koppling.',
    temperature: 'Temperatur',
    humidity: 'Luftfuktighet',
    battery: 'Batteri',
    lowBatteryLabel: 'Lågt batteri',
    tracker: 'Tracker (IMEI)',
    lastReading: 'Senaste mätning',
    noSensors: 'Inga sensorer tilldelade ännu.',
    recentExcursions: 'Senaste avvikelser',
    noExcursions: 'Inga registrerade avvikelser.',
    sensor: 'Sensor',
    excursionType: 'Typ',
    started: 'Start',
    registerSensor: 'Registrera sensor',
    organizationRequired: 'Välj kund/organisation innan du skapar sensorn.',
    registeredSensors: 'Tilldelade sensorer',
    editName: 'Ändra namn',
    sensorRenamed: 'Visningsnamn uppdaterat',
    noSerial: 'Inget serienummer',
    sensorName: 'Namn (visningsnamn)',
    serialNumber: 'Serienummer (SN)',
    product: 'Produkt',
    macAddress: 'MAC-adress (valfritt, kolon behövs inte)',
    invalidMac: 'MAC-adressen ska vara 12 hex-tecken, t.ex. 7CD9F4142349',
    linkToTracker: 'Koppla till tracker',
    configuredSlot: 'Aktiv slot i DQFleet',
    slotChangeHint: 'Vid sparning konfigureras vald slot på trackern. Byter du slot stängs den gamla av automatiskt.',
    willConfigure: 'Skickas till tracker',
    scanInterval: 'Skanningsintervall',
    scanIntervalOptions: {
      30: '30 sekunder',
      60: '1 minut',
      120: '2 minuter',
      300: '5 minuter',
    },
    measurements: 'Mätningar',
    measurement: {
      temperature: 'Temperatur',
      humidity: 'Luftfuktighet',
      magnet: 'Magnet (dörr/lucka)',
    },
    editLinkTitle: 'Redigera koppling',
    linkSettingsSaved: 'Inställningar sparade',
    saveAndSendConfig: 'Spara och skicka till tracker',
    saveWithoutSend: 'Spara utan att skicka',
    saveOnlyHint: 'Ändringar skickas till trackern först när du trycker «Spara och skicka till tracker». Om trackern är offline hamnar config i kö och skickas vid nästa uppkoppling.',
    settingsSavedNotSent: 'Sparat i DQFleet. Config är inte skickad till trackern än — tryck «Spara och skicka» eller «Skicka BLE-config».',
    configSentQueuedBanner: 'Config ligger i kö — trackern är offline. Skickas automatiskt vid nästa uppkoppling. Se status och skicklogg nedan.',
    configSentAppliedBanner: 'Config mottagen av trackern. Senaste status och skicklogg uppdaterade nedan.',
    configSendLogEmpty: 'Inga skickade config ännu.',
    configSyncStatus: 'Config-status',
    configLastSent: 'Senast skickad',
    configSendLog: 'Skicklogg',
    linkSyncStatus: {
      applied: 'Mottagen av tracker',
      pending: 'I kö (tracker offline)',
      applying: 'Skickar…',
      failed: 'Misslyckades',
      unknown: 'Okänd',
    },
    syncLogStatus: {
      applied: 'Mottagen',
      queued: 'I kö',
      failed: 'Misslyckades',
    },
    selectSensor: 'Välj sensor',
    selectVehicle: 'Välj fordon',
    selectSensorFirst: 'Välj sensor först',
    vehiclePlaceholder: 'Sök reg.nr, märke eller modell…',
    imeiFromVehicle: 'Välj fordon för att hämta IMEI',
    noDeviceOnVehicle: 'Fordonet har ingen kopplad GPS-enhet (IMEI)',
    deviceId: 'Enhets-ID (devices.id)',
    slot: 'Slot',
    link: 'Koppla',
    activeLinks: 'Aktiva kopplingar',
    noLinks: 'Inga kopplingar.',
    loadError: 'Kunde inte ladda data',
    saveError: 'Kunde inte spara',
    saveForbidden: 'Du saknar behörighet att spara. Kontrollera att du är inloggad som kunden och har rätt att skapa sensorer.',
    sensorCreated: 'Sensor skapad',
    linkCreated: 'Koppling skapad',
    linkAndConfigSent: 'Koppling skapad och BLE-config skickad till trackern',
    sendTrackerConfig: 'Skicka BLE-config',
    provisionError: 'Kunde inte skicka BLE-config till trackern',
    configSaved: 'Config sparad i DQFleet',
    configApplied: 'Config skickad till enhet',
    configQueued: 'Enheten offline — config måste skickas vid uppkoppling',
    syncStatusLabel: 'Synkstatus',
    saveInCloud: 'Spara i DQFleet',
    sendToDevice: 'Skicka till enhet',
    imeiRequired: 'Ange IMEI för att skicka config',
    recipientName: 'Namn',
    email: 'E-post',
    phone: 'Telefon (SMS)',
    recipientCreated: 'Mottagare skapad',
    noRecipients: 'Inga mottagare.',
    exportCsv: 'Exportera CSV',
    eyeDeviceId: 'Sensor-ID',
    showReport: 'Visa rapport',
    reportLoadError: 'Kunde inte hämta rapporten',
    noReportReadings: 'Inga temperaturmätningar i vald period.',
    reportPeriod: 'Period: {{from}} – {{to}}',
    reportReadingCount: '{{count}} mätningar',
    status: {
      ok: 'OK',
      no_signal: 'Ingen signal',
      out_of_range: 'Utanför gräns',
      low_battery: 'Lågt batteri',
      sensor_error: 'Sensorfel',
      disconnected: 'Frånkopplad',
    },
  },

  // Drivers
  drivers: {
    schedule: {
      title: 'Arbetsschema',
      description: 'Ange arbetstider för att automatiskt klassificera resor som tjänst eller privat. Resor utanför schemat markeras som privata.',
      modeLabel: 'Användning',
      mode: {
        privateManual: 'Privat – markera tjänstresor manuellt',
        privateManualHelp: 'Bilen syns inte på kartan. Alla resor blir privata tills du markerar dem som tjänst i körjournalen.',
        workHours: 'Tjänstebil med arbetstid',
        workHoursHelp: 'Bilen syns på kartan inom angiven arbetstid. Resor klassificeras automatiskt som tjänst eller privat.',
        companyCar: 'Företagsbil – alltid synlig',
        companyCarHelp: 'Bilen syns alltid på kartan. Alla resor klassificeras som tjänst.',
        alwaysBusiness: 'Alltid tjänst',
      },
      sameAllDays: 'Samma tid alla dagar',
      commonTime: 'Arbetstid (gäller valda dagar)',
      noWorkTime: 'Privat (ingen arbetstid)',
      noSchedule: 'Inget schema angivet - alla resor klassificeras som privata',
      activeInfo: 'dagar med arbetstid angivna',
      weekdays: 'Vardagar',
      weekend: 'Helg',
      weekdaysActive: 'vardagar',
      weekendActive: 'helgdagar',
      saveSuccess: 'Arbetsschema sparat',
      saveDraft: 'Klar – sparas när användaren skapas',
      saveDraftSuccess: 'Schemat ingår när du klickar Skapa användare.',
      applyOrgDefaults: 'Använd organisationsstandard (vardagar)',
      orgDefaultsReady: 'Organisationens standard är införd. Klicka Spara för att spara till servern.',
      emptyPrefilledFromOrg:
        'Inget schema var sparat på servern. Nedan visas organisationens standard – klicka Spara för att använda den, eller ändra tiderna för ett eget schema.',
      applyOrgDefaultsHelp: 'Fyller i måndag–fredag med standard tjänsttid från kundens körjournalinställningar på toppnoden. Spara för att skriva till servern.',
      applyOrgDefaultsMissing: 'Ingen organisationsstandard är konfigurerad på toppnoden.',
      applyOrgDefaultsNoOrg: 'Välj organisation för användaren först.',
      days: {
        monday: 'Mån',
        tuesday: 'Tis',
        wednesday: 'Ons',
        thursday: 'Tor',
        friday: 'Fre',
        saturday: 'Lör',
        sunday: 'Sön',
      },
    },
    assignment: {
      title: 'Fordonstilldelning',
      selectVehicle: 'Välj fordon',
      searchVehicle: 'Sök registreringsnummer...',
      noVehiclesFound: 'Inga fordon hittades',
      typeToSearch: 'Skriv för att söka fordon',
      hasDriver: 'Har förare',
      selectDate: 'Startdatum',
      selectTrip: 'Välj startresa (valfritt)',
      currentVehicle: 'Aktuellt fordon',
      since: 'Sedan',
      currentDriverWarning: 'Fordonet har redan en förare: {{name}}. Den tilldelningen avslutas automatiskt.',
      newAssignment: 'Ny tilldelning',
      assign: 'Tilldela fordon',
      endAssignment: 'Avsluta tilldelning',
      confirmEnd: 'Är du säker på att du vill avsluta denna tilldelning?',
      assignSuccess: 'Förare tilldelad till fordon',
      endSuccess: 'Tilldelning avslutad',
      history: 'Tilldelningshistorik',
      noUnassignedVehicles: 'Inga lediga fordon — alla har redan en aktiv förartilldelning',
      noTrips: 'Inga resor denna dag',
      modePickUnassigned: 'Ledigt fordon i organisationen',
      modeLinkDevice: 'Koppla enhet till befintligt fordon',
      modeRegisterNew: 'Registrera nytt fordon',
      modeHelpPick: 'Välj ett fordon utan aktiv förartilldelning i din kundstruktur.',
      modeHelpLink: 'Sök fordon på registreringsnummer, välj en ej monterad enhet och startdatum. Befintlig förare på fordonet byts ut vid tilldelning.',
      modeHelpRegister: 'Hämta uppgifter från Car.info, ange mätarställning, välj enhet och datum. Fordonet skapas i vald organisation.',
      orgRequired: 'Organisation krävs för denna åtgärd.',
      searchVehicleInOrg: 'Sök fordon (reg.nr) i organisationen',
      searchDevice: 'Sök enhet (IMEI)…',
      selectDevice: 'Välj enhet',
      noDevicesFound: 'Inga enheter hittades',
      deviceGlobalSearch: 'Alla ej kopplade enheter i systemet (global admin)',
      existingDevicePolicy: 'Fordonet har redan en enhet',
      unmountExisting: 'Demontera befintlig',
      swapDevices: 'Byt plats (byte)',
      linkDeviceAndAssign: 'Koppla enhet och tilldela förare',
      linkDeviceSuccess: 'Enhet kopplad och förare tilldelad',
      registerRegPlaceholder: 'ABC123',
      fetchCarInfo: 'Hämta från Car.info',
      initialOdometerKm: 'Mätarställning vid start (km)',
      createVehicleAndAssign: 'Skapa fordon, koppla enhet och tilldela',
      registerSuccess: 'Fordon skapat och förare tilldelad',
      scheduleApplied: 'Förarschema uppdaterat enligt organisation',
      scheduleApplyWarn: 'Kunde inte sätta schema från organisation (kontrollera toppnodens körjournalinställningar).',
      regLabel: 'Reg.nr',
      makePlaceholder: 'Märke',
      modelPlaceholder: 'Modell',
      yearPlaceholder: 'År',
      fuelPlaceholder: 'Bränsle',
      fuelPetrol: 'Bensin',
      fuelDiesel: 'Diesel',
      fuelElectric: 'El',
      fuelHybrid: 'Hybrid',
    },
  },

  // Profile Modal
  profile: {
    title: 'Min profil',
    edit: 'Redigera',
    personalInfo: 'Personuppgifter',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    email: 'E-post',
    phone: 'Mobiltelefon',
    role: 'Roll',
    organization: 'Organisation',
    cabinetPin: 'PIN-kod',
    cabinetPinHint: 'Din kod till nyckelskåpet.',
    noCabinetPin: 'Ingen PIN ännu',
    changePassword: 'Byt lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    saveSuccess: 'Profilen har uppdaterats',
    driverInfo: 'Förarinformation',
    licenseNumber: 'Körkortsnummer',
    licenseExpiry: 'Körkort utgår',
    licenseCategories: 'Körkortskategorier',
    employeeId: 'Anställnings-ID',
    department: 'Avdelning',
    costCenter: 'Kostnadsställe',
    currentPasswordRequired: 'Nuvarande lösenord krävs för att byta lösenord',
    passwordTooShort: 'Lösenordet måste vara minst 6 tecken',
    passwordMismatch: 'Lösenorden matchar inte',
    passwordMinLength: 'Minst 6 tecken',
    roleDriver: 'Förare',
    roleViewer: 'Visare',
    defaultPickupLocation: 'Förvald utlämningsplats',
    defaultPickupLocationHint: 'Den utlämningsplats som väljs automatiskt åt dig, t.ex. vid bokning.',
    selectPickupLocation: '— Välj utlämningsplats —',
    selectPickupLocationRequired: 'Välj en utlämningsplats',
    noDefaultPickupLocation: 'Ingen vald',
    pickupPromptTitle: 'Välj din förvalda utlämningsplats',
    pickupPromptDescription: 'Du måste välja en förvald utlämningsplats innan du fortsätter. Välj den plats du oftast använder så förifylls den åt dig framöver. Du kan ändra valet när som helst under Min profil.',
    pickupPromptLater: 'Senare',
  },

  // SysAdmin
  sysAdmin: {
    title: 'Systemadministratör',
    manageRoles: 'Hantera roller och behörigheter',
    manageOrganizations: 'Hantera organisationer',
    dataMigration: 'Datamigrering',
    migrateData: 'Migrera data från gammal databas',
    deviceCommands: 'Enhetskommandon',
    deviceCommandsDescription: 'Skicka kommandon till enheter',
    auditLog: 'Audit Log',
    auditLogDescription: 'Visa logg över skickade kommandon',
    generalAuditLog: 'Ändringslogg',
    generalAuditLogDescription: 'Visa alla ändringar (CREATE, UPDATE, DELETE)',
    errorLog: {
      name: 'Fellogg',
      title: 'Fellogg',
      description: 'Logg över alla systemfel och exceptions',
      viewDetails: 'Fel – detaljer',
      close: 'Stäng',
      resolutionNotes: 'Lösningsanteckningar',
      resolutionNotesPlaceholder: 'Valfria anteckningar...',
      saveStatus: 'Spara status',
      saveStatusSuccess: 'Status uppdaterad',
      loading: 'Laddar...',
      noErrorsFound: 'Inga fel hittades',
      noResultsMatchFilters: 'Inga fel matchar nuvarande filter. Rensa filter eller ändra Severity/Status för att se fel.',
      status: 'Status',
      clearFilters: 'Rensa filter',
      searchPlaceholder: 'Sök i felmeddelande...',
      searchLabel: 'Sök',
      severityLabel: 'Severity',
      statusLabel: 'Status',
      clearLog: 'Rensa felloggen',
      clearLogTitle: 'Rensa felloggen',
      clearLogDescription: 'Välj om du vill radera alla fel eller bara de som är äldre än ett visst antal dagar.',
      clearOlderThanLabel: 'Radera poster äldre än (dagar)',
      clearOlderThanPlaceholder: 'Lämna tomt för att radera alla',
      clearOlderThanHint: 'Raderar poster äldre än {days} dagar.',
      clearAllHint: 'Lämna tomt för att radera ALLA poster.',
      deleteAll: 'Radera alla',
      deleteOlderThan: 'Radera äldre än {days} dagar',
      deleting: 'Raderar...',
      deletedSuccess: '{count} fel raderades från felloggen.',
      deletedError: 'Kunde inte rensa felloggen',
      showing: 'Visar {from} - {to} av {total}',
      previous: 'Föregående',
      next: 'Nästa',
      totalLabel: 'Totalt',
      messageLabel: 'Meddelande',
      errorTypeLabel: 'Feltyp',
      errorCodeLabel: 'Kod',
      serviceLabel: 'Service',
      moduleLabel: 'Modul',
      functionLabel: 'Funktion',
      timeLabel: 'Tidpunkt',
      requestLabel: 'Request',
      resolvedLabel: 'Löst',
    },
    generalAuditLogSection: {
      title: 'Ändringslogg',
      description: 'Logg över alla ändringar i systemet',
      total: 'Totalt',
      entityTypeLabel: 'Entitetstyp',
      entityTypePlaceholder: 't.ex. vehicle, user...',
      actionLabel: 'Åtgärd',
      searchLabel: 'Sök',
      searchPlaceholder: 'Sök användare, entitet...',
      clearFilters: 'Rensa filter',
      loading: 'Laddar...',
      noChanges: 'Inga ändringar hittades',
      colTime: 'Tidpunkt',
      colUser: 'Användare',
      colAction: 'Åtgärd',
      colEntity: 'Entitet',
      colChanges: 'Ändringar',
      system: 'System',
      fieldsCount: '{count} fält',
      showing: 'Visar {from} - {to} av {total}',
      previous: 'Föregående',
      next: 'Nästa',
      allActions: 'Alla',
    },
    errorLogDescription: 'Visa alla systemfel och exceptions',
    systemMonitor: {
      title: 'Systemövervakning',
      description: 'Övervaka CPU, minne, disk, databaser och köer',
      docker: {
        title: 'Docker Containers',
        notAvailable: 'Docker är inte tillgängligt på denna server',
        total: 'Totalt',
        running: 'Kör',
        stopped: 'Stoppade',
        healthy: 'Healthy',
        unhealthy: 'Unhealthy',
        container: 'Container',
        image: 'Image',
        status: 'Status',
        health: 'Health',
        cpu: 'CPU',
        memory: 'Minne',
        swarm: {
          title: 'Docker Swarm',
          nodes: 'Noder',
          services: 'Tjänster',
          host: 'Host',
          manager: 'Manager',
          service: 'Tjänst',
          replicas: 'Replicas',
        },
      },
      scheduledJobs: {
        title: 'Schemalagda Jobb',
        jobStatus: 'Jobbstatus',
        jobs: 'Jobb',
        runningNow: 'Kör nu',
        successLast24h: 'OK (24h)',
        failedLast24h: 'Fel (24h)',
        schedule: 'Schema',
        nextRun: 'Nästa',
        recentRuns: 'Senaste körningar',
        noHistory: 'Ingen körhistorik ännu',
        job: 'Jobb',
        startTime: 'Starttid',
        duration: 'Tid',
        processed: 'OK/Fel',
        success: 'OK',
        failed: 'FEL',
        running: 'KÖR',
      },
    },
    slowQueries: {
      title: 'Slow Queries',
      description: 'Analysera långsamma SQL-frågor',
    },
    apiMetrics: {
      title: 'Prestanda',
      cardDescription: 'Användartillväxt, bokningar och API-latens mot systemlast',
      description:
        'Grafer över användare, bokningar och API-tider. Latens samlas i Redis per normaliserad route. p50/p95 är övre kanten på duration-hinken, inte exakt percentil. Live-kort uppdateras varje minut.',
      loadError: 'Kunde inte hämta API-mätningen',
      loadErrorHistory: 'Kunde inte hämta prestandahistorik',
      empty: 'Inga anrop registrerade ännu. Surfa i systemet en stund och uppdatera.',
      emptyHistory: 'Ingen historik för vald period ännu.',
      periodDays: '{{n}} dagar',
      usersTitle: 'Användare mot systemlast',
      usersHint: 'Nya och aktiva användare mot API-anrop och p95. Aktiva är användare vars senaste inloggning inföll den dagen.',
      cumulativeUsers: 'Kumulativa användare',
      newUsers: 'Nya användare',
      activeUsers: 'Aktiva (senaste login)',
      activeAccounts: '{{count}} aktiva konton',
      bookingsTitle: 'Bokningar',
      bookingsHint: 'Skapade bokningar mot soft delete (deleted_at). Streckad linje är avbokning utan soft delete.',
      bookingsCreated: 'Skapade',
      bookingsSoftDeleted: 'Avbokade (soft delete)',
      bookingsCancelledOnly: 'Avbokade utan delete',
      apiTitle: 'API-anrop och fel',
      apiHint: 'Antal anrop per dag, viktad p95 och andel 5xx.',
      requestsPerDay: 'Anrop/dag',
      p95Ms: 'p95 (ms)',
      errorShare: 'Andel 5xx',
      watchlistTitle: 'p95 per flaskhals',
      watchlistHint: 'Klicka en rad i tabellen för att lägga till den routen i grafen.',
      selectedRoute: 'Markerad: {{route}}',
      actionTitle: 'Åtgärder',
      actionHint: 'Gul betyder varning för långsamt svar. Rött betyder att något bör åtgärdas. Listan visar långsamma anrop och serverfel.',
      actionEmpty: 'Inget över tröskel i senaste dygnet.',
      actionWarn: 'Varning',
      actionFix: 'Åtgärda',
      actionErrors: 'Serverfel 5xx:',
      actionTrend: 'Föregående dag:',
      unitMs: 'ms',
      hourP95: 'Timme p95 {{value}}',
      hourTitle: 'Denna timme',
      todayTitle: 'Hela dagen',
      requests: 'anrop',
      colRoute: 'Sökväg',
      colStatus: 'Status',
      colCount: 'Antal',
      colP50: 'p50',
      colP95: 'p95',
      colAvg: 'Medel',
      colMax: 'Max',
      apiHeap: 'API-heap',
      redisMemory: 'Redis-minne',
      redisMax: 'Tak {{value}}',
      tripState: 'trip:state-nycklar',
      tripStateSample: 'Medel sample {{value}}',
      gpsWorker: 'GPS-worker heap',
      gpsWorkerWaiting: 'Väntar på worker-snapshot',
      gpsPackets: '{{count}} paket, medel {{avg}}',
    },
    dataReplay: {
      title: 'Data Replay',
      description: 'Återläs historisk GPS-data',
    },
    importSources: {
      title: 'Importkällor',
      description: 'Hantera mailbox- och SFTP-källor för importsync',
      loadError: 'Kunde inte ladda importkällor',
      saveError: 'Kunde inte spara importkälla',
      deleteError: 'Kunde inte radera importkälla',
      testError: 'Anslutningstest misslyckades',
      testSuccess: 'Anslutning OK',
      created: 'Importkälla skapad',
      updated: 'Importkälla uppdaterad',
      deleted: 'Importkälla raderad',
      newSource: 'Ny källa',
      createSource: 'Skapa källa',
      editSource: 'Redigera källa',
      create: 'Skapa',
      saveChanges: 'Spara ändringar',
      sourcesList: 'Importkällor',
      noSources: 'Inga importkällor skapade ännu',
      confirmDelete: 'Radera denna importkälla?',
      testConnection: 'Testa anslutning',
      syncNow: 'Synka nu',
      syncSuccess: 'Synk klar',
      syncError: 'Synk misslyckades',
      type: 'Typ',
      mailbox: 'Mailbox',
      sftp: 'SFTP',
      local: 'Lokal katalog',
      localDirectoryPath: 'Katalogsökväg (på servern)',
      localDirectoryHint: 'Absolut sökväg till katalogen som backend läser filer från (t.ex. en SFTP-upload-katalog).',
      name: 'Namn',
      namePlaceholder: 'T.ex. Delad mailbox Circle K',
      mailboxEmail: 'Mailbox e-post',
      sftpHost: 'Host',
      sftpPort: 'Port',
      sftpUsername: 'Användarnamn',
      sftpPassword: 'Lösenord (valfritt)',
      sftpPrivateKeyPath: 'Private key path (valfritt)',
      sftpPassphrase: 'Lösenfras för nyckel (valfritt)',
      sftpBasePath: 'Base path',
      allowedExtensions: 'Tillåtna filändelser (kommaseparerat)',
      filenameExclusions: 'Filnamn att exkludera (kommaseparerat)',
      minDate: 'Min datum (mailbox, YYYY-MM-DD)',
      pathPattern: 'Path pattern (SFTP)',
      retentionDays: 'Retention (dagar)',
      isActive: 'Aktiv källa',
      inactive: 'Inaktiv',
      lastFetchAt: 'Senaste hämtning',
      lastFetchError: 'Senaste fel',
      lastFetchFilesCount: 'Filer i källan',
      totalFilesInSource: 'filer i källan',
      validation: {
        nameRequired: 'Namn krävs',
        mailboxEmailRequired: 'Mailbox-adress krävs för mailbox-källa',
        sftpRequired: 'Host, användarnamn och base path krävs för SFTP-källa',
        localDirectoryRequired: 'Katalogsökväg krävs för lokal källa',
      },
    },
    tripValidation: {
      title: 'Trip Validering',
      description: 'Validera trippar mellan MongoDB och MariaDB',
      resolveTitle: 'Hantera valideringsfel',
      errorType: 'Feltyp',
      date: 'Datum',
      binAnalysisTitle: 'Bin-fil analys',
      analyzeBinFile: 'Analysera bin-fil',
      analyzing: 'Analyserar...',
      binAnalysisFailed: 'Kunde inte analysera bin-filen',
      binAnalysis502Hint: 'Servern svarade inte (502). Bin-filanalys kan ta lång tid eller bin-filen finns inte på servern (gps-data). Kontrollera backend-loggar.',
      binSegmentsExcludedNote:
        '{{count}} hastighetssegment i bin-filen visas inte i listan (under {{minDuration}} s eller under {{minDistance}} m — samma minimikrav som för en sparad tripp).',
      tryAgain: 'Försök igen',
      clearLog: 'Töm hela loggen',
      clearLogConfirm: 'Är du säker? Alla poster i trip valideringsloggen raderas. Detta kan inte ångras.',
      clearLogSuccess: 'Loggen tömd. {{count}} poster borttagna.',
      clearLogFailed: 'Kunde inte tömma loggen',
      replayAllDatesQueue: 'Replay alla datum (kö)',
      replayAllDatesQueueTitle: 'Kör replay via kö (gps_worker_*_replay) för alla unika datum i listan',
      bulkClean: 'Rensa extra MariaDB-trippar',
      bulkCleanTitle: 'Tar bort MariaDB-trippar utan matchande MongoDB-trip och synkar saknade trippar. Hanterar alla synk-mismatch-poster.',
      bulkCleanSuccess: '{{deleted}} extra MariaDB-trippar borttagna, {{synced}} MongoDB-trippar synkade.',
      bulkCleanFailed: 'Bulk-rensning misslyckades',
      syncMismatchInfo: 'Synk-mismatch innebär att antalet trippar skiljer sig mellan MongoDB och MariaDB. Bin-fil-analys är inte tillgänglig för denna feltyp. Kör en replay för att synkronisera data.',
      syncMismatchWhyTitle: 'Varför två trippar i MariaDB men rätt antal i MongoDB?',
      syncMismatchWhyMongo: 'har dubblettkontroll: innan sparning kollas findDuplicateTrip (samma fordon, starttid ±10 s, sträcka ±200 m). Om en matchande tripp redan finns sparas inte den nya – bara en logisk resa per tidsfönster hamnar i Mongo.',
      syncMismatchWhyMaria: 'hade ingen motsvarande kontroll: varje anrop till synk gjorde INSERT (med eget trip_id). Om synk tidigare anropades även när trippen inte sparats i Mongo (t.ex. för en avvisad dubblett med annat trip_id), fick MariaDB en extra rad. Därför kan du se två rader i MariaDB (två olika trip_id) men bara en i MongoDB.',
      syncMismatchToday: 'Idag anropas MariaDB-synk endast när trippen först sparats i MongoDB, och vi har lagt in dubblettkontroll även vid MariaDB-insert (samma fordon + starttid ±10 s, sträcka ±200 m). Nya sådana dubbletter ska därför inte uppstå.',
      syncMismatchAction: 'Åtgärd: Kör "Kör om dagens data (replay)" för att fylla i MongoDB från bin-filen, eller ta bort den extra MariaDB-raden (den som saknas i MongoDB) manuellt om det är en äkta dubblett.',
      syncMismatchMariaMore: 'MariaDB har fler trippar än MongoDB. Listan "MariaDB-trippar" ovan visar vilka som också finns i MongoDB (✓ MongoDB) respektive endast i MariaDB – dessa kan ha skapats av en tidigare synk-bugg eller manuellt. Analysera vilken tripp som saknas i MongoDB innan du kör replay; efter replay kan extra trippar som fortfarande bara finns i MariaDB behöva tas bort manuellt.',
      currentPoints: 'Nuvarande punkter',
      pointsInBinFile: 'Punkter i bin-fil',
      totalInFile: 'Totalt i filen',
      tripTime: 'Tidsperiod',
      updateMongoDB: 'Uppdatera MongoDB med {{count}} punkter',
      repairing: 'Reparerar...',
      repairSuccess: 'Trip reparerad med {{count}} GPS-punkter',
      repairFailed: 'Kunde inte reparera trip',
      noPointsFound: 'Inga GPS-punkter hittades i bin-filen för denna trip',
      tooFewPoints: 'Bara {{count}} punkt hittades, minst 2 krävs',
      manualResolveTitle: 'Markera manuellt',
      notes: 'Anteckningar (valfritt)',
      notesPlaceholder: 'Beskriv hur problemet löstes...',
      markResolved: 'Markera som löst',
      mongoTrips: 'MongoDB-trippar (kan tas bort)',
      deleteTripTitle: 'Ta bort trip',
      deleteTripWarning: 'Du är på väg att ta bort en trip med {{count}} punkter. Detta kan inte ångras.',
      deleteReason: 'Anledning till borttagning *',
      deleteReasonPlaceholder: 'Beskriv varför denna trip tas bort (minst 5 tecken)...',
      deleteReasonError: 'Minst 5 tecken krävs',
      deleteTrip: 'Ta bort trip',
      deletingTrip: 'Tar bort...',
      deleteTripSuccess: 'Trip {{tripId}} borttagen',
      deleteTripFailed: 'Kunde inte ta bort trip',
      createInMariaDB: 'Skapa i MariaDB',
      creatingInMariaDB: 'Skapar...',
      createInMariaDBSuccess: 'Trip skapad i MariaDB',
      createInMariaDBFailed: 'Kunde inte skapa trip i MariaDB',
      replayDay: 'Kör om dagens data (replay)',
      replayDaySuccess: 'Replay startad',
      systematicErrorHint: 'Många fel av samma typ kan tyda på ett systemfel – t.ex. att synk till MariaDB misslyckades under en period. Kontrollera Felrapport (Administration → Felrapport) efter "TripSyncService" eller "syncTripToMariaDB", och överväg att köra Replay för berörda datum.',
    },
    tripSync: {
      title: 'Trip Sync',
      description: 'Bakgrundsjobb som synkar trippar från MongoDB till MariaDB',
      jobEnabled: 'Bakgrundsjobb är aktiverat',
      jobDisabled: 'Bakgrundsjobb är inaktiverat',
      intervalInfo: 'Körs var {{minutes}} minut(er). Trippar som finns i MongoDB men saknas i MariaDB synkas automatiskt.',
      lastRun: 'Senaste körning',
      lastRunTime: 'Körnings tid',
      synced: 'Synkade',
      failed: 'Misslyckade',
      duration: 'Varaktighet',
      runManualSync: 'Kör synk manuellt',
      syncing: 'Synkar...',
      jobRunning: 'Ett synk-jobb körs.',
      missingTripsTitle: 'Saknade trippar (sample)',
      missingTripsDescription: 'Antal trippar som finns i MongoDB men saknas i MariaDB (max 100 visade). Nästa körning kommer att synka dessa.',
      manualSyncSuccess: 'Synk klar: {{synced}} synkade, {{failed}} misslyckade, {{skipped}} hoppade över.',
      manualSyncError: 'Manuell synk misslyckades',
    },
    carinfoFilter: {
      title: 'Fordonsfilter',
      description: 'Välj vilka Car.info-fält som visas i filtret',
    },
    deviceQueues: {
      title: 'Enhetsköer',
      cardDescription: 'Jasper-sessioner tills kedjan är klar',
      description:
        'Bara enheter från Jasper SESSION_START. getver/getvin går först över TCP om enheten är online, annars SMS. getvin N/A: vänta tills bilen läggs upp manuellt (eller tänds), sedan tas VIN från registret och P&P fortsätter. Enhet utan uppkoppling i 30 dagar tas ur kön och kommer tillbaka vid nästa session. Gula rader = STUCK (>24h utan framsteg).',
      refresh: 'Uppdatera',
      empty: 'Inga aktiva enheter i kön.',
      emptyDone: 'Inga klara händelser (senaste 14 dagar).',
      viewLabel: 'Visa',
      viewQueue: 'I kö',
      viewDone: 'Klara',
      sortColumn: 'Sortera på {{column}}',
      countsShort: '{{queue}} i kö · {{done}} klara',
      countsHint: '{{queue}} i kö, {{done}} klara (aktuellt organisationsfilter)',
      colCompleted: 'Klar',
      loadError: 'Kunde inte hämta enhetsköer',
      searchPlaceholder: 'Sök reg.nr, modell, IMEI, grupp…',
      typeSession: 'Jasper',
      typeCommand: 'Kommando-kö',
      typePnp: 'OBD P&P',
      typeForceNonObd: 'Non-OBD',
      colType: 'Fas',
      colReg: 'Reg.nr',
      colMakeModel: 'Fabrikat / modell',
      colGroup: 'Grupp',
      colImei: 'Enhetsnummer',
      colFw: 'FW',
      colLastSeen: 'Sista uppkoppling',
      colAdded: 'Tillagd',
      colStatus: 'Status',
      colActions: 'Åtgärder',
      cmdCount: '{{count}} kommando(n)',
      actionForce: 'Återuppta / tvinga',
      actionRemove: 'Avbryt (cancelled)',
      actionGetver: 'Fråga FW (getver)',
      confirmForce: 'Återuppta pipeline / tvinga nästa steg för denna enhet?',
      confirmRemove: 'Avbryt pipeline för enheten? (enhet/fordon raderas inte)',
      forceOk: 'Körning klar',
      forceQueued: 'Enheten offline — parametrarna är köade till nästa uppkoppling',
      forceFail: 'Kunde inte tvinga körning',
      removeOk: 'Avbruten / borttagen från kö',
      removeFail: 'Kunde inte ta bort från kö',
      getverTitle: 'Firmware från enhet',
      getverOk: 'getver mottagen',
      getverQueued: 'Enheten offline — getver köad',
      getverFail: 'Kunde inte fråga FW',
      markInteresting: 'Markera interessant',
      markOk: 'Markerad som interessant',
      markFail: 'Kunde inte markera',
      exportEmpty: 'Ingen data att exportera',
      exportOk: 'Exporterade {{count}} rader',
    },
    gpsDataLag: {
      title: 'GPS dump-kö',
      cardDescription: 'Enheter som skickar eftersläpande GPS-data',
      description:
        'Visar bara enheter med aktiv dump-kö (mottagen data ligger efter enhetens GPS-tid). När en enhet kommer ikapp försvinner den från listan. Flush skickar Teltonika-kommando via Jasper SMS.',
      refresh: 'Uppdatera',
      loading: 'Laddar…',
      empty: 'Ingen enhet ligger efter just nu.',
      loadError: 'Kunde inte hämta GPS dump-kö',
      searchPlaceholder: 'Sök reg.nr, org, IMEI, ICCID…',
      summary: '{{count}} i dump-kö · uppdaterad {{snapped}}',
      colReg: 'Reg.nr',
      colOrg: 'Organisation',
      colImei: 'IMEI',
      colIccid: 'ICCID',
      colDumpLag: 'Dump-lag',
      colDeviceData: 'Data i enhet',
      colReceived: 'Mottaget',
      colLastRecs: 'Sista recs',
      colActions: 'Åtgärder',
      flush: 'Flush',
      flushing: 'Skickar…',
      flushTitle: 'Skicka flush via SMS (tömma flash)',
      confirmFlush: 'Skicka flush till {{reg}}?',
      flushOk: 'Flush skickad till {{reg}}',
      flushFail: 'Kunde inte skicka flush',
      smsBadge: 'SMS',
    },
    certMonitor: {
      title: 'Certifikatbevakning',
      cardDescription: 'Bevaka certifikat som går ut och hur de förnyas',
      description: 'Bevakar certifikat som går ut – OIDC-klientcert upptäcks automatiskt, HTTPS-hostar proberas live vid Uppdatera, övriga kan registreras manuellt med förnyelse-instruktion.',
      refresh: 'Uppdatera',
      addManual: 'Lägg till certifikat',
      editTitle: 'Redigera certifikat',
      empty: 'Inga certifikat bevakas ännu.',
      colName: 'Namn',
      colStatus: 'Status',
      colExpires: 'Går ut',
      colSource: 'Källa',
      colRenewal: 'Förnyelse',
      sourceAuto: 'Auto (OIDC)',
      sourceManual: 'Manuell',
      statusOk: 'OK ({{days}} dagar kvar)',
      statusExpiring: 'Går ut om {{days}} dagar',
      statusExpired: 'Utgånget',
      statusUnknown: 'Okänt utgångsdatum',
      bannerSummary: '{{expired}} certifikat har gått ut och {{expiring}} går ut snart.',
      bannerLink: 'Visa certifikatbevakning',
      fieldName: 'Namn',
      fieldOrg: 'Organisation',
      fieldCheckHost: 'HTTPS-host (auto)',
      fieldCheckHostHelp: 'T.ex. dqfleet.deque.se – vid Uppdatera hämtas utgångsdatum automatiskt via TLS.',
      fieldPem: 'Certifikat (PEM)',
      fieldPemHelp: 'Klistra in publikt certifikat för att automatiskt läsa ut utgångsdatum, utfärdare och thumbprint.',
      fieldValidTo: 'Utgångsdatum',
      fieldWarningDays: 'Varna antal dagar innan',
      fieldRenewal: 'Förnyelse-instruktion',
      fieldContact: 'Kontakt (e-post)',
      fieldNotes: 'Anteckningar',
      fieldActive: 'Aktiv (bevaka detta certifikat)',
      nameRequired: 'Namn krävs',
      created: 'Certifikat tillagt',
      updated: 'Certifikat uppdaterat',
      deleted: 'Certifikat borttaget',
      confirmDelete: 'Ta bort "{{name}}"?',
      refreshed: 'Skannade {{count}} certifikat',
      refreshedDetail: 'Uppdaterade {{oidc}} OIDC och {{host}} HTTPS-cert ({{errors}} fel)',
      loadError: 'Kunde inte hämta certifikat',
      saveError: 'Kunde inte spara certifikat',
      deleteError: 'Kunde inte ta bort certifikat',
      refreshError: 'Kunde inte uppdatera certifikat',
    },
    security: {
      title: 'Security',
      description: 'CrowdSec-händelser på den här servern, frigör IP och safelista betrodda adresser',
      loadError: 'Kunde inte hämta security-status',
      hostctlMissing: 'Värdkommandot för fail2ban är inte installerat på den här servern. Safelistan sparas i databasen, men bans och loggar syns först när ctl-skriptet är på plats.',
      fail2ban: 'fail2ban',
      crowdsec: 'CrowdSec',
      crowdsecMissing: 'CrowdSec är inte installerat',
      eventsHint: 'Aktiva lokala ban visas överst. Community-blocklistan (tusentals IP) visas inte här.',
      localBans: '{{count}} aktiva lokala ban',
      activeBansHeading: 'Aktiva ban',
      recentAlertsHeading: 'Senaste larm',
      bansMissingInList: 'CrowdSec har aktiva ban men de saknas i listan. Uppdatera sidan.',
      noEvents: 'Inga lokala CrowdSec-händelser just nu',
      banActive: 'Aktiv',
      banExpired: 'Utgången',
      alertOnly: 'Larm (ingen ban)',
      colWhen: 'När',
      colReason: 'Orsak',
      colCountry: 'Land',
      colDetail: 'Nät',
      colUntil: 'Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      noBans: 'Inga banade IP just nu',
      colIp: 'IP',
      colJail: 'Jail',
      unban: 'Frigör',
      unbanOk: 'IP frigjord',
      unbanError: 'Kunde inte frigöra IP',
      safeList: 'Safelista (betrodda IP)',
      comment: 'Kommentar',
      addSafe: 'Lägg till som safe',
      noSafe: 'Inga betrodda IP sparade',
      safeAddOk: 'IP tillagd som safe',
      safeAddError: 'Kunde inte lägga till IP',
      safeRemoveOk: 'IP borttagen från safelista',
      safeRemoveError: 'Kunde inte ta bort IP',
      noLogFile: 'Ingen loggfil hittades för den källan',
      emptyLog: 'Tom logg',
      log: {
        fail2ban: 'fail2ban',
        ufw: 'UFW',
        crowdsec: 'CrowdSec',
        lifeline: 'Livlina',
      },
      scenario: {
        'ssh-bf': 'SSH brute-force',
        'ssh-slow-bf': 'SSH långsam brute-force',
        'ssh-time-based-bf': 'SSH utdragen brute-force',
        'http-bad-user-agent': 'HTTP dålig user-agent',
        'http-sensitive-files': 'HTTP känsliga filer',
        'http-probing': 'HTTP probing',
        'http-crawl-non_statics': 'HTTP crawl',
        'http-path-traversal': 'HTTP path traversal',
        'http-admin-interface-probing': 'HTTP admin-probing',
        'http-technology-probing': 'HTTP teknik-probing',
        'http-cve-probing': 'HTTP CVE-probing',
        'http-generic-test': 'HTTP generic test',
      },
    },
    ssoLog: {
      title: 'SSO-logg',
      cardDescription: 'Misslyckade och avbrutna SSO-försök, per kund och enhet',
      description: 'Visa misslyckade SSO-inloggningar: vem som försökte, vilken kund, varför det stoppade och om det kom från mobil eller dator.',
      loadError: 'Kunde inte hämta SSO-loggen',
      empty: 'Inga SSO-försök matchar filtren',
      period: 'Period',
      days: '{{count}} dagar',
      customer: 'Kund',
      allOrgs: 'Alla kunder',
      user: 'Användare',
      userPlaceholder: 'E-post eller namn',
      channel: 'Kanal',
      deviceLabel: 'Enhet',
      statusLabel: 'Status',
      colCustomer: 'Kund',
      colWhen: 'När',
      colEmail: 'Inloggningsadress',
      colSentToIdp: 'Skickat till Microsoft',
      colUser: 'Användare',
      unknownEmail: 'Okänd (ingen e-post innan Microsoft)',
      nothingSentToIdp: 'Inget skickat till Microsoft',
      sentToIdp: 'Skickat till Microsoft: {{value}}',
      sentToIdpNone: 'Skickat till Microsoft: inget',
      idpUsernameFilledThere: 'Användaren fyller användarnamn hos IdP (Skåne: rsid@skane.se)',
      nothingPrefillsIdp: 'Inget användarnamn förifyllt hos Microsoft',
      exportError: 'Kunde inte exportera CSV',
      colOrg: 'Kund',
      colChannel: 'Kanal',
      colDevice: 'Enhet',
      colReason: 'Orsak',
      showing: 'Visar {{from}}–{{to}} av {{total}}',
      client: {
        web: 'Dator (webb)',
        mobile: 'Mobilapp',
        unknown: 'Okänd kanal',
      },
      device: {
        phone: 'Mobiltelefon',
        tablet: 'Surfplatta',
        computer: 'Dator',
        unknown: 'Okänd enhet',
      },
      os: {
        ios: 'iOS',
        android: 'Android',
        windows: 'Windows',
        macos: 'macOS',
        linux: 'Linux',
        unknown: 'okänt OS',
      },
      status: {
        all: 'Alla',
        unsuccessful: 'Misslyckade och avbrutna',
        failed: 'Misslyckade',
        abandoned: 'Avbrutna',
        in_progress: 'Pågående',
        success: 'Lyckade',
      },
      reason: {
        none: '–',
        idp_error: 'Avvisad hos Microsoft / IdP',
        callback_error: 'Fel vid återkomst från inloggning',
        initiate_error: 'Kunde inte starta SSO',
        app_no_exchange: 'Appen hämtade inte sessionen',
        abandoned_at_idp: 'Avbröts hos Microsoft (ingen återkomst)',
        abandoned_after_callback: 'Avbröts efter återkomst',
        unknown_error: 'Okänt fel',
      },
    },
    vehicleCarinfoSync: {
      title: 'Synka fordon från Car.info',
      description: 'Synka fordonsinformation från Car.info-tjänsten',
    },
    ecoSettings: {
      title: 'ECO-inställningar',
      description: 'Konfigurera tröskelvärden för ECO-körning',
      selectOrganization: 'Välj organisation',
      globalDefaults: 'Globala standardvärden',
      harshDriving: 'Hård körning',
      harshDrivingDescription: 'Tröskelvärden för att detektera hård körning',
      maxAcceleration: 'Max acceleration (m/s²)',
      maxBraking: 'Max inbromsning (m/s²)',
      maxCornering: 'Max kurvtagning (m/s²)',
      excessiveIdling: 'Tomgång (sekunder)',
      overspeedPercent: 'Fortkörningsgräns (%)',
      greenDriving: 'Grön körning',
      greenDrivingDescription: 'Tröskelvärden för att belöna mjuk körning',
      greenMaxAcceleration: 'Max acceleration för grön körning (m/s²)',
      greenMaxBraking: 'Max inbromsning för grön körning (m/s²)',
      greenMinSpeed: 'Min hastighet (km/h)',
      greenMinDuration: 'Min duration (sekunder)',
      save: 'Spara inställningar',
      saved: 'Inställningar sparade',
      saveError: 'Kunde inte spara inställningar',
      infoTitle: 'Information om tröskelvärden',
      infoText: 'Dessa tröskelvärden används för att detektera ECO-körningshändelser. Teltonika-standardvärden är baserade på tillverkarens rekommendationer. Du kan anpassa värdena per organisation eller använda globala standardvärden.',
    },
  },

  // Systems & Modules
  systems: {
    noModules: 'Inga moduler tillgängliga',
    selectModule: 'Välj en modul för att fortsätta',
  },

  // Device Commands
  deviceCommands: {
    title: 'Skicka kommandon till enhet',
    description: 'Välj kommandon och skicka till en enhet',
    availableCommands: 'Tillgängliga kommandon',
    selectedCommands: 'Valda kommandon',
    addCommand: 'Lägg till kommando',
    removeCommand: 'Ta bort',
    deviceImei: 'Enhet IMEI',
    deviceImeiPlaceholder: 'Ange IMEI (t.ex. 869616066816375)',
    searchDevicePlaceholder: 'Sök IMEI eller fordon...',
    searchCommands: 'Sök kommandon...',
    noCommands: 'Inga kommandon hittades',
    noCommandsSelected: 'Välj kommandon från katalogen',
    noDevicesFound: 'Inga enheter hittades',
    loadingDevices: 'Laddar enheter...',
    loading: 'Laddar...',
    sendCommands: 'Skicka kommandon',
    sendCount: 'Skicka {count} kommando(n)',
    sending: 'Skickar...',
    commandsSent: 'Kommando(n) skickade',
    errorSending: 'Kunde inte skicka kommandon',
    errorLoading: 'Kunde inte ladda kommandon',
    requiredParameter: 'Parameter krävs',
    enterImei: 'Ange IMEI för enheten',
    selectAtLeastOne: 'Välj minst ett kommando',
    vehicleLabel: 'Fordon',
    selectOption: 'Välj...',
    booleanYes: 'Ja',
    booleanNo: 'Nej',
  },

  // Audit Log
  auditLog: {
    title: 'Mina skickade kommandon',
    description: 'Logg över alla kommandon och queries som du har skickat till enheter',
    dateTime: 'Datum/Tid',
    device: 'Enhet (IMEI)',
    command: 'Kommando',
    parameters: 'Parametrar',
    status: 'Status',
    response: 'Svar',
    showParameters: 'Visa parametrar',
    showResponse: 'Visa svar',
    received: 'Mottaget',
    noCommands: 'Inga kommandon hittades',
    loading: 'Laddar...',
    total: 'Totalt',
    successful: 'Lyckade',
    pending: 'Väntande',
    failed: 'Misslyckade',
    devices: 'Enheter',
    commandTypes: 'Kommando-typer',
    filterImei: 'Sök IMEI...',
    filterCommand: 'Sök kommando...',
    filterStatus: 'Alla statusar',
    filterDateFrom: 'Från datum',
    filterDateTo: 'Till datum',
    statusPending: 'Väntande',
    statusSent: 'Skickat',
    statusAcknowledged: 'Bekräftat',
    statusFailed: 'Misslyckat',
    statusTimeout: 'Timeout',
    showing: 'Visar',
    of: 'av',
    previous: 'Föregående',
    next: 'Nästa',
    queueStatus: 'Kö-status',
    lastSeen: 'Senast uppkopplad',
    inQueue: 'I kö',
    showCount: 'Visa ({count})',
    none: 'Inga',
    deleteCommand: 'Ta bort kommando',
    justNow: 'Just nu',
    minutesAgo: '{count} min sedan',
    hoursAgo: '{count} tim sedan',
    daysAgo: '{count} dagar sedan',
    never: 'Aldrig',
  },

  // Migration
  migration: {
    title: 'Datamigrering',
    description: 'Migrera data från gamla databaser till nytt system',
    selectDatabase: 'Välj databas',
    selectMigrations: 'Välj vad som ska migreras',
    migrationOrder: 'Migreringar körs i den ordning de är listade. Markera de du vill köra.',
    testConnection: 'Testa anslutning',
    testing: 'Testar...',
    connected: 'Ansluten',
    disconnected: 'Ej ansluten',
    connectionSuccess: 'Anslutning lyckades',
    connectionFailed: 'Anslutning misslyckades',
    connectionError: 'Fel vid anslutningstest',
    errorLoadingDatabases: 'Fel vid laddning av databaser',
    selectDatabaseFirst: 'Välj en databas först',
    selectMigrationsFirst: 'Välj minst en migrering att köra',
    runSelected: 'Kör valda migreringar',
    dryRun: 'Testkörning (Dry Run)',
    dryRunDescription: 'Visa vad som skulle migreras utan att spara data',
    run: 'Kör migrering',
    rerun: 'Kör igen',
    running: 'Körs',
    completed: 'Slutförd',
    failed: 'Misslyckades',
    success: 'Migrering lyckades: {succeeded} av {processed} poster',
    error: 'Fel vid migrering',
    runAll: 'Kör alla migreringar',
    records: 'poster',
    processed: 'Processade',
    succeeded: 'Lyckades',
    errors: 'Fel',
    warnings: 'Varningar',
    users: 'Användare',
    usersDescription: 'Migrera användare från gammal databas',
    organizations: 'Organisationer',
    organizationsDescription: 'Migrera organisationer från gammal databas (måste köras först)',
    vehicles: 'Fordon',
    vehiclesDescription: 'Migrera fordon från gammal databas',
    deviceVehicleHistory: 'Enhet–fordon-historik',
    deviceVehicleHistoryDescription: 'Importera när IMEI varit kopplad till vilken bil (obd_config_logger). Kräver att fordonsmigrering körts först.',
    deviceOrganizations: 'Enheter till organisationer',
    deviceOrganizationsDescription: 'Koppla IMEI-enheter till organisationer från tobd. Sätter status CUSTOMER på enheter som inte redan sitter i fordon.',
    mongoTripsVehicleBackfill: 'Mongo: synka trip vehicleId',
    mongoTripsVehicleBackfillDescription:
      'Uppdaterar MongoDB trips.vehicleId utifrån aktiv devices.vehicle_id per IMEI (samma princip som trip-sync IMEI-remap). Kör efter fordonsmigrering; påverkar hela databasen, inte bara vald org.',
    step1: 'Välj databas',
    step2: 'Välj organisationer',
    step3: 'Kör migreringar',
    selectOrganizations: 'Välj organisationer att importera',
    selectOrganizationsDescription: 'Markera de organisationer du vill importera. Underliggande organisationer inkluderas automatiskt.',
    loadingOrganizations: 'Hämtar organisationer...',
    noOrganizationsFound: 'Inga organisationer hittades i databasen',
    selectAll: 'Markera alla',
    deselectAll: 'Avmarkera alla',
    selectedCount: '{count} valda',
    next: 'Nästa',
    back: 'Tillbaka',
    searchOrganizations: 'Sök organisationer...',
    selectOrganizationsFirst: 'Välj minst en organisation att importera',
    children: 'underliggande',
    topNode: 'Topnod',
    preview: 'Förhandsgranska / Validera',
    previewing: 'Validerar...',
    previewTitle: 'Förhandsgranskning / validering',
    previewDescription: 'Kontrollera namnkollisioner, strukturkonflikter och fordon-till-grupp innan skarp körning. Ändrar ingen data.',
    previewError: 'Fel vid förhandsgranskning',
    previewOrgs: 'Organisationer',
    previewCollisions: 'Namnkollisioner',
    previewConflicts: 'Strukturkonflikter',
    previewVehicles: 'Fordon (OK/totalt)',
    previewVehicleIssues: 'Fordon som skippas',
    previewColName: 'Namn',
    previewColPath: 'Källans o_path',
    previewColExisting: 'Befintliga i målet',
    previewColCurrentParent: 'Nuvarande förälder',
    previewColSourceParent: 'Förälder i källan',
    previewColReg: 'Reg.nr',
    previewColImei: 'IMEI',
    previewColStatus: 'Status',
    previewStatusUnmapped: 'Org ej mappad (skippas)',
    previewStatusNoImei: 'Saknar IMEI (skippas)',
    previewCollisionNote: 'Samma namn finns redan i målet (annan struktur/källa). Import skapar en SEPARAT nod – ingen sammanslagning på namn.',
    previewNoIssues: 'Inga problem hittades.',
    previewGroups: 'Grupper (finns/totalt)',
    previewNewShort: 'nya',
    previewGroupOverview: 'Grupper – finns i systemet?',
    previewColInSystem: 'I systemet',
    previewGroupExists: 'Finns',
    previewGroupNameCollision: 'Namn finns (annan grupp)',
    previewGroupNew: 'Saknas – skapas',
    previewGroupWillCreate: 'Skapas vid import',
    previewGroupNote: 'Grupper markerade "Saknas – skapas" finns inte i systemet och skapas vid import. "Namn finns (annan grupp)" = samma namn finns redan men på en annan nod.',
    previewVehiclesOtherGroup: 'Bilar i annan grupp',
    previewVehiclesOtherGroupNote: 'Dessa bilar finns redan i systemet men ligger i en annan grupp än den de skulle mappas till.',
    previewColCurrentGroup: 'Ligger nu i',
    previewColTargetGroup: 'Skulle mappas till',
  },

  // Devices
  devices: {
    imei: 'IMEI',
    model: 'Modell',
    currentFirmware: 'Nuvarande firmware',
    fotaStatus: 'FOTA-status',
    currentConfiguration: 'Nuvarande konfiguration',
    gsmNumber: 'GSM-nummer',
    searchPlaceholder: 'Sök IMEI (hela eller del), modell, firmware, konfiguration eller GSM...',
    showingResults: 'Visar {count} av {total} enheter',
    lastSync: 'Senast synkroniserad',
    lastSeen: 'Senast sedd',
    seenAt: 'Senast sedd',
    online: 'Online',
    offline: 'Offline',
    noResults: 'Inga enheter matchade sökningen',
    noDevices: 'Inga enheter hittades',
    loadCommandsError: 'Kunde inte ladda kommandon',
    loadDevicesError: 'Kunde inte ladda enheter',
    sendCommandsError: 'Kunde inte skicka kommandon',
    simStatus: 'SIM-STATUS',
    simStatusChanged: 'SIM-status ändrad',
    couldNotChangeStatus: 'Kunde inte ändra status',
    statusChangeError: 'Fel vid ändring av status',
    noSim: 'Inget SIM',
    deviceDetailsTitle: 'Enhetsdetaljer',
    firmware: 'Firmware',
    configuration: 'Konfiguration',
    simCardJasper: 'SIM-kort (Jasper)',
    fetchingSimStatus: 'Hämtar SIM-status...',
    ratePlan: 'Tariffplan',
    commPlan: 'Komm.plan',
    usageThisPeriod: 'Användning denna period',
    sessions: 'Sessioner',
    couldNotFetchSimStatus: 'Kunde inte hämta SIM-status',
    simStatusActivated: 'Aktiverad',
    simStatusReady: 'Redo',
    simStatusInactive: 'Inaktiv',
    simStatusInventory: 'Lager',
    simStatusRetired: 'Avslutad',
    simStatusTest: 'Test',
    syncNow: 'Synka enheter nu',
    syncStarted: 'Enhetssynk startad',
    syncStartedBody: 'Uppdatering från Teltonika och Jasper körs i bakgrunden (kan ta några minuter). Fält som FOTA-status och senast synkad uppdateras när jobbet är klart.',
    syncForbidden: 'Du saknar behörighet att starta enhetssynk.',
    syncFailed: 'Kunde inte starta enhetssynk',
  },

  // Vehicles
  vehicles: {
    loadError: 'Kunde inte ladda fordon',
    deviceLink: {
      modalTitle: 'Koppla enhet till {{reg}}',
      successTitle: 'Enhet kopplad',
      successMessage: 'Enhet kopplad till {{reg}}',
      successAssigned: 'Enheten är nu tilldelad {{org}}',
      existingDeviceWarning: 'Fordonet har redan enhet: ',
      unmountToStock: 'Demontera befintlig (till lager)',
      swap: 'Byt ut (SWAP)',
      searchPlaceholder: 'Sök IMEI, modell, ICCID...',
      filterAvailable: 'Lediga (ej monterade)',
      filterStock: 'Lager',
      filterCustomer: 'Kund',
      filterReturned: 'Returnerad',
      countAvailable: 'Visar {{count}} lediga enheter',
      countAvailablePaged: 'Visar {{shown}} av {{total}} lediga enheter',
      loadMore: 'Visa fler',
      countFilteredOrg: 'Egna lediga enheter och Deque-lager',
      platformStock: 'Deque-lager',
      assignedToOrg: 'Tilldelas "{{org}}" vid koppling',
      noDevicesFound: 'Inga lediga enheter hittades',
      loadingDevices: 'Laddar enheter...',
      statusCurrent: 'Nuvarande',
      selectedDevice: 'Vald enhet: ',
      deviceMountedElsewhere: 'Obs: Enheten är monterad på {{reg}} — den kommer demonteras därifrån',
      linking: 'Kopplar...',
      linkButton: 'Koppla enhet till fordon',
      statusStock: 'Lager',
      statusCustomer: 'Kund',
      statusVehicle: 'Monterad',
      statusReturned: 'Returnerad',
    },
  },

  // SIM Cards
  simCards: {
    title: 'SIM-korthantering',
    description: 'Hantera SIM-kort, visa användning och skapa rapporter',
    overview: 'Översikt',
    simCards: 'SIM-kort',
    reports: 'Rapporter',
    totalSimCards: 'Totalt SIM-kort',
    totalDataUsage: 'Total dataanvändning',
    totalSms: 'Totalt SMS',
    billingCycle: 'Faktureringsperiod',
    ratePlans: 'Tariffplaner',
    refresh: 'Uppdatera',
    fetch: 'Hämta',
    allStatuses: 'Alla status',
    searchPlaceholder: 'Sök ICCID, MSISDN, IMEI...',
    ratePlan: 'Tariffplan',
    dataMB: 'Data (MB)',
    activated: 'Aktiverad',
    noSimCards: 'Inga SIM-kort hittades',
    loading: 'Laddar...',
    createReport: 'Skapa rapport',
    creatingReport: 'Skapar rapport...',
    reportCreated: 'Rapport skapad',
    latestReport: 'Senaste rapport',
    deviceCount: 'Antal enheter',
    totalData: 'Total data',
    period: 'Period',
    invoiceNote: 'Fakturor kan inte hämtas automatiskt. Logga in på Jasper Control Center för att ladda ner fakturor.',
    // Status
    statusActivated: 'Aktiverad',
    statusActivationReady: 'Redo',
    statusDeactivated: 'Inaktiv',
    statusInventory: 'Lager',
    statusRetired: 'Avslutad',
    statusTestReady: 'Test',
    statusDistribution: 'Statusfördelning',
    activatedCount: 'Aktiverade',
    deactivatedCount: 'Inaktiverade',
    otherCount: 'Övriga',
    lastSynced: 'Senast synkad',
    showingRange: 'Visar {start}-{end} av {total}',
    previous: 'Föregående',
    next: 'Nästa',
    createUsageReport: 'Skapa användningsrapport',
    createUsageReportDesc: 'Generera en aggregerad rapport över all SIM-kortsanvändning för aktuell faktureringsperiod.',
    noteLabel: 'OBS:',
    // Errors
    fetchError: 'Kunde inte hämta data',
    createReportError: 'Kunde inte skapa rapport',
  },

  // Geofences
  geofences: {
    title: 'Geofences',
    subtitle: 'Hantera geografiska områden',
    list: 'Geofences',
    create: 'Skapa geofence',
    edit: 'Redigera geofence',
    delete: 'Ta bort geofence',
    noGeofences: 'Inga geofences skapade',
    searchPlaceholder: 'Sök geofences...',
    showSystemGeofences: 'Visa systemgeofences',
    area: 'Område',
    polygonWith: 'Polygon med',
    points: 'punkter',
    editPoints: 'Redigera punkter',
    redraw: 'Rita om',
    drawPolygon: 'Rita polygon på kartan',
    editModeActive: 'Redigeringsläge aktivt',
    dragPoints: 'Dra',
    redPointsToMove: 'röda punkter för att flytta',
    clickGreenPoints: 'Klicka på gröna punkter',
    toAdd: 'för att lägga till',
    rightClickRedPoint: 'Högerklicka',
    onRedToRemove: 'på röd punkt för att ta bort',
    doneBackToForm: 'Klar - Tillbaka till formulär',
    events: {
      title: 'Geofence-händelser',
      subtitle: 'Visa alla in- och utpassage-händelser med plats, tid och kostnad',
      filter: 'Filter',
      vehicle: 'Fordon',
      allVehicles: 'Alla fordon',
      geofence: 'Geofence',
      searchGeofence: 'Sök geofence...',
      allGeofences: 'Alla geofences',
      geofencesMatch: 'geofences matchar',
      eventType: 'Händelsetyp',
      allTypes: 'Alla typer',
      enter: 'Inpassage',
      exit: 'Utpassage',
      fromDate: 'Från datum',
      toDate: 'Till datum',
      clearFilters: 'Rensa filter',
      refresh: 'Uppdatera',
      vehicleColumn: 'Fordon',
      geofenceColumn: 'Geofence',
      eventTypeColumn: 'Typ',
      locationColumn: 'Plats',
      timeColumn: 'Tidpunkt',
      durationColumn: 'Varaktighet',
      costColumn: 'Kostnad',
      totalCost: 'Totalkostnad',
      noEvents: 'Inga händelser hittades',
      loading: 'Laddar händelser...',
      error: 'Kunde inte ladda geofence-händelser',
      totalEvents: 'Totalt antal händelser',
      enterEvents: 'Inpassage',
      exitEvents: 'Utpassage',
      error404: 'Geofence-händelser API saknas (404)',
      error401: 'Autentisering krävs (401)',
      searchVehicle: 'Sök fordon...',
      vehicleFallback: 'Fordon',
      eventColumn: 'Händelse',
      durationInside: 'Tid inne',
      showing: 'Visar',
      of: 'av',
      events: 'händelser',
      page: 'Sida',
      vehiclesMatch: 'fordon matchar',
    },
    name: 'Namn',
    description: 'Beskrivning',
    scope: 'Omfattning',
    scopeGlobal: 'Global (alla organisationer)',
    scopeOrganization: 'Specifik organisation',
    organization: 'Organisation',
    isActive: 'Aktiv',
    alarmOnEnter: 'Larm vid inpassage',
    alarmOnExit: 'Larm vid utpassage',
    filterCoordinates: 'Dölj koordinater inom området',
    isToll: 'Tullområde',
    costPerEntry: 'Kostnad per inpassage (SEK)',
    costPerMinute: 'Kostnad per minut (SEK)',
    polygonDrawn: 'Polygon ritad',
    finishDrawing: 'Slutför',
    cancelDrawing: 'Avbryt',
    minPoints: 'En polygon måste ha minst 3 punkter',
    hide: 'Dölj',
    show: 'Visa',
    inactive: 'Inaktiv',
    alarmIn: 'Larm in',
    alarmOut: 'Larm ut',
    activated: 'Geofence aktiverad',
    deactivated: 'Geofence inaktiverad',
    created: 'Geofence skapad',
    updated: 'Geofence uppdaterad',
    deleted: 'Geofence borttagen',
    errorLoading: 'Kunde inte ladda geofences',
    errorSaving: 'Kunde inte spara geofence',
    errorDeleting: 'Kunde inte ta bort geofence',
    confirmDelete: 'Vill du ta bort geofence',
    minPointsRequired: 'Minst 3 punkter krävs',
    pointRemoved: 'Punkt borttagen',
    pointAdded: 'Ny punkt tillagd',
    loadError: 'Kunde inte ladda geofences',
  },

  // Trips
  tripAnalysis: {
    title: 'Analysera Trippar',
    description: 'Jämför registrerade trippar mot fordonets bin-fil för att identifiera avvikelser',
    analyze: 'Analysera',
    replay: 'Replay',
    replayHint: 'Kör om trippdetektering från bin-fil (skapar/uppdaterar trippar)',
    replayStarted: 'Replay startad',
    replayFailed: 'Kunde inte starta replay',
    selectVehicleFirst: 'Välj ett fordon för att börja',
    registered: 'Registrerade',
    fromBin: 'Från bin-fil',
    diff: 'Differens',
    records: 'punkter',
    registeredTrips: 'Registrerade trippar',
    binTrips: 'Trippar från bin-fil',
    noRegistered: 'Inga registrerade trippar',
    noBinTrips: 'Inga trippar i bin-filen (se varningar ovan)',
    loadBinHint: 'Analysera för att läsa in bin-filen',
    maxSpeed: 'max',
    gpsPoints: 'GPS-punkter',
    noAvl250: 'Ingen AVL250',
    warnNoRecords: 'Inga GPS-punkter i bin-filen',
    warnNoSpeed: 'Hastighet = 0 i alla punkter (ingen körlogg)',
    warnNoAvl250: 'AVL250 (trippsignal) saknas helt',
    warnNoGpsFix: 'GPS-fix saknas ofta (sat=0)',
    warnSparse: 'Glesa punkter – bara heartbeats',
    reconstructed: 'Rekonstruerad',
    reconstructedHint: 'Rekonstruerad tripp (GPS saknades vid kallstart) - sträcka från OEM-mätare eller OSRM-uppskattning',
    warnNoBinFile: 'Ingen bin-fil finns för fordonet/datumet på gatewayen',
    underDetectedTitle: 'Färre bin-trippar än registrerat – trolig detekteringsmiss',
    underDetectedBody:
      'Bin-filen innehåller körning (hastighet > 0) men batch-/replay-detekteringen hittade färre trippar än de registrerade. Rådatan är korrekt – det är trippdetekteringen (samma som replay använder) som under-segmenterar, t.ex. för enheter med gles AVL250. Kör INTE replay för detta fordon: det skulle ersätta korrekta trippar med färre.',
    replayDestructiveConfirm:
      'Varning: bin-/replay-detekteringen hittade färre trippar än de registrerade trots att bin-filen innehåller körning. En replay skulle troligen ERSÄTTA korrekta trippar med färre. Vill du ändå fortsätta?',
  },
  obdVehicles: {
    title: 'OBD-fordonslista',
    description: 'Sök Teltonikas OBD OEM-stöd per märke och modell. Listan gäller FMX001/FMM00A/FMX003, inte FMM003-certifiering.',
    deviceFamilyNote: 'Källa: Teltonika wiki för FMX001, FMM00A och FMX003. DQFleet P&P kör FMM003 — använd listan som OEM-referens.',
    checkNow: 'Kolla nu',
    import: 'Importera',
    checkFailed: 'Kunde inte kolla wikin',
    searchFailed: 'Kunde inte söka',
    syncFailed: 'Kunde inte importera listan',
    detailFailed: 'Kunde inte hämta detaljer',
    alreadyLatest: 'Redan senaste versionen',
    imported: 'Importerade {{count}} rader',
    wikiDate: 'Wiki-datum',
    ourDate: 'Vår version',
    none: 'Ingen',
    rows: 'Rader',
    newerAvailable: 'Ny fil finns',
    allMakes: 'Alla märken',
    allParameters: 'Alla parametrar',
    make: 'Märke',
    model: 'Modell',
    year: 'År',
    fuelType: 'Bränsle',
    resultCount: '{{count}} träffar',
    scrollHint: 'Scrolla i sidled för alla parametrar',
    deviceFamily: 'Källenheter',
    relatedKb: 'Relaterade wiki-sidor',
    fleetMatches: 'Fordon i flottan',
    forceNonObd: 'tvingad Non-OBD',
  },
  obdKnowledge: {
    title: 'OBD Knowledge',
    description: 'Sökbar kopia av Teltonika OBD Solutions. Alltid länk tillbaka till wikin.',
    sources: 'Källor',
    sync: 'Synka nu',
    loadFailed: 'Kunde inte hämta källor',
    searchFailed: 'Kunde inte söka',
    syncFailed: 'Kunde inte synka',
    pageMissing: 'Sidan är inte hämtad ännu — kör synk',
    synced: 'Synk klar: {{updated}} uppdaterade av {{checked}}',
    notFetched: 'ej hämtad',
    openWiki: 'Öppna hos Teltonika',
    searchPlaceholder: 'Sök t.ex. Non-OBD, EV, Kia…',
    vehicleHits: '{{count}} fordon i listan',
    openVehicleList: 'Öppna fordonslistan',
    vehicleListPageNote:
      'Wiki-sidan är en stor tabell. Använd OBD-fordonslistan för att söka märke, modell och parametrar.',
    noVehicleHits: 'Inga rader i den importerade fordonslistan. Importera xlsx under OBD-fordonslistan.',
    askAi: 'Fråga AI',
    askPlaceholder: 'T.ex. Vilka OEM-parametrar stöds för Kia Niro och hur felsöker jag om de saknas?',
    ask: 'Fråga',
    askFailed: 'AI kunde inte svara',
  },
  trips: {
    private: 'Privat resa',
    business: 'Tjänsteresa',
    privateHidden: 'Privat - detaljer dolda',
    privateNoMap: 'Kartvy inte tillgänglig för privata resor',
    title: 'Trippar',
    description: 'Visa och analysera trippar för dina fordon',
    selectVehicle: 'Välj fordon',
    selectVehiclePlaceholder: '-- Välj fordon --',
    tripsList: 'Trippar',
    loading: 'Laddar trippar...',
    noTrips: 'Inga trippar hittades för detta fordon',
    selectVehicleFirst: 'Välj ett fordon för att visa trippar',
    fromDate: 'Från datum',
    toDate: 'Till datum',
    clearDateFilter: 'Rensa datumfilter',
    selectTripToView: 'Välj en tripp för att visa på karta',
    selectVehicleToView: 'Välj ett fordon för att börja',
    completed: 'Klar',
    alarms: 'Larm',
    alarmCount: '{{count}} larm',
    alarmCountTitle: 'Körbeteendelarm på denna resa',
    noAlarms: 'Inga larm',
    electricShare: 'Elandel {{pct}} %',
    electricDistance: '{{km}} km el',
    electricShareTitle: 'Andel av sträckan i eldrift ({{km}} km el)',
    errorLoadingVehicles: 'Kunde inte ladda fordon',
    errorLoadingTrips: 'Kunde inte ladda trippar',
    speedChart: 'Hastighetskurva',
    showSpeedChart: 'Visa hastighetskurva',
    hideSpeedChart: 'Dölj hastighetskurva',
    vehicleSpeed: 'Fordonets hastighet',
    speedLimit: 'Hastighetsgräns',
    speedUnit: 'km/h',
    playTrip: 'Spela upp',
    pauseTrip: 'Stoppa',
    resetTrip: 'Återställ',
    jammingLegend: 'Jamming (AVL 249) – {count} GPS-punkter',
    speed: 'Hastighet',
    routePointCount: 'Antal ruttpunkter',
    noSpeedLimitData: 'Hastighetsbegränsning saknas för alla punkter i denna tripp. Data kan saknas för äldre trippar eller om OSM-tjänsten inte kunde hämta hastighetsbegränsningar.',
    speedLimitRefreshHint: 'Hastighetsgränser läggs till i bakgrunden efter avslutad tripp. Ladda om trippen (byt tripp och tillbaka, eller ladda om sidan) om några sekunder om de fortfarande saknas.',
    partialSpeedLimitData: 'Hastighetsbegränsning finns endast för {withLimit} av {total} punkter.',
    loadRouteError: 'Kunde inte ladda tripp-rutt',
    loadingRoute: 'Laddar rutt...',
    showPointsTable: 'Visa punkttabell',
    hidePointsTable: 'Dölj punkttabell',
    pointsTableTitle: 'Punkter (tid, hastighet, körd sträcka)',
    avl199: 'Körd sträcka (km)',
    time: 'Tid',
    binData: 'Bin-data',
    binDataModalTitle: 'Bin-data – tripp',
    binDataLoading: 'Hämtar bin-data...',
    binDataFetchError: 'Kunde inte hämta bin-data',
    saveAsCsvColon: 'Spara som CSV (semikolon-separerad)',
    close: 'Stäng',
    binDataTimestamp: 'Timestamp',
    binDataAvl: 'AVL',
    binDataParameter: 'Parameter',
    binDataDescription: 'Beskrivning',
    binDataValue: 'Värde',
  },

  // ECO Driving
  eco: {
    title: 'ECO Driving',
    description: 'Analysera körvanor och miljöpåverkan',
    score: 'ECO-poäng',
    overview: 'Översikt',
    events: 'Händelser',
    trends: 'Trender',
    comparison: 'Jämförelse',
    totalEvents: 'Totalt händelser',
    harshAcceleration: 'Hård acceleration',
    harshBraking: 'Hård inbromsning',
    harshCornering: 'Hård kurvtagning',
    overspeed: 'Fortkörning',
    excessiveIdling: 'Tomgångskörning',
    coasting: 'Utrullning',
    greenDriving: 'Miljövänlig körning',
    fuelWaste: 'Bränsleförlust',
    energyLoss: 'Energiförlust',
    fuelSaved: 'Bränslebesparing',
    energySaved: 'Energibesparing',
    estimatedExtraCo2: 'Uppskattad extra CO₂-utsläpp',
    estimatedFuelLoss: 'Uppskattad bränsleförlust',
    noTailpipeEmissions: 'Elbil — inga avgasutsläpp från fordonet',
    comparisonWithinOrg: 'Jämförelse inom din organisation',
    fuelLossPerDay: 'Bränsleförlust per dag (ml)',
    energyLossPerDay: 'Energiförlust per dag (kWh)',
    co2Emission: 'CO₂-utsläpp',
    scoreImpact: 'Poängpåverkan',
    eventsPerTrip: 'Händelser per resa',
    environmentImpact: 'Miljöpåverkan',
    distributionByType: 'Fördelning per typ',
    eventsPerDay: 'Händelser per dag',
    noEvents: 'Inga händelser under vald period',
    basedOnTrips: 'Baserat på {trips} resor och {events} händelser',
    of100: 'av 100',
    totalScoreImpact: 'Total poängpåverkan',
  },

  speedCompliance: {
    title: 'Hastighetsefterlevnad',
    description: 'Analysera hastighetsefterlevnad per organisation och fordon',
    overview: 'Översikt',
    organizations: 'Per organisation',
    vehicles: 'Per fordon',
    trend: 'Trend',
    complianceRate: 'Efterlevnad',
    overspeeds: 'Överträdelser',
    trips: 'Resor',
    distance: 'Distans',
    timeOverLimit: 'Tid över gräns',
    exportExcel: 'Exportera Excel',
    topOffenders: 'Flest överträdelser (fordon)',
    complianceByOrg: 'Efterlevnad per organisation',
    trendOverTime: 'Efterlevnad över tid',
    newSystem: 'DQFleet (Nya systemet)',
    oldSystem: 'Gamla systemet',
    noLegacyConnection: 'Fordonet har ingen koppling till gamla systemet',
    tripsFound: 'trippar hittade',
    noTripsForDate: 'Inga trippar för valt datum',
    selectVehicle: 'Välj ett fordon',
    loadingTrips: 'Laddar trippar...',
    loadingOldTrips: 'Laddar trippar från gamla systemet...',
    source: 'Källa',
    oldId: 'Gammalt ID',
    notMigrated: 'Ej migrerad',
    gpsPoints: 'GPS-punkter',
    totalDistance: 'Total sträcka',
  },

  // Energiförbrukning
  energyConsumption: {
    title: 'Energiförbrukning',
    description: 'Analysera bränsleförbrukning per organisation och fordon',
    totalVehicles: 'Antal fordon',
    totalDistance: 'Total distans',
    totalFuel: 'Total bränsleförbrukning',
    avgConsumption: 'Genomsnittlig förbrukning',
    fuel: 'Bränsle (L)',
    wltp: 'WLTP Blandad',
    consumption: 'Förbrukning',
    avgSpeed: 'Snitthastighet',
    fuelByOrg: 'Bränsle per organisation',
    consumptionDist: 'Förbrukningsfördelning',
    consumptionTrend: 'Förbrukningstrend',
    distanceTrend: 'Distanstrend',
    lowConsumption: 'Låg förbrukning',
    mediumConsumption: 'Medium förbrukning',
    highConsumption: 'Hög förbrukning',
  },

  // Heatmap
  jamDetection: {
    title: 'Störningsdetektering',
    from: 'Från',
    to: 'Till',
    refresh: 'Uppdatera',
    markers: 'Markörer',
    heatmap: 'Värmekarta',
    totalPoints: 'Störningspunkter',
    affectedVehicles: 'Berörda fordon',
    vehicle: 'Fordon',
    truncated: 'Visar max 20 000 punkter – begränsa datumspannet',
    noData: 'Inga störningar i perioden',
    loadError: 'Kunde inte hämta störningsdata',
  },
  heatmap: {
    title: 'Heatmap',
    description: 'Visualisera GPS-data och hastighetsöverträdelser',
    organization: 'Organisation',
    selectOrganization: 'Välj organisation...',
    vehicles: 'Fordon',
    selectVehicle: 'Välj fordon...',
    selectVehicleFromOrg: 'Välj fordon från organisation...',
    allVehicles: 'Alla',
    allVehiclesInOrg: 'Alla fordon i organisationen',
    vehiclesInOrg: 'fordon i organisationen',
    fromDate: 'Från datum',
    toDate: 'Till datum',
    mode: 'Läge',
    modeAll: 'Alla punkter',
    modeOverspeed: 'Hastighetsöverträdelser',
    modeIdling: 'Idling/Tomgång',
    modeParking: 'Parkeringar',
    modeEco: 'ECO-händelser',
    modeTimePattern: 'Tidsbaserade mönster',
    modeGeofence: 'Geofence-överträdelser',
    modeIncidents: 'Olyckor/Incidenter',
    modeCharging: 'Laddningsstationer',
    modeRiskScore: 'Kombinerad risk-score',
    timePattern: 'Tidsmönster',
    timePatternAll: 'Alla tider',
    timePatternMorning: 'Morgon (06:00-09:00)',
    timePatternDay: 'Dag (09:00-17:00)',
    timePatternEvening: 'Kväll (17:00-22:00)',
    timePatternNight: 'Natt (22:00-06:00)',
    loadData: 'Ladda data',
    loading: 'Laddar...',
    loadingData: 'Laddar heatmap-data...',
    dataLoaded: '{count} punkter laddade',
    tripCount: '{count} trippar, {points} punkter',
    errorLoadingVehicles: 'Kunde inte ladda fordon',
    errorLoadingData: 'Kunde inte ladda heatmap-data',
    showInfo: 'Visa information om analyslägen',
    infoTitle: 'Information om analyslägen',
    infoAll: 'Visar alla GPS-punkter från valda fordon under vald tidsperiod. Intensitet baseras på antal punkter per område.',
    infoOverspeed: 'Visar var fordon har överskridit hastighetsbegränsningen. Intensitet baseras på antal överträdelser och max överskridande.',
    infoIdling: 'Visar var fordon har stått stilla med tändning på. Intensitet baseras på total idling-tid per plats.',
    infoParking: 'Visar var resor avslutas (parkeringar). Varje nål representerar en parkeringsplats med 100 meter radie. Färg baseras på antal gånger man parkerat: Grön (1-2), Gul (3-5), Orange (6-10), Röd (11+).',
    infoEco: 'Visar hård körning (harsh acceleration, braking, cornering). Intensitet baseras på antal händelser och allvarlighetsgrad.',
    infoTimePattern: 'Visar trafikmönster baserat på tid på dygnet. Välj morgon, dag, kväll eller natt för att se när fordon är mest aktiva.',
    infoGeofence: 'Visar var fordon har lämnat eller kommit in i geofence-områden. Intensitet baseras på antal överträdelser.',
    infoIncidents: 'Visar allvarliga händelser som paniklarm, olyckor eller kraschar. Intensitet baseras på allvarlighetsgrad och antal incidenter.',
    infoCharging: 'Visar var fordon har laddats (EV). Baseras på långa stopp (minst 5 minuter). Intensitet baseras på antal laddningar och unika fordon.',
    infoRiskScore: 'Kombinerar flera riskfaktorer (hastighetsöverträdelser, ECO-händelser, incidenter) för att visa områden med hög risk. Intensitet baseras på kombinerad risk-score.',
  },
  // Heatmap Import
  heatmapImport: {
    title: 'Heatmap Import',
    selectFile: 'Välj CSV-fil att importera',
    fileFormat: 'Format: timestamp;latitude;longitude;registration_number;speed;speed_limit',
    selectFileButton: 'Välj fil',
    uploading: 'Laddar upp...',
    uploadSuccess: '{valid} av {total} rader importerades',
    invalidRows: '{count} rader kunde inte importeras',
    uploadError: 'Kunde inte ladda upp filen',
    invalidFileType: 'Endast CSV-filer är tillåtna',
    fileTooLarge: 'Filen är för stor (max 100MB)',
    importComplete: 'Import klar',
    importStats: '{valid} punkter, {vehicles} fordon',
    clear: 'Rensa',
    cleared: 'Import-data rensad',
    clearError: 'Kunde inte rensa data',
    selectVehicle: 'Välj fordon...',
  },

  // Realtime
  realtime: {
    loading: 'Laddar positioner...',
    fetchError: 'Kunde inte hämta realtids-positioner',
    speed: 'Hastighet',
    heading: 'Riktning',
    ignition: 'Tändning',
    movement: 'Rörelse',
    voltage: 'Spänning',
    battery: 'Batteri',
    on: 'På',
    off: 'Av',
    moving: 'Rör sig',
    still: 'Stilla',
  },

  // Support Admin
  supportAdmin: {
    title: 'Support Administration',
    subtitle: 'Hantera supportärenden och systemmeddelanden',
    openKeywin: 'KeyWin-administration',
    openKeywinTitle: 'Öppna KeyWin-administration i ny flik',
    openProvisioning: 'Skåp-provisionering',
    openProvisioningTitle: 'Öppna skåp-provisionering (endast internt/VPN)',
    queue: 'Support Kö',
    broadcasts: 'Broadcasts',
    stats: 'Statistik',
    allTickets: 'Alla ärenden',
    assignToMe: 'Ta ärendet',
    internalNote: 'Intern notering',
    sendReply: 'Skicka svar',
    sendBroadcast: 'Skicka broadcast',
    targetAll: 'Alla användare',
    targetOrg: 'Specifik organisation',
    includeChildren: 'Inkludera underorganisationer',
    pinMessage: 'Pinna meddelandet',
    newBroadcast: 'Skicka nytt broadcast',
    sentBroadcasts: 'Skickade broadcasts',
    readBy: 'läst',
    selectOrg: 'Välj organisation',
    priorityInfo: 'Info (blå)',
    priorityWarning: 'Varning (gul)',
    priorityCritical: 'Kritisk (röd)',
    faq: 'FAQ',
    faqQuestion: 'Fråga',
    faqAnswer: 'Svar',
    faqQuestionPlaceholder: 'Fråga...',
    faqAnswerPlaceholder: 'Svar...',
    addToFaq: 'Lägg till i FAQ',
    addToFaqFromTicket: 'Lägg till detta ärende som FAQ',
    saveToFaq: 'Spara till FAQ',
    newFaq: 'Ny FAQ',
    faqList: 'FAQ-lista',
    sortOrder: 'Sorteringsordning',
    fillQuestionAnswer: 'Fyll i fråga och svar',
    deleteFaqConfirm: 'Vill du ta bort denna FAQ?',
    deleteBroadcastConfirm: 'Vill du ta bort detta broadcast?',
    searchTickets: 'Sök ärenden...',
    noTickets: 'Inga ärenden',
    messageTitlePlaceholder: 'Titel på meddelandet',
    categoryPlaceholder: 't.ex. Installation och uppsättning',
    queueTab: 'Support Kö',
    partnerHandling: 'Partner hanterar',
    handlingFilter: 'Hanteras av',
    handlingAll: 'Alla',
    handlingPartner: 'Partner',
    handlingDeque: 'Deque',
    escalateToDeque: 'Lämna över till Deque',
    returnToPartner: 'Lämna tillbaka till partner',
    escalateSuccess: 'Ärendet lämnades över till Deque',
    returnSuccess: 'Ärendet lämnades tillbaka till partnern',
    partnerReplyLocked: 'Partnern hanterar ärendet. Du kan skriva intern notering men inte svara kunden.',
    transferError: 'Kunde inte flytta ärendet',
    broadcastTab: 'Broadcasts',
    broadcastSendTitle: 'Skicka nytt broadcast',
    broadcastSentTitle: 'Skickade broadcasts',
    noBroadcasts: 'Inga broadcasts skickade',
    broadcastMessage: 'Meddelande *',
    broadcastMessagePlaceholder: 'Skriv ditt meddelande...',
    broadcastTitle: 'Titel *',
    broadcastPinned: 'Pinna meddelandet (visas högst upp)',
    broadcastScope: 'Målgrupp',
    broadcastPriority: 'Prioritet',
    broadcastOrg: 'Organisation',
    broadcastSelectOrg: 'Välj organisation',
    broadcastScopeAll: 'Alla användare',
    broadcastScopeOrg: 'Specifik organisation',
    sendBroadcastButton: 'Skicka broadcast',
    statusAll: 'Alla statusar',
    statusOpen: 'Öppna',
    statusInProgress: 'Pågår',
    statusWaiting: 'Väntar kund',
    statusResolved: 'Lösta',
    statusClosed: 'Stängda',
    markComplete: 'Klarmarkera',
    ticketStatusOpen: 'Öppen',
    ticketStatusInProgress: 'Pågår',
    ticketStatusWaiting: 'Väntar kund',
    ticketStatusResolved: 'Löst',
    ticketStatusClosed: 'Klarmarkerad',
    priorityAll: 'Alla prioriteter',
    priorityCritical2: 'Kritisk',
    priorityHigh: 'Hög',
    priorityMedium: 'Medium',
    priorityLow: 'Låg',
    ticketCountsOpen: 'Öppna',
    ticketCountsInProgress: 'Pågår',
    ticketCountsWaiting: 'Väntar',
    ticketCountsResolved: 'Lösta',
    unknownUser: 'Okänd',
    assignedTo: 'Tilldelad',
    selectCategory: 'Välj kategori',
    categoryLabel: 'Kategori',
    assignLabel: 'Tilldela',
    notAssigned: 'Ej tilldelad',
    internalNoteLabel: 'Intern notering',
    internalNotePlaceholder: 'Skriv intern notering...',
    replyPlaceholder: 'Skriv svar till kund...',
    replyEmailPlaceholder: 'Skriv svar (skickas som e-post)...',
    viaEmail: 'Via e-post',
    viaChat: 'Via chatt',
    viaPhone: 'Via samtal',
    telephonyTab: 'Telefoni',
    telephonyNumberTitle: 'Supportnummer',
    telephonyNumberHelp: 'Välj vilket 46elks-nummer som ska ta emot supportsamtal. Numret måste redan vara hyrt hos 46elks.',
    telephonyActiveNumber: 'Aktivt nummer',
    telephonyActive: 'Aktivt',
    telephonyUseNumber: 'Använd som supportnummer',
    telephonyDisabled: 'Röst är avstängd (ELKS_VOICE_ENABLED). Webhooken lägger på tills flaggan slås på.',
    telephonyNoElksNumbers: 'Inga nummer hos 46elks ännu.',
    telephonyNumberActivated: 'Supportnummer aktiverat',
    telephonyAgentsTitle: 'Jaktlista',
    telephonyAgentsHelp: 'Samtalet kopplas till första mobilen. Vid upptaget går det vidare direkt, vid ej svar efter {seconds} sekunder.',
    callEvent: {
      incoming: 'Inkommande samtal',
      greeting: 'Hälsning spelas',
      ringing: 'Ringer',
      busy: 'Upptaget',
      noanswer: 'Inget svar',
      answered: 'Svarade',
      hangup: 'Samtalet avslutades',
      abandoned: 'Avslutade innan vi hann svara',
    },
    callState: {
      ringing: 'Pågår',
      answered: 'Svarat',
      missed: 'Missat',
      busy: 'Upptaget',
      failed: 'Misslyckades',
      abandoned: 'Avslutade innan svar',
    },
    telephonySelectAgent: 'Välj person',
    telephonyPhonePlaceholder: 'Mobil +46…',
    telephonyAgentSaved: 'Mobil tillagd',
    telephonySaveError: 'Kunde inte spara',
    telephonyNoAgents: 'Inga mobiler i jaktlistan.',
    telephonyMoveUp: 'Flytta upp',
    telephonyMoveDown: 'Flytta ner',
    telephonyCallsTitle: 'Senaste samtal',
    telephonyCallFrom: 'Från',
    telephonyCallState: 'Status',
    telephonyCallAnswered: 'Svarade',
    telephonyCallStarted: 'Start',
    telephonyCallDuration: 'Samtalstid',
    statsPerSource: 'Per källa',
    statsTelephony: 'Telefoni',
    statsCallsTotal: 'Samtal',
    statsCallOffered: 'Ringde',
    statsCallAnswered: 'Svarade',
    statsCallAnsweredSomeone: 'Någon svarade',
    statsCallReceived: 'Mottagna',
    statsCallMissedByAgent: 'Missade',
    statsCallNobodyAnswered: 'Ingen svarade',
    statsCallAbandoned: 'Avslutade innan svar',
    telephonyNoticeTitle: 'Hälsning före koppling',
    telephonyNoticeHelp:
      'Ladda upp en egen WAV-inspelning som spelas för den som ringer, i stället för den inbyggda röstfilen.',
    telephonyNoticeCustom: 'Egen inspelning: {{name}}',
    telephonyNoticeDefault: 'Standardfil (syntetisk röst) används tills du laddar upp en egen.',
    telephonyNoticeUpload: 'Ladda upp WAV',
    telephonyNoticeReset: 'Återställ standard',
    telephonyNoticeSaved: 'Hälsning sparad',
    telephonyNoticeRemoved: 'Egen hälsning borttagen',
    statsCallUnanswered: 'Obesvarade',
    statsCallNotTried: 'Ej kopplade',
    statsCallRinging: 'Pågående',
    statsAvgCallDuration: 'Snitt samtalstid',
    statsPerCallAgent: 'Per person i jaktlistan',
    statsPerCallAgentHelp:
      'Mottagna är samtal personen svarade på. Missade är när luren ringde men personen inte tog samtalet. Ingen svarade är samtal där ingen i jaktlistan svarade.',
    statsHandlingTab: 'Handläggningstid',
    statsHandlingHelp:
      'Tid från att du tar eller får ett ärende till du stänger eller skickar vidare. Tid när vi väntar på kund räknas inte.',
    statsHandlingYear: 'År',
    statsHandlingMonth: 'Månad',
    statsHandlingAllMonths: 'Hela året',
    statsHandlingPerson: 'Person',
    statsHandlingCompany: 'Hela företaget',
    statsHandlingAvg: 'Snitt handläggningstid',
    statsHandlingClosed: 'Avslutade / skickade vidare',
    statsHandlingWaitExcluded: 'Exkluderad väntan på kund',
    statsHandlingTotal: 'Total handläggningstid',
    statsHandlingCompanyYear: 'Företaget {{year}}',
    statsHandlingPersonYear: '{{name}} {{year}}',
    statsHandlingByPersonYear: 'Per person, hela året',
    statsHandlingByPersonMonth: 'Per person, {{month}}',
    statsHandlingEmpty: 'Ingen avslutad handläggning i vald period.',
    statsNoCallData: 'Ingen samtalsdata ännu.',
    telephonyNoCalls: 'Inga samtal ännu.',
    telephonyTicket: 'Ärende',
    replyAfterStatus: 'Efter svar',
    replyStatusWaiting: 'Väntar på svar',
    replyStatusResolved: 'Löst',
    sendEmailAria: 'Skicka e-post',
    sendReplyAria: 'Skicka svar',
    replySent: 'Svar sparat',
    replySentEmail: 'Svar skickat som e-post',
    internalNoteSaved: 'Intern notering sparad',
    internalNoteBadge: '🔒 Intern notering',
    callTranscriptBadge: '🔒 Samtalsunderlag – internt',
    callTranscriptNeverToCustomer: 'Skickas aldrig till kund',
    telephonyRecordingOn: 'Samtal spelas in. Transkript och sammanfattning är alltid interna.',
    editInternalNote: 'Redigera intern notering',
    internalNoteUpdated: 'Intern notering uppdaterad',
    editInternalNoteError: 'Kunde inte uppdatera intern notering',
    editedLabel: 'redigerad',
    statsOverview: 'Översikt',
    statsTotalTickets: 'Totalt ärenden',
    statsOpenTickets: 'Öppna ärenden',
    statsResolvedTickets: 'Lösta ärenden',
    statsAvgResponse: 'Snittid till svar',
    statsMin: 'min',
    statsPerCategory: 'Per kategori',
    statsPerPriority: 'Per prioritet',
    statsPerOrg: 'Per organisation',
    statsPerAssignee: 'Per tilldelad',
    statsPerCategoryTab: 'Per kategori',
    statsOrgColumn: 'Organisation',
    statsPersonColumn: 'Person',
    statsCategoryColumn: 'Kategori',
    statsTotal: 'Totalt',
    statsOpen: 'Öppna',
    statsResolved: 'Lösta',
    statsAvgTime: 'Snitt-tid',
    statsSolvePct: 'Lösningsgrad',
    statsLoading: 'Laddar statistik...',
    addCategoryTitle: 'Lägg till kategori',
    categoryNameLabel: 'Namn (internt) *',
    categoryNamePlaceholder: 't.ex. installation',
    categoryDescLabel: 'Beskrivning',
    confirmLabel: 'Bekräfta',
    createTicketButton: 'Nytt ärende',
    createTicketTitle: 'Skapa ärende manuellt',
    createTicketSubtitle: 'För samtal, disk eller mejl som inte kommit in automatiskt',
    createTicketName: 'Kontaktperson',
    createTicketNamePlaceholder: 'Namn på den ni ska svara',
    createTicketReplyTo: 'Svara till',
    createTicketReplyToHint: 'Ange telefon och/eller e-post. Minst ett krävs.',
    createTicketPhone: 'Telefon',
    createTicketPhonePlaceholder: '070-123 45 67',
    createTicketRegNumber: 'Regnummer',
    createTicketRegNumberPlaceholder: 'ABC123',
    createTicketBookingNumber: 'Bokningsnummer',
    createTicketBookingNumberPlaceholder: 't.ex. 1812',
    createTicketEmail: 'E-post',
    createTicketEmailPlaceholder: 'kund@exempel.se',
    createTicketOrg: 'Organisation',
    createTicketOrgNone: 'Ingen / okänd organisation',
    createTicketSubject: 'Ämne',
    createTicketMessage: 'Beskrivning',
    createTicketMessagePlaceholder: 'Vad gäller ärendet? Anteckna samtalet här.',
    createTicketAssignMe: 'Tilldela mig ärendet',
    createTicketSubmit: 'Skapa ärende',
    createTicketSuccess: 'Ärende skapat',
    createTicketError: 'Kunde inte skapa ärende',
  },

  // Chat & Support
  chat: {
    title: 'Meddelanden & Support',
    support: 'Support',
    chat: 'Chat',
    broadcasts: 'Info',
    newTicket: 'Nytt ärende',
    partnerContactTitle: 'Kontakta support:',
    noTickets: 'Inga ärenden',
    noBroadcasts: 'Inga meddelanden',
    subject: 'Ämne',
    phoneOptional: 'Telefon (valfritt)',
    emailOptional: 'E-post (valfritt)',
    regNumberOptional: 'Regnummer (valfritt)',
    bookingNumberOptional: 'Bokningsnummer (valfritt)',
    message: 'Beskriv ditt ärende...',
    send: 'Skicka',
    typeReply: 'Skriv svar...',
    fillAllFields: 'Fyll i alla fält',
    ticketCreated: 'Ärende skapat',
    justNow: 'Just nu',
    statusOpen: 'Öppen',
    statusInProgress: 'Pågår',
    statusWaiting: 'Väntar svar',
    statusResolved: 'Löst',
    statusClosed: 'Stängd',
    priorityLow: 'Låg',
    priorityMedium: 'Medium',
    priorityHigh: 'Hög',
    priorityCritical: 'Kritisk',
    chatComingSoon: 'Intern chat kommer snart!',
    chatDescription: 'Chatta med kollegor inom din organisation',
    broadcastTitle: 'Systemmeddelanden',
    markAsRead: 'Markera som läst',
    newConversation: 'Ny konversation',
    noConversations: 'Inga konversationer',
    startConversation: 'Starta en ny konversation',
    searchUsers: 'Sök användare (namn, e-post eller RSID)...',
    noUsers: 'Inga användare hittades',
    noMessages: 'Inga meddelanden ännu',
    typeMessage: 'Skriv meddelande...',
    closeTicket: 'Klarmarkera',
    ticketClosed: 'Ärendet har stängts',
    ticketClosedByUser: 'Ärendet stängdes av användaren.',
    ticketIsClosed: 'Detta ärende är avslutat',
    closeConversation: 'Avsluta konversation',
    conversationClosed: 'Konversationen avslutad',
    couldNotClose: 'Kunde inte avsluta konversationen',
    minChars: 'Skriv minst 2 tecken för att söka',
    noUsersFound: 'Inga användare hittades',
    searchToFind: 'Börja skriva för att söka användare',
    faq: 'FAQ',
    faqSearchPlaceholder: 'Sök i vanliga frågor...',
    noFaqFound: 'Inga träffar',
    noFaqYet: 'Inga FAQ tillagda ännu',
  },

  // Version
  version: {
    title: 'Version',
    fleetManagement: 'Fleet Management System',
    currentRelease: 'Aktuell version',
    viewChangelog: 'Visa ändringslogg',
    releaseHistory: 'Versionshistorik',
    current: 'Aktuell',
    upcoming: 'Kommande',
    released: 'Släppt',
    unreleased: 'Ej i version',
    noReleases: 'Ingen versionshistorik',
    releaseAction: 'Släpp version',
    releaseLoadError: 'Kunde inte räkna nästa version',
    releaseSaved: 'v{{version}} är släppt',
    releaseError: 'Kunde inte släppa versionen',
    confirmLower: 'Väntande moduler pekar på en högre nivå. Släpp ändå?',
    pendingCount: '{{count}} moduler utan version följer med.',
    level: 'Nivå',
    releaseDate: 'Datum',
    releaseTitle: 'Rubrik',
    summary: 'Kort text',
    summaryEn: 'Kort text (engelska)',
    notes: 'Punkter, en per rad',
    bump: {
      patch: 'Patch',
      minor: 'Minor',
      major: 'Major',
    },
    release: {
      upcoming: {
        drivingLogApp: 'App för körjournaler',
      },
      v500: {
        newPlatform: 'Deque nya plattform',
        dashboard: 'Anpassningsbar dashboard med drag-and-drop',
        fleet: 'Fordonsflotta med fullständig översikt',
        liveTracking: 'Realtidsspårning med OSM-kartor',
        reports: 'Rapporter (resor, körjournal, eco-driving, hastighet, energi, slitage, CO2)',
        analysis: 'Analysverktyg (ruttanalys, heatmap, kraschdetektering)',
        crm: 'CRM med kundhantering och hierarki',
        geofences: 'Geofence-hantering med händelser',
        homecare: 'Hemtjänstmodul',
        deviceManagement: 'Enhetshantering med SIM-kort',
        admin: 'Administration (användare, roller, organisationer)',
        rbac: 'Rollbaserad behörighetskontroll (RBAC)',
        osmMaps: 'OpenStreetMap-integration',
      },
    },
  },
  // SCB Testing
  scbTesting: {
    title: 'SCB API Testning',
    description: 'Testa SCB API endpoints och visa resultat',
    selectEndpoint: 'Välj Endpoint',
    parameters: 'Parametrar',
    execute: 'Kör Endpoint',
    executing: 'Kör...',
    result: 'Resultat',
    success: 'Framgångsrikt',
    error: 'Fel',
    responseData: 'Response Data',
    noResult: 'Inget resultat än. Välj en endpoint och klicka på "Kör Endpoint".',
  },
  vehicleCard: {
    refresh: 'Uppdatera från Car.info',
    vehicleInfo: 'Fordonsdata',
    engineInfo: 'Motor & Prestanda',
    dates: 'Datum',
    deviceInfo: 'Enhet',
    specifications: 'Specifikationer',
    notes: 'Anteckningar',
    tags: 'Extra information',
    vin: 'VIN',
    brand: 'Märke',
    model: 'Modell',
    year: 'Årsmodell',
    vehicleType: 'Fordonstyp',
    fuelType: 'Bränsle',
    engine: 'Motor',
    engineType: 'Motortyp',
    gearbox: 'Växellåda',
    horsepower: 'Effekt',
    mileage: 'Mätarställning',
    registerDate: 'Registrerad',
    manufacturedDate: 'Tillverkad',
    lastUpdated: 'Senast uppdaterad',
    externalVoltage: 'Extern spänning',
    batteryLevel: 'Batteri',
    fuelLevel: 'Bränslenivå',
    stolenWarning: 'FORDONET ÄR ANMÄLT STULET!',
    drivingBanWarning: 'FORDONET HAR KÖRFÖRBUD!',
    statusActive: 'Aktiv',
    statusMaintenance: 'Underhåll',
    statusInactive: 'Inaktiv',
    statusDeregistered: 'Avställd',
    systemStatus: 'Systemstatus:',
    tabGeneral: 'Allmän information',
    tabEconomy: 'Ekonomi',
    tabCards: 'Bränslekort',
    tabSpec: 'Kort specifikation',
    tabProperties: 'Egenskaper',
    tabPlacement: 'Placering',
    tabHistory: 'Historik',
    tabBooking: 'Bokningsinformation',
    tabBookingBadge: 'NY',
    tabDevicePnP: 'Enhet / P&P',
    tabNotes: 'Anteckningar',
    tabAttachments: 'Bilagor',
    pnp: {
      globalOff:
        'Plug & Play är avstängd globalt (OBD_PROVISIONING_ENABLED≠true). Konfigurera FMM003-baseline under Enhetshantering, markera enheter med P&P, och slå sedan på i .env.',
      baselineMissing:
        'Ingen FW/config-fil angiven för denna modell. Fyll i baseline under Enhetshantering innan ni aktiverar P&P.',
      noDevice: 'Ingen enhet kopplad till fordonet.',
      sectionDevice: 'Enhet & firmware',
      sectionProfile: 'Bränsleprofil',
      sectionEye: 'EYE-parametrar',
      sectionParams: 'Satta parametrar',
      paramsHint:
        'Parametrar P&P sätter efter godkänd FW/cfg. Satt = levererad i senast lyckade steg. Planerad = ingår i profilen men inte bekräftad än.',
      paramId: 'ID',
      paramValue: 'Värde',
      paramLabel: 'Betydelse',
      paramGroup: 'Paket',
      paramStatus: 'Status',
      groupIce: 'ICE',
      groupEv: 'EV / PHEV / ID.x',
      groupProblem: 'Problemlista',
      groupVin: 'VIN',
      statusApplied: 'Satt',
      statusPlanned: 'Planerad',
      statusSkipped: 'Hoppad',
      onProblemList: 'På problemlista (Renault Trafic/Master – Non-OBD)',
      onProblemListDisable: 'På problemlista (OBD-Disable 40000:0 / VW ID.x / BMW i4 / Mercedes)',
      problemListPending: 'Inställningen är inte levererad än — bilen ligger kvar tills den fått den.',
      problemListApplied: 'Inställningen levererad {when}. Bilen stannar på problemlistan.',
      notOnProblemList: 'Inte på problemlista',
      imei: 'IMEI',
      model: 'Modell',
      currentFw: 'Aktuell firmware',
      targetFw: 'Mål-firmware',
      targetConfig: 'Mål-konfig',
      status: 'P&P-status',
      fuelType: 'Bränsle (fordon)',
      profile: 'Profil',
      profileSource: 'Profilkälla',
      profileIce: 'ICE',
      profilePheV: 'PHEV',
      profileEv: 'EV',
      eyeParams: 'EYE på enheten',
      eyeYes: 'Ja (aktiva länkar)',
      eyeNo: 'Nej',
      eyeReset: 'Återställd av P&P',
      eyeLinks: 'Aktiva EYE-länkar',
      enablePnp: 'Markera som P&P',
      disablePnp: 'Avmarkera P&P',
      pnpEnabled: 'Enheten markerad för Plug & Play',
      pnpDisabled: 'P&P avmarkerad för enheten',
      simulate: 'Simulera kedja',
      simulateDone: 'Simulering klar',
      profileSaved: 'Profil sparad',
      loadError: 'Kunde inte hämta P&P-status',
      saveError: 'Kunde inte spara',
      runError: 'Kunde inte köra provisionering',
    },
    placement: {
      description:
        'Spara var fordonet normalt står (placeringsort). Används vid områdesfilter i realtidskartan. Ange adress, välj punkt på kartan eller hämta från fordonets aktuella GPS-position.',
      pickOnMap: 'Välj på karta',
      mapHelp: 'Klicka på kartan för att sätta placering. Minst en punkt krävs.',
      geocodeFromAddress: 'Hämta koordinat från adress',
      geocodeSuccess: 'Koordinat hämtad',
      geocodeNotFound: 'Kunde inte hitta adressen',
      geocodeError: 'Fel vid geokodning',
      addressRequired: 'Ange minst adress, postnummer eller ort',
      coordinates: 'Koordinat',
      clear: 'Rensa placering',
      fromGps: 'Hämta från GPS',
      fromGpsSuccess: 'Placering hämtad från fordonets GPS. Klicka på Spara.',
      fromGpsMissing: 'Ingen aktuell GPS-position för fordonet (saknas enhet, privat körning eller ingen data ännu)',
      fromGpsError: 'Koordinat satt från GPS, men adressen kunde inte slås upp',
      gpsTime: 'Senaste GPS-position: {{time}}',
    },
    booking: {
      banner:
        'Inställningar för bokning när fordonet ingår i en utlämningsplats. Redigera pool och plats under Bokning.',
      sectionDescription: 'Bokningsbeskrivning',
      descriptionHint:
        'Redigerbar text som visas för bokande personal (högst 50 tecken). Om fältet är tomt används registreringsnummer och växellåda.',
      charCount: '{{current}}/{{max}} tecken',
      charCountLong: '{{current}}/{{max}} tecken',
      sectionEmailNote: 'Meddelande i bokningsbekräftelse (e-post)',
      emailNoteHint:
        'Visas endast i e-post till användaren när ni skickar kalenderinbjudan/bokningsbekräftelse. Högst 2000 tecken.',
      emailNotePlaceholder: 'Valfri information till den som bokat …',
      previewForStaff: 'Förhandsvisning (som bokande ser)',
      saveBookingDesc: 'Spara bokningsuppgifter',
      bookingDescSaved: 'Bokningsuppgifter sparade',
      noDescription: '—',
      sectionSlot: 'Slottid',
      slotHint:
        'Standardlängd, min/max bokningstid, buffert och bokningsbara timmar styrs i bokningsmodulen per plats och kalender — komplettera där vid behov.',
      restMinutesLabel: 'Vilotid mellan bokningar',
      restMinutesHint:
        'Minuter detta fordon ska vila mellan bokningar (t.ex. elbil som behöver laddas). Tomt = ärv pool/organisation. 0 = ingen vilotid. Värdet överstyr pool/org.',
      restMinutesPlaceholder: 'Ärv',
      restMinutesUnit: 'minuter',
      restMinutesSave: 'Spara vilotid',
      restMinutesSaved: 'Vilotid sparad',
      restMinutesInvalid: 'Ange ett positivt antal minuter (eller lämna tomt)',
      sectionPoolLocker: 'Pool och nyckelskåp',
      poolTitle: 'Pool / utlämningsplats',
      lockerTitle: 'Nyckelskåp (Flinkey)',
      keyTagTitle: 'Nyckeltapp',
      keyTagNone: 'Ingen nyckeltapp kopplad till fordonet.',
      keyTagInHome: 'I skåpet',
      keyTagTaken: 'Uttagen',
      keyTagInOther: 'I annat skåp',
      keyTagUnknown: 'Status okänd',
      keyTagHomeCabinet: 'Hemmahörande i {{name}}',
      keyTagSlot: 'Plats {{slot}}',
      keyTagOtherAllowed: 'Tappen får sitta i ett annat skåp.',
      goToPickupLocations: 'Utlämningsplatser',
      goToVehiclePools: 'Fordonspooler',
      available: 'Tillgänglig för bokning',
      unavailable: 'Ej tillgänglig för bokning',
      noLockerLinked: 'Ingen Flinkey-box kopplad till fordonet.',
      sectionBlock: 'Blockera bil för bokning',
      blockHint:
        'Ange start och slut nedan. Bilen visas som grå blockering i bokningskalendern. Överlappande bokningar behålls men utan tilldelad bil och listas under Kollisionsbokningar (tidigare pool och bil sparas).',
      blockStart: 'Start',
      blockEnd: 'Slut',
      blockCreate: 'Blockera',
      blockRemove: 'Ta bort',
      blockRemoveConfirm: 'Ta bort denna blockering?',
      blockSaved: 'Blockering skapad',
      blockRemoved: 'Blockering borttagen',
      blockListTitle: 'Kommande blockeringar',
      blockNone: 'Inga kommande blockeringar.',
      blockCollisionLink: 'Kollisionsbokningar →',
      openCalendar: 'Bokningskalender',
      regHint: 'Aktuellt regnr: {{reg}}',
    },
    general: {
      sectionVehicleAttributes: 'Fordonsuppgifter',
      alternativeFuel: 'Alternativt drivmedel',
      noAlternativeFuel: 'Inget valt',
      usageStatus: 'Status',
      noUsageStatus: 'Ingen status',
      businessResponsibility: 'Verksamhetsansvar',
      noBusinessResponsibility: 'Inget valt',
      businessResponsibilitySearch: 'Sök ANSVAR_ID eller text…',
      businessResponsibilityIkpart: 'Verksamhetsområde',
      businessResponsibilityShowHistory: 'Visa historik',
      businessResponsibilityHideHistory: 'Dölj historik',
      businessResponsibilityNoHistory: 'Ingen historik ännu.',
      businessResponsibilityFrom: 'Tidigare',
      businessResponsibilityCleared: 'Avmarkerat',
      tempFordonsansvarigSection: 'Fordonsansvarig',
      tempFordonsansvarigRsid: 'RSID',
      tempFordonsansvarigName: 'Namn',
      tempFordonsansvarigEmail: 'Mail',
      tempFordonsansvarigPhone: 'Telefon',
      sectionInspection: 'Besiktning',
      sectionTax: 'Skatt',
      sectionReferences: 'Referensnummer',
      lastInspection: 'Senaste besiktning',
      inspectionResult: 'Resultat',
      odometerAtInspection: 'Mätarställning vid besiktning',
      nextInspectionDue: 'Nästa besiktning senast',
      inspectionStation: 'Besiktningsstation',
      registeredForUse: 'Påställd / i trafik',
      emergencyVehicle: 'Utryckningsfordon',
      hasDrivingBan: 'Körförbud',
      ternaryYes: 'Ja',
      ternaryNo: 'Nej',
      ternaryNA: 'Ej tillämpligt',
      annualVehicleTax: 'Årlig fordonsskatt',
      malus: 'Malus',
      taxationMonths: 'Betalningsmånad/er',
      nextTaxDue: 'Nästa skatt senast',
      taxDueHint: 'Skatten ska vara betald senast sista dagen i betalningsmånaden. Avisering 45 dagar före.',
      taxPeriod: 'Skatteperiod',
      noCarInfo: 'Ingen Car.info-data för detta fordon.',
      noTaxAttrs: 'Inga skattfält i Car.info för detta fordon.',
      noEconomyRefs: 'Inga referenser i ekonomi är ifyllda ännu.',
      ownership: 'Ägd eller leasad',
      leasingAgreementNo: 'Avtalsnummer (leasing)',
      contractNo: 'Kontraktsnummer',
      costCenter: 'Kostnadsställe',
    },
    color: 'Färg:',
    changeDevice: 'byt',
    selectDevice: 'välj',
    removeDeviceLink: 'Ta bort koppling',
    searchImei: 'Sök IMEI...',
    odometerFromOem: 'Mätarställning hämtas från fordonets OEM-kluster',
    distanceDriven: 'Körd sträcka:',
    currentOdometer: 'Nuvarande mätarställning:',
    saveOdometer: 'Spara mätarställning',
    tripsRecalculated: 'Trippar räknas om automatiskt efter sparning',
    noSpecifications: 'Inga specifikationer tillgängliga',
    propertiesSearchPlaceholder: 'Sök i alla egenskaper (namn eller värde)…',
    propertiesSearchClear: 'Rensa sökning',
    propertiesSearchNoResults: 'Inga egenskaper matchar sökningen.',
    propertiesSearchMatchCount: '{{count}} träffar',
    propertiesSearchMatchesInCategory: '{{count}} träffar',
    propertiesAttributeCount: '{{count}} attribut',
    propertiesBasicCategory: 'Grund information (Car.info)',
    propertiesExtendedCategory: 'Övriga uppgifter (Car.info)',
    noHistory: 'Ingen historik tillgänglig',
    ownerChange: 'Ägarbyte',
    writeNotesHere: 'Skriv anteckningar här...',
    unsavedChanges: 'Osparade ändringar',
    updateFromCarInfo: 'Uppdatera från Car.info',
    tryAgain: 'Försök igen',
    vehicleReportedStolen: 'FORDONET ÄR ANMÄLT STULET!',
    userId: 'Användare (ID)',
    userIdPlaceholder: 'Användar-ID',
    validFrom: 'Giltig från (valfritt)',
    costCenter: 'Kostnadsställe',
    organizationGroup: 'Organisation (grupp)',
    vehicleCategory: 'Fordonskategori',
    noVehicleCategory: 'Ingen kategori',
    replacesVehicleReg: 'Ersätter fordon (regnr)',
    replacesVehicleRegPlaceholder: 'Regnr som detta fordon ersätter',
    viewDequeVehicleLog: 'Visa i Deque-logg',
    orgMoveTitle: 'Flytta fordon',
    orgMoveSameTopBody:
      'Fordonet flyttas till vald organisation inom samma kund. Historik (resor, GPS) kan följa med fordonet eller stanna på det gamla kortet. Monterad enhet följer med fordonet.',
    crossTopTitle: 'Flytt till annan kund (toppnod)',
    crossTopBody:
      'Fordonet flyttas till vald organisation under en annan toppnod. Flinkey och aktiva tankkort kopplas loss. Välj om historik ska följa med, och om enheten ska flyttas till den nya toppnoden.',
    crossTopMoveDeviceLabel: 'Ska enheten flyttas till den nya toppnoden?',
    crossTopMoveDeviceYes: 'Ja, flytta enheten',
    crossTopMoveDeviceYesHelp: 'Enheten läggs i den nya organisationen och stannar monterad på fordonet.',
    crossTopMoveDeviceNo: 'Nej, lämna enheten kvar',
    crossTopMoveDeviceNoHelp: 'Enheten demonteras och stannar hos den gamla organisationen.',
    crossTopMoveDeviceRequired: 'Välj om enheten ska följa med.',
    crossTopKeepDataLabel: 'Behåll data med fordonet',
    crossTopKeepDataHelp:
      'Samma fordonskort och historik (resor, GPS) följer med, även vid flytt inom samma toppnod.',
    crossTopStartFreshLabel: 'Börja på nytt',
    crossTopStartFreshHelp:
      'Ett nytt fordonskort skapas. Historik stannar på det gamla kortet.',
    crossTopNoteLabel: 'Anteckning (valfritt)',
    crossTopConfirm: 'Bekräfta flytt',
  },

  dequeVehicleLog: {
    title: 'Deque — Fordonslogg',
    description: 'Org-flytt inom kund, ersättning av fordon, byte av toppnod och status (aktiv/inaktiv).',
    scopeNote:
      'Aktivering/inaktivering visas under «Status» eller «Allt» (från audit). Superadmin ser mer under Ändringslogg. Enhetshistorik (device_change_log) kräver monterad GPS-enhet.',
    scopeNoteUpdated:
      'Aktivering/inaktivering (ändring av status) visas under fliken «Status» eller i «Allt». Superadmin ser samma händelser med mer kontext under Ändringslogg.',
    auditLogLink: 'Öppna ändringslogg',
    tabAll: 'Allt',
    tabOrgMove: 'Org-flytt',
    tabReplacement: 'Ersättning',
    tabCrossTop: 'Toppnodsbyte',
    tabVehicleStatus: 'Status',
    vehicleActivated: 'Aktiverad',
    vehicleInactivated: 'Inaktiverad',
    vehicleId: 'Fordon-ID',
    registrationNumber: 'Regnummer',
    registrationNumberPlaceholder: 'ABC123',
    dateFrom: 'Från datum',
    dateTo: 'Till datum',
    colWhen: 'Tid',
    colType: 'Typ',
    colVehicle: 'Fordon',
    colDetail: 'Detalj',
    colUser: 'Utfört av',
    empty: 'Inga händelser för valda filter.',
    loadError: 'Kunde inte hämta logg',
    showing: 'Visar {{from}}–{{to}} av {{total}}',
    replaces: 'Ersätter',
    replacedReg: 'Ersatt regnr',
  },

  replacementChain: {
    title: 'Ersättningskedja',
    description: 'Sök regnummer och visa vilka fordon som ersatts i en kedja.',
    searchPlaceholder: 'Regnummer…',
    emptyState: 'Sök på ett regnummer för att visa ersättningskedjan.',
    loadError: 'Kunde inte hämta ersättningskedja',
    resultHint: 'Äldre ersatta fordon till vänster, senare ersättare till höger.',
    noChain: 'Ingen ersättningskedja kopplad till detta fordon.',
    legendLeft: 'Till vänster: fordon som det sökta fordonet ersätter (fältet «Ersätter fordon»).',
    legendRight: 'Till höger: fordon som ersatt det sökta fordonet.',
    legendCurrent: 'Markerat fordon',
    openVehicle: 'Öppna fordon',
    notInSystem: 'Finns inte som fordon i systemet',
    noAccess: 'Du har inte behörighet att visa ersättningskedjor.',
  },

  vehicleCategories: {
    title: 'Fordonskategorier',
    description: 'Hantera valbara fordonskategorier för din toppnod.',
    newCategoryPlaceholder: 'Ny fordonskategori',
    categoryName: 'Kategorinamn',
    empty: 'Inga fordonskategorier finns ännu.',
    saved: 'Fordonskategorin sparades',
    loadError: 'Kunde inte hämta fordonskategorier',
    saveError: 'Kunde inte spara fordonskategori',
  },

  alternativeFuels: {
    title: 'Alternativa drivmedel',
    description: 'Hantera valbara alternativa drivmedel för din toppnod (t.ex. Region Skåne).',
    newFuelPlaceholder: 'Nytt drivmedel, t.ex. HVO',
    fuelName: 'Drivmedel',
    empty: 'Inga alternativa drivmedel finns ännu.',
    saved: 'Alternativt drivmedel sparades',
    loadError: 'Kunde inte hämta alternativa drivmedel',
    saveError: 'Kunde inte spara alternativt drivmedel',
  },

  nordeaLeasing: {
    title: 'Nordea leasingimport',
    description: 'Importera månatlig TXT-fil från Nordea. Uppdaterar fordons ekonomi, sparar fil i arkiv och betalningshistorik per period.',
    uploadTitle: 'Ladda upp fil',
    uploadHint:
      'Välj semikolonseparerad .txt-fil (t.ex. 2026-04.TXT). Samma fil importeras bara en gång. Nästa hyra delas med kolumnen Per (fakturaperiod i månader) till månadshyra.',
    selectFile: 'Välj fil',
    importHistory: 'Tidigare importer',
    noImports: 'Inga importer ännu',
    colFilename: 'Filnamn',
    colPeriodEnd: 'Datum to',
    colRows: 'Rader',
    colUpdated: 'Uppdaterade',
    colSkipped: 'Hoppade över',
    colImportedAt: 'Importerad',
    loadError: 'Kunde inte hämta importlista',
    importError: 'Import misslyckades',
    importSuccess: 'Import klar: {{updated}} fordon uppdaterade, {{skipped}} hoppades över',
    duplicateFile: 'Filen är redan importerad – ingen ny lagring eller historik',
    skippedRegistrations: 'Regnr utan matchande fordon',
  },

  protectorInsurance: {
    title: 'Protector försäkringsimport',
    description:
      'Importera försäkringsfiler (Excel) från Protector. Matchar fordon på regnr (kolumn F), uppdaterar fordons försäkring och bygger historik per period.',
    uploadTitle: 'Ladda upp filer',
    uploadHint:
      'Välj en eller flera .xls/.xlsx-filer. RegNo (kolumn F) är nyckel. Månadskostnad = Belopp (kolumn V) / 12. Samma fil importeras bara en gång.',
    selectFiles: 'Välj filer',
    importHistory: 'Tidigare importer',
    noImports: 'Inga importer ännu',
    colFilename: 'Filnamn',
    colPeriodEnd: 'Til datum',
    colRows: 'Rader',
    colUpdated: 'Uppdaterade',
    colSkipped: 'Hoppade över',
    colImportedAt: 'Importerad',
    loadError: 'Kunde inte hämta importlista',
    importError: 'Import misslyckades',
    importSuccess: 'Import klar: {{updated}} fordon uppdaterade, {{skipped}} hoppades över',
    duplicateFile: 'Filen är redan importerad – ingen ny lagring eller historik',
    skippedRegistrations: 'Regnr utan matchande fordon',
  },

  vehicleUsageStatuses: {
    title: 'Fordonsstatus',
    description: 'Hantera valbara statusar per toppnod (leasing, avveckling m.m.).',
    newStatusPlaceholder: 'Ny status, t.ex. Under avveckling',
    statusName: 'Status',
    empty: 'Inga statusar finns ännu.',
    saved: 'Fordonsstatus sparades',
    loadError: 'Kunde inte hämta fordonsstatusar',
    saveError: 'Kunde inte spara fordonsstatus',
  },

  personalTrackers: {
    title: 'Personal trackers',
    description: 'Register för personliga trackers. Sätt SIM-kort och tilldela organisation.',
    orgDescription: 'Se var organisationens trackers är, koppla dem till en användare och styr knappen.',
    add: 'Lägg till tracker',
    save: 'Spara',
    cancel: 'Avbryt',
    delete: 'Ta bort',
    imei: 'IMEI',
    serial: 'Serienummer',
    iccid: 'SIM (ICCID)',
    organization: 'Organisation',
    noOrganization: 'Ingen organisation',
    user: 'Användare',
    noUser: 'Ingen användare',
    searchUser: 'Sök användare',
    needsOrganization: 'Välj organisation ovan. Då kan en användare i den organisationen kopplas.',
    model: 'Modell',
    lastSeen: 'Senast sedd',
    battery: 'Batteri',
    charging: 'Laddar',
    empty: 'Inga trackers i registret.',
    emptyOrg: 'Inga trackers är tilldelade organisationen.',
    saved: 'Sparat',
    deleted: 'Trackern togs bort',
    loadError: 'Kunde inte hämta trackers',
    saveError: 'Kunde inte spara',
    confirmDelete: 'Ta bort trackern från registret?',
    mapEmpty: 'Ingen position har kommit in ännu.',
    buttonTitle: 'Knapp',
    click1: '1 klick',
    click2: '2 klick',
    longPress: 'Långt tryck (2–5 s)',
    powerOff: 'Avstängning via knapp (håll >5 s)',
    actionNone: 'Ingen',
    actionAlarm: 'Larm',
    priority: 'Prioritet',
    priorityOff: 'Av',
    priorityLow: 'Låg',
    priorityHigh: 'Hög',
    configStatus: 'Skickad till enhet',
    configDelivered: 'Levererad',
    configQueued: 'Köad tills enheten är online',
    configFailed: 'Kunde inte skickas',
    configPending: 'Väntar',
    alarm: 'Senaste larm',
    iccidHint: 'ICCID från konfiguratorn. Uppdateras om enheten rapporterar ett annat SIM-kort.',
    alarmType: {
      fall: 'Fall',
      button: 'Knapp',
      alarm: 'Larm',
    },
    alarmClick1: '1 klick',
    alarmClick2: '2 klick',
    alarmLong: 'Långt tryck',
    alarmTitle: 'Personal tracker-larm',
    alarmEmpty: 'Inga okvitterade larm.',
    alarmWho: 'Person',
    alarmPhone: 'Telefon',
    alarmNoPhone: 'Inget telefonnummer',
    alarmNoPosition: 'Ingen position följde med larmet.',
    alarmAck: 'Kvittera',
    alarmAcked: 'Larmet är kvitterat',
    alarmBell: 'Okvitterade larm',
  },

  licenseCheck: {
    title: 'Körkortskontroll',
    description: 'Behörighetskontroll via BKY för organisationer som måste kontrollera förarbehörighet.',
    apiWaiting: 'Anrop till BKY väntar på konto och meddelandeschema. Personer och anslutning kan sparas redan nu.',
    organization: 'Organisation',
    connection: 'BKY-anslutning',
    questionUrl: 'Fråga-URL',
    answerUrl: 'Svar-URL',
    username: 'Användarnamn',
    password: 'Lösenord',
    passwordKept: 'Lämna tomt för att behålla sparat lösenord',
    active: 'Aktiv',
    saveConnection: 'Spara anslutning',
    saved: 'Sparat',
    subjects: 'Personer',
    name: 'Namn',
    personnummer: 'Personnummer',
    addSubject: 'Lägg till person',
    competence: 'Behörighet',
    tachograph: 'Färdskrivarkort (16 siffror)',
    addCompetence: 'Lägg till behörighet',
    wouldAsk: 'Frågas',
    inactive: 'Inaktiv',
    activate: 'Aktivera',
    deactivate: 'Inaktivera',
    emptySubjects: 'Inga personer registrerade.',
    previewCount: 'Antal frågor som skulle skickas: {{count}}',
    history: 'Historik',
    emptyHistory: 'Inga frågor har skickats ännu.',
    questions: 'Frågor',
    answers: 'Svar',
    yes: 'JA',
    no: 'NEJ',
    askedBy: 'Frågade av',
    when: 'När',
    run: 'Skicka frågor',
    purge: 'Radera all data',
    purgeHelp: 'Tar bort anslutning, personer, behörigheter och historik för den här organisationen. Skriv organisationsnamnet för att bekräfta.',
    purgeConfirm: 'Organisationsnamn',
    purged: 'All körkortskontroll för organisationen är raderad',
    loadError: 'Kunde inte hämta körkortskontroll',
    saveError: 'Kunde inte spara',
    deleteConfirm: 'Ta bort personen och personens behörigheter?',
  },

  // Impersonation (Växla användare)
  impersonation: {
    title: 'Växla till användare',
    switchUser: 'Växla användare',
    searchPlaceholder: 'Sök användare...',
    partnerSearchHint: 'Visar användare i dina kunders organisationer',
    noUsers: 'Inga användare hittades',
    viewingAs: 'Visar som',
    returnToAdmin: 'Gå tillbaka till ditt konto',
    returnButton: 'Tillbaka',
    fetchError: 'Kunde inte hämta användare',
    startError: 'Kunde inte växla användare',
    stopError: 'Kunde inte återgå till admin',
    showingFirst: 'Visar första {{count}}',
  },

  // Track Playback
  track: {
    title: 'Track Playback',
    subtitle: 'Historisk GPS-spårning för flera fordon',
    addVehicle: 'Lägg till fordon',
    selectVehicle: 'Välj fordon...',
    selectedVehicles: 'Valda fordon',
    timePeriod: 'Tidsperiod',
    interval: 'Intervall',
    search: 'Sök',
    noData: 'Välj fordon och tidsperiod för att visa spår',
    play: 'Spela',
    pause: 'Pausa',
    stop: 'Stoppa',
    reset: 'Återställ',
    speed: 'Hastighet',
    currentTime: 'Aktuell tid',
    pointsLoaded: 'GPS-punkter laddade',
    maxVehicles: 'Max 10 fordon kan spåras samtidigt',
    vehicleAlreadyAdded: 'Fordonet är redan tillagt',
    jammingLegend: 'Jamming (AVL 249) – {count} GPS-punkter',
  },

  // AI Analysis
  ai: {
    title: 'AI-assistent',
    pageTitle: 'AI-analys',
    pageDescription: 'Använd AI för att analysera flottan och få rekommendationer. All data bearbetas lokalt.',
    welcomeMessage: 'Hej! Jag kan hjälpa dig analysera flottan, förklara mätvärden och ge rekommendationer.',
    inputPlaceholder: 'Ställ en fråga om flottan...',
    clearChat: 'Rensa chatt',
    selectOrganization: 'Välj en organisation för att starta analysen',
    allOrganizations: 'Alla organisationer',
    organization: 'Organisation',
    analyzing: 'Analyserar...',
    runAnalysis: 'Kör AI-analys',
    aiAnalysis: 'AI-analys',
    analysisResult: 'Analysresultat',
    analysisError: 'Analysen misslyckades',
    fleetOverview: 'Flottöversikt',
    topVehicles: 'Fordon',
    vehicleAnalysis: 'Fordonsanalys',
    noVehicles: 'Inga fordon med data hittades',
    status: {
      online: 'Online',
      offline: 'Offline',
      checking: 'Kontrollerar...',
    },
    period: {
      label: 'Period',
      week: 'Vecka',
      month: 'Månad',
      quarter: 'Kvartal',
    },
    stats: {
      vehicles: 'Fordon totalt',
      activeVehicles: 'Aktiva fordon',
      distance: 'Total körsträcka',
      totalKm: 'Total körsträcka (km)',
      fuelConsumption: 'Snittförbrukning',
      fuelCost: 'Bränslekostnad',
      ecoScore: 'Eco-score',
    },
    log: {
      title: 'AI-logg',
      description: 'Visa alla AI-förfrågningar som gjorts i systemet',
      question: 'Fråga',
      response: 'Svar',
      user: 'Användare',
      organization: 'Organisation',
      requestType: 'Typ',
      responseTime: 'Svarstid',
      success: 'Status',
      createdAt: 'Tidpunkt',
      noLogs: 'Inga AI-förfrågningar hittades',
      viewDetails: 'Visa detaljer',
      types: {
        chat: 'Chatt',
        analyze_vehicle: 'Fordonsanalys',
        analyze_driver: 'Föraranalys',
        analyze_fleet: 'Flottanalys',
        compare_vehicles: 'Fordonsjämförelse',
        explain_metric: 'Metrikförklaring',
      },
    },
  },

  // Route Analysis - Ruttanalys (verifiering: faktiskt vs ruttoptimerad)
  routeAnalysis: {
    title: 'Ruttanalys',
    pageTitle: 'Ruttanalys – verifiering',
    description: 'Välj en bil och ett datum. Se hur lång körtid och sträcka det blev – jämför med vägoptimerad rutt (samma stopp, samma ordning).',
    
    // Välj trippar
    selectTrips: 'Välj trippar att analysera',
    selectVehicle: 'Välj fordon',
    selectDate: 'Välj datum',
    tripsOnDate: 'Trippar denna dag',
    noTripsFound: 'Inga trippar hittades för valt datum',
    selectedTrips: 'Valda trippar',
    selectAll: 'Välj alla',
    selectMorning: 'Välj förmiddag',
    selectAfternoon: 'Välj eftermiddag',
    
    // Analys
    analyze: 'Analysera',
    analyzing: 'Analyserar...',
    analyzeSelected: 'Analysera valda trippar',
    quickCompare: 'Snabbjämförelse',
    
    // Resultat – verifiering
    result: 'Jämförelse',
    actualRoute: 'Faktiskt',
    actualRouteSubtitle: 'så bilen körde',
    optimalRoute: 'Ruttoptimerad',
    optimalRouteSubtitle: 'samma stopp, samma ordning',
    comparison: 'Skillnad',
    comparisonIntro: 'Skillnad mellan faktisk och ruttoptimerad körning.',
    emptyState: 'Välj fordon och datum, välj minst 2 trippar och klicka på Analysera.',
    routeMapPerVehicle: 'Ruttjämförelse per fordon',
    routeMapClickHint: 'Klicka på ett fordon för att se kartor med körd och optimal rutt',
    
    // Mätvärden
    totalDistance: 'Total distans',
    drivingTime: 'Körtid',
    stopTime: 'Stopptid',
    sameStopTime: 'samma',
    serviceTime: 'Servicetid',
    stopCount: 'Antal stopp',
    routeOrder: 'Besöksordning',
    
    // Frigjord potential (INTE "sparad")
    freedPotential: 'Frigjord potential',
    freedTime: 'Frigjord tid',
    freedTimeDescription: 'Tid som frigörs för andra uppgifter',
    reducedDistance: 'Reducerad körsträcka',
    reducedDrivingTime: 'Reducerad körtid',
    distanceSimilar: 'Distans likartad',
    
    // Vad frigjord tid kan användas till
    freedTimeUsage: 'Frigjord tid kan användas till',
    potentialExtraVisits: 'Extra kundbesök',
    potentialExtraTimePerStop: 'Extra tid per kund',
    betterService: 'Bättre service',
    bufferTime: 'Buffer för oförutsett',
    
    // Ekonomisk effekt
    economicEffect: 'Ekonomisk effekt',
    fuelSavings: 'Lägre bränslekostnad',
    co2Reduction: 'CO₂-reduktion',
    
    // Årlig potential
    annualPotential: 'Årlig potential',
    annualFreedTime: 'Frigjord tid per år',
    annualReducedDistance: 'Reducerad körsträcka per år',
    workDaysPerYear: 'arbetsdagar',
    
    // Karta
    showActualRoute: 'Visa körd rutt',
    showOptimalRoute: 'Visa optimal rutt',
    compareRoutes: 'Jämför rutter',
    
    // Export
    exportReport: 'Exportera rapport',
    shareAnalysis: 'Dela analys',
    
    // Status
    vroomAvailable: 'Ruttoptimering tillgänglig',
    vroomUnavailable: 'Ruttoptimering inte tillgänglig',
    minTripsRequired: 'Minst 2 trippar krävs för jämförelse',
    noOptimalRoute: 'Visar endast faktisk kördata (optimal rutt ej tillgänglig)',
    
    // Enheter
    minutes: 'min',
    hours: 'tim',
    kilometers: 'km',
    liters: 'liter',
    sek: 'kr',
    kg: 'kg',
    percent: '%',

    // Metodförklaring
    methodologyDisclaimer: 'Viktigt att veta: "Körd rutt" är total tripptid (från trip start till trip slut) och kan inkludera tid vid varje stopp (t.ex. besökstid). "Optimal rutt" är endast beräknad körtid mellan stopp i optimal ordning (A–B-ruttning). Skillnaden är därför en teoretisk övre gräns – vid hemtjänst kan inte besökstiden "sparas" genom bättre rutt. Reell potential beror på tidsfönster, besökstider och hur trippar är avgränsade.',
    methodologyNote: 'Per sträcka (start→stopp): Faktiskt = sträcka och tid fordonet tog. Ruttoptimerad = bästa vägsträcka och uppskattad körtid från vägnätet. Samma punkter, jämförbart.',
    calculatingRoute: 'Optimal rutt beräknas...',
    vroomRequired: 'VROOM-optimering krävs för denna vy',
    checkingVroom: 'Kontrollerar...',
    stopsCount: '{{count}} stopp',
    stopsAnalyzed: '{{count}} stopp analyserade',
    showingTrip: 'Visar tripp {{num}}',
    showAllTrips: 'Visa alla trippar',
    showOnlyThisTrip: 'Visa bara denna tripp',
    showAll: 'Visa alla',
    vehicles: 'fordon',
    trips: 'trippar totalt',
    selected: 'valda',
    expandAll: 'Expandera alla',
    collapseAll: 'Kollapsa alla',
    stopStart: 'Stopp {{num}} (start)',
    stopEnd: 'Stopp {{num}} (slut)',
    start: 'Start',
    goal: 'Mål',
    actualRouteLabel: 'Körd rutt (GPS från MongoDB)',
    gpsPoints: '{{count}} GPS-punkter',
    optimalRouteLabel: 'Optimal rutt (VROOM)',
    points: '{{count}} punkter',
  },

  mapServices: {
    title: 'Kartjänster',
    liveTracking: 'Realtidskarta',
    liveTrackingDescription: 'Följ fordon i realtid på kartan',
    track: 'Track',
    trackDescription: 'Historisk GPS-spårning med playback för flera fordon',
    geofence: 'Geofence',
    geofenceDescription: 'Hantera geografiska zoner och områdesövervakning',
    heatmap: 'Heatmap',
    heatmapDescription: 'Visualisera aktivitetsmönster som värmekarta',
    opensInNewWindow: 'Öppnas i nytt fönster',
  },

  analysis: {
    stopTime: {
      title: 'Stopptidsanalys - Elstolpeplanering',
      description: 'Analys av fordonsstopptider för optimal placering av laddinfrastruktur',
      startDate: 'Startdatum',
      endDate: 'Slutdatum',
      organization: 'Organisation',
      selectOrganization: 'Välj organisation',
      update: 'Uppdatera',
      loading: 'Laddar...',
      totalLocations: 'Totalt antal platser',
      totalHours: 'Total stopptid',
      totalStops: 'Totalt antal stopp',
      vehiclesAnalyzed: 'Fordon analyserade',
      tabHeatmap: 'Heatmap',
      tabMap: 'Karta',
      emptyState: 'Välj datum och organisation för att visa analys',
    },
    trends: {
      title: 'Trender',
      description: 'Trendanalys, utveckling över tid och körsträcka mot leasingavtal',
      distance: 'Körsträcka',
      fuelCost: 'Bränslekostnad',
      vsPrevious: 'Mot föregående period',
      forecastLiters: 'Prognos nästa period',
      forecastHint: 'Linjär trend från historiken',
      costTrend: 'Kilometer och kostnad',
      seasonal: 'Säsongsvariation (12 mån)',
      behaviorTitle: 'Fordon med ändrat beteende',
      previousKm: 'Föregående km',
      recentKm: 'Senaste km',
      change: 'Förändring',
      reason: 'Orsak',
      noBehavior: 'Inga stora avvikelser mot föregående period',
      tabTrends: 'Trender',
      tabLeasing: 'Leasingkörsträcka',
      leasing: {
        vehicle: 'Fordon',
        selectVehicle: 'Välj registreringsnummer (valfritt)',
        clearVehicle: 'Visa alla fordon',
        vehicles: 'Fordon',
        tableTitle: 'Körsträcka mot leasingavtal',
        allowed: 'Avtalad km',
        measured: 'Uppmätt km',
        estimatedUsed: 'Beräknad användning',
        forecastEnd: 'Prognos vid slut',
        delta: 'Avvikelse',
        extraCost: 'Merkostnad',
        status: 'Status',
        statusOver: 'Risk överskrida',
        statusUnder: 'Risk underskrida',
        statusOnTrack: 'Enligt avtal',
        statusMissing: 'Saknar data',
        budgetLine: 'Avtalsbudget',
        measuredLine: 'Uppmätt',
        forecastLine: 'Prognos (takt)',
        rateHint: 'Prognosen bygger på uppmätt km/dag under den period enheten har skickat data — startmätare krävs inte.',
        lateInstallHint: 'Enheten verkar ha monterats efter avtalsstart. Första kördata:',
        shortHistoryHint: 'Kort mätperiod — prognosen är osäker.',
      },
    },
    benchmarks: {
      title: 'Jämförelser',
      description: 'Jämför prestanda mellan avdelningar och organisationer',
      bestPractice: 'Best practice',
      improve: 'Förbättringsområden',
      ranking: 'Ranking per organisation',
      eco: 'ECO',
      lPer100: 'L/100 km',
      utilization: 'Utnyttjande',
      drillHint: 'Klicka på en organisation för att zooma in på dess fordon.',
      vehicles: 'Fordon i urvalet',
    },
    crashDetection: {
      title: 'Crash detection',
      description: 'Lista och visualisering av krockhändelser (Crash Trace från enheter).',
      regNumber: 'Regnummer',
      imei: 'IMEI',
      date: 'Datum',
      samples: 'Antal samples',
      triggerCount: 'Utlösanden',
      timeSpan: 'Tidspan',
      triggerPositions: '{{count}} position(er)',
      fromDate: 'Från datum',
      toDate: 'Till datum',
      imeiPlaceholder: 'Filtrera på IMEI',
      noEvents: 'Inga krockhändelser hittades.',
      detailTitle: 'Data kring krocken',
      speedAtCrash: 'Hastighet vid krock',
      speedAtCrashHint: 'Hastigheten är från utlösandet vid själva händelsen.',
      xyzChart: 'Accelerometer X/Y/Z (mG)',
      xyzHint: 'Bromsning syns som negativt utslag (t.ex. Z). Sidförflyttning syns som utslag på Y eller X.',
      tripMap: 'Trippen vid krocktidpunkten',
      mapTitle: 'Karta',
      speedChart: 'Hastighetskurva',
      speedChartHint: 'Hastighet (km/h). Vid trippdata: ±2 min runt händelsen. Annars: varje utlösande.',
      brakeChart: 'Bromskurva',
      brakeChartHint: 'Positivt värde = bromsning (m/s²). Beräknat från hastighetsförändring.',
      noRouteForCharts: 'Ingen trippdata – hastighet och bromsning kräver tripp med GPS-punkter.',
      speedAtEventOnly: 'Hastighet vid händelse: {{speed}} km/h. Ingen trippdata för kurva.',
    },
  },

  // ============================================================
  // Service - Fordonsservice
  // ============================================================
  service: {
    title: 'Service',
    overview: 'Serviceöversikt',
    servicePoints: 'Servicepunkter',
    addPoint: 'Lägg till servicepunkt',
    saveFailed: 'Kunde inte spara servicepunkt. Försök igen.',
    noCreatePermission: 'Du saknar behörighet att lägga till servicepunkter.',
    syncCarInfo: 'Synka från Car.info',
    noServicePoints: 'Inga servicepunkter. Klicka "Synka från Car.info" för att importera.',
    noServiceDue: 'Inga servicepunkter att visa',
    horizonHint: 'Visar service inom 300 km eller 60 dagar. Besiktning visas 40 dagar före utgångsdatum (endast datum).',
    horizonListEmpty: 'Inga åtgärder förfaller inom 300 km eller 60 dagar, och ingen besiktning inom 40 dagar.',
    inspectionDateOnly: 'Datum',
    inspectionBookHint: 'Boka hos företaget, fyll i station, datum och tid och bekräfta. Då sparas bokningen direkt. Bekräftelsemejlet till besiktning@deviaq.se hinner sällan fram i tid – om det kommer fyller vi i fälten åt dig.',
    inspectionConfirmEmailLabel: 'Kopiera returadress',
    inspectionConfirmEmailHint: 'Klistra in den hos besiktningsföretaget som e-post för bekräftelse.',
    inspectionCopyEmail: 'Kopiera adress',
    inspectionAppliesTo: 'Gäller {reg}',
    inspectionCompare: 'Jämför stationer (bokabesiktning.nu)',
    inspectionSwedac: 'Swedac ackrediterade företag',
    inspectionStation: 'Station',
    inspectionStationPlaceholder: 'T.ex. Malmö Innerstaden',
    inspectionBookingTime: 'Tid',
    inspectionOpenedHint: 'Bokningssidan öppnades i en ny flik. Fyll i station, datum och tid och bekräfta – då sparas bokningen.',
    inspectionWaitingEmail: 'Mejlet hinner sällan fram medan du väntar. Fyll i uppgifterna och bekräfta så sparas bokningen.',
    inspectionFilledFromEmail: 'Uppgifterna är ifyllda från bekräftelsemejlet.',
    inspectionBookedFromEmail: 'Besiktningen är bokad från bekräftelsemejlet.',
    inspectionCompanyRequired: 'Välj ett besiktningsföretag.',
    inspectionStationRequired: 'Ange vilken station du bokade.',
    inspectionDateRequired: 'Ange bokningsdatum.',
    inspectionBookFailed: 'Kunde inte spara bokningen. Försök igen.',
    allPointsHint: 'Visar alla servicepunkter på fordonet och när de ska utföras nästa gång.',
    totalActions: 'Totalt åtgärder',
    vehicles: 'fordon',
    actions: 'åtgärder',
    searchPlaceholder: 'Sök fordon, service...',
    allStatuses: 'Alla statusar',
    interval: 'Intervall',
    nextDue: 'Nästa',
    lastPerformed: 'Senast utförd',
    reminder: 'Påminnelse',
    booking: 'Bokning',
    bookingInfo: 'Bokningsinformation',
    bookingDate: 'Bokningsdatum',
    book: 'Boka',
    bookedFor: 'Bokad',
    confirmBooking: 'Bekräfta bokning',
    markComplete: 'Markera klar',
    confirmComplete: 'Markera som utförd',
    performedDate: 'Utfört datum',
    performedKm: 'Mätarställning (km)',
    cost: 'Kostnad (kr)',
    notes: 'Anteckningar',
    history: 'Historik',
    editReminder: 'Påminnelse',
    updateReminder: 'Uppdatera påminnelse',
    warningKm: 'Varna vid (km före)',
    warningDays: 'Varna vid (dagar före)',
    workshopLabel: 'Verkstad',
    noWorkshop: '-- Välj verkstad --',
    days: 'dagar',
    intervalKm: 'Intervall (km)',
    intervalMonths: 'Intervall (mån)',
    intervalHint: 'Ange minst ett intervall – km, tid (mån) eller båda.',
    existingType: 'Befintlig typ',
    customType: 'Egen typ',
    selectType: 'Välj servicetyp',
    chooseType: '-- Välj --',
    typeName: 'Namn på servicetyp',
    categoryLabel: 'Kategori',
    categoryCustom: 'Egen',
    categoryMaintenance: 'Underhåll',
    lastPerformedDate: 'Senast utförd (datum)',
    lastPerformedKm: 'Senast utförd (km)',
    status: {
      ok: 'OK',
      warning: 'Förfaller snart',
      overdue: 'Förfallen',
      booked: 'Bokad',
      completed: 'Utförd',
    },
    attachments: {
      title: 'Bilagor',
      noAttachments: 'Inga bilagor uppladdade',
      uploadHint: 'Klicka på "Ladda upp" för att lägga till filer',
      upload: 'Ladda upp',
      uploading: 'Laddar upp...',
      descriptionOptional: 'Beskrivning (valfritt)',
      descriptionPlaceholder: 'T.ex. Besiktningsprotokoll 2026',
      all: 'Alla',
      categoryInsurance: 'Försäkring',
      categoryInspection: 'Besiktning',
      categoryDamage: 'Skada',
      categoryInvoice: 'Faktura',
      categoryContract: 'Avtal',
      categoryService: 'Service',
      categoryOther: 'Övrigt',
    },
    tires: {
      title: 'Däck',
      add: 'Lägg till',
      addNew: 'Nytt däckset',
      type: 'Däcktyp',
      brand: 'Märke',
      model: 'Modell',
      size: 'Dimension',
      treadDepth: 'Mönsterdjup',
      treadDepthVf: 'VF (Vänster Fram)',
      treadDepthHf: 'HF (Höger Fram)',
      treadDepthVb: 'VB (Vänster Bak)',
      treadDepthHb: 'HB (Höger Bak)',
      treadDepthMm: 'mm',
      treadDepthSection: 'Mönsterdjup per hjulposition',
      storageType: 'Förvaringstyp',
      storageLocation: 'Plats',
      storage: 'Förvaring',
      summer: 'Sommardäck',
      winterFriction: 'Snödäck (friktion)',
      winterStudded: 'Dubbdäck',
      hotel: 'Däckhotell',
      installed: 'Monterade',
      stored: 'Lagrade',
      other: 'Övrigt',
      installedSince: 'Monterade sedan',
      lastChanged: 'Senast bytt',
      mount: 'Montera',
      unmount: 'Avmontera',
      save: 'Spara',
      none: 'Inga däck registrerade',
      noTireInfo: 'Däckinformation saknas',
      manage: 'Hantera däck',
      edit: 'Redigera däck',
      currentTires: 'Monterade däck',
      tireChangeSection: 'Däckinformation (registreras vid bytet)',
      minTread: 'Sämsta mönsterdjup',
      changeHistory: 'Byteshistorik',
      noHistory: 'Inga däckbyten loggade än',
      removed: 'Avmonterat',
      installedNew: 'Monterat',
      kmDriven: 'Körda km på avmonterat däck',
      odometerAtChange: 'Mätarställning vid byte',
      treadWorn: 'Slitage per hjul (mm)',
      treadWornAvg: 'Snittslitage',
      treadDepthAutoMin: 'Lägsta värdet sparas automatiskt som sämsta mönsterdjup',
      treadDepthLabel: 'Mönsterdjup',
      storageHotel: 'Däckhotell',
      storageStorage: 'Förråd',
      storageVehicle: 'I fordonet',
      storageOther: 'Annat',
    },
    // Vy-lägen
    viewList: 'Lista',
    viewCalendar: 'Kalender',
    viewCosts: 'Kostnader',
    // Kategorier
    category: {
      all: 'Alla kategorier',
      tire: 'Däckbyte',
      maintenance: 'Service',
      inspection: 'Besiktning',
      custom: 'Övrigt',
    },
    // Filter
    filter: {
      allStatuses: 'Alla statusar',
    },
    // Bulk-operationer
    bulk: {
      selected: 'markerade',
      action: 'Åtgärda markerade',
      title: 'Åtgärda servicepunkter',
      points: 'punkter',
      book: 'Boka',
      complete: 'Klarmarkera',
      bookingDate: 'Bokningsdatum',
      performedDate: 'Utförandedatum',
      totalCost: 'Total kostnad',
      costNote: 'gäller för hela gruppen',
      confirmBook: 'Bekräfta bokning',
      confirmComplete: 'Markera som utförda',
    },
    // Kalender
    calendar: {
      title: 'Servicekalender',
    },
    // Verkstad
    workshop: {
      create: 'Skapa verkstad',
      edit: 'Redigera verkstad',
      name: 'Namn',
      type: 'Typ',
      extern: 'Extern',
      intern: 'Intern',
      internalPerson: 'Intern person (servicepersonal)',
      selectPersonnel: '-- Välj servicepersonal --',
      noPersonnelHint: 'Inga servicepersonal hittades. Lägg till rollen via Kontaktroller.',
      contactPerson: 'Kontaktperson',
      address: 'Adress',
      city: 'Ort',
      phone: 'Telefon',
      email: 'E-post',
      listTitle: 'Verkstäder',
      listDescription: 'Administrera verkstäder och servicepersonal',
      searchPlaceholder: 'Sök namn, ort eller kontakt',
      empty: 'Inga verkstäder ännu',
      loadError: 'Kunde inte ladda verkstäder',
    },
    internal: 'Intern',
    // Faktura / AI-tolkning
    invoice: {
      upload: 'Ladda upp faktura (PDF/bild) för AI-tolkning',
      uploadShort: 'Ladda upp',
      parsed: 'AI tolkade fakturan',
      supplier: 'Leverantör',
      number: 'Fakturanr',
      total: 'Totalt',
      vat: 'Moms',
    },
    // Kostnadsrapport
    costs: {
      month: 'Månad',
      category: 'Kategori',
      categoryName: 'Kategorinamn',
      totalSek: 'Kostnad (kr)',
      serviceCount: 'Antal',
      grandTotal: 'Total kostnad',
      monthlyChart: 'Kostnad per månad',
      exportExcel: 'Exportera Excel',
      noData: 'Inga kostnadsdata för vald period',
      reportPageTitle: 'Servicekostnader',
      reportSubtitle: 'Kostnader per kategori och period',
    },
    // Automatisk service (per org)
    autoTire: {
      title: 'Automatisk däckservice',
      description: 'Skapa servicepunkter automatiskt för vinterdäck och sommardäck baserat på svenska regler.',
      enable: 'Aktivera automatisk däckservice',
      enableHint: 'Skapar servicepunkter för alla fordon inom angivet antal dagar före deadline.',
      winterDeadline: 'Vinterdäck – senast monterat',
      summerDeadline: 'Dubbdäck/Vinterdäck – senast avmonterat',
      winterHint: 'Senast detta datum ska vinterdäck vara monterat (enl. Transportstyrelsen: 1 december)',
      summerHint: 'Senast detta datum ska dubbdäck och vinterdäck vara avmonterade (enl. Transportstyrelsen: 15 april)',
      advanceDays: 'Dagar i förväg',
      advanceDaysUnit: 'dagar',
      advanceDaysHint: 'Antal dagar innan deadline som serviceordern skapas. Standard: 60 dagar (2 månader).',
    },
    // Serviceansvarig
    responsible: 'Serviceansvarig',
    selectResponsible: 'Välj serviceansvarig...',
  },

  // Fordonsekonomi – leasing, försäkring, aveckling, export
  vehicleEconomy: {
    leasing: 'Leasing',
    ownershipType: 'Ägd eller leasad',
    ownershipHint: 'Hämtas från Car.info (leasing startad/avslutad). Du kan ändra status här.',
    insurance: 'Försäkring',
    disposal: 'Avveckling',
    disposalType: 'Typ',
    disposalTypeSale: 'Försäljning',
    disposalTypeReturn: 'Återlämning',
    disposalNotes: 'Anteckning',
    saveSuccess: 'Ekonomi sparad',
    agreementNo: 'Avtalsnr',
    contractNo: 'Kontraktsnr',
    leasingCompany: 'Leasingbolag',
    insuranceCompany: 'Försäkringsbolag',
    vehicleSupplier: 'Bilförsäljare',
    addVehicleSupplier: 'Lägg till bilförsäljare…',
    newVehicleSupplierPlaceholder: 'Namn på bilförsäljare',
    vehicleSupplierCustomerHint: 'Sparas på kunden och kan väljas på andra fordon.',
    supplierSaveFailed: 'Kunde inte spara bilförsäljaren',
    rentStart: 'Hyresstart',
    rentEnd: 'Hyresslut',
    termMonths: 'Avtalstid (månader)',
    leasingProduct: 'Produkt',
    originalBasePrice: 'Ursp baspris',
    bookValue: 'Bokfört värde',
    guaranteedResidualValue: 'Garanterat restvärde',
    importHistory: 'Historik (Nordea-import)',
    readOnlyDeque: 'Visningsläge – du kan se importerad leasingdata men saknar behörighet att redigera ekonomi.',
    historyPeriod: 'Period (Datum to)',
    historyInvoice: 'Fakturanr',
    historyPer: 'Per',
    costMonthLeasing: 'Månadskostnad leasing',
    allowedDistance: 'Tillåten km',
    costPerExtraKm: 'Kostnad extra km',
    costCenter: 'Kostnadsställe',
    costCenterLeasing: 'Kostnadsställe (leasing)',
    costCenterInsurance: 'Kostnadsställe (försäkring)',
    costCenterTax: 'Kostnadsställe (skatt)',
    costCenterTaxMalus: 'Kostnadsställe (malus)',
    insuranceStartDate: 'Startdatum',
    insuranceEndDate: 'Slutdatum',
    insuranceAgreementNo: 'Avtal',
    costMonthInsurance: 'Månadskostnad försäkring',
    costMonthTax: 'Månadskostnad skatt',
    costMonthTaxMalus: 'Månadskostnad skatt malus',
    insuranceImportHistory: 'Historik (Protector-import)',
    insHistoryPeriod: 'Period (Til datum)',
    insHistoryAgreement: 'Avtal',
    insHistoryTrafficTotal: 'Trafik tot',
    insHistoryDelkasko: 'Delk',
    insHistoryVagnskada: 'Vagn',
    insHistoryPremiumYear: 'Belopp',
    insHistoryTotal: 'Total',
    insHistoryCostMonth: 'Månad',
    disposalDate: 'Avyttringsdatum',
    disposalSaleAmount: 'Försäljningsbelopp',
    disposalExtraCosts: 'Extrakostnader vid avyttring',
    exportTitle: 'Export fordonsekonomi',
    exportDescription: 'Välj organisation och period. Exporten bygger på importerade kostnadsrader och skapar en Unit4-fil (konto, ansvar, verksamhet, motpart).',
    period: 'Period (år-månad)',
    exportBokforing: 'Underlag för bokföring (Unit4)',
    exportBokforingDesc: 'CSV enligt Unit4-kodplan, aggregerat per konto och ansvar – för import i redovisning.',
    exportFakturering: 'Underlag för fakturering (Unit4)',
    exportFaktureringDesc: 'CSV med internfaktura (debet/kredit) per fordon och kostnadsslag – för inläsning i Unit4.',
    exportSelectOrg: 'Välj organisation för att skapa underlag.',
    exportError: 'Kunde inte ladda ner export.',
    costInvoiceLines: 'Importerade fakturarader',
    costInvoiceSummary: 'Importerade kostnader',
    costInvoiceSummaryMeta: '{{count}} rader · period {{period}}',
    costInvoiceSummaryCount: 'Rader',
    costInvoiceSummaryTotal: 'Totalt',
    costInvoiceDate: 'Fakturadatum',
    costInvoiceNumber: 'Fakturanr',
    costInvoiceCategory: 'Kostnadsslag',
    costInvoiceDescription: 'Beskrivning',
    costInvoiceAmount: 'Belopp exkl. moms',
  },

  costInvoice: {
    title: 'Kostnadsfakturaimport',
    cardDescription: 'Importera Ayvens-fakturor och mappa kostnadsslag',
    description:
      'Importera blandade fordonskostnader från leasingbolag (t.ex. Ayvens). Mappa kostnadsslag och ladda upp en eller flera filer, eller en hel mapp. Varje fil importeras bara en gång.',
    uploadTitle: 'Ladda upp filer',
    uploadHint:
      'Välj Excel-filer (.xlsx) eller en mapp. Samma filinnehåll importeras bara en gång per organisation. Bränslekortsrader är avstängda som standard.',
    selectFiles: 'Välj filer',
    selectFolder: 'Välj mapp',
    mappingTitle: 'Kostnadsslag-mappning (Ayvens)',
    mappingHint:
      'Leverantörens kod mappas till ett DQFleet-kostnadsslag. Avmarkera Inkludera om raderna inte ska sparas (t.ex. bränsle som redan kommer från Circle K).',
    saveMapping: 'Spara mappning',
    mappingSaved: 'Mappningen är sparad',
    mappingSaveError: 'Kunde inte spara mappningen',
    importHistory: 'Tidigare importer',
    noImports: 'Inga importer ännu',
    colFilename: 'Filnamn',
    colInvoiceDate: 'Fakturadatum',
    colRows: 'Rader',
    colImported: 'Importerade',
    colSkipped: 'Hoppade över',
    colUnmapped: 'Omappade',
    colUnmatched: 'Okända regnr',
    colImportedAt: 'Importerad',
    colSourceCode: 'Kod',
    colSourceLabel: 'Leverantörstyp',
    colCategory: 'DQFleet-slag',
    colInclude: 'Inkludera',
    loadError: 'Kunde inte hämta import eller mappning',
    importError: 'Import misslyckades',
    importTimeout: 'Importen tog för lång tid. Försök med en fil i taget.',
    fileTooLarge: 'Filen är för stor för servern (nginx). Be admin höja client_max_body_size.',
    importSuccess: 'Import klar för {{count}} fil(er)',
    duplicateFiles: '{{count}} fil(er) var redan importerade',
    noSpreadsheetFiles: 'Mappen innehöll inga .xls/.xlsx-filer',
    unmappedCodesHint: 'Omappade koder: {{codes}} — lägg till dem i mappningen och importera igen',
    autoMappedHint: 'Nya koder mappades automatiskt: {{codes}}. Kontrollera tabellen om något ska ändras.',
    createdVehiclesHint: '{{count}} saknade fordon skapades på toppnoden och hämtades från car.info',
    carInfoFailedHint: '{{count}} fordon skapades men car.info kunde inte fyllas i',
  },

  ayvensFuel: {
    title: 'Ayvens bränslekort (manuell import)',
    description:
      'Ladda upp Ayvens "Bränslekort, detaljer". Transaktioner sparas som Ayvens. Om samma tankning redan finns hos Circle K, OKQ8 eller annat bolag märks raden som dubblett — det kan vara dubbelfakturering.',
    selectFiles: 'Välj bränslefil',
    importSuccess: '{{count}} bränslerader importerade',
    duplicateHint: '{{count}} rader märktes som dubblett mot annat bolag',
    nothingImported: 'Inga nya rader (filen kan redan vara importerad)',
    importError: 'Import av Ayvens-bränsle misslyckades',
  },

  vehicleCostAnalysis: {
    title: 'Fordons ekonomi',
    cardDescription: 'Analysera importerade kostnader per organisation, grupp och fordon',
    description:
      'Välj en organisation eller grupp för att se alla bilar summerade. Markera en eller flera bilar för att analysera kostnadsslag och fakturarader.',
    totalCost: 'Total kostnad',
    vehiclesWithCost: 'Bilar med kostnad',
    lineCount: 'Rader',
    unmatched: 'Omatchade (okänt regnr)',
    groupBreakdown: 'Kostnadsslag i gruppen',
    vehiclesTitle: 'Bilar i gruppen',
    onlyWithCosts: 'Visa bara bilar med kostnad',
    clearSelection: 'Rensa urval',
    noVehicles: 'Inga fordon i vald grupp',
    selectionTitle: 'Analys av {{count}} vald(a) bil(ar)',
    selectedVehicles: 'Valda bilar',
    selectionBreakdown: 'Kostnadsslag för urvalet',
    linesTitle: 'Fakturarader',
    noLines: 'Inga fakturarader för urvalet i perioden',
    colReg: 'Regnr',
    colVehicle: 'Fordon',
    colOrg: 'Organisation',
    colLines: 'Rader',
    colTotal: 'Summa exkl. moms',
    colCategory: 'Kostnadsslag',
    colInvoiceDate: 'Fakturadatum',
    colInvoiceNumber: 'Fakturanr',
    colDescription: 'Beskrivning',
    colAmount: 'Belopp exkl. moms',
    loadError: 'Kunde inte hämta kostnadssummeringen',
    tabs: {
      overview: 'Översikt',
      vehicles: 'Bilar',
      analysis: 'Analys',
    },
    goToAnalysis: 'Analysera valda',
    selectVehiclesHint: 'Markera en eller flera bilar under fliken Bilar för att analysera dem.',
  },

  contractDocument: {
    title: 'Kontraktsbekräftelser (PDF)',
    description:
      'Ladda upp Ayvens-bekräftelser. AI läser förare, kontrakt och leasinguppgifter. PDF:en kopplas till bilen och uppgifterna fylls i under Ekonomi.',
    selectFiles: 'Välj PDF-filer',
    selectFolder: 'Välj mapp',
    noPdfFiles: 'Mappen innehöll inga PDF-filer',
    noImports: 'Inga kontraktsdokument ännu',
    loadError: 'Kunde inte hämta kontraktsdokument',
    importError: 'Import av kontraktsdokument misslyckades',
    importSuccess: 'Importerade {{count}} kontraktsdokument',
    unmatchedHint: '{{count}} fil(er) kunde inte kopplas till ett fordon',
    attachedHint: '{{count}} PDF kopplad(e) till fordon',
    aiSkipped: 'AI-servern svarade inte — regnr och grundfält lästes ur filen ändå',
    duplicateFile: '{{name}} var redan importerad',
    colFilename: 'Filnamn',
    colReg: 'Regnr',
    colDriver: 'Förare',
    colContract: 'Kontrakt',
    colStart: 'Start',
    colEnd: 'Slut',
    colAi: 'AI',
  },

  // Booking - Utlämningsplatser, leverantörer, destinationer
  booking: {
    title: 'Bokning',
    pickupLocations: 'Utlämningsplatser',
    pickupLocationsTitle: 'Utlämningsplatser',
    pickupLocationsDescription: 'Under Bokning: platser där fordon hämtas och lämnas',
    addPickupLocation: 'Lägg till utlämningsplats',
    editPickupLocation: 'Redigera utlämningsplats',
    noPickupLocations: 'Inga utlämningsplatser. Lägg till en för att komma igång.',
    noPickupLocationsCalendar: 'Inga utlämningsplatser skapade. Öppna Bokning och välj Utlämningsplatser för att skapa pooler och koppla fordon.',
    goToPickupLocations: 'Öppna Bokning',
    managedBySupplier: 'Hanteras av biluthyrare',
    managedBySupplierNone: 'Egen pool (ingen biluthyrare)',
    managedBySupplierHelp:
      'Välj en biluthyrare för att låta dem hantera poolen och tilldela bilar för förfrågningar. Bilarna i poolen ägs av biluthyraren.',
    managedBySupplierNoLinks:
      'Inga biluthyrarkopplingar finns för denna organisation. Skapa en koppling under Biluthyrare först.',
    pickupAllowedCarClasses: 'Bilklasser (kan bokas/request:as)',
    pickupAllowedCarClassesHelp:
      'Skriv in de bilklasser som kan bokas eller request:as på denna plats. Lämnas listan tom ärvs biluthyrarkopplingens bilklasser, och om även den är tom får bokaren skriva in bilklass fritt.',
    pickupLocationResponsibles: 'Ansvariga',
    pickupLocationResponsiblesHelp:
      'Personer som ansvarar för utlämningsplatsen. De kan hantera Flinkey-boxar för poolens fordon i mobilappen (FlinkyBoxes) om de har behörighet.',
    pickupLocationResponsiblesSearch: 'Sök användare',
    pickupLocationResponsiblesSearchPlaceholder: 'Namn eller e-post…',
    pickupLocationResponsiblesNone: 'Inga ansvariga valda',
    pickupLocationActiveLabel: 'Aktiv (visas i bokning och pooler)',
    pickupLocationActiveHelp:
      'Om du avmarkerar avaktiveras platsen. Framtida bokningar med status Bokad som fortfarande har bil från denna pool tappar bilen och listas under Kollisionsbokningar så att ni kan tilldela annan pool eller avboka.',
    pickupBookingsLockedLabel: 'Synlig men låst',
    pickupBookingsLockedHelp:
      'Poolen syns i kalendern och användare ser sina bokningar, men ingen kan skapa, ändra eller avboka förrän låset släpps.',
    pickupBookingsLockedBadge: 'Låst',
    poolBookingsLockedHint:
      'Poolen är låst. Du kan se bokningar men inte skapa, ändra eller avboka förrän låset släpps.',
    pickupLocationOpens: 'öppnar {{date}}',
    pickupLocationNotYetOpenHint:
      'Utlämningsplatsen öppnar {{date}}. Du kan se den i listan men inte boka förrän den är giltig.',
    pickupValidFrom: 'Giltig från',
    pickupValidTo: 'Giltig till',
    pickupValidDatesHelp:
      'Styr när platsen visas och går att boka. Lämna tomt för ingen begränsning (gäller direkt). Utanför perioden döljs platsen i bokningen och går inte att boka. Admin ser den ändå här.',
    showBookerNameInResourceManager: 'Visa namn på den som bokat i resurshanteraren',
    showBookerNameInResourceManagerHelp:
      'Om markerat visas bokarens namn (och medresenärer via hovring) på bokningsblocken i resurshanteraren. Standard är att namnet inte visas.',
    fellowTravelers: 'Medresenärer',
    pickupInactiveBadge: 'Inaktiv',
    pickupDeactivate: 'Avaktivera',
    pickupActivate: 'Aktivera',
    pickupDelete: 'Radera',
    pickupExportPools: 'Ladda ner poollista',
    pickupExportPoolsLoading: 'Exporterar…',
    pickupActivateConfirm: 'Aktivera "{{name}}" igen?',
    pickupDeleteConfirm: 'Radera "{{name}}" permanent? Detta kan inte ångras.',
    pickupDeleteHasBookings: 'Platsen har {{count}} bokning(ar) i historiken och kan inte raderas. Avaktivera i stället.',
    pickupDeactivateSuccess: 'Utlämningsplats avaktiverad',
    pickupActivateSuccess: 'Utlämningsplats aktiverad',
    pickupDeleteSuccess: 'Utlämningsplats raderad',
    pickupDeactivateConfirm:
      'Avaktivera "{{name}}"? Platsen avaktiveras. Alla framtida bokningar (status Bokad, inte utcheckade) som har bil tilldelad i denna pool tappar bilen och visas under Kollisionsbokningar. Vill du fortsätta?',
    pickupDeactivateStripped: '{{count}} bokning(ar) flyttades till kollisionshantering.',
    pickupLocationSaveError: 'Kunde inte spara utlämningsplatsen.',
    createUnderOrganization: 'Skapa under organisation',
    loadingOrganizations: 'Laddar organisationer...',
    noTopNodesFound: 'Inga toppnoder hittades. Kontrollera behörighet eller försök igen.',
    drawGeofenceArea: 'Rita område på karta',
    startDrawing: 'Starta ritning',
    finishArea: 'Klar – spara område',
    geofenceAreaHelp: 'Klicka på kartan för att sätta punkter. Minst 3 punkter krävs. Området används för in/ut-pasering och för att validera att bokning avslutas på rätt plats.',
    geofenceEnforceOnReturn: 'Kräv att bilen är inom området vid incheckning',
    geofenceEnforceOnReturnHelp: 'Om aktiverat måste bilen befinna sig inom kartområdet när bokningen checkas in/avslutas via appen. Annars blockeras avslutet. Kundtjänst med behörigheten Återlämning på annan plats kan tillåta undantag (t.ex. fördröjd GPS). Kräver ett ritat område.',
    nearbyPoolSearchRadiusM: 'Sök lediga bilar i närliggande pooler (meter)',
    nearbyPoolSearchRadiusMHelp:
      'Vid ny bokning visas även lediga bilar från andra pooler vars parkeringsyta ligger inom detta avstånd från denna pools parkeringsyta. Standard 2000 m. Sätt 0 för att endast visa denna pool.',
    nearbyPoolSearchRadiusMPlaceholder: '2000',
    pickupHasGeofenceArea: 'Har kartområde',
    pickupShowAreasOnMap: 'Visa kartområden',
    pickupAreasMapTitle: 'Kartområden för utlämningsplatser',
    pickupAreasMapNoAreas: 'Inga utlämningsplatser har kartområden ritade.',
    pickupAreasMapListHint: 'Klicka på ett namn för att zooma till området.',
    pickupAreasMapListCount: '{{count}} platser med kartområde',
    pickupAreasMapShowAll: 'Visa alla områden',
    selectOrgGroup: 'Välj grupp (organisation)',
    vehiclesInPool: 'Fordon i poolen',
    bookingResourcesInPool: 'Resurser i poolen',
    bookingResourcesInPoolHelp: 'Cyklar, släp och andra kundresurser. Resurstyp ärvs från resursregistret.',
    addBookingResourceToPool: 'Lägg till resurs',
    selectBookingResource: 'Välj resurs',
    noUnassignedResources: 'Inga otilldelade resurser. Skapa resurser under Bokningsresurser.',
    bookingResourceAdded: 'Resurs tillagd i poolen',
    bookingResourceRemoved: 'Resurs borttagen från poolen',
    vehiclesInGroup: 'Fordon i gruppen',
    pickupLinkedTotal: '{{count}} fordon kopplade till utlämningsplatsen',
    pickupLinkedInList: 'av {{total}} fordon är kopplade',
    pickupLinkedOtherOrgsTitle: '{{count}} kopplade fordon visas inte i listan (annan organisation än vald grupp)',
    pickupLinkedOtherOrgsHint: '{{count}} kopplade fordon tillhör annan organisation än vald grupp (märkta i listan).',
    pickupLinkedOtherOrgBadge: 'Annan org',
    pickupVehicleSearch: 'Sök fordon',
    pickupVehicleSearchPlaceholder: 'Reg.nr, märke eller modell…',
    pickupVehicleSearchResults: 'Visar {{shown}} av {{total}} fordon',
    pickupVehicleSearchNoHits: 'Inga fordon matchar sökningen.',
    pickupLinkedBadge: 'Kopplad',
    pickupVehiclesApplyOnSave:
      'Bocka i eller ur fordon här. Ändringen verkställs först när du klickar Spara. Avbryt lämnar listan som den var.',
    pickupRemoveVehiclesConfirm:
      'Ta bort {{count}} fordon från utlämningsplatsen? Kommande bokningar på dessa bilar bokas om eller blir kollisioner.',
    pickupPoolResourceTypeHeading: 'Resurstyp vid bokning (per fordon i poolen)',
    pickupPoolResourceTypeHelp: 'Tom = räknas som bil i bokningssök. Välj t.ex. Cykel när poolen innehåller cyklar.',
    pickupPoolResourceTypeDefault: 'Standard (bil)',
    pickupBookingInfo: 'Info till bokande',
    pickupBookingInfoHelp: 'Den här texten skickas med i bokningsbekräftelsen till personen som bokat bil från poolen.',
    pickupLocationMapShow: 'Visa utlämningsplats på karta',
    pickupLocationMapTitle: 'Utlämningsplats på karta',
    pickupLocationMapNoAddress: 'Ingen adress angiven.',
    pickupLocationMapNoCoords: 'Ingen karta finns för den här platsen.',
    pickupTabSettings: 'Inställningar',
    pickupTabBooking: 'Bokning',
    pickupTabVehicles: 'Fordon',
    pickupTabResources: 'Resurser',
    pickupTabKeyCabinet: 'Nyckelskåp',
    pickupTabKeyCabinetPlaceholder: 'Här kopplas nyckelskåp till utlämningsplatsen. Funktionen byggs ut inom kort.',
    pickupTabKeyCabinetHelp: 'Kopplade skåp syns här. Du kan även koppla skåp som tillhör samma organisation men inte är kopplade till någon utlämningsplats.',
    pickupKeyCabinetsConnected: 'Kopplade skåp',
    pickupKeyCabinetsNone: 'Inga skåp är kopplade till den här utlämningsplatsen.',
    pickupKeyCabinetsAvailable: 'Tillgängliga skåp i organisationen',
    pickupKeyCabinetsNoneAvailable: 'Inga okopplade skåp finns i organisationen.',
    pickupKeyCabinetSelect: 'Välj skåp',
    pickupKeyCabinetConnect: 'Koppla skåp',
    pickupKeyCabinetDisconnect: 'Ta bort koppling',
    pickupKeyCabinetConnectSuccess: 'Skåpet kopplades till utlämningsplatsen.',
    pickupKeyCabinetDisconnectSuccess: 'Skåpkopplingen togs bort.',
    pickupKeyCabinetConnectError: 'Kunde inte koppla skåpet.',
    pickupKeyCabinetDisconnectError: 'Kunde inte ta bort skåpkopplingen.',
    pickupKeyCabinetLoadError: 'Kunde inte hämta nyckelskåp.',
    pickupTabResponsibles: 'Ansvariga',
    addVehiclesToPool: 'Lägg till valda i poolen',
    name: 'Namn',
    address: 'Adress',
    postalCode: 'Postnummer',
    city: 'Ort',
    pickupMappedVehicleCount: 'Fordon',
    nearbyPoolSearchRadiusMeters: 'Sök närliggande pooler (meter)',
    nearbyPoolSearchRadiusPlaceholder: 't.ex. 5000',
    nearbyPoolSearchRadiusHelp:
      'Vid bokning söks även lediga fordon i andra utlämningsplatser inom detta avstånd (mätt från kartområdets centrum). Lämna tomt eller 0 för att endast använda denna pool. Kräver ritat kartområde.',
    displayOrder: 'Sortering',
    suppliers: 'Leverantörer',
    suppliersTitle: 'Leverantörer',
    suppliersDescription: 'Konfigurera era leverantörer och egna bilgruppsnamn. Samma biluthyrare i CRM kan kopplas av flera kunder – varje kund har sin egen lista och benämning.',
    addSupplier: 'Lägg till leverantör',
    addCarRentalFromCrm: 'Lägg till Biluthyrare från CRM',
    selectCarRental: 'Välj Biluthyrare',
    noCarRentalCustomers: 'Inga kunder med typ Biluthyrare i CRM. Skapa först en kund med kundtyp Biluthyrare under CRM → Kunder.',
    deliversToAllPools: 'Levererar till alla pooler',
    editSupplier: 'Redigera leverantör',
    noSuppliers: 'Inga leverantörer. Lägg till en för att komma igång.',
    supplierType: 'Typ',
    supplierTypeCarRental: 'Biluthyrning',
    supplierTypeOther: 'Övrig',
    supplierEmail: 'E-post',
    supplierPhone: 'Telefonnummer',
    supplierEmailPlaceholder: 't.ex. bokning@avis.se',
    supplierPhonePlaceholder: 't.ex. 011-123 45 67',
    supplierCarClasses: 'Bilgrupper',
    supplierCarClassesHelp: 'Era egna namn på bilgrupper hos leverantören, t.ex. Liten bil eller Mellan bil. Används vid bokningsförfrågan.',
    supplierCarClassPlaceholder: 't.ex. Liten bil',
    supplierCarClassAdd: 'Lägg till',
    supplierCarClassRemove: 'Ta bort {{name}}',
    rentalManagementTitle: 'Biluthyrare',
    rentalManagementDescription: 'Koppla kund-organisationer till en biluthyrare för poolbilar och request-uthyrning. Åtkomstnivån styr om kunden bokar själv eller endast ser statistik.',
    addRentalLink: 'Lägg till koppling',
    editRentalLink: 'Redigera koppling',
    noRentalLinks: 'Inga biluthyrarkopplingar ännu. Lägg till en för att komma igång.',
    rentalCompany: 'Biluthyrare',
    rentalCustomer: 'Kund-organisation',
    rentalSelectCompany: 'Välj biluthyrare',
    rentalSelectCustomer: 'Välj kund-organisation',
    rentalAccessLevel: 'Åtkomstnivå',
    rentalAccessFullBooking: 'Full bokning (boka/skapa request)',
    rentalAccessStatsOnly: 'Endast statistik',
    rentalAccessFullBookingHelp: 'Kundens användare bokar befintliga poolbilar eller skapar förfrågningar. Biluthyraren tilldelar bil. Kunden kan inte hantera fordonen.',
    rentalAccessStatsOnlyHelp: 'Kundens anställda kan boka/skapa request, men kunden hanterar inte fordonen. Kund-admin ser bokningsstatistik och miljörapport.',
    rentalLinkSelectBoth: 'Välj både biluthyrare och kund-organisation.',
    rentalLinkSaveError: 'Kunde inte spara kopplingen.',
    rentalLinkDeleteConfirm: 'Vill du ta bort denna biluthyrarkoppling?',
    requestedCarClass: 'Önskad bilgrupp',
    requestedCarClassPlaceholder: 'Välj bilgrupp',
    requestedCarClassFreePlaceholder: 'Ange önskad bilgrupp',
    requestedCarClassNoOptionsHint: 'Inga bilgrupper konfigurerade hos era leverantörer – ange manuellt eller lägg till under Leverantörer.',
    requestedCarClassRequired: 'Välj eller ange önskad bilgrupp',
    supplierCrmCustomer: 'Kund (Biluthyrare i CRM)',
    supplierCrmNone: 'Ingen koppling – fristående leverantör',
    supplierCrmCustomerHelp: 'Valfri koppling till biluthyrare i CRM. Samma CRM-post kan användas av flera kunder – ni konfigurerar egna bilgrupper och kontaktuppgifter per kund.',
    supplierNameFromCrm: 'Namnet hämtas från CRM-kunden.',
    destinations: 'Destinationer',
    destinationsTitle: 'Destinationer',
    destinationsDescription: 'Fördefinierade resemål vid bokning',
    addDestination: 'Lägg till destination',
    editDestination: 'Redigera destination',
    noDestinations: 'Inga destinationer. Lägg till en för att komma igång.',
    vehiclesAtLocation: 'Fordon på plats',
    addVehicle: 'Lägg till fordon',
    calendarTitle: 'Bokningskalender',
    calendarDescription: 'Gantt-schema över beläggning per pool – se lediga tider och skapa bokningar',
    weekTitle: 'Vecka {{week}} ({{start}} - {{end}})',
    calendarViewAll: 'Alla dagar',
    calendarViewWorkdays: 'Endast vardagar',
    viewWeek: 'Vecka',
    viewDay: 'Dag',
    today: 'Idag',
    prevDay: 'Föregående dag',
    nextDay: 'Nästa dag',
    openDayView: 'Öppna dagvy',
    vehicleColumn: 'Fordon',
    redDay: 'Röd dag (arbetsbefriad helgdag)',
    status: 'Status',
    statusBooked: 'Bokad',
    statusCheckedOut: 'Utcheckad',
    statusReturned: 'Återlämnad',
    statusCancelled: 'Avbokad',
    statusCancelledBySystem: 'Avbokad av systemet',
    statusNoShow: 'No-show (ej uthämtad)',
    statusOverdue: 'Överskriden tid',
    checkedOutAt: 'Utcheckad',
    returnedAt: 'Återlämnad kl',
    checkoutButton: 'Checka ut',
    checkoutDialogTitle: 'Checka ut bokning',
    checkoutTimeLabel: 'Tidpunkt för utcheckning',
    ksMarkPickedUp: 'Markera som uthämtad',
    ksMarkPickedUpTitle: 'Markera som uthämtad',
    ksMarkPickedUpConfirm: 'Vill du markera bokningen som uthämtad?',
    ksReturnTitle: 'Återlämna bokning',
    ksReturnConfirm: 'Vill du återlämna bokningen?',
    returnButton: 'Återlämna',
    changeResource: 'Byta resurs',
    changeResourceTitle: 'Byt resurs',
    changeResourceCurrent: 'Nuvarande resurs',
    changeResourceNew: 'Ny resurs',
    changeResourceSearchPlaceholder: 'Sök fordon (t.ex. 197, GNB563, Manuell)…',
    changeResourceSelected: 'Vald',
    changeResourceNoneAvailable: 'Inga lediga fordon i poolen för perioden',
    changeResourceSave: 'Byt resurs',
    changeResourceSuccess: 'Resursen har bytts.',
    changeResourceError: 'Kunde inte byta resurs.',
    vehicleMapShow: 'Visa på karta',
    vehicleMapTitle: 'Fordonets position',
    vehicleMapSourceLive: 'Aktuell position',
    vehicleMapSourceStored: 'Senast sparade position',
    vehicleMapUpdatedAt: 'Uppdaterad',
    vehicleMapNoPosition: 'Ingen position finns sparad för fordonet.',
    vehicleMapLoadError: 'Kunde inte hämta fordonets position.',
    legendVehicleBlock: 'Fordon block (admin)',
    legendImportedBooking: 'Importerad bokning (JSON)',
    legendQuickBooking: 'Snabbokning',
    vehicleBlockShort: 'Block',
    noVehicleAssigned: 'Ingen bil tilldelad',
    ownCar: {
      formTitle: 'Skapa resa med egen bil',
      listTitle: 'Resor med egen bil',
      listIntro: 'Dina egna resor och de du har granskningsrätt för.',
      listEmpty: 'Inga resor att visa.',
      listLoadError: 'Kunde inte hämta resor.',
      loadError: 'Kunde inte ladda formuläret.',
      toList: 'Visa alla resor',
      newTrip: 'Ny resa',
      bookedFor: 'Bokad för',
      phone: 'Telefonnummer',
      car: 'Bil',
      selectCar: 'Välj din bil',
      newCar: 'Ny bil…',
      lookupCar: 'Hämta från car.info',
      regRequired: 'Ange registreringsnummer först',
      carInfoSuccess: 'Fordonsuppgifter hämtade från car.info',
      carInfoError: 'Kunde inte hämta fordonet från car.info',
      model: 'Modell',
      year: 'Årsmodell',
      color: 'Färg',
      fuel: 'Bränsletyp',
      co2PerKm: 'CO₂',
      reimbursement: 'Ersättning per kilometer',
      odometerStart: 'Mätarställning – resans start',
      odometerEnd: 'Mätarställning – resans slut',
      directKm: 'Alternativt ange resans längd direkt (i hela km)',
      totalReimbursement: 'Total ersättning',
      from: 'Bokning fr.o.m.',
      to: 'Bokning t.o.m.',
      costCenter: 'Kostnadsställe',
      selectCostCenter: 'Välj kostnadsställe',
      project: 'Projektnummer',
      emission: 'Utsläpp',
      km: 'Km',
      total: 'Totalt',
      co2: 'CO₂',
      travelFrom: 'Resa – Från',
      travelTo: 'Resa – Till',
      purpose: 'Syfte',
      ownCarReason: 'Orsak till val av egen bil',
      save: 'Spara',
      saveAndSubmit: 'Spara och skicka in',
      saveSuccess: 'Resan sparades och kan fortfarande redigeras.',
      submitSuccess: 'Resan skickades in för granskning.',
      saveError: 'Kunde inte spara resan.',
      approve: 'Godkänn',
      reject: 'Avvisa',
      approveSuccess: 'Resan är godkänd.',
      rejectSuccess: 'Resan avvisades.',
      reviewError: 'Kunde inte granska resan.',
      sendPayroll: 'Skicka till lönekontor',
      payrollSuccess: 'Resan är markerad som skickad till lönekontor.',
      payrollError: 'Kunde inte skicka till lönekontor.',
      export: 'Exportera CSV',
      exportError: 'Kunde inte exportera.',
      searchPlaceholder: 'Sök namn, regnr, från/till…',
      allStatuses: 'Alla statusar',
      statusLabel: 'Status',
      status: {
        draft: 'Utkast',
        submitted: 'Inskickad',
        approved: 'Godkänd',
        rejected: 'Avvisad',
        sent_to_payroll: 'Skickad till lön',
      },
    },
    collisionTitle: 'Kollisionsbokningar',
    collisionIntro:
      'Bokningar som saknar tilldelat fordon (t.ex. efter att en bil blockerats för bokning). Tidigare pool och bil visas så att ni kan tilldela ny bil eller avboka.',
    collisionBack: 'Tillbaka till bokning',
    collisionEmpty: 'Inga kollisionsbokningar just nu.',
    collisionLoadError: 'Kunde inte ladda kollisionsbokningar.',
    collisionDetailLoadError: 'Kunde inte öppna bokningen.',
    collisionColPool: 'Pool',
    collisionColCustomer: 'Bokad för',
    collisionColTime: 'Tid',
    collisionColPriorVehicle: 'Tidigare bil',
    collisionColAvailableResource: 'Ledig resurs',
    collisionAssignVehicle: 'Tilldela',
    collisionAssignSuccess: 'Fordon tilldelat.',
    collisionAssignError: 'Kunde inte tilldela fordon.',
    collisionCancelBySystem: 'Avboka',
    collisionCancelConfirm:
      'Ingen ledig resurs finns. Vill du avboka bokningen? E-post skickas till bokare och medresenärer.',
    collisionCancelSuccess: 'Bokningen avbokades av systemet.',
    collisionCancelError: 'Kunde inte avboka bokningen.',
    collisionColStatus: 'Status',
    collisionColAction: 'Åtgärd',
    collisionOpenBooking: 'Öppna bokning',
    assignVehicleTitle: 'Tilldela bil i poolen',
    assignVehicleHint:
      'Välj ett ledigt fordon för bokningens tid. Du kan också ta bort bokningen eller skicka kunden till avbokningslänken nedan.',
    assignVehicleSelectPlaceholder: 'Välj fordon…',
    assignVehicleButton: 'Tilldela',
    assignVehicleSuccess: 'Bil tilldelad.',
    assignVehicleError: 'Kunde inte tilldela bil.',
    assignVehicleNoneAvailable:
      'Inga lediga fordon i poolen för denna tid (kontrollera blockeringar och andra bokningar).',
    staffCancelLinkHint: 'Länk för kund att avboka själv (ny flik):',
    staffCancelLinkOpen: 'Avbokningssida',
    newBooking: 'Ny bokning',
    newBookingSubtitle: 'Fyll i fordonsbokning med syfte, destination och återkommande alternativ.',
    organization: 'Organisation',
    pool: 'Pool',
    date: 'Datum',
    vehicle: 'Fordon',
    selectPoolAndDate: 'Välj pool och datum för att se beläggningen.',
    noVehiclesInPool: 'Inga fordon i denna pool. Lägg till fordon under Bokning → Utlämningsplatser.',
    start: 'Start',
    end: 'Slut',
    customerName: 'Bokad av / för',
    bookerRsid: 'RSID',
    bookerPhone: 'Telefonnummer',
    customerNamePlaceholder: 'Namn eller enhet',
    bookedFor: 'Bokad för',
    searchUserPlaceholder: 'Sök namn, e-post eller RSID...',
    createdBy: 'Bokad av',
    createdChannel: 'Bokad från',
    createdChannelApp: 'App',
    createdChannelWeb: 'Dator',
    bookingTypeSingle: 'Bokning',
    bookingTypeGroup: 'Gruppbokning',
    bookingTypePool: 'Fordonspool',
    tripPurpose: 'Syfte med resan',
    tripPurposePlaceholder: 't.ex. Kundbesök',
    notes: 'Anteckningar',
    estimatedKm: 'Uppskattad sträcka (km)',
    passengerCount: 'Antal passagerare',
    destination: 'Destination',
    destinationPlaceholder: 'Välj eller ange plats',
    destinationTypeFree: 'Ange fritext om ingen träff',
    driverLicenseConfirmed: 'Jag har giltigt körkort',
    bookingPolicyCheckbox: 'Jag har läst och godkänner bokningspolicyn',
    bookingPolicyCheckboxHelp: 'Markera rutan för att öppna policyn. Bekräfta längst ner i fönstret när du läst klart.',
    isServiceBooking: 'Service / Jour',
    isServiceBookingHelp: 'Kryssa i om bokningen gäller service på fordonet. Sådana bokningar påverkas inte av no-show-regeln som annars frigör platsen efter angiven tid.',
    bookingPolicyTitle: 'Bokningspolicy',
    bookingPolicyReadConfirm: 'Jag har läst policyn',
    approvedBy: 'Godkänd av (attestation)',
    approvedByPlaceholder: '— Valfritt —',
    noAvailableVehicles: 'Inga lediga fordon för vald period',
    recurrence: 'Återkommande',
    recurrenceDaily: 'Dag',
    recurrenceWeekly: 'Vecka',
    recurrenceMonthly: 'Månad',
    recurrenceCount: 'Antal gånger',
    loadingAvailableVehicles: 'Laddar lediga fordon...',
    filterByEquipment: 'Filtrera på utrustning',
    filterAutomaticTransmission: 'Endast automatväxel',
    filterAutomaticTransmissionHelp: 'När markerad visas bara fordon som har automatväxel registrerad.',
    filterByResourceType: 'Resurstyp',
    resourceTypeFilterAll: 'Alla typer',
    resourceTypeFilterCar: 'Bil',
    resource: 'Resurs',
    loadingAvailableResources: 'Laddar tillgängliga resurser…',
    noAvailableResources: 'Inga tillgängliga resurser för vald tid',
    noAutomaticTransmissionVehicles: 'Inga lediga fordon med automatväxel för vald period. Avmarkera filtret eller välj annan tid.',
    noVehicleCreateRental: 'Ingen ledig bil – skapa hyra från leverantör',
    createRentalAndBooking: 'Skapa hyra och bokning',
    externalDisplayName: 'Visningsnamn (t.ex. hyrbil)',
    externalDisplayNamePlaceholder: 't.ex. Hyrbil A',
    selectSupplier: 'Välj leverantör',
    costCenter: 'Kostnadställe',
    project: 'Projekt',
    costCenterPlaceholder: '— Välj kostnadställe —',
    costCentersTitle: 'Kostnadställen',
    costCentersDescription: 'Kostnadställen per organisation – väljs vid bokning. Kan avaktiveras men aldrig tas bort.',
    addCostCenter: 'Lägg till kostnadställe',
    editCostCenter: 'Redigera kostnadställe',
    noCostCenters: 'Inga kostnadställen. Lägg till ett för att komma igång.',
    costCenterCode: 'Kod (max 15 tecken)',
    costCenterDescription: 'Beskrivning (max 50 tecken)',
    costCenterValidFrom: 'Giltig från',
    costCenterActive: 'Aktiv',
    costCenterInactive: 'Avaktiverad',
    saveError: 'Kunde inte spara bokning',
    resourceTypesTitle: 'Resurstyper per kund',
    resourceTypesDescription: 'Resurstyper (Bil, Cykel, Konferensrum, m.fl.) definieras systembrett. Här markerar du vilka resurstyper varje kund (organisation) får använda vid bokning.',
    resourceTypesOrganization: 'Organisation (kund)',
    resourceTypesSelectOrg: 'Välj organisation',
    resourceTypesSelectOrgFirst: 'Välj en organisation för att ange vilka resurstyper som får användas.',
    resourceTypesMyOrg: 'Min organisation',
    resourceTypesForOrg: 'Aktiva resurstyper för',
    resourceTypeLabel: 'Resurstyp',
    resourceTypeEnabled: 'Aktiverad för denna kund',
    resourceTypeDisabled: 'Inaktiverad för denna kund',
    resourceTypesSaved: 'Resurstyper sparade',
    resourceTypesSaveError: 'Kunde inte spara resurstyper',
    bookingCreated: 'Bokning skapad',
    sendCalendarInvitePrompt: 'Vill du skicka kalenderinbjudan till kunden? E-post med kalenderbilaga skickas till kundens adress.',
    noEmailForCalendarInvite: 'Kunden har ingen e-postadress kopplad – kalenderinbjudan kan inte skickas.',
    sendCalendarInvite: 'Skicka kalenderinbjudan',
    done: 'Klart',
    calendarInviteSent: 'Kalenderinbjudan skickad till kundens e-post.',
    calendarInviteError: 'Kunde inte skicka kalenderinbjudan.',
    bookingDetailsTitle: 'Bokningsdetaljer',
    notesShow: 'Visa anteckningar',
    notesHide: 'Dölj anteckningar',
    cancelBookingTitle: 'Avboka bokning',
    cancelBookingConfirm: 'Vill du avboka denna bokning? Den raderas inte, utan markeras som inaktiv.',
    cancelBookingSuccess: 'Bokningen är avbokad (inaktiv).',
    cancelBookingInvalid: 'Ogiltig eller redan använd avbokningslänk.',
    cancelBookingError: 'Kunde inte avboka.',
    cancelBookingPast: 'Bokningen har redan passerat och kan inte avbokas.',
    cancelBookingAlready: 'Bokningen är redan avbokad.',
    cancelBookingButton: 'Avboka',
    importLockedHint: 'Importerad bokning är låst på fordonet tills den kopplats till en person. Då hanteras den som en vanlig bokning.',
    cancelBookingHelp: 'Avboka markerar bokningen som inaktiv (raderas inte) och frigör tiden. "Stäng" stänger fönstret.',
    keyCabinetAccessActive: 'Nyckelskåp-åtkomst aktiv under bokningstiden.',
    noShowReleasePoolOverride: 'No-show frigör (pool)',
    noShowReleasePoolOverridePlaceholder: 'Tomt = ärv från org, 0 = inaktiverat, t.ex. 30 = min',
    noShowReleasePoolOverrideHelp: 'Överskrida organisationens regel för denna pool. Tomt = använd org (top nod). 0 = regeln gäller inte här. Annat = antal minuter efter start.',
    poolBookingRulesHeading: 'Bokningsregler (överstyr org)',
    poolOverrideInheritHelp: 'Tomt = ärv från organisation (top nod). 0 = ingen begränsning.',
    poolClosuresHeading: 'Stängningsperioder',
    poolClosuresEmpty: 'Inga stängningsperioder.',
    closureFrom: 'Stängd från',
    closureToOptional: 'Stängd till (valfritt)',
    closureOpenEnded: 'Tills vidare',
    closureReasonPlaceholder: 'Anledning (valfritt)',
    closureAdd: 'Lägg till stängning',
    closureDeleteConfirm: 'Ta bort stängningsperioden?',
    closureStripped: '{{count}} framtida bokning(ar) flyttades till kollisionsbokningar.',
    fallbackSuppliersHeading: 'Leverantörer vid bilbrist',
    allowExternalBookingWhenNoCars: 'Tillåt bokning via leverantör när inga bilar finns',
    fallbackSuppliersHelp: 'Alla valda leverantörer meddelas när en bokning skapas utan tillgänglig bil.',
    noSuppliersInOrg: 'Inga leverantörer i organisationen.',
    supplierFallbackPrompt: 'Ingen bil tillgänglig – skicka bokningen till konfigurerade leverantörer.',
    createSupplierFallbackBooking: 'Skapa bokning via leverantörer',
    managedRequestPrompt: 'Ingen bil tillgänglig – skicka en förfrågan till biluthyraren som tilldelar bil.',
    createManagedRequest: 'Skapa förfrågan till biluthyrare',
    requestsRow: 'Förfrågningar',
    requestShort: 'Förfrågan',
    pastBookingNotDeletable: 'Passerade bokningar kan inte avbokas.',
    bookingHistoryLimitHint: 'Du ser bokningar från de senaste 3 månaderna.',
    vehicleReplacementTitle: 'Fordonsbyte',
    replaceWithVehicle: 'Ersätt med fordon',
    replaceVehicle: 'Byt fordon',
    takeOutOfService: 'Tag ur drift',
    returnToService: 'Åter i drift',
    removeFromPool: 'Ta bort från pool',
    outOfService: 'Ur drift',
    futureBookingsCount: '{{count}} framtida/pågående bokning(ar) på fordonet.',
    vehicleReplaceConfirm: 'Byt fordon och flytta {{count}} bokning(ar)?',
    vehicleReplaceDone: '{{count}} bokning(ar) flyttades till nytt fordon.',
    vehicleOutOfServiceConfirm: 'Markera ur drift och omtilldela {{count}} bokning(ar)?',
    vehicleOutOfServiceDone: '{{reassigned}} omtilldelade, {{collisions}} i kollisionsbokningar.',
    vehicleReturnToServiceDone: 'Fordonet är tillbaka i drift.',
    vehicleRemoveFromPoolConfirm: 'Ta bort fordonet och omtilldela {{count}} bokning(ar)?',
    vehicleRemoveFromPoolDone: '{{reassigned}} omtilldelade, {{collisions}} i kollisionsbokningar.',
    requestsTitle: 'Bokningsförfrågningar',
    requestsDescription: 'Bokningar som inte kunde tilldelas bil vid bokningstillfället – tilldela bil eller hantera via leverantör.',
    requestsBack: 'Tillbaka till bokning',
    requestsEmpty: 'Inga bokningsförfrågningar just nu.',
    requestsLoadError: 'Kunde inte ladda bokningsförfrågningar.',
    requestsDetailLoadError: 'Kunde inte öppna bokningen.',
    requestsColPool: 'Pool',
    requestsColCustomer: 'Bokad för',
    requestsColOrganization: 'Kund/grupp',
    bookingOrganization: 'Kund/grupp',
    requestsColTime: 'Tid',
    requestsColCarClass: 'Bilgrupp',
    requestsColSuppliers: 'Leverantörer',
    requestsColStatus: 'Status',
    requestsColAction: 'Åtgärd',
    requestsOpenBooking: 'Öppna bokning',
    fleetAssignTitle: 'Tilldela bil från flottan',
    fleetAssignHint: 'Biluthyraren kan tilldela en egen bil till denna utlämningsplats. Kunden kan bara lägga till egna bilar.',
    fleetAssignEmpty: 'Inga lediga bilar i flottan just nu.',
    fleetAssignPlaceholder: 'Välj bil från flottan',
    fleetAssignButton: 'Tilldela',
    fleetAssignSuccess: 'Bilen är tilldelad.',
    fleetAssignError: 'Kunde inte tilldela bilen.',
    fleetAssignFromRequestHint: 'Eller tilldela en ledig bil från flottan för just denna bokning.',
    basisTitle: 'Bokningsunderlag',
    basisBack: 'Tillbaka till bokning',
    basisBackToList: 'Tillbaka till listan',
    basisDescriptionOwn: 'Sök bland dina återlämnade bokningar och öppna underlaget.',
    basisDescriptionAll: 'Sök bland återlämnade bokningar i organisationen och öppna underlaget.',
    basisSearch: 'Sök',
    basisSearchPlaceholder: 'Namn, regnr, utlämningsställe…',
    basisEmpty: 'Inga återlämnade bokningar hittades.',
    basisLoadError: 'Kunde inte ladda bokningsunderlag.',
    basisDetailLoadError: 'Kunde inte öppna underlaget.',
    basisOpen: 'Öppna underlag',
    basisColVehicle: 'Fordon',
    basisColPeriod: 'Period',
    basisDownloadPdf: 'Skriv ut / PDF',
    basisPdfError: 'Kunde inte skapa PDF.',
    basisBookedFor: 'Bokad för',
    basisLoanHint: 'Bilen var tillfälligt tilldelad från biluthyrarens flotta.',
    basisKpiDistance: 'Körsträcka',
    basisKpiOdometer: 'Mätarställning',
    basisKpiWarnings: 'Varningar',
    basisKpiCo2: 'CO₂',
    basisSectionTrips: 'Resor',
    basisSectionGeofences: 'Geofences',
    basisSectionWarnings: 'Varningar',
    basisSectionEnvironment: 'Miljö',
    basisNoTrips: 'Inga resor under perioden.',
    basisNoWarnings: 'Inga varningar.',
    basisGeofenceCost: 'Kostnad',
    basisPassages: 'passager',
    basisFuel: 'Bränsle',
    requestsSearchPlaceholder: 'Sök namn, syfte...',
    requestsCount: 'bokningar',
    requestsNoResults: 'Inga bokningsförfrågningar hittades',
    requestsBookedBy: 'Bokad av',
    resourceManagerTitle: 'Resurshanteraren',
    resourceManagerDescription: 'Dagsöversikt per fordon – se beläggning och bokningsstatus för alla bilar i poolen',
    resourceManagerStatus: 'Status',
    resourceManagerToday: 'Idag',
    resourceManagerNowLine: 'Aktuell tid',
    resourceManagerSearchOrg: 'Sök organisation...',
    resourceManagerShowAllPools: 'Visa alla pooler',
    oldBookingTitle: 'Old Booking',
    oldBookingDescription: 'Dagsöversikt per fordon – historisk bokningsdata (temporär modul)',
    oldBookingTemporaryNotice: 'Temporär modul med historisk export. Tas bort när migreringen är klar.',
    oldBookingDateRange: 'Data: {{from}} – {{to}}',
    bookingSearchTitle: 'Kundtjänst',
    bookingSearchDescription: 'Administrera och supporta bokningar – sök, visa och ändra (referens, pool, datum, förare, fordon, resurstyp).',
    bookingSearchPrompt: 'Välj filter och klicka på Sök för att visa träffar.',
    bookingSearchReference: 'Referens (boknings-id)',
    bookingSearchReferencePlaceholder: 'UUID eller del av id',
    bookingSearchAllPools: 'Alla pooler',
    bookingSearchDateFrom: 'Bokning fr.o.m.',
    bookingSearchDateTo: 'Bokning t.o.m.',
    timelineSpan: 'Tidsfönster',
    timelineSpan1Day: '1 dag',
    timelineSpan2Days: '2 dagar',
    timelineSpan14Days: '14 dagar',
    timelineSpan40Days: '40 dagar',
    bookingSearchBookedFor: 'Bokad för (förare / visningsnamn)',
    bookingSearchBookedForPlaceholder: 'Namn eller e-post',
    bookingSearchBookedForHelp: 'Söker i kundnamn och i användaren som skapade bokningen.',
    bookingSearchVehicle: 'Resurs (fordon)',
    bookingSearchVehiclePlaceholder: 'Reg.nr eller visningsnamn',
    bookingSearchVehicleHelp: 'Söker i registreringsnummer, visningsnamn och leverantörsreferens.',
    bookingSearchResourceTypeAll: 'Alla resurstyper',
    bookingSearchResourceTypeHint: 'Resurstyp styrs per fordon i poolen (utlämningsplats). Tom typ = räknas som bil vid filter «Bil». Cykel m.m. kräver att resurstyp satts på poolfordonet.',
    bookingSearchStatusAll: 'Alla statusar',
    bookingSearchRun: 'Sök',
    bookingSearchResults: 'Sökresultat',
    bookingSearchNoHits: 'Inga bokningar matchade filtren.',
    bookingSearchLoadError: 'Kunde inte uppdatera sökresultatet. Föregående lista visas.',
    bookingSearchColReference: 'Referens',
    bookingSearchColPickupLocation: 'Utlämningsställe',
    bookingSearchColBookingFrom: 'Bokning fr.o.m.',
    bookingSearchColBookingTo: 'Bokning t.o.m.',
    bookingSearchColResource: 'Resurs',
    bookingSearchColTripCount: 'Antal resor',
    bookingSearchColBookedBy: 'Bokad av',
    viewList: 'Lista',
    viewTimeline: 'Tidslinje',
    timelineDragHint: 'Dra en bokning för att flytta den, dra i högerkanten för att ändra sluttid, eller dra i tom yta för att skapa en ny bokning.',
    timelineResizeHint: 'Dra för att ändra sluttid',
    timelineMoveFailed: 'Kunde inte flytta bokningen.',
    timelineMoveConfirmTitle: 'Bekräfta flytt av bokning',
    timelineMoveConfirmQuestion: 'Vill du flytta bokningen? Bekräfta för att spara ändringen.',
    timelineMoveFrom: 'Från',
    timelineMoveTo: 'Till',
    timelineMoveNewTime: 'Ny tid',
    timelineMoveNewVehicle: 'Nytt fordon',
    timelineMoveConfirmButton: 'Bekräfta flytt',
    timelineParticipants: 'Deltagare',
    userConflictWarningTitle: 'Användaren har redan en bokning under denna tid:',
    editBooking: 'Ändra bokning',
    editButton: 'Redigera',
    editBookingTitle: 'Ändra bokning',
    editBookingSelfSubtitle: 'Ändra din bokning – tid, syfte och deltagare. Med behörighet kan du byta utlämningsplats och ledig bil innan start.',
    editBookingStaffSubtitle: 'Ändra bokningen – tid, utlämningsplats, fordon, syfte och deltagare.',
    extendConflictTitle: 'Tiden krockar med nästa bokning på samma bil.',
    extendConflictMax: 'Du kan förlänga till {{time}}.',
    extendConflictUseMax: 'Använd den tiden',
    extendConflictContactCs: 'Behöver du längre tid måste du kontakta kundtjänst.',
    deleteBooking: 'Radera bokning',
    deleteBookingConfirm: 'Vill du radera bokningen? Den avaktiveras men tas inte bort.',
    deleteBookingSuccess: 'Bokningen avaktiverades',
    deleteBookingError: 'Kunde inte radera bokningen',
    startTooFarInPast: 'Starttiden får inte vara mer än 5 minuter före nu.',
    assignedVehicleLocked: 'Tilldelat fordon (kan inte bytas vid förlängning)',
    bookedForRequired: 'Välj vem som ska ha bilen',
    editBookingLoadError: 'Kunde inte öppna bokningen för redigering',
    startLockedHint: 'Bokningen har redan startat – starttiden kan inte ändras.',
    editBookingStartAt: 'Bokning fr.o.m.',
    editBookingEndAt: 'Bokning t.o.m.',
    editBookingCustomerName: 'Kundnamn',
    editBookingNotes: 'Kommentar',
    editBookingSaveSuccess: 'Bokningen uppdaterades',
    editBookingSaveError: 'Kunde inte uppdatera bokningen',
    editBookingInvalidRange: 'Sluttiden måste vara efter starttiden',
    editBookingPersonSearch: 'Sök person (namn, e-post eller RSID)…',
    editBookingNoMatches: 'Inga träffar',
    editBookingFreeTextHint: 'Välj en person från listan eller skriv ett fritt namn.',
    editBookingMembers: 'Fler deltagare',
    editBookingAddMember: 'Lägg till deltagare (namn, e-post eller RSID)…',
    editBookingMembersHint: 'Lägg till högst 4 extra personer. Ikryssad "Nyckel" tillåter uthämtning/återlämning. Samma person kan inte läggas till mer än en gång.',
    editBookingGroupBadge: 'Gruppbokning',
    newBookingButton: 'Skapa ny bokning',
    newBookingSelectPoolFirst: 'Välj en pool först för att skapa en ny bokning.',
    guideButton: 'Guide',
    guideMenuTitle: 'Starta guide',
    guideSearch: 'Sök & filter',
    guideList: 'Listvy',
    guideTimeline: 'Tidslinje',
    blockButton: 'Blockera',
    blockButtonHint: 'Blockera fordonet och skapa skadeanmälan',
    blockNoVehicle: 'Bokningen har inget tilldelat fordon att blockera',
    blockTitle: 'Blockera fordon',
    blockVehicleLabel: 'Fordon',
    blockDamageType: 'Skadetyp',
    blockDamageType_collision: 'Kollision',
    blockDamageType_theft: 'Stöld',
    blockDamageType_fire: 'Brand',
    blockDamageType_vandalism: 'Vandalisering',
    blockDamageType_other: 'Övrigt',
    blockDamageTypeRequired: 'Välj en skadetyp',
    blockDescription: 'Beskrivning',
    blockLocation: 'Plats (valfritt)',
    blockDuration: 'Blockera resursen i',
    blockHours_12: '12 timmar',
    blockHours_24: '24 timmar',
    blockHours_120: '120 timmar',
    blockUntilPreview: 'Blockeringen gäller till',
    blockConfirm: 'Blockera',
    blockSaveSuccess: 'Fordonet blockerades. Ombokade till ledig bil: {{reassigned}}. Väntar på hantering: {{collisions}}',
    blockSaveSuccessReassigned: 'Fordonet blockerades. {{reassigned}} bokning(ar) flyttades till ledig bil. Andra bokningars bilar rördes inte.',
    blockSaveSuccessWaiting: 'Fordonet blockerades. Ingen ledig bil — {{collisions}} bokning(ar) väntar på hantering.',
    blockSaveSuccessNone: 'Fordonet blockerades.',
    blockSaveSuccessEnded: 'Bokningen avslutades eftersom fordonet inte är brukbart. Sluttiden sattes till nu.',
    blockSaveError: 'Kunde inte blockera fordonet',
    blockedListButton: 'Blockerade bilar',
    blockedListButtonHint: 'Visa kundens blockerade fordon',
    blockedListTitle: 'Blockerade fordon',
    blockedListEmpty: 'Inga aktiva blockeringar',
    blockedListLoadError: 'Kunde inte hämta blockerade fordon',
    blockedListVehicle: 'Fordon',
    blockedListStart: 'Start',
    blockedListEnd: 'Stopp',
    blockedListDamage: 'Skadeanmälan',
    blockedListDamageLink: 'Skadeanmälan #{{id}}',
    blockedListDamageInline: 'Skadeanmälan #{{id}}',
    blockedListNoDamage: 'Ingen skadeanmälan',
    blockedListRelease: 'Släpp',
    blockedListReleaseConfirm: 'Släppa blockeringen så att fordonet kan bokas igen?',
    blockedListReleased: 'Blockeringen släpptes',
    blockedListReleaseError: 'Kunde inte släppa blockeringen',
    blockedListUpdated: 'Blockeringen uppdaterades',
    blockedListUpdateError: 'Kunde inte uppdatera blockeringen',
    fuelPinTooltipTitle: 'Tankkort (PIN)',
    fuelPinLoading: 'Hämtar tankkort…',
    fuelPinNone: 'Inga tankkort',
    fuelPinError: 'Kunde inte hämta tankkort',
    fuelPinNoPin: '(ingen PIN)',
    fuelCardsTitle: 'Tankkort',
    optimizationTitle: 'Bokningsoptimering',
    optimizationDescription: 'Se dagens beläggning per pool och optimera fordonsutnyttjandet med AI.',
    optimizationDate: 'Datum',
    optimizationAllPools: 'Alla pooler',
    optimizationCurrentTitle: 'Nuläge',
    optimizationProposedTitle: 'Så här blir det',
    optimizationKpiBookings: 'Bokningar',
    optimizationKpiUsedVehicles: 'Bilar som används',
    optimizationKpiTotalVehicles: 'Totalt antal bilar',
    optimizationKpiUtilization: 'Utnyttjandegrad',
    optimizationRun: 'Optimera',
    optimizationRunning: 'Optimerar…',
    optimizationResultTitle: 'Resultat (före/efter)',
    optimizationBefore: 'Före',
    optimizationAfter: 'Efter',
    optimizationFreedVehicles: 'Frigjorda bilar',
    optimizationSuggestions: 'Förslag',
    optimizationNoSuggestions: 'Inga förbättringsförslag för den valda dagen.',
    optimizationSuggestionMove: '{{booking}}: {{from}} → {{to}}',
    optimizationNoData: 'Inga bokningar för den valda dagen.',
    optimizationAiUnavailable: 'AI-tjänsten är inte tillgänglig just nu. Nuläget visas ändå – försök optimera igen senare.',
    optimizationError: 'Kunde inte köra optimeringen',
    optimizationLoadError: 'Kunde inte hämta beläggning',
    optimizationApply: 'Genomför optimering',
    optimizationApplying: 'Genomför…',
    optimizationApplyConfirm: 'Detta flyttar bokningarna enligt förslaget för att frigöra fordon. Vill du fortsätta?',
    optimizationApplied: 'Optimering genomförd: {{moves}} bokning(ar) flyttade, {{freed}} fordon frigjort.',
    optimizationApplyError: 'Kunde inte genomföra optimeringen',
    optimizationApplyNeedsPool: 'Välj en pool ovan för att kunna genomföra optimeringen.',
    fitTitle: 'Få plats för en bokning',
    fitDescription: 'Ange önskad tid och krav. Systemet kontrollerar om bokningen ryms genom att flytta befintliga bokningar mellan poolens fordon (utan att ändra deras tider).',
    fitStart: 'Önskad start',
    fitEnd: 'Önskat slut',
    fitCustomerName: 'Namn/referens',
    fitCustomerNamePlaceholder: 'Valfritt namn eller referens',
    fitBookedFor: 'Bokas för (person)',
    fitSelectPerson: 'Välj person',
    fitSelectPersonRequired: 'Välj en person som bokningen ska gälla.',
    fitResourceType: 'Resurstyp',
    fitAnyResourceType: 'Valfri resurstyp',
    fitAutomaticOnly: 'Endast automatlåda',
    fitEquipment: 'Krav på utrustning',
    fitCheck: 'Kontrollera inpassning',
    fitChecking: 'Kontrollerar…',
    fitCheckError: 'Kunde inte kontrollera inpassning',
    fitFeasible: 'Bokningen får plats på {{vehicle}}.',
    fitInfeasible: 'Bokningen får inte plats även med omflyttning.',
    fitNoMoves: 'Inga befintliga bokningar behöver flyttas.',
    fitMovesTitle: 'Följande {{count}} bokning(ar) flyttas:',
    fitApply: 'Skapa bokning och flytta',
    fitApplying: 'Tillämpar…',
    fitApplyConfirm: 'Detta skapar den nya bokningen och flyttar befintliga bokningar till andra fordon. Vill du fortsätta?',
    fitApplyError: 'Kunde inte tillämpa inpassningen',
    groupMembers: 'Gruppmedlemmar',
    canCheckoutKey: 'Kan hämta nyckel',
    addMemberPlaceholder: 'Lägg till medlem (namn, e-post eller RSID)...',
    maxExtraMembersHint: 'Högst 4 extra personer kan läggas till.',
    memberAlreadyAdded: 'Personen är redan tillagd på bokningen.',
    groupMemberCount: '{{count}} personer',
    groupOrganizerRole: 'Ansvarig · kan alltid hämta nyckel',
    groupDriverLicenseConfirmed: 'Minst en gruppmedlem har giltigt körkort',
    groupFooterStatus: '{{members}} gruppmedlemmar · {{keys}} med nyckelbehörighet',
    newGroupBookingSubtitle: 'Fyll i fordonsbokning för flera personer med gemensam resa.',
    settingsTitle: 'Bokningsinställningar',
    settingsDescription: 'Konfigurera bokningsformulär, projekt, destinationer, kostnadsställen, syften och bokningsvillkor per organisations toppnod.',
    settingsTopNode: 'Organisation (toppnod)',
    settingsSaved: 'Inställningar sparade',
    settingsSaveError: 'Kunde inte spara inställningar',
    tabFormFields: 'Bokningsformulär',
    tabQuickGuest: 'Snabb bokning',
    quickGuestSettingsHelp:
      'Standard är att gästkontot raderas 60 minuter efter att bokningen avslutats. Namn, telefon och e-post stannar på bokningen.',
    quickGuestReuseLabel: 'Behåll gästkonton för återanvändning',
    quickGuestReuseHint:
      'Om rutan är ikryssad raderas inte kontot. Samma e-post fyller i namn och telefon och återanvänder kontot vid nästa snabb bokning.',
    quickGuestReusedHint: 'Sparat gästkonto hittades — det återanvänds.',
    quickSavedReused: 'Snabb bokning skapad, sparat gästkonto återanvänt',
    tabProjectImport: 'Import projekt',
    tabDestinations: 'Destinationer',
    tabCostCenters: 'Kostnadsställen',
    tabCostSettings: 'Bokningskostnader',
    costSettings: {
      orgHelp: 'Generell intern debitering per resurstyp för kunden. Gäller alla utlämningsplatser om inget eget värde anges på platsen.',
      pickupHeading: 'Bokningskostnader (plats)',
      pickupHelp: 'Tomt fält = ärv generell inställning för resurstypen. Ange värde för att åsidosätta på denna plats.',
      noResourceTypes: 'Inga resurstyper är aktiverade för kunden. Aktivera systemtyper eller skapa kundtyper under Bokningsresurser.',
      inheritPlaceholder: 'Ärv',
      inheritedValue: 'Generellt',
      legacyCancellationNote: 'Avbokningsregel på organisationsnivå (administration) är separat; debitering per resurstyp styrs här.',
      baseCostPerBooking: 'Grundkostnad (kr/bokning)',
      hourlyCost: 'Total timkostnad (kr/timme)',
      kmCost: 'Kilometerkostnad (kr/km)',
      cancellationFee: 'Avbokningsavg. (kr/bokning)',
      cancellationHours: 'Avbokas inom (timmar)',
      maxDailyCost: 'Maxpris per dygn (kr)',
      monthlyCost30d: 'Månadskostnad per 30 dygn (kr)',
      billingTimeFrom: 'Timdebitering från klockan',
      billingTimeTo: 'Timdebitering till klockan',
      offHoursHourlyCost: 'Timdebitering övrig tid (kr/timme)',
    },
    tabTerms: 'Bokningsvillkor',
    tabTripPurposes: 'Syften',
    tripPurposesTitle: 'Syften',
    tripPurposesDescription: 'Hantera fördefinierade syften med resan per organisations toppnod.',
    newTripPurposePlaceholder: 'Nytt syfte med resan',
    noTripPurposes: 'Inga syften har lagts till ännu.',
    costCenterFreeTextPlaceholder: 'Eller skriv eget kostnadsställe',
    formSettingsHelp: 'Inställningarna gäller alla användare under vald organisations toppnod.',
    formSettingsField: 'Fält',
    formSettingsVisible: 'Synlig',
    formSettingsRequired: 'Obligatorisk',
    formSettingsListOnly: 'Endast lista',
    formSettingsListOnlyForced: 'Detta fält läser alltid endast från lista.',
    formSettingsLocked: 'låst',
    projectImportDescription: 'Ladda ner mallen, fyll i projekt och ladda upp filen. Befintliga projnr uppdateras.',
    downloadProjectTemplate: 'Ladda ner projektmall',
    importProjects: 'Importera projekt',
    importProjectsSuccess: 'Import klar: {{created}} nya, {{updated}} uppdaterade',
    importProjectsError: 'Import misslyckades',
    importProjectsResult: 'Skapade {{created}}, uppdaterade {{updated}}',
    importRowError: 'Rad {{row}}: {{message}}',
    projectSearchPlaceholder: 'Sök projekt...',
    projectCode: 'Projnr',
    projectDescription: 'Projektbeskrivning',
    projectAccountString: 'Kontosträng',
    projectValidFrom: 'Giltig från',
    projectNumber: 'Projektnummer',
    projectPlaceholder: 'Sök projekt...',
    noProjects: 'Inga projekt. Importera från mall för att komma igång.',
    downloadTemplateError: 'Kunde inte ladda ner mallen',
    footerRequiredHint: 'Fält märkta * är obligatoriska',
    saveBlockedTitle: 'Kan inte spara ännu:',
    saveBlockedPolicy: 'Godkänn bokningspolicyn (scrolla ner i formuläret)',
    saveBlockedTerms: 'Godkänn bokningsvillkoren (scrolla ner i formuläret)',
    saveBlockedDriverLicense: 'Bekräfta att du har giltigt körkort',
    saveBlockedNoVehicle: 'Inget tillgängligt fordon för vald tid',
    saveBlockedProject: 'Välj projektnummer från listan (klicka på träff efter sökning)',
    section: {
      booking: 'Bokning',
      group: 'Gruppmedlemmar',
      vehicle: 'Fordon',
      resource: 'Resurs',
      trip: 'Resa',
      admin: 'Administrativt',
    },
    formField: {
      booking_type: 'Typ (bokning / gruppbokning)',
      booked_for: 'Bokad av / för',
      start_end: 'Start och slut',
      recurrence: 'Återkommande bokning',
      group_members: 'Gruppmedlemmar',
      vehicle: 'Fordon',
      automatic_transmission_filter: 'Endast automatväxel',
      equipment_filter: 'Filtrera på utrustning',
      trip_purpose: 'Syfte med resan',
      destination: 'Destination',
      estimated_km: 'Uppskattad sträcka',
      passenger_count: 'Antal passagerare',
      driver_license: 'Körkort bekräftat',
      service_booking: 'Service / Jour',
      approved_by: 'Godkänd av (attestation)',
      cost_center: 'Kostnadsställe',
      project: 'Projektnummer',
      notes: 'Anteckningar',
      booking_policy: 'Bokningspolicy',
      terms: 'Bokningsvillkor',
    },
    acceptTerms: 'Jag godkänner bokningsvillkoren',
    status_BOOKED: 'Bokad',
    status_CHECKED_OUT: 'Uthämtad',
    status_RETURNED: 'Återlämnad',
    owner: 'Ägare',
    checkedOut: 'Uthämtad',
    returned: 'Återlämnad',
    checkedOutSuccess: 'Bokningen har checkats ut',
    returnedSuccess: 'Bokningen har lämnats tillbaka',
    checkoutError: 'Kunde inte checka ut bokningen',
    returnError: 'Kunde inte lämna tillbaka bokningen',
    returnOverrideButton: 'Tillåt återlämning utan nyckel',
    returnOverrideHint: 'Tillåt att bokningen avslutas även om nyckel/kort saknas i boxen.',
    returnOverrideTitle: 'Tillåt återlämning utan nyckel',
    returnOverrideDescription: 'Användaren kan avsluta bokningen även om nyckel/kort saknas eller luckan inte är låst. Ange en orsak (loggas).',
    returnOverrideReasonLabel: 'Orsak',
    returnOverrideReasonPlaceholder: 'T.ex. nyckel borttappad, kort saknas...',
    returnOverrideConfirm: 'Tillåt återlämning',
    returnOverrideSuccess: 'Återlämning utan nyckel tillåten för bokningen',
    returnOverrideError: 'Kunde inte tillåta återlämning utan nyckel',
    returnOffsiteButton: 'Återlämning på annan plats',
    returnOffsiteHint: 'Tillåt att bokningen avslutas även om GPS inte visar att bilen är på utlämningsplatsen (fördröjd signal).',
    returnOffsiteTitle: 'Återlämning på annan plats',
    returnOffsiteDescription:
      'Användaren kan avsluta bokningen även om GPS visar att bilen inte är inom området. Ange en orsak (loggas).',
    returnOffsiteReasonPlaceholder: 'T.ex. GPS-fördröjning, bilen står på platsen...',
    returnOffsiteConfirm: 'Tillåt annan plats',
    returnOffsiteSuccess: 'Återlämning på annan plats tillåten för bokningen',
    returnOffsiteError: 'Kunde inte tillåta återlämning på annan plats',
    postReturnAccessButton: 'Ge 15 min åtkomst',
    postReturnAccessHint: 'Ge kunden tillgång till bilen igen i 15 minuter (t.ex. glömd väska). Endast inom 60 min efter återlämning.',
    postReturnAccessConfirm:
      'Ge kunden 15 minuters tillgång till bilen igen? Detta går även om fordonet är bokat av någon annan.',
    postReturnAccessSuccess: 'Kunden har fått 15 minuters tillgång igen',
    postReturnAccessError: 'Kunde inte ge ny åtkomst',
    postReturnAccessTooLate: 'Ny åtkomst kan endast ges inom 60 minuter efter återlämning',
    postReturnAccessReturnedHint:
      'Bokningen är återlämnad. Använd "Ge 15 min åtkomst" för glömd väska — ändra inte bara sluttiden.',
    termsTitle: 'Bokningsvillkor',
    termsDescription: 'Hantera bokningsvillkor för bokningar',
    addTerms: 'Ny version',
    noTerms: 'Inga bokningsvillkor har skapats ännu.',
    termsVersion: 'Version',
    termsVersionTitle: 'Titel',
    termsContent: 'Innehåll',
    termsVersionPlaceholder: 'Version (t.ex. 1.0)',
    termsTitlePlaceholder: 'Titel',
    termsContentPlaceholder: 'Innehåll (HTML eller text)',
    termsActivate: 'Aktivera',
    termsDeactivate: 'Inaktivera',
    termsActive: 'Aktiv',
    vehiclePoolTitle: 'Fordonspool',
    vehiclePoolsTitle: 'Bilpooler',
    vehiclePoolDescription: 'Hantera fordonspooler med automatisk bokning vid nyckeluttag',
    vehiclePoolsDescription: 'En fordonspool är en egen utlämningsplats som inte går att boka. Skåpet kan delas med bokningsbara platser. Bokningar vid nyckeluttag syns som vanligt.',
    createPool: 'Skapa pool',
    addPool: 'Skapa bilpool',
    noPools: 'Inga bilpooler ännu',
    poolName: 'Poolnamn',
    poolNamePlaceholder: 'Namn på fordonspool...',
    pickupLocation: 'Utlämningsplats',
    cabinetViaPickupLocation: 'Skåp via utlämningsplats',
    cabinetViaPickupLocationHint: 'Välj den bokningsbara platsen vars nyckelskåp poolen ska dela.',
    selectOrgFirstForUsers: 'Välj organisation först för att se användare',
    selectKeysHint: 'Endast nycklar som inte redan ligger på en bokningsbar utlämningsplats.',
    noCandidateKeys: 'Inga lediga poolnycklar för valt skåp och organisation',
    maxHoursPerCheckout: 'Max timmar per utlåning',
    maxHours: 'Max timmar',
    poolMembers: 'Medlemmar',
    members: 'Medlemmar',
    addMember: 'Lägg till medlem',
    removeMember: 'Ta bort',
    selectUser: 'Välj användare',
    activeCheckouts: 'Aktiva utlåningar',
    noPoolsYet: 'Inga fordonspooler har skapats ännu',
    noMembers: 'Inga medlemmar ännu',
    noMembersYet: 'Inga medlemmar i denna pool',
    memberName: 'Namn',
    memberEmail: 'E-post',
    pinCode: 'PIN-kod',
    editPool: 'Redigera pool',
    linkedCabinet: 'Kopplat skåp',
    noCabinet: 'Inget skåp kopplat — tilldela i Nyckelhantering',
    selectKeys: 'Vilka nycklar?',
    selectUsers: 'Användare',
    noCabinetAtLocation: 'Inget skåp kopplat till denna utlämningsplats',
    confirmDeletePool: 'Vill du radera denna bilpool? Nyckelkorgen i KeyWin tas också bort.',
    cannotDeleteActiveCheckouts: 'Kan inte radera — aktiva utlåningar finns',
    validFrom: 'Giltig från',
    validTo: 'Giltig till',
    poolWatchTitle: 'Saknade uppgifter',
    poolWatchDescription: 'Pooluttag där syfte eller andra obligatoriska fält inte är ifyllda.',
    poolWatchEmpty: 'Inga bokningar väntar på komplettering.',
    poolWatchComplete: 'Komplettera',
    poolWatchCompleteTitle: 'Komplettera bokning',
    poolWatchCompleteHint: 'Fyll i syfte och anteckningar efter nyckeluttaget.',
    poolWatchSaved: 'Uppgifterna är sparade.',
    poolWatchLoadError: 'Kunde inte hämta bevakningslistan.',
    poolWatchSaveError: 'Kunde inte spara uppgifterna.',
    needsPurposeFilter: 'Bara saknade uppgifter',
    needsPurposeBadge: 'Saknar uppgifter',
    quickTitle: 'Snabb bokning',
    quickDescription: 'Boka en ledig skåpsbil eller Flinkey-bil åt en gäst. PIN skickas som SMS. Minst namn, telefon eller e-post.',
    quickCabinet: 'Nyckelskåp',
    quickAccessCabinet: 'Skåpsbil',
    quickAccessFlinkey: 'Flinkey-box',
    quickGuestName: 'Gästens namn',
    quickGuestPhone: 'Mobil',
    quickGuestEmail: 'E-post',
    quickSubmit: 'Boka och skicka PIN',
    quickSaved: 'Bokningen är skapad',
    quickLoadError: 'Kunde inte hämta lediga bilar.',
    quickSaveError: 'Kunde inte skapa bokningen.',
    quickMissingFields: 'Fyll i fordon och skåp (om det är en skåpsbil).',
    quickMissingIdentity: 'Ange minst namn, telefon eller e-post.',
    quickIdentityHint: 'Minst ett av namn, telefon eller e-post krävs.',
    quickPhoneHint: 'Landskod, t.ex. +47 eller +1',
    quickSaveCustomer: 'Spara kunden',
    quickPinLabel: 'PIN',
    quickSmsSent: 'PIN skickad som SMS.',
    quickSmsFailed: 'Bokningen skapades men SMS kunde inte skickas. Visa PIN för gästen.',
    quickTabNew: 'Ny bokning',
    quickTabCurrent: 'Aktuella',
    quickTabPrevious: 'Tidigare',
    quickEmptyCurrent: 'Inga aktuella snabba bokningar.',
    quickEmptyPrevious: 'Inga tidigare snabba bokningar.',
    quickListError: 'Kunde inte hämta bokningar.',
    quickCancel: 'Avboka',
    quickCancelConfirm: 'Avboka den här bokningen?',
    quickCancelled: 'Bokningen är avbokad.',
    quickCancelError: 'Kunde inte avboka.',
    quickNoCreateAccess: 'Du saknar behörighet att skapa snabb bokning.',
    quickNoVehicles: 'Inga lediga skåps- eller Flinkey-bilar i vald tid.',
  },

  // Work Orders - Arbetsorder
  workOrders: {
    title: 'Arbetsorder',
    pageTitle: 'Arbetsorderhantering',
    description: 'Hantera arbetsorder, leveranser och hemtjänstuppdrag',
    
    // Actions
    create: 'Skapa arbetsorder',
    edit: 'Redigera',
    delete: 'Ta bort',
    deleteConfirm: 'Ta bort arbetsordern? Detta går inte att ångra.',
    deleteBlocked: 'Startad arbetsorder kan inte tas bort.',
    deleteError: 'Kunde inte ta bort arbetsordern.',
    assign: 'Tilldela',
    unassign: 'Avbryt tilldelning',
    start: 'Starta',
    complete: 'Slutför',
    cancel: 'Avbryt',
    optimize: 'Optimera rutt',
    
    // Types
    types: {
      SERVICE: 'Servicejobb',
      DELIVERY: 'Leverans',
      HOMECARE: 'Hemtjänst',
      INSPECTION: 'Besiktning',
      INSTALLATION: 'Installation',
    },
    
    // Status
    status: {
      DRAFT: 'Utkast',
      PENDING: 'Väntar',
      ASSIGNED: 'Tilldelad',
      OPTIMIZED: 'Optimerad',
      IN_PROGRESS: 'Pågående',
      ARRIVED: 'Framme',
      PAUSED: 'Pausad',
      COMPLETED: 'Slutförd',
      CANCELLED: 'Avbruten',
      FAILED: 'Misslyckad',
    },
    
    // Priority
    priority: {
      LOW: 'Låg',
      NORMAL: 'Normal',
      HIGH: 'Hög',
      URGENT: 'Akut',
    },
    
    // Table columns
    colType: 'Typ',
    colStatus: 'Status',
    colStops: 'Stopp',
    // Filter
    allStatuses: 'Alla statusar',
    allTypes: 'Alla typer',
    searchPlaceholder: 'Sök ordernummer, titel, kund...',
    // Fields
    orderNumber: 'Ordernummer',
    customer: 'Kund',
    customerName: 'Kundnamn',
    customerPhone: 'Telefon',
    customerEmail: 'E-post',
    jobTitle: 'Titel',
    jobDescription: 'Beskrivning',
    notes: 'Anteckningar',
    plannedDate: 'Planerat datum',
    timeWindow: 'Tidsfönster',
    estimatedDuration: 'Beräknad tid',
    assignedVehicle: 'Tilldelat fordon',
    assignedDriver: 'Tilldelad förare',
    
    // Stops
    stops: 'Stopp',
    addStop: 'Lägg till stopp',
    stopAddress: 'Adress',
    stopContact: 'Kontaktperson',
    stopTimeWindow: 'Tidsfönster',
    stopDuration: 'Beräknad tid',
    
    // Routes
    routes: 'Rutter',
    route: 'Rutt',
    routeDate: 'Datum',
    routeVehicle: 'Fordon',
    routeDriver: 'Förare',
    routeStatus: 'Status',
    routeDistance: 'Distans',
    routeDuration: 'Tid',
    optimizeRoute: 'Optimera rutt',
    routeOptimized: 'Rutt optimerad',
    routeNotOptimized: 'Rutt inte optimerad',
    
    // Optimization
    optimization: {
      title: 'Ruttoptimering',
      optimize: 'Optimera',
      optimizing: 'Optimerar...',
      freedTime: 'Frigjord tid',
      reducedDistance: 'Reducerad sträcka',
      newOrder: 'Ny ordning',
      originalOrder: 'Ursprunglig ordning',
      vroomAvailable: 'VROOM tillgänglig',
      vroomUnavailable: 'VROOM inte tillgänglig',
    },
    
    // Stats
    stats: {
      total: 'Totalt',
      today: 'Idag',
      completed: 'Slutförda',
      pending: 'Väntande',
      overdue: 'Försenade',
      avgTime: 'Snittid',
    },
    
    // Messages
    noOrders: 'Inga arbetsorder hittades',
    selectVehicle: 'Välj fordon',
    selectDriver: 'Välj förare',
    confirmDelete: 'Är du säker på att du vill ta bort denna arbetsorder?',
    deleteSuccess: 'Arbetsorder borttagen',
    createSuccess: 'Arbetsorder skapad',
    updateSuccess: 'Arbetsorder uppdaterad',
    assignSuccess: 'Arbetsorder tilldelad',
    completeSuccess: 'Arbetsorder slutförd',
    cancelSuccess: 'Arbetsorder avbruten',
    optimizeSuccess: 'Rutt optimerad',
    delivery: {
      title: 'Paketleverans',
      subtitle: 'Arbetsorder för paket och leveranser',
      recipient: 'Mottagare',
      address: 'Adress',
      stop: 'Stopp',
      searchPlaceholder: 'Sök ordernummer, mottagare, adress...',
      newDelivery: 'Ny leverans',
      noDeliveries: 'Inga leveranser hittades',
    },
    craftsman: {
      title: 'Hantverkare',
      subtitle: 'Arbetsorder för hantverkare och service',
      customer: 'Kund',
      address: 'Adress',
      time: 'Tid',
      searchPlaceholder: 'Sök ordernummer, kund, adress...',
      newWorkOrder: 'Ny arbetsorder',
      noWorkOrders: 'Inga arbetsorder hittades',
      assigned: 'Tilldelad',
      unassigned: 'Otilldelad',
      assignPlaceholder: 'Sök person...',
      assignSuccess: 'Arbetsorder tilldelad',
      assignError: 'Kunde inte tilldela',
      edit: 'Redigera',
      detail: 'Detaljer / utförande',
      viewList: 'Lista',
      viewGantt: 'Gantt',
      viewCalendar: 'Kalender',
      ordersShort: 'ordrar',
    },

    form: {
      newTitle: 'Ny arbetsorder',
      editTitle: 'Redigera arbetsorder',
      title: 'Titel',
      titleRequired: 'Titel krävs',
      organization: 'Organisation',
      orgRequired: 'Välj organisation',
      serviceType: 'Servicetyp',
      serviceTypeRequired: 'Välj eller lägg till en servicetyp',
      serviceTypeEmpty: 'Inga typer ännu – välj Lägg till…',
      serviceTypeAdd: 'Lägg till…',
      serviceTypeSelectOrgFirst: 'Välj organisation först',
      serviceTypeNamePlaceholder: 'Namn på servicetyp',
      serviceTypeNameRequired: 'Ange namn på servicetyp',
      serviceTypeCreateError: 'Kunde inte skapa servicetyp',
      customerName: 'Kundnamn',
      customerPhone: 'Telefon',
      address: 'Adress',
      postalCode: 'Postnummer',
      city: 'Ort',
      plannedDate: 'Planerat datum',
      timeWindowStart: 'Tidsfönster från',
      timeWindowEnd: 'Tidsfönster till',
      description: 'Beskrivning',
    },

    detail: {
      assignment: 'Tilldelning',
      person: 'Person',
      vehicleOptional: 'Fordon (valfritt)',
      noVehicle: 'Inget fordon',
      assign: 'Tilldela',
      gpsHint: 'Med tilldelat fordon registreras restid och km automatiskt från fordonets GPS. Utan fordon stämplas tid manuellt i appen.',
      start: 'Starta',
      pause: 'Pausa',
      resume: 'Återuppta',
      complete: 'Slutför',
      accounting: 'Redovisning',
      actualStart: 'Faktisk start',
      actualEnd: 'Faktiskt slut',
      timeline: 'Start och slut',
      historyStarted: 'Startad',
      historyPaused: 'Pausad',
      historyResumed: 'Återupptagen',
      historyCompleted: 'Slutförd',
      totalTime: 'Totaltid',
      travelTime: 'Restid',
      workTime: 'Arbetstid',
      distance: 'Sträcka',
      manualTime: 'Manuell tidsregistrering',
      segmentType: 'Typ',
      minutes: 'Minuter',
      segments: 'Tidssegment',
      completionNotes: 'Slutkommentar',
    },

    import: {
      title: 'Importera',
      selectFile: 'Välj fil (Excel/CSV)',
      dropHint: 'Klicka för att välja en Excel- eller CSV-fil',
      emptyFile: 'Filen innehåller inga rader',
      parseError: 'Kunde inte läsa filen',
      mapping: 'Kolumnmappning',
      rows: 'rader',
      row: 'Rad',
      ignore: 'Ignorera',
      import: 'Importera',
      importing: 'Importerar...',
      created: 'Skapade',
      failed: 'Misslyckade',
      titleMappingRequired: 'Mappa kolumnen för Titel',
      field: {
        title: 'Titel',
        customerName: 'Kundnamn',
        customerPhone: 'Telefon',
        customerEmail: 'E-post',
        address: 'Adress',
        postalCode: 'Postnummer',
        city: 'Ort',
        plannedDate: 'Planerat datum',
        timeWindowStart: 'Tid från',
        timeWindowEnd: 'Tid till',
        estimatedDurationMinutes: 'Beräknad tid (min)',
        notes: 'Anteckning',
      },
    },
  },

  // ============================================================
  // Serviceåtagande
  // ============================================================
  serviceAgreements: {
    title: 'Serviceåtagande',
    subtitle: 'Återkommande serviceuppdrag med intervall',
    new: 'Nytt serviceåtagande',
    newTitle: 'Nytt serviceåtagande',
    editTitle: 'Redigera serviceåtagande',
    empty: 'Inga serviceåtaganden',
    titleField: 'Titel',
    titlePlaceholder: 't.ex. Kontroll av frånluftspump',
    customerSection: 'Kund och serviceadress',
    serviceAddress: 'Serviceadress',
    billingSection: 'Faktureringsadress',
    billingName: 'Faktureringsnamn',
    billingAddress: 'Faktureringsadress',
    billingReference: 'Fakturareferens',
    scheduleSection: 'Schema och pris',
    intervalMonths: 'Intervall (månader)',
    monthsShort: 'mån',
    nextDueDate: 'Nästa förfallodatum',
    pricingType: 'Prissättning',
    hourly: 'Timpris',
    fixed: 'Fast pris',
    estimatedMinutes: 'Beräknad tid (min)',
    estimatedHours: 'Beräknad tid (timmar)',
    estimatedHoursHint: 'Hur lång tid uppdraget beräknas ta, t.ex. 1,5',
    hourlyRate: 'Timpris (kr/timme)',
    fixedPrice: 'Fast pris (kr)',
    dueWidgetTitle: 'Förfaller inom 30 dagar',
    noneDue: 'Inga åtaganden förfaller inom 30 dagar',
    dueInDays: 'Förfaller om {{days}} dagar',
    overdueBy: 'Försenad {{days}} dagar',
    assign: 'Tilldela person',
    assignTitle: 'Tilldela och skapa arbetsorder',
    createWorkOrder: 'Skapa arbetsorder',
    personRequired: 'Välj en person',
    confirmDelete: 'Vill du ta bort detta serviceåtagande?',
  },

  // ============================================================
  // Hemtjänstmodul
  // ============================================================
  homecare: {
    title: 'Hemtjänst',
    subtitle: 'Ruttplanering och schemaläggning för hemtjänst',
    date: 'Datum',

    tabs: {
      planning: 'Planering',
      gantt: 'Gantt-schema',
      map: 'Karta',
      roster: 'Tjänstgöringsschema',
      clients: 'Brukare',
      staff: 'Personal',
    },

    planning: {
      visits: 'Besök',
      requiresMultiStaff: 'kräver 2+ personal',
      teams: 'Team',
      pairTeams: 'par-team',
      soloTeams: 'solo-team',
      pairTeam: 'Par-team',
      vehicles: 'Fordon',
      vehicleShortage: 'saknas',
      vehiclesOk: 'Tillräckligt',
      distance: 'Körsträcka',
      suggestTeams: 'Föreslå team',
      optimizeRoutes: 'Optimera rutter',
      suggestedTeams: 'Föreslagna team',
      optimizationResult: 'Optimeringsresultat',
      unassignedVisits: 'Ej tilldelade besök',
      teamError: 'Kunde inte föreslå team',
      optimizeError: 'Kunde inte optimera rutter',
      timeWindow: 'Tidsfönster',
      duration: 'Tid',
      staff: 'Personal',
      priority: 'Prioritet',
      strategy: 'Strategi',
      strategyBalanced: 'Balanserad',
      strategyBalancedDesc: 'Optimerar med kompetenskrav. Vissa besök kan bli ej tilldelade.',
      strategyCoverAll: 'Täck alla besök',
      strategyCoverAllDesc: 'Alla besök tilldelas oavsett kompetens. Varningar visas.',
      strategyCalculateExtra: 'Beräkna resursbehov',
      strategyCalculateExtraDesc: 'Visar hur många extra team som behövs för full täckning.',
      optimizationRuns: 'Optimeringshistorik',
      noRuns: 'Inga sparade optimeringar',
      selectRun: 'Välj denna plan',
      deleteRun: 'Ta bort',
      selectedRun: 'Aktiv',
      archivedRun: 'Arkiverad',
      draftRun: 'Utkast',
      runStrategy: 'Strategi',
      runCreated: 'Skapad',
      extraTeamsNeeded: 'Extra team som behövs',
      competenceWarnings: 'Kompetensvarningar',
      competenceWarningDetail: 'saknar kompetens',
      missingCompetences: 'Saknad kompetens',
      reassignVisit: 'Flytta till',
      reassignSuccess: 'Besök flyttat',
      reassignError: 'Kunde inte flytta besök',
      reoptimize: 'Optimera om',
      manualChanges: 'Manuella ändringar gjorda',
    },
    vehicleSource: 'Hämta fordon från',
    selectVehicleSource: 'Välj fordonsorganisation',

    gantt: {
      team: 'Team',
      summary: 'Sammanfattning',
      noData: 'Inget Gantt-schema tillgängligt',
      noDataHint: 'Kör optimering i planeringsfliken först',
      travel: 'Transport',
      visit: 'Hos brukare',
      break: 'Rast',
      unplanned: 'Ej planerad',
      totalTeams: 'Team',
      totalVisits: 'Besök',
      totalTravel: 'Körsträcka',
      visitsLabel: 'besök',
      planned: 'planerad tid',
    },

    roster: {
      staff: 'Personal',
      week: 'Vecka',
      copyWeek: 'Kopiera till nästa vecka',
      weekCopied: 'Veckans schema kopierat',
      confirmCopyWeek: 'Vill du kopiera schemat till nästa vecka? Befintliga poster i nästa vecka påverkas inte.',
      nothingToCopy: 'Inget att kopiera – schemat för denna vecka är tomt eller nästa vecka har redan samma poster.',
      copyFailed: 'Kunde inte kopiera schemat',
    },

    clients: {
      searchPlaceholder: 'Sök brukare...',
      add: 'Ny brukare',
      newClient: 'Ny brukare',
      editClient: 'Redigera brukare',
      name: 'Namn',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      personalNumber: 'Personnummer',
      address: 'Adress',
      postalCode: 'Postnummer',
      city: 'Ort',
      phone: 'Telefon',
      doorCode: 'Portkod',
      floor: 'Våning',
      specialInstructions: 'Särskilda instruktioner',
      emergencyContact: 'Kontaktperson',
      emergencyPhone: 'Kontakttelefon',
      competences: 'Kompetenskrav',
      noClients: 'Inga brukare hittades',
      saved: 'Brukare sparad',
      coordinates: 'Koordinater',
      allocatedHours: 'Beviljad vårdtid',
      hoursPerWeek: 'timmar/vecka',
    },

    careNeeds: {
      title: 'Vårdbehov',
      add: 'Lägg till vårdbehov',
      edit: 'Redigera vårdbehov',
      name: 'Benämning',
      duration: 'Varaktighet (min)',
      timeWindowStart: 'Tidsfönster start',
      timeWindowEnd: 'Tidsfönster slut',
      frequency: 'Frekvens',
      weekdays: 'Veckodagar',
      requiredStaff: 'Antal personal',
      priority: 'Prioritet',
      description: 'Beskrivning',
      competences: 'Kompetenskrav',
      mandatory: 'Obligatorisk',
      noNeeds: 'Inga vårdbehov tillagda',
      saved: 'Vårdbehov sparat',
      deleted: 'Vårdbehov borttaget',
      confirmDelete: 'Vill du ta bort detta vårdbehov?',
      generateVisits: 'Generera besök',
      generateVisitsDesc: 'Skapa besök från vårdbehov för en period',
      fromDate: 'Från datum',
      toDate: 'Till datum',
      generated: 'besök genererade',
      noVisitsGenerated: 'Inga nya besök att generera',
      frequencies: {
        DAILY: 'Dagligen',
        WEEKDAYS: 'Vardagar',
        WEEKLY: 'Veckovis',
        BIWEEKLY: 'Varannan vecka',
        MONTHLY: 'Månadsvis',
        CUSTOM: 'Anpassad',
      },
      priorities: {
        LOW: 'Låg',
        NORMAL: 'Normal',
        HIGH: 'Hög',
        URGENT: 'Akut',
      },
      weekdayNames: {
        '1': 'Mån',
        '2': 'Tis',
        '3': 'Ons',
        '4': 'Tor',
        '5': 'Fre',
        '6': 'Lör',
        '7': 'Sön',
      },
    },

    staff: {
      searchPlaceholder: 'Sök personal...',
      startsFromHome: 'Startar hemifrån',
      startsFromOffice: 'Startar från kontoret',
      startType: 'Startposition',
      homeAddress: 'Hemadress',
      homeLat: 'Latitud (hem)',
      homeLng: 'Longitud (hem)',
      shiftStart: 'Arbetspass start',
      shiftEnd: 'Arbetspass slut',
      workHours: 'Arbetstid',
      competences: 'Kompetenser',
      editStaff: 'Redigera personal',
      noCompetences: 'Inga kompetenser',
      noStaff: 'Ingen personal hittades',
      saved: 'Personal sparad',
    },
  },

  // Fuel Management
  charging: {
    title: 'Laddning',
    description: 'Redovisning av EV-laddsessioner (kWh) och plats',
    tab: 'Laddning',
    month: 'Månad',
    organization: 'Organisation',
    allOrganizations: 'Alla organisationer',
    selectVehicle: 'Fordon',
    vehiclePlaceholder: 'Alla fordon – sök eller välj...',
    export: 'Exportera',
    estimateNote: 'kWh är uppskattat utifrån batteriets laddnivå (SoC), inte ett mätt väggvärde. För exakt skatteunderlag krävs mätande laddbox.',
    loadError: 'Kunde inte hämta laddsessioner',
    exportError: 'Kunde inte exportera',
    noData: 'Inga laddsessioner för perioden',
    location: {
      label: 'Plats',
      all: 'Alla platser',
      home: 'Hem',
      work: 'Jobb',
      public: 'Publik',
      unknown: 'Okänd',
    },
    summary: {
      homeKwh: 'Hemmaladdning (kWh)',
      totalKwh: 'Totalt laddat (kWh)',
      sessions: 'Antal sessioner',
    },
    table: {
      vehicle: 'Fordon',
      start: 'Start',
      end: 'Slut',
      soc: 'Laddnivå',
      wallKwh: 'kWh (vägg)',
      location: 'Plats',
    },
    config: {
      description: 'Konfigurera batterikapacitet, laddförlust samt hem- och arbetsplats för korrekt laddredovisning. Saknas värde i Car.info kan du fylla i kWh manuellt — Car.info skriver över när uppgiften finns.',
      batteryCapacity: 'Batterikapacitet (kWh)',
      batteryFromCarInfo: 'Använd uppslaget värde från Car.info: {{value}} kWh',
      batterySourceManual: 'Källa: manuellt ifyllt (skrivs över om Car.info får kWh)',
      batterySourceCarInfo: 'Källa: Car.info',
      efficiency: 'Laddförlust (batteri/vägg, 0–1)',
      homeLatitude: 'Hemladdplats latitud',
      homeLongitude: 'Hemladdplats longitud',
      homeRadius: 'Hemladdplats radie (m)',
      homeLocation: 'Hemladdplats',
      workLocation: 'Arbetsplats',
      pickOnMap: 'Välj på karta',
      changeOnMap: 'Ändra på karta',
      clear: 'Rensa',
      address: 'Adress',
      addressPlaceholder: 'Klicka på kartan för att hämta adress',
      radius: 'Radie',
      pickerHelp: 'Sök en adress eller klicka på kartan/dra markören för att välja platsen. Adressen hämtas automatiskt.',
      pickerNoPoint: 'Ingen plats vald',
      searchPlaceholder: 'Sök adress eller plats…',
      publicNote: 'Laddning utanför hem- och arbetsplats klassas automatiskt som publik.',
    },
  },
  fuelCards: {
    title: 'Tankkort',
    description: 'Register över tankkort, OKQ8-nummer och fordonskoppling',
    create: 'Nytt kort',
    createTitle: 'Registrera tankkort',
    editTitle: 'Redigera tankkort',
    fuelCompany: 'Bränslebolag',
    selectCompany: 'Välj bränslebolag…',
    cardNumber: 'Kortnummer',
    invoiceNumber: 'Fakturanummer',
    embossedNumber: 'Präglat nummer',
    cardName: 'Kortnamn',
    pinCode: 'Pinkod',
    expiresAt: 'Utgångsdatum',
    status: 'Status',
    statusActive: 'Aktivt',
    statusBlocked: 'Spärrat',
    statusCancelled: 'Makulerat',
    notes: 'Anteckning',
    vehicle: 'Fordon',
    selectVehicle: 'Välj fordon…',
    missingOrganization: 'Kortet saknar organisation, så fordon kan inte kopplas.',
    notLinked: 'Ej kopplat',
    link: 'Koppla',
    unlink: 'Koppla loss',
    linkTitle: 'Koppla kort till fordon',
    cancel: 'Makulera',
    expiringFilter: 'Förfaller inom 60 dagar',
    noCards: 'Inga tankkort hittades',
    loadError: 'Kunde inte hämta tankkort',
    createSuccess: 'Tankkort registrerat',
    saveSuccess: 'Tankkort uppdaterat',
    saveError: 'Kunde inte spara tankkort',
    linkSuccess: 'Kort kopplat till fordon',
    linkError: 'Kunde inte koppla kort',
    unlinkSuccess: 'Kort kopplat loss',
    unlinkError: 'Kunde inte koppla loss kort',
    confirmUnlink: 'Koppla loss kortet från fordonet? Kortet finns kvar i registret.',
    cancelSuccess: 'Kortet är makulerat',
    cancelError: 'Kunde inte makulera kort',
    confirmCancel: 'Makulera detta tankkort?',
    historyTitle: 'Kopplingshistorik',
    historyVehicle: 'Fordon',
    historyFrom: 'Kopplad från',
    historyTo: 'Frånkopplad',
    historyUnlinked: 'Okopplad',
    historyOngoing: 'Pågår',
    historyCurrent: 'Nuvarande',
    historyPast: 'Avslutad',
    historyEmpty: 'Ingen kopplingshistorik',
    historyLoadError: 'Kunde inte hämta kopplingshistorik',
  },

  fuel: {
    title: 'Bränslehantering',
    description: 'Fakturor, bränsletransaktioner och kortkopplingar',
    invoices: {
      tab: 'Fakturor',
      invoiceNumber: 'Fakturanummer',
      invoiceDate: 'Fakturadatum',
      transactionCount: 'Antal',
      totalExclVat: 'Exkl. moms',
      vat: 'Moms',
      total: 'Totalt',
      noInvoices: 'Inga fakturor hittades',
      loadError: 'Kunde inte hämta fakturor',
      date: 'Datum',
      station: 'Station',
      product: 'Produkt',
      quantity: 'Liter',
      priceExclVat: 'Pris exkl. moms',
      vatAmount: 'Moms',
      company: 'Bolag',
    },
    duplicate: {
      badge: 'Dubblett',
      tooltip: 'Samma tankning finns redan från ett annat bolag — möjlig dubbelfakturering',
      tooltipCompany: 'Samma tankning finns redan hos {{company}} — möjlig dubbelfakturering',
    },
    cards: {
      tab: 'Bränslekort',
      cardNumber: 'Kortnummer',
      invoiceNumber: 'Fakturanummer',
      embossedNumber: 'Präglat nummer',
      cardName: 'Kortnamn',
      pinCode: 'Pinkod',
      fuelCompany: 'Bränslebolag',
      linkedVehicle: 'Kopplat fordon',
      linkedSince: 'Kopplad sedan',
      notLinked: 'Ej kopplat',
      link: 'Koppla',
      unlink: 'Koppla bort',
      noCards: 'Inga bränslekort hittades',
      loadError: 'Kunde inte hämta kort',
      confirmUnlink: 'Är du säker på att du vill koppla bort detta kort?',
      unlinkSuccess: 'Kort bortkopplat',
      unlinkError: 'Kunde inte koppla bort kort',
      linkModal: {
        title: 'Koppla kort till fordon',
        vehicle: 'Fordon',
        validFrom: 'Kopplad från',
        selectVehicle: 'Välj fordon...',
        pinCode: 'Pinkod',
        pinCodePlaceholder: 'Pinkod',
        save: 'Koppla',
        success: 'Kort kopplat till fordon',
        error: 'Kunde inte koppla kort',
      },
      history: {
        title: 'Kopplingshistorik',
        vehicle: 'Fordon',
        from: 'Från',
        to: 'Till',
        active: 'Aktiv',
        inactive: 'Avslutad',
        noHistory: 'Ingen historik',
        loadError: 'Kunde inte hämta historik',
      },
    },
    vehicleCard: {
      noCards: 'Inga bränslekort har kopplats till detta fordon',
      loadError: 'Kunde inte hämta bränslekort',
      noTransactions: 'Inga bränsletransaktioner hittades för vald period',
      outsidePeriod: 'Inga transaktioner i vald period. Det finns {{count}} transaktioner utanför perioden — utöka datum.',
      loadTxError: 'Kunde inte hämta bränsletransaktioner',
      totalLiters: 'Totalt liter',
      totalCost: 'Total kostnad',
      addCard: 'Lägg till kort',
      cardNumber: 'Kortnummer',
      invoiceNumber: 'Fakturanummer',
      embossedNumber: 'Präglat nummer',
      okq8BothRequired: 'OKQ8 kräver både fakturanummer och präglat nummer',
      validFrom: 'Giltig från',
      linkSuccess: 'Bränslekort kopplat',
      linkError: 'Kunde inte koppla bränslekort',
      unlinkSuccess: 'Bränslekort bortkopplat',
      unlinkError: 'Kunde inte koppla bort bränslekort',
      confirmUnlink: 'Är du säker på att du vill koppla bort detta kort?',
      unlink: 'Koppla bort',
    },
  },

  // Module translations (for SystemLandingPage - maps module.name to translated title/description)
  modules: {
    addFavorite: 'Lägg till som favorit',
    removeFavorite: 'Ta bort från favoriter',
    // Administration
    roles: { title: 'Roller', description: 'Roller och behörigheter' },
    organizations: { title: 'Organisationer', description: 'Hantera organisationer' },
    users: { title: 'Användare', description: 'Användarhantering' },
    translations: { title: 'Översättningar', description: 'Översättningar och språk' },
    imports: { title: 'Import', description: 'Importera data från filer' },
    packages: { title: 'Paket', description: 'Hantera paket och prenumerationer' },
    devices: { title: 'Enheter', description: 'Hantera enheter' },
    'device-management': { title: 'Enhetshantering', description: 'Avancerad enhetshantering' },
    'sim-cards': { title: 'Simkort', description: 'Hantera SIM-kort, visa användning och skapa rapporter via Jasper API' },
    geofences: { title: 'Geofences', description: 'Hantera geofences' },
    'geofence-events': { title: 'Geofence-händelser', description: 'Visa geofence-händelser' },
    support: { title: 'Support', description: 'Supportfunktioner' },
    'service-workshops': { title: 'Verkstäder', description: 'Administrera verkstäder och servicepersonal' },
    // SysAdmin
    'ai-log': { title: 'AI-logg', description: 'Visa AI-loggar' },
    'data-migration': { title: 'Datamigrering', description: 'Migrera data mellan system' },
    'device-commands': { title: 'Enhetskommandon', description: 'Skicka kommandon till enheter' },
    'audit-log': { title: 'Audit Log', description: 'Visa audit-loggar' },
    'general-audit-log': { title: 'Ändringslogg', description: 'Visa ändringslogg' },
    'error-log': { title: 'Fellogg', description: 'Visa felloggar' },
    'eco-settings': { title: 'ECO-inställningar', description: 'Konfigurera ECO-inställningar' },
    'system-monitor': { title: 'Systemövervakning', description: 'Övervaka systemstatus' },
    'slow-queries': { title: 'Slow Queries', description: 'Visa långsamma databasfrågor' },
    'data-replay': { title: 'Data Replay', description: 'Spela om GPS-data' },
    'trip-validation': { title: 'Trippvalidering', description: 'Validera trippar' },
    'import-sources': { title: 'Importkällor', description: 'Hantera importkällor' },
    'sso-log': { title: 'SSO-logg', description: 'Misslyckade och avbrutna SSO-försök, per kund och enhet' },
    'gps-data-lag': { title: 'GPS dump-kö', description: 'Enheter som aktivt skickar eftersläpande GPS-data; flush via SMS' },
    'api-metrics': { title: 'Prestanda', description: 'Användartillväxt, bokningar och API-latens mot systemlast' },
    // Reports
    trips: { title: 'Trippar', description: 'Visa och analysera trippar för dina fordon' },
    'eco-driving': { title: 'ECO Driving', description: 'Analysera körvanor och miljöpåverkan' },
    'speed-compliance': { title: 'Hastighetsefterlevnad', description: 'Analysera hastighetsefterlevnad per organisation och fordon' },
    'energy-consumption': { title: 'Energiförbrukning', description: 'Analysera bränsleförbrukning per organisation och fordon' },
    'vehicle-wear': { title: 'Fordonsslitage', description: 'Analysera hur körbeteende påverkar fordonsslitage' },
    underutilized: { title: 'Underutnyttjade fordon', description: 'Identifiera fordon med lågt utnyttjande' },
    co2: { title: 'CO2-utsläpp', description: 'Beräkna och analysera CO2-utsläpp' },
    'geofence-zones': { title: 'Geofence Zonrapport', description: 'Analysera hur ofta fordon befinner sig inom zoner' },
    'driving-log': { title: 'Körjournal', description: 'Körjournal enligt Skatteverkets riktlinjer' },
    'work-trips': { title: 'Arbetsresor', description: 'Resor med delade företagsbilar' },
    odometer: { title: 'Mätarställningsrapport', description: 'Visa mätarställning per fordon vid specifikt datum' },
    rental: { title: 'Uthyrningsrapport', description: 'Komplett rapport för uthyrning med resor, kostnader och status' },
    'rental-report': { title: 'Uthyrningsrapport', description: 'Uthyrningsstatistik och rapporter' },
    'stop-time': { title: 'Stopptidsanalys', description: 'Analysera fordonens stopptider' },
    'route-analysis': { title: 'Ruttanalys', description: 'Ruttoptimering och analys' },
    'vehicle-kpi': { title: 'Nyckeltal fordon', description: 'Nyckeltal per fordon' },
    dtc: { title: 'DTC-felrapport', description: 'Visa och analysera diagnostiska felkoder (DTC) per fordon' },
    'dtc-report': { title: 'DTC-rapport', description: 'Diagnostiska felkoder' },
    // CRM
    customers: { title: 'Kunder', description: 'Hantera kunder' },
    projects: { title: 'Projekt', description: 'Hantera projekt' },
    procurements: { title: 'Upphandlingar', description: 'Hantera upphandlingar' },
    pipeline: { title: 'Pipeline', description: 'Säljpipeline' },
    economy: { title: 'Ekonomi', description: 'Ekonomiöversikt' },
    invoices: { title: 'Fakturor', description: 'Hantera fakturor' },
    pricelist: { title: 'Prislista', description: 'Hantera prislista' },
    // Deque (DB-modulnamn)
    organization: { title: 'Organisation', description: 'Hantera organisationsstruktur' },
    fleet: { title: 'Flotta', description: 'Fordonsöversikt och hantering' },
    drivers: { title: 'Förare', description: 'Förarhantering' },
    // Deque (legacy/alias-nycklar)
    'fleet-overview': { title: 'Fordonsflotta', description: 'Fordonsöversikt och hantering' },
    'live-tracking': { title: 'Realtidskarta', description: 'Realtidsspårning av fordon' },
    'track-playback': { title: 'Track Playback', description: 'Visa historiska rutter' },
    'map-services': { title: 'Kartjänster', description: 'Karta, spårning, geofence och heatmap' },
    'fuel-management': { title: 'Bränslehantering', description: 'Fakturor, bränslekort och kortkopplingar' },
    'fuel-cards': { title: 'Tankkort', description: 'Register över tankkort och fordonskoppling' },
    assignments: { title: 'Tilldelningar', description: 'Hantera tilldelningar av uppgifter till personer' },
    'vehicle-categories': { title: 'Fordonskategorier', description: 'Hantera valbara fordonskategorier' },
    'equipment-tags': { title: 'Fordonsutrustning', description: 'Hantera fordonsutrustning per toppnod' },
    'replacement-chain': { title: 'Ersättningskedja', description: 'Visa vilka fordon som ersatts i en kedja' },
    'alternative-fuels': { title: 'Alternativa drivmedel', description: 'Hantera valbara alternativa drivmedel per toppnod' },
    'usage-statuses': { title: 'Fordonsstatus', description: 'Hantera valbara fordonsstatusar per toppnod' },
    'service-overview': { title: 'Service', description: 'Serviceöversikt och hantering' },
    heatmap: { title: 'Heatmap', description: 'Heatmap av fordonspositioner' },
    'heatmap-import': { title: 'Heatmap Import', description: 'Importera CSV-data för heatmap-analys' },
    'crash-detection': { title: 'Crash detection', description: 'Krockhändelser från enheter med Crash Trace (AVL 257)' },
    'ai-analysis': { title: 'AI-analys', description: 'Analysera fordon och flotta med AI' },
    // Rapporter (DB-modulnamn)
    eco: { title: 'ECO-körning', description: 'Miljö och körbeteende' },
    fuel: { title: 'Bränsle', description: 'Bränslerapporter' },
    activity: { title: 'Aktivitet', description: 'Aktivitetsloggar' },
    // Analys (DB-modulnamn)
    statistics: { title: 'Statistik', description: 'Statistisk översikt' },
    trends: { title: 'Trender', description: 'Trendanalys och körsträcka mot leasingavtal' },
    benchmarks: { title: 'Jämförelser', description: 'Benchmarking' },
    // SysAdmin (DB-modulnamn)
    overview: { title: 'Översikt', description: 'Systemstatus' },
    replay: { title: 'Data Replay', description: 'Spela om GPS-data' },
    logs: { title: 'Loggar', description: 'Systemloggar' },
    // Bokning
    'pickup-locations': { title: 'Utlämningsplatser', description: 'Under Bokning: platser där fordon hämtas och lämnas' },
    suppliers: { title: 'Leverantörer', description: 'Leverantörer t.ex. biluthyrare' },
    destinations: { title: 'Destinationer', description: 'Fördefinierade resemål vid bokning' },
    calendar: { title: 'Kalender', description: 'Bokningskalender' },
    'bookings-search': { title: 'Kundtjänst', description: 'Administrera och supporta bokningar' },
    'booking-optimization': { title: 'Bokningsoptimering', description: 'AI-optimering av en dags bokningar per pool' },
    requests: { title: 'Bokningsförfrågningar', description: 'Hantera bokningsförfrågningar' },
    'vehicle-replacement': { title: 'Fordonsbyte', description: 'Ersätt fordon i pool, markera ur drift och omtilldela bokningar' },
    'own-car-trip': { title: 'Resa med egen bil', description: 'Registrera och hantera tjänsteresor med privat bil' },
    'own-car-trips': { title: 'Resa med egen bil', description: 'Registrera och hantera tjänsteresor med privat bil' },
    'collision-bookings': { title: 'Kollisionsbokningar', description: 'Bokningar utan tilldelat fordon efter pool- eller fordonsändring' },
    // Verkstad (DB-modulnamn)
    service: { title: 'Service', description: 'Serviceintervall och påminnelser' },
    repairs: { title: 'Reparationer', description: 'Reparationshistorik och kostnader' },
    inspections: { title: 'Besiktning', description: 'Besiktningsstatus och påminnelser' },
    // Nyckelhantering (DB-modulnamn)
    'key-cabinet': { title: 'Nyckelskåp', description: 'Översikt över nyckelskåp och nycklar' },
    'key-log': { title: 'Nyckelhistorik', description: 'Logg över nyckeluttag och inlämningar' },
    // Hemtjänst
    'homecare-planning': { title: 'Ruttplanering', description: 'Hemtjänst ruttoptimering' },
    'homecare-clients': { title: 'Brukare', description: 'Hemtjänstens brukare' },
    'homecare-staff': { title: 'Personal', description: 'Hemtjänstens personal' },
    // System
    administration: { title: 'Administration', description: 'Systemadministration' },
    sysadmin: { title: 'Systemadministration', description: 'Avancerade systeminställningar' },
    reports: { title: 'Rapporter', description: 'Rapporter och statistik' },
    crm: { title: 'CRM', description: 'Kundhantering' },
    deque: { title: 'Deque', description: 'Fordonsflotthantering' },
    booking: { title: 'Bokning', description: 'Fordonsbokningar' },
    homecare: { title: 'Hemtjänst', description: 'Hemtjänstplanering' },
    workshop: { title: 'Verkstad', description: 'Verkstad och underhåll' },
    keymanagement: { title: 'Nyckelhantering', description: 'Nyckelskåpshantering' },
    workorder: { title: 'Arbetsorder', description: 'Arbetsordrar och tilldelningar' },
    analysis: { title: 'Analys', description: 'Statistik och analys' },
    'cost-centers': { title: 'Kostnadsställen', description: 'Hantera kostnadsställen' },
    'old-booking': { title: 'Old Booking', description: 'Historisk bokningsdata (temporär)' },
    'cabinet-sync': { title: 'Skåpsynk', description: 'Vad KeyWin skickar till skåpen (global admin)' },
    'carinfo-filter': { title: 'Fordonsfilter', description: 'Filterkonfiguration för bildata' },
  },

  // System Landing Page
  systemPage: {
    loading: 'Laddar system...',
    errorTitle: 'Fel vid laddning av system',
    tryAgain: 'Försök igen',
    systemNotFound: 'System hittades inte',
    systemNotFoundDescription: 'Systemet "{name}" kunde inte hittas i databasen.',
    backToStart: 'Tillbaka till startsidan',
    noModules: 'Inga moduler hittades för detta system.',
    comingSoon: 'Kommer snart',
    plannedFeatures: 'Planerade funktioner',
    underDevelopment: 'Denna modul är under aktiv utveckling.',
    notFoundOrNoAccess: 'Systemet "{name}" hittades inte eller du saknar behörighet.',
    notLoggedIn: 'Du är inte inloggad eller din session har gått ut. Du kommer att omdirigeras till inloggningen.',
    noPermission: 'Du har inte behörighet att se denna information.',
    serverError: 'Serverfel. Vänligen försök igen senare.',
    unexpectedError: 'Ett oväntat fel uppstod vid hämtning av systemdata',
    noSystemName: 'Inget systemnamn angivet',
    apiError: 'API returnerade ett fel',
    // Coming Soon features
    comingSoonBooking: {
      feature1: 'Kalendervy för bokningar',
      feature2: 'Förfrågningar och godkännanden',
      feature3: 'Konflikthantering',
      feature4: 'Notifieringar till förare',
      feature5: 'Integration med fordonsflottan',
    },
    comingSoonWorkshop: {
      feature1: 'Serviceintervall och påminnelser',
      feature2: 'Reparationshistorik',
      feature3: 'Besiktningsstatus',
      feature4: 'Kostnadsuppföljning',
      feature5: 'Verkstadsbokning',
    },
    comingSoonKeymanagement: {
      feature1: 'Nyckelskåpsöversikt',
      feature2: 'In/ut-loggning',
      feature3: 'Behörighetshantering',
      feature4: 'Larmfunktioner',
      feature5: 'Integration med bokningssystem',
    },
    comingSoonWorkorder: {
      feature1: 'Skapa arbetsorder',
      feature2: 'Tilldela till förare/fordon',
      feature3: 'Statusuppföljning',
      feature4: 'Prioritering och deadline',
      feature5: 'Dokumentation och bilagor',
    },
    comingSoonAnalysis: {
      feature1: 'Statistisk översikt',
      feature2: 'Trendanalys över tid',
      feature3: 'Jämförelser mellan fordon',
      feature4: 'Exportera rapporter',
      feature5: 'Anpassade dashboards',
    },
  },

  // Vehicle attachments
  vehicleAttachments: {
    attachments: 'Bilagor',
    uploadButton: 'Ladda upp',
    category: 'Kategori',
    insurance: 'Försäkring',
    inspection: 'Besiktning',
    damage: 'Skada',
    invoice: 'Faktura',
    contract: 'Avtal',
    service: 'Service',
    other: 'Övrigt',
    addCategory: 'Lägg till egen kategori…',
    newCategoryPlaceholder: 'Namn på kategori',
    categoryCustomerHint: 'Syns bara för den här kunden.',
    categorySaveFailed: 'Kunde inte spara kategorin',
    edit: 'Redigera',
    description: 'Text',
    descriptionPlaceholder: 'Valfri text om bilagan',
    saveFailed: 'Kunde inte spara ändringen',
    clickToPreview: 'Klicka för förhandsgranskning',
    download: 'Ladda ner',
    deleteFile: 'Ta bort',
    preview: 'Förhandsgranskning',
    closePreview: 'Stäng',
  },

  // Eco settings
  ecoSettings: {
    couldNotSave: 'Kunde inte spara inställningar',
    confirmDelete: 'Är du säker på att du vill ta bort dessa organisationsspecifika inställningar?',
    couldNotDelete: 'Kunde inte ta bort inställningar',
    globalDefaults: 'Globala standardvärden',
    globalDefaultsOption: 'Globala standardvärden',
    hasOwnSettings: 'Har egna inställningar',
    usesGlobal: 'Använder globala',
    orgsWithOwnSettings: 'Organisationer med egna inställningar:',
    removeOrgSettings: 'Ta bort organisationsspecifika inställningar',
    hardAccelDescription: 'Tröskelvärden för att detektera hård acceleration...',
    defaultSpeedOverLimit: 'Standard: 10% över hastighetsgräns',
    smoothDrivingDescription: 'Tröskelvärden för att belöna ekonomisk och miljövänlig körning.',
    defaultSmoothAccel: 'Standard: 1.5 m/s\u00B2 för mjuk körning',
    defaultSmoothBrake: 'Standard: 2.0 m/s\u00B2 för mjuk bromsning',
    defaultMinSpeed: 'Standard: 10 km/h (stillastående räknas inte)',
    defaultIdleTime: 'Standard: 120 sekunder (2 minuter) sammanhängande',
  },

  // Geofences page
  geofencesPage: {
    exportToCsv: 'Exportera till CSV',
    clearSelection: 'Rensa val',
    noGeofences: 'Inga geofences skapade',
    hide: 'Dölj',
    show: 'Visa',
    editGeofence: 'Redigera',
    deleteGeofence: 'Ta bort',
    clickMapToAddPoints: 'Klicka på kartan för att lägga till punkter',
    minPointsRequired: 'Minst 3 punkter krävs för en polygon',
    globalAllOrgs: 'Global (alla organisationer)',
    specificOrg: 'Specifik organisation',
    selectOrg: 'Välj organisation',
    hideCoordinatesInArea: 'Dölj koordinater inom området',
    tollArea: 'Tullområde',
    defaultPricePlaceholder: 'Standardpris om ingen tidsregel matchar',
  },

  // Dashboard widgets
  widgets: {
    remove: 'Ta bort',
    addWidget: 'Lägg till widget',
    selectColumn: 'Välj kolumn:',
    available: 'Tillgänglig',
    lowBattery: 'Låg batterispänning',
    openVehicleCard: 'Öppna fordonskort',
    vehicleStatus: 'Fordonsstatus',
    vehicleStatusSubtitle: 'Fordon per status',
    noUsageStatus: 'Ingen status',
    noVehicles: 'Inga fordon',
    serviceDue: 'Förfallande service',
    overdue: 'förfallna',
    noServiceDue: 'Ingen service förfaller',
    servicePointsNeedAction: 'servicepunkter kräver åtgärd',
    overdueLabel: 'Förfallna',
    soonLabel: 'Snart',
    bookedLabel: 'Bokade',
    allBatteriesOk: 'Alla batterier OK',
    move: 'Flytta',
    alreadyAdded: 'Finns redan på dashboard',
    alreadyAddedHint: 'Stäng den här dialogen och titta på din dashboard — widgeten visas redan. Ta bort den under Redigera om du vill lägga till den i en annan kolumn.',
    sectionAvailable: 'Kan läggas till',
    sectionOnDashboard: 'Redan på din dashboard',
    notInPackage: 'Inte aktiverad för er organisation i Tjänster',
    comingSoon: 'Kommer snart',
    columns: {
      left: 'Vänster',
      center: 'Mitten',
      right: 'Höger',
    },
  },

  // Users management
  usersManagement: {
    title: 'Användarhantering',
    usersCount: 'användare',
    driversLicense: 'Körkort:',
    employeeId: 'Anställnings-ID:',
    costCenter: 'Kostnadsställe:',
    createUser: 'Skapa användare',
    editUser: 'Redigera användare',
    downloadTemplate: 'Ladda ner mall',
    importUsers: 'Importera användare',
    importTitle: 'Importera användare från Excel',
    importDescription: 'Ladda upp en ifylld Excel-mall för att skapa användare, förare och fordonstilldelningar i ett steg.',
    importSelectOrg: 'Välj organisation att importera till',
    importUploadLabel: 'Välj Excel-fil (.xlsx)',
    importUploadHint: 'Ladda ned mallen, fyll i och ladda upp här.',
    importPreviewTitle: 'Förhandsgranskning',
    importPreviewRows: 'rader hittades',
    importRun: 'Kör import',
    importRunning: 'Importerar...',
    importResultTitle: 'Importresultat',
    importResultSuccess: 'användare skapades',
    importResultFailed: 'rader misslyckades',
    importErrorsTitle: 'Misslyckade rader',
    importPasswordsTitle: 'Genererade lösenord',
    importPasswordsHint: 'Kopiera och dela dessa lösenord med respektive användare.',
    importPasswordsCopied: 'Kopierat!',
    importDone: 'Stäng',
    importNoFile: 'Välj en fil innan du fortsätter.',
    importNoOrg: 'Välj en organisation innan du fortsätter.',
    importVehicleNotFound: 'Regnummer hittades inte',
    sendWelcomeEmail: 'Skicka välkomstmail med lösenordsåterställning',
    sendWelcomeEmailDesc: 'Användaren får ett mail med en länk för att aktivera sitt konto och välja ett eget lösenord. Länken är giltig i 72 timmar.',
    sendWelcomeEmailSent: 'Välkomstmail skickat',
    sendWelcomeEmailSentTo: 'Välkomstmail skickat till {{email}}',
    sendWelcomeEmailButton: 'Skicka välkomstmail',
    sendWelcomeEmailSending: 'Skickar...',
    sendWelcomeEmailError: 'Kunde inte skicka välkomstmail',
    sendWelcomeEmailBulk: 'Skicka välkomstmail till listan',
    sendWelcomeEmailBulkHint: 'Skickar välkomstmail med aktiveringslänk till alla användare i listan. Användare utan e-post, SSO-inloggning eller inaktiva/låsta hoppas över.',
    sendWelcomeEmailBulkConfirm: 'Skicka välkomstmail med aktiveringslänk till {{count}} användare i listan?',
    sendWelcomeEmailBulkDone: 'Välkomstmail skickat till {{sent}} användare',
    sendWelcomeEmailBulkPartial: '{{skipped}} hoppades över, {{failed}} misslyckades',
    sendWelcomeEmailBulkNone: 'Det finns inga användare i listan att skicka till',
    welcomeSkipNoEmail: 'saknar e-post',
    welcomeSkipSso: 'SSO-inloggning',
    welcomeSkipInactive: 'inaktiv/låst',
    welcomeSkipNotFound: 'hittades inte',
    notVerified: 'Ej verifierad',
    neverLoggedIn: 'Aldrig inloggad',
    noPassword: 'Inget lösenord',
    lastLoginAt: 'Senaste inloggning: {{date}}',
    searchPlaceholder: 'Sök namn, e-post eller regnr...',
    department: 'Avdelning',
    editUserTitle: 'Redigera',
    deleteUserTitle: 'Ta bort',
    hardDeleteButton: 'Radera helt',
    hardDeleteTitle: 'Radera användare helt (SSO-test)',
    hardDeleteConfirm: 'Detta tar bort {{name}} ({{email}}) helt från systemet så att SSO kan skapa kontot på nytt. Kan inte ångras.',
    emailRequiredForWelcome: 'E-post krävs för att skicka välkomstmail.',
    downloadTemplateError: 'Kunde inte ladda ner mallen',
    driverInformation: 'Förarinformation',
    connectedVehicle: 'Kopplat fordon: {{reg}}',
  },

  // User form fields
  userFormFields: {
    password: 'Lösenord',
    twoFactorAuth: 'Tvåfaktorsautentisering',
    selectOrg: 'Välj organisation...',
    selectOrgForRoles: 'Välj organisation först',
    noRolesForOrg: 'Inga roller för denna organisation',
    rolesFromOrganization: 'Visar roller från organisationens toppnod.',
    keepCurrentPassword: 'Lämna tomt för att behålla nuvarande',
    mobileLoginOptional: 'Valfritt - för inloggning i mobilapp',
    driverInfo: 'Förarinfo',
    tabSchedule: 'Schema',
    tabVehicle: 'Fordon',
    tabHistory: 'Historik',
    driverDraftHint: 'Schemat och fordonet sparas när du klickar Skapa användare – du behöver inte spara användaren först.',
    vehicleDraftSaved: 'Tilldelning sparad i utkast – skapas tillsammans med användaren.',
    isAlsoDriver: 'Är också Driver',
    ongoing: ' — pågående',
    globalAdminRolesHint:
      'Vissa interna roller (t.ex. Deviaq Ledning) kan endast tilldelas av global admin.',
    roleViewer: 'Viewer',
    roleDriver: 'Driver',
    roleAdmin: 'Admin',
  },

  // Role permissions
  rolePermissions: {
    selectFunctions: 'Välj vilka funktioner som ska vara tillgängliga',
    moduleNotEnabled: 'Modulen är inte aktiverad',
    selectModuleLeft: 'Välj en modul till vänster för att se funktioner',
  },

  // Data table
  dataTable: {
    searchPlaceholder: 'Sök...',
    filterPlaceholder: 'Filtrera…',
  },

  // Customer detail
  customerDetail: {
    privateCompany: 'Privat företag',
    companyName: 'Företagsnamn: ',
    employees: 'Anställda: ',
    yearsInBusiness: 'Verksamhetsår: ',
    perBrand: 'Per märke',
    perFuelType: 'Per bränsletyp',
    usersLabel: 'Användare',
    keyCabinet: 'Nyckelskåp',
    devices: 'Enheter (GPS)',
    flinkeyBoxes: 'Flinkey-boxar',
    registeredCables: 'Kablar (registrerat)',
    devicesPerType: 'Enheter per typ',
    firstName: 'Förnamn',
    primaryContact: 'Primär kontakt',
  },

  // Customer wizard
  customerWizard: {
    namePlaceholder: 'T.ex. Linköpings kommun',
    privateCompany: 'Privat företag',
    cityPlaceholder: 'Linköping',
    fixedMonthly: 'Fast månadsavgift',
    perUser: 'Per användare',
    otherInfoPlaceholder: 'Övrig information...',
  },

  // Customer packages
  customerPackages: {
    allPackagesSelected: 'Alla tillgängliga paket är valda',
  },

  // Customer API config
  customerApiConfig: {
    lastUsed: 'Senast använd:',
    noEndpoints: 'Inga endpoints tillgängliga',
  },

  // Customer federation config
  customerFederationConfig: {
    autoGenerate: 'Lämna tomt för automatisk generering baserat på organisation-ID.',
    redirectUri: 'Redirect URI (för IdP-konfiguration)',
    clientAuthMethod: 'Klientautentisering',
    certificate: 'Certifikat (private_key_jwt)',
    certHelp: 'Vi (klienten) håller den privata nyckeln. Det publika certifikatet laddas upp i Entra (Certificates & secrets → Certificates). Fälten accepterar inline PEM eller en filsökväg på servern (rekommenderat: fil med 0600).',
    certificatePem: 'Publikt certifikat (PEM eller filsökväg)',
    privateKeyPem: 'Privat nyckel (PEM eller filsökväg)',
    privateKeyHint: 'Lagras hemligt hos oss och returneras aldrig av API:et. Använd helst en filsökväg på servern.',
    defaultRole: 'Standardroll för nya SSO-användare',
    defaultRoleFallback: 'Standard (User / VIEWER)',
    defaultRoleHelp: 'Roll som tilldelas automatiskt när en ny användare loggar in via SSO. Befintliga konton behåller sin roll.',
    claimMapping: 'Claim-mappning',
    claimMappingHelp: 'Ange claim-namnen som IdP:n skickar. Lämna tomt för att använda standardnamn (email, given_name, family_name, rsid, phone_number).',
    claimRsid: 'RSID',
    claimEmail: 'E-post',
    claimFirstName: 'Förnamn',
    claimLastName: 'Efternamn',
    claimPhone: 'Telefon',
    mustActivate: 'Kunden måste aktiveras för att kunna konfigurera federation.',
    mustActivateSso: 'Aktivera kunden för att skapa en organisation och sedan konfigurera SSO.',
    configured: 'Konfigurerad men inaktiv',
    notConfigured: 'Ej konfigurerad',
    enabled: 'Aktiverad',
    activateSaml: 'Aktivera SAML 2.0',
    activateOidc: 'Aktivera OpenID Connect',
    activateAdSync: 'Aktivera AD-användarsynkronisering',
    updateSaml: 'Uppdatera SAML',
    saveSaml: 'Spara SAML',
    updateOidc: 'Uppdatera OIDC',
    saveOidc: 'Spara OIDC',
    update: 'Uppdatera',
    save: 'Spara',
    delete: 'Ta bort',
    adSyncTab: 'AD-användarsynk',
    adSyncTitle: 'Vad kunden behöver tillhandahålla (Entra ID)',
    adSyncStep1: 'Steg 1 – App-registrering i Entra ID',
    adSyncStep2: 'Steg 2 – API-behörigheter (kräver Global Admin)',
    adSyncStep3: 'Steg 3 – Client Secret',
    adSyncSyncMode: 'Synkläge',
    adSyncModeManual: 'Manuell (via knapp)',
    adSyncModeNightly: 'Automatisk varje natt',
    adSyncLastSync: 'Senaste synkronisering',
    adSyncNone: 'Ingen synk utförd ännu',
    adSyncSyncChanges: 'Synka ändringar',
    adSyncSyncAll: 'Synka alla',
    adSyncFullSync: 'Fullsynk',
    adSyncTestConnection: 'Testa anslutning (förhandsgranska)',
    adSyncLogTitle: 'Senaste synkroniseringar',
    adSyncPreviewOk: 'Anslutning OK – ~{{count}} användare i AD ({{disabled}} inaktiverade)',
    adSyncPreviewMore: 'Visar 10 av {{count}} hämtade (förhandsvisning)',
    adSyncIncremental: '(inkrementell)',
    adSyncFull: '(full)',
    adSyncFetched: 'hämtade',
    adSyncCreated: 'nya',
    adSyncUpdated: 'uppdaterade',
    adSyncDeactivated: 'inaktiverade',
    copyUrl: 'Kopiera URL',
    copyUrlShort: 'Kopiera',
    giveUrlToIt: 'Ge denna URL till kundens IT-avdelning för att konfigurera deras IdP.',
    tableColName: 'Namn',
    tableColEmail: 'E-post',
    tableColDepartment: 'Avdelning',
    tableColStatus: 'Status',
    userActive: 'Aktiv',
    userInactive: 'Inaktiv',
  },

  // Customer SMS config
  customerSmsConfig: {
    enableSmsService: 'Aktivera SMS-tjänst',
    useCases: 'Användningsområden:',
    title: 'SMS-konfiguration',
    subtitle: 'Konfigurera SMS-utskick för notifieringar och larm',
    statusActive: 'Aktiv',
    statusInactive: 'Inaktiv',
    provider: 'SMS-leverantör',
    senderId: 'Avsändar-ID (max 11 tecken)',
    apiKey: 'API-nyckel',
    apiKeyUnchanged: '(oförändrad)',
    apiKeyPlaceholder: 'Ange API-nyckel',
    apiKeyConfigured: 'En API-nyckel är redan konfigurerad. Lämna fältet tomt för att behålla den.',
    apiUrl: 'API-URL (valfritt)',
    apiUrlPlaceholder: 'Lämna tomt för standard-URL',
    saveSettings: 'Spara inställningar',
    saving: 'Sparar...',
    saveSuccess: 'SMS-inställningar sparade',
    saveError: 'Kunde inte spara SMS-inställningar',
    testSection: 'Testa SMS-konfiguration',
    testPhonePlaceholder: '07XXXXXXXX eller +46...',
    testSend: 'Skicka test',
    testSending: 'Skickar...',
    testSuccess: 'Test-SMS skickat!',
    testFailed: 'Test misslyckades',
    testError: 'Kunde inte skicka test-SMS',
    noOrgId: 'Organisationen saknar organisation_id',
    noPhoneNumber: 'Ange ett telefonnummer för test',
    noOrgActivated: 'Denna kund har ingen kopplad organisation. Aktivera organisationen först.',
    useCaseGeofence: 'Geofence-larm till förare',
    useCaseVehicleEvents: 'Notifieringar vid fordonshändelser',
    useCaseService: 'Påminnelser om service och besiktning',
    providerNone: 'Ingen (inaktiverad)',
  },

  // System packages manager
  systemPackagesManager: {
    featuresPlaceholder: 'Telefonsupport\nSLA 99.9%\nAPI-tillgång',
  },

  // Imports management
  importsManagement: {
    namePlaceholder: 'T.ex. Fordonsimport från Excel',
    selectTable: 'Välj tabell...',
    firstRowIsHeader: 'Första raden är rubrik',
    dragFileHere: 'Dra fil hit eller klicka för att välja',
    skipKeepExisting: 'Hoppa över (behåll befintlig)',
    replaceRow: 'REPLACE (ersätt rad)',
    runImport: 'Kör import',
    filesFromSource: 'Filer från källa',
    runImportFromFtp: 'Kör import från FTP',
  },

  // Trip validation
  tripValidation: {
    needsReview: 'Kräver granskning',
    manage: 'Hantera',
    resolve: 'Lös',
    deleteReasonPlaceholder: 'Beskriv varför denna trip tas bort (minst 5 tecken)...',
    minCharsRequired: 'Minst 5 tecken krävs',
  },

  // System monitor
  systemMonitor: {
    title: 'Systemövervakning',
    queue: 'Kö',
    queueLength: 'Kölängd',
    serverNumbers: 'Siffror från servern:',
    running: 'Kör',
    runNow: 'Kör nu',
    latestRuns: 'Senaste körningar',
    speedLimitBackfill: 'Hastighetsgräns-backfill',
    speedLimitQueue: 'Kö (trip_speed_limit_backfill)',
    speedLimitConsumers: 'Consumers',
    speedLimitDlq: 'DLQ-meddelanden',
    speedLimitRate: 'Trippar/min (snitt 5 min)',
    speedLimitProcessedTotal: 'Bearbetade totalt',
    speedLimitWorkers: 'Workers online',
    speedLimitAlerts: 'Varningar',
    noAlerts: 'Inga varningar',
    importSources: {
      title: 'Importkällor (mottagning)',
      total: 'Källor',
      active: 'Aktiva',
      failed: 'Fel',
      pendingFiles: 'Filer i kataloger',
      none: 'Inga importkällor konfigurerade',
      name: 'Namn',
      type: 'Typ',
      lastFetch: 'Senaste hämtning',
      filesInDir: 'Filer i katalog',
      newestFile: 'Senaste fil',
      inactive: 'Inaktiv',
      never: 'Aldrig',
      dirMissing: 'Katalogen saknas/oläsbar',
    },
  },

  // Data replay
  dataReplay: {
    clearAllDescription: 'Töm all tripp-/GPS-/eco-/stats-data och köer. Fordon och enheter behålls.',
    searchPlaceholder: 'Sök IMEI eller regnummer...',
    verifyDataStatus: 'Verifiera data-status',
    fullReset: 'Full reset',
    replayAllFiles: 'Replay alla filer (Dev)',
    fullResetInProgress: 'Full reset pågår... Detta kan ta flera minuter. Vänta.',
    allDbEmpty: 'Alla databaser tomma (full reset verifierad)',
    someTablesHaveData: 'Vissa tabeller/kollektioner innehåller fortfarande data',
    startReplay: 'Starta Replay',
    startReplaySection: 'Starta Replay',
    fromDate: 'Från datum',
    toDate: 'Till datum',
    organization: 'Organisation',
    vehicleImei: 'Fordon (IMEI)',
    selectOrgFirst: 'Välj organisation först',
    allVehiclesInOrg: 'Alla fordon i organisationen',
    allVehiclesInOrgHint: 'Tomt IMEI — alla enheter i org (enligt databas-scope)',
    noVehiclesFound: 'Inga fordon i listan för detta datumspann (eller inget som matchar sökningen)',
    replayNote: 'OBS: Replay rensar först befintlig data för vald organisation och datumintervall. Med valt fordon (IMEI) används batch-replay som bygger och sparar trippar direkt (rekommenderat). Utan valt IMEI köas paket via workers för alla enheter i org-scope.',
    availableDates: 'Tillgängliga Datum',
    noBinFiles: 'Inga bin-filer hittades',
    clickDateHint: 'Klicka på ett datum för att sätta Från/Till. Du kan också skriva valfritt datum i fälten ovan (listan visar max 90 dagar).',
    files: 'filer',
    showingDates: 'Visar 90 av {{total}} datum. Använd Från/Till-fälten för äldre datum.',
    replayJobs: 'Replay-jobb',
    noActiveJobs: 'Inga aktiva jobb',
    orgLabel: 'Org {{id}}',
    allDevicesInOrg: 'alla enheter i org',
    allVehiclesGlobal: 'Alla fordon (global)',
    filesProgress: '{{processed}}/{{total}} filer',
    tripsDeleted: '{{count}} trips raderade',
    queued: '{{count}} köade',
    stopReplay: 'Stoppa replay',
    stepLog: 'Steg-logg:',
    selectOrgPlaceholder: 'Välj organisation…',
  },

  // Speed compliance report
  speedComplianceReport: {
    selectOrgAndDateRange: 'Välj organisation och datumintervall',
    violationPercent: 'Överträdelse (%)',
    violations: 'Överträdelser',
    timeOverLimit: 'Tid över gräns',
    segmentsHint: 'Visar mätpunkter per hastighetsgräns (NVDB, annars OSM-skylt). Högsta vid överträdelse är den högsta GPS-hastigheten när fordonet körde mer än 10 % över gränsen. Enstaka sekunder där positionen träffar en sidoväg räknas inte. Bara GPS-spikar över 250 km/h filtreras bort.',
  },

  // Vehicle wear report
  vehicleWearReport: {
    wearScore: 'Slitagepoäng',
    wear: 'Slitage',
    noVehicleData: 'Inga fordonsdata',
  },

  // CO2 report
  co2Report: {
    noVehicleData: 'Inga fordonsdata',
  },

  // Odometer report
  odometerReport: {
    searchPlaceholder: 'Sök regnr, märke...',
  },

  // Driving log
  drivingLog: {
    searchVehiclePlaceholder: 'Sök eller välj fordon...',
  },

  // Rental report
  rentalReport: {
    recipientNamePlaceholder: 'Namn på mottagare',
  },

  // Geofence events
  geofenceEvents: {
    searchVehiclePlaceholder: 'Sök fordon...',
  },

  // Signup
  signup: {
    title: 'Skapa DQFleet-konto',
    subtitle: 'Efter registrering måste du bekräfta din e-postadress innan du kan logga in.',
    firstNameLabel: 'Förnamn',
    lastNameLabel: 'Efternamn',
    emailLabel: 'E-post',
    passwordLabel: 'Lösenord',
    confirmPasswordLabel: 'Bekräfta lösenord',
    firstNamePlaceholder: 'Förnamn',
    lastNamePlaceholder: 'Efternamn',
    emailPlaceholder: 'din@foretag.se',
    passwordPlaceholder: 'Minst 8 tecken',
    confirmPasswordPlaceholder: 'Bekräfta lösenord',
    passwordRulesHint:
      'Minst 8 tecken, stor bokstav, liten bokstav, siffra och specialtecken (samma krav som vid manuellt skapade konton).',
    infoBoxTitle: 'Organisation och åtkomst',
    infoBoxBody:
      'Använd helst din jobbmail. Om er organisation har registrerat er e-postdomän kopplas du automatiskt till dem med rollen Viewer efter verifiering.',
    infoBoxManual:
      'Om domänen inte är registrerad får du ett konto som en administratör kan koppla till rätt organisation i efterhand.',
    tosPrefix: 'Jag accepterar',
    tosTerms: 'användarvillkoren',
    tosAnd: 'och',
    tosPrivacy: 'integritetspolicyn',
    submit: 'Skapa konto',
    creating: 'Skapar konto...',
    hasAccount: 'Har du redan ett konto?',
    loginLink: 'Logga in',
    toastSuccessOrgLinked:
      'Konto skapat. Din domän är kopplad till en organisation — verifiera din e-post för att aktivera kontot.',
    toastSuccessManual:
      'Konto skapat. Verifiera din e-post. Om din organisation inte känner igen din domän kan en administratör behöva koppla ditt konto.',
    createError: 'Kunde inte skapa konto. Försök igen.',
  },

  // Packages management
  packagesManagement: {
    unlimitedPlaceholder: 'Obegränsat',
    phoneSupportPlaceholder: 'Telefonsupport...',
  },

  // Service overview
  serviceOverview: {
    statusOverdue: 'Förfallen',
    statusDueSoon: 'Förfaller snart',
    statusCompleted: 'Utförd',
    allStatuses: 'Alla statusar',
    overdueFilter: 'Förfallna',
    dueSoonFilter: 'Förfaller snart',
    bookedFilter: 'Bokade',
    nextKm: 'Nästa km',
  },

  // Device assign modal
  deviceAssignModal: {
    title: 'Tilldela IMEI till organisation',
    pasteImeiAndSelectOrg: 'Ladda upp .xlsx eller klistra in IMEI och välj organisation',
    assignmentComplete: 'Tilldelning klar',
    devicesAssigned: 'enheter tilldelade',
    assigned: 'Tilldelade',
    skippedMounted: 'Hoppade över (monterade)',
    notFound: 'Ej hittade',
    invalidFormat: 'Ogiltigt format',
    notFoundImeis: 'Ej hittade IMEI:',
    errors: 'Fel:',
    selectOrg: 'Välj organisation...',
    imeiLabel: 'IMEI-nummer (klistra in, ett per rad, komma- eller semikolonseparerade)',
    pasteImeiHere: 'Klistra in IMEI här...',
    validateImei: 'Validera IMEI',
    validImeiFound: '{count} giltiga IMEI-nummer hittade',
    clear: 'Rensa',
    assignDevices: 'Tilldela {count} enheter',
    xlsxSection: 'Excel-import (.xlsx)',
    xlsxHint: 'Klicka för att välja fil — kolumn A = IMEI, cell B2 = antal kablar',
    xlsxOnly: 'Endast .xlsx-filer stöds.',
    xlsxNoImei: 'Inga giltiga IMEI hittades i kolumn A.',
    xlsxReadError: 'Kunde inte läsa filen.',
    xlsxImeiNote: 'Tips: formatera IMEI som text i Excel så att siffrorna inte avrundas.',
    orPaste: 'eller',
    cablesFromFile: 'Kablar från fil (B2): {n} (sparas på CRM-kund vid tilldelning)',
  },

  // Common UI
  commonUi: {
    closeModal: 'Stäng',
    previousMonth: 'Föregående månad',
    nextMonth: 'Nästa månad',
    noLanguages: 'Inga språk tillgängliga',
    noRouteData: 'Ingen rutt-data tillgänglig',
    highPriority: 'Hög',
  },

  // Customer devices tab
  customerDevicesTab: {
    inVehicle: 'I fordon',
    customerStock: 'Kundlager',
    centralStock: 'Centrallager',
    allOrganizations: 'Alla organisationer',
    deviceCount: 'enheter',
  },

  // Vehicle list widget
  vehicleListWidget: {
    totalVehicles: 'Fordon totalt',
  },

  // Inspection widget
  inspectionWidget: {
    title: 'Besiktningar',
    titleWithDays: 'Besiktning inom 40d',
    noVehicles: 'Inga fordon',
    overdue: 'förfallna',
    daysAgo: '{days}d sedan',
    today: 'Idag',
  },

  leasingWidget: {
    title: 'Leasing',
    titleWithMonths: 'Leasing inom {months} mån',
    noVehicles: 'Inga leasingavtal som löper ut snart',
    overdue: 'förfallna',
    daysAgo: '{days}d sedan',
    today: 'Idag',
    openCase: 'Öppna ärende',
    toModule: 'Till införskaffning',
  },

  procurement: {
    title: 'Införskaffning och avveckling',
    cardDescription: 'Beslut om att ersätta eller avveckla fordon när leasing närmar sig slut',
    tabCases: 'Ärenden',
    tabSettings: 'Inställningar',
    newCase: 'Nytt ärende',
    newCaseHelp: 'Välj fordon först. Ärende sparas först när du klickar Spara.',
    selectVehicle: 'Välj fordon i toppnoden',
    selectVehiclePlaceholder: 'Sök registreringsnummer, märke eller modell',
    noVehiclesFound: 'Inga fordon matchade sökningen',
    vehicleSearchError: 'Kunde inte söka fordon',
    vehicleLoadError: 'Kunde inte hämta fordonsuppgifter',
    business: 'Verksamhet',
    unknownBusiness: 'Ingen verksamhet angiven',
    organization: 'Organisation',
    makeModel: 'Märke, modell och årsmodell',
    currentStatus: 'Nuvarande status',
    vehicleType: 'Fordonstyp',
    poolCar: 'Poolbil',
    alreadyOpenCase: 'Det finns redan ett öppet ärende för detta fordon.',
    openExisting: 'Öppna befintligt ärende',
    existingCaseOpened: 'Öppnade befintligt ärende',
    caseCreated: 'Ärendet sparades',
    firstDecisionHint:
      'Nytjandet nedan är underlaget för första beslutet: ersätta eller avveckla fordonet.',
    utilizationWindow: 'Analys mot de senaste {months} månaderna, beräknad på tillgänglig kördata.',
    insufficientHistory:
      'Vi har mindre än 12 månaders kördata ({months} mån). Beräkningen är gjord på den data som finns.',
    poolUtilization: 'Nytjandegrad poolbil',
    poolOccupancy: '{pct} % beläggning ({booked} bokade timmar av {capacity} möjliga).',
    poolUtilizationMissing: 'Ingen bokningsdata att beräkna beläggning på.',
    noCases: 'Inga ärenden',
    noVehicle: 'Utan fordon',
    loadError: 'Kunde inte ladda ärenden',
    createError: 'Kunde inte skapa ärende',
    saveError: 'Kunde inte spara',
    refreshError: 'Kunde inte uppdatera underlaget',
    uploadError: 'Kunde inte ladda upp filen',
    settingsLoadError: 'Kunde inte ladda inställningar',
    settingsSaveError: 'Kunde inte spara inställningar',
    settingsSaved: 'Inställningar sparade',
    colTitle: 'Ärende',
    colVehicle: 'Fordon',
    colOrg: 'Organisation',
    colStatus: 'Status',
    colOutcome: 'Utfall',
    colStep: 'Steg',
    colRentEnd: 'Leasing slut',
    statusOpen: 'Öppna',
    statusDraft: 'Utkast',
    statusInProgress: 'Pågående',
    statusCompleted: 'Avslutade',
    statusCancelled: 'Avbrutna',
    status_draft: 'Utkast',
    status_in_progress: 'Pågående',
    status_completed: 'Avslutat',
    status_cancelled: 'Avbrutet',
    outcome_undecided: 'Ej beslutat',
    outcome_replace: 'Ersätt',
    outcome_decommission: 'Avveckla',
    decisionModel: 'Beslutsmodell',
    decisionAuthority: 'Vem beslutar',
    authorityFleet: 'Fleetmanager',
    authorityOperations: 'Verksamheten',
    utilizationMonths: 'Nytjandeperiod (månader)',
    utilizationMonthsHelp: 'Standard 36. Går att ändra per kund (1–60).',
    steps: 'Steg',
    processTitle: 'Kundens process',
    processHelp:
      'Stegen gäller toppnoden och kopieras in i varje nytt ärende. Befintliga ärenden behåller den process de skapades med. Bocka i Använd för de steg som ska följa med när ett ärende skapas.',
    stepOrder: 'Ordning',
    stepName: 'Stegnamn',
    stepNamePlaceholder: 'Till exempel Offert från leverantör',
    stepApplies: 'Gäller',
    stepUse: 'Använd',
    stepRequired: 'Obligatoriskt',
    stepAttachment: 'Bilaga',
    addStep: 'Lägg till steg',
    moveUp: 'Flytta upp',
    moveDown: 'Flytta ner',
    noProcessSteps: 'Inga steg ännu. Lägg till de steg som gäller för denna kund.',
    stepNameRequired: 'Alla steg måste ha ett namn',
    processNeedsStep: 'Minst ett steg måste vara ikryssat som Använd',
    grounds: 'Beslutsgrunder',
    applies_always: 'Alltid',
    applies_replace: 'Ersätt',
    applies_decommission: 'Avveckla',
    applies_both: 'Båda',
    utilization: 'Nytjandeunderlag',
    refreshUtilization: 'Uppdatera underlag',
    kpiDistance: 'Körsträcka',
    kpiTrips: 'Resor',
    kpiDaysDriven: 'Dagar körda',
    kpiScore: 'Nytjandescore',
    recommend: 'Fleetmanager-rekommendation',
    fleetStatement: 'Utlåtande från Fleetmanager',
    saveRecommend: 'Spara rekommendation',
    recommendSaved: 'Rekommendation sparad',
    decide: 'Formellt beslut',
    operationsStatement: 'Utlåtande från verksamheten',
    justification: 'Motivering',
    saveDecision: 'Fatta beslut',
    decisionSaved: 'Beslut sparat',
    markDone: 'Klar',
    attach: 'Bifoga',
    proposals: 'Ersättningsförslag',
    proposalTitle: 'Förslagets titel',
    addProposal: 'Lägg till förslag',
    documents: 'Dokument',
    complete: 'Avsluta ärende',
    cancel: 'Avbryt ärende',
    step_pending: 'Väntar',
    step_done: 'Klar',
    step_skipped: 'Hoppad',
  },

  taxWidget: {
    title: 'Fordonsskatt',
    titleWithDays: 'Skatt inom 45d',
    noVehicles: 'Inga fordon med skatt inom 45 dagar',
    overdue: 'förfallna',
    daysAgo: '{days}d sedan',
    today: 'Idag',
  },

  // Unplugged widget
  unpluggedWidget: {
    title: 'Urkopplade',
    subtitle: 'Urkopplade',
    warning: 'Varning',
    allConnected: 'Alla enheter anslutna',
  },

  gpsLagWidget: {
    title: 'GPS släpar efter',
    subtitle: 'Bin mottagen vs data skapad i enhet (>1 h)',
    noVehicles: 'Inga fordon med fördröjd GPS-data',
    dumpQueue: 'i dump-kö',
    dumpLagLabel: 'Diff mottagning−enhet',
    showDumpOnly: 'Visa bara dump-kö',
    showAllStale: 'Visa alla stale',
    kind: {
      dumping_lag: 'Dump-kö',
      silent: 'Tyst',
      parked_or_old: 'Parkerad',
      lost_while_driving: 'Körde — tappad',
    },
  },

  unplugEvents: {
    title: 'Urkopplingshistorik',
    subtitle: 'In- och urkoppling av GPS-enhet med tid och närmaste position.',
    backToDashboard: 'Tillbaka till dashboard',
    openHistory: 'Visa historik för in- och urkoppling',
    eventType: 'Händelse',
    allTypes: 'Alla',
    unplugged: 'Urkopplad',
    plugged: 'Inkopplad',
    occurredAt: 'Tid',
    address: 'Position',
    email: 'Mejl',
    emailSent: 'Skickat',
    emailNotSent: 'Ej skickat',
    searchPlaceholder: 'Sök regnummer',
    registrationNumber: 'Regnummer',
    empty: 'Inga händelser i vald period.',
    showing: 'Visar {{from}}–{{to}} av {{total}}',
    pageOf: 'Sida {{page}} av {{pages}}',
    loadError: 'Kunde inte hämta urkopplingshistorik.',
    mapSource: 'Närmaste GPS-punkt',
  },

  // App (routes)
  appRoutes: {
    salesPipeline: 'Säljpipeline',
    salesPipelineDesc: 'Försäljningstratt och leads',
    economicOverview: 'Ekonomisk översikt',
    economicOverviewDesc: 'Rullande 12, trender och intäkter',
  },

  // Device import modal
  deviceImportModal: {
    pasteImeiAndSelectOrg: 'Klistra in IMEI-nummer och välj organisation',
  },

  // Tire management
  tireManagement: {
    partnerPlaceholder: 'Däckpartner Sundsvall',
  },

  // Company Search (Checkbiz)
  companySearch: {
    title: 'Sök företag',
    lookupButton: 'Sök företag',
    whoLabel: 'Företagsnamn / telefon',
    whoPlaceholder: 'T.ex. Volvo eller 08-123',
    whereLabel: 'Ort (valfritt)',
    wherePlaceholder: 'T.ex. Stockholm',
    search: 'Sök',
    searching: 'Söker...',
    minChars: 'Ange minst 2 tecken',
    searchError: 'Kunde inte söka företag',
    noResults: 'Inga företag hittades. Försök med ett annat sökord.',
    startSearching: 'Sök på företagsnamn, telefonnummer eller adress.',
    resultsCount: '{{count}} träffar',
    showingOfTotal: 'Visar {{showing}} av {{total}} träffar',
    refineSearch: 'Förfina sökningen för fler resultat',
    wildcardHint: 'Wildcard (*) läggs till automatiskt. Använd ? för enskilt tecken.',
    page: 'Sida',
  },

  // Pool Car Demo (Region Skåne)
  poolcarDemo: {
    myBookings: 'Mina bokningar',
    bookingDetails: 'Bokningsdetaljer',
    digitalKey: 'Digital nyckel',
    returnVehicle: 'Återlämna fordon',
    receipt: 'Kvittens',
    noBookings: 'Inga bokningar',
    noBookingsHint: 'Du har inga kommande bokningar just nu.',
    upcoming: 'Kommande bokningar',
    active: 'Aktiv',
    vehicle: 'Fordon',
    pool: 'Pool',
    period: 'Period',
    destination: 'Destination',
    licenseConfirm: 'Jag intygar att jag har giltigt körkort och är i skick att framföra fordonet.',
    startsIn: 'Bokningen börjar om',
    checkoutVehicle: 'Hämta ut fordon',
    vehicleUnlocked: 'Bilen är olåst',
    vehicleLocked: 'Bilen är låst',
    communicating: 'Kommunicerar...',
    bookingEnded: 'Bokningen avslutad',
    cannotUnlock: 'Bilen kan inte öppnas efter avslutad bokning.',
    tapToToggle: 'Tryck för att låsa/låsa upp',
    bookingTime: 'Bokningstid',
    returnTitle: 'Återlämning',
    checkParked: 'Bilen är parkerad på rätt plats',
    checkLocked: 'Bilen är låst',
    reportDamage: 'Anmäl skada eller avvikelse',
    damageDescription: 'Beskriv skadan...',
    confirmReturn: 'Bekräfta återlämning',
    thankYou: 'Tack!',
    vehicleReturned: 'Fordonet är återlämnat och registrerat.',
    backToBookings: 'Tillbaka till bokningar',
    demoTitle: 'Nyckelfri bilpool – Demo',
    demoDescription: 'Demonstrationen visar hela användarflödet för en medarbetare som vill nyttja en poolbil, inklusive bokning, uthämtning, digital nyckellösning och återlämning.',
    step1: 'Välj bokning',
    step2: 'Hämta ut fordon',
    step3: 'Lås upp / Lås (Digital nyckel)',
    step4: 'Återlämning',
    step5: 'Kvittens',
  },

  tidbok: {
    title: 'Digital Tidbok',
    subtitle: 'Kör- och vilotider enligt EU 561/2006 och TSFS 2013:3',
    registerActivity: 'Registrera aktivitet',
    selectDriver: 'Förare',
    selectDriverPlaceholder: 'Välj förare...',
    searchDriverPlaceholder: 'Sök förare (namn eller förarkortsnummer)…',
    selectDriverToStart: 'Välj en förare för att visa tidboken',
    driverCard: 'Förarkort',
    previousWeek: 'Föregående',
    nextWeek: 'Nästa',
    weekLabel: 'Vecka {{week}}, {{year}}',
    noActivities: 'Inga aktiviteter registrerade denna vecka',
    registerFirstActivity: 'Registrera första aktivitet',
    activitySaved: 'Aktivitet sparad',
    errorLoadingDrivers: 'Kunde inte hämta förare',
    errorLoadingVehicles: 'Kunde inte hämta fordon',
    errorLoadingEntries: 'Kunde inte hämta tidbok-poster',
    errorSaving: 'Kunde inte spara aktiviteten',
    weekDriving: 'Körtid vecka',
    weekWork: 'Arbetstid vecka',
    weekRest: 'Vila vecka',
    driving: 'Körtid',
    continuous: 'Kontinuerlig',
    activityType: 'Aktivitetstyp',
    vehicle: 'Fordon',
    selectVehiclePlaceholder: 'Välj fordon...',
    date: 'Datum',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    noteOptional: 'Anteckning (valfritt)',
    notePlaceholder: 't.ex. Stockholm → Göteborg',
    saving: 'Sparar...',
    saveActivity: 'Spara aktivitet',
    rulesTitle: 'Regelverk – gällande gränsvärden',
    activity: {
      driving: 'Körtid',
      otherWork: 'Annat arbete',
      available: 'Disponibel',
      rest: 'Vila',
    },
    rule: {
      maxDailyDriving: 'Max körtid per dygn',
      maxContinuousDriving: 'Max kontinuerlig körtid',
      mandatoryBreak: 'Obligatorisk rast',
      minDailyRest: 'Min dygnsvila',
      maxWeeklyDriving: 'Max körtid per vecka',
      maxBiweeklyDriving: 'Max körtid per 2 veckor',
    },
    validation: {
      selectVehicle: 'Välj ett fordon',
      enterDate: 'Ange datum',
      enterStartTime: 'Ange starttid',
      enterEndTime: 'Ange sluttid',
      endAfterStart: 'Sluttid måste vara efter starttid',
    },
  },
  keyManagement: {
    title: 'Nyckelhantering',
    tabs: {
      cabinets: 'Skåp',
      keys: 'Nycklar',
      cabinetSync: 'Skåpsynk',
    },
    cabinetSync: {
      title: 'Skåpsynk (Creone Rabbit)',
      subtitle: 'Vad KeyWin skickar till varje skåp. Bara global admin. PIN och persondata är maskade.',
      spyConnected: 'Observatör ansluten',
      spyDisconnected: 'Observatör frånkopplad',
      traceOn: 'Firehose på',
      traceOff: 'Firehose av',
      eventsLastMinute: 'Händelser / min',
      eventsLastHour: 'Händelser / timme',
      bytesLastHour: 'Bytes / timme',
      storedEvents: 'Sparade händelser',
      queues: 'Köer',
      events: 'Händelser',
      queue: 'Kö',
      kind: 'Typ',
      backlog: 'Backlog',
      consumers: 'Consumers',
      publishRate: 'Publish / s',
      deliverRate: 'Deliver / s',
      online: 'Skåp uppe',
      offline: 'Skåp nere',
      time: 'Tid',
      type: 'Typ',
      size: 'Storlek',
      summary: 'Innehåll',
      payload: 'Payload',
      noEvents: 'Inga meddelanden fångade ännu. Gör en bokning eller vänta på nästa synk.',
      loadError: 'Kunde inte hämta skåpsynk',
      filterQueue: 'Filtrera kö',
      allQueues: 'Alla köer',
      cabinet: 'Skåp',
      keywin: 'KeyWin-moln',
      other: 'Övrigt',
      source: 'Källa',
      sourceAll: 'Alla källor',
      sourceRabbit: 'Rabbit',
      sourceLocker: 'Vår API',
      sourceCabinetHttp: 'Skåp-HTTP',
    },
    summary: {
      totalCabinets: 'Skåp totalt',
      keysIn: 'Nycklar inne',
      keysOut: 'Nycklar ute',
      unusedSlots: 'Outnyttjade tappar',
    },
    cabinet: {
      name: 'Namn',
      location: 'Plats',
      status: 'Status',
      capacity: 'Kapacitet',
      occupiedSlots: 'Upptagna platser',
      availableSlots: 'Lediga platser',
      assignedGroup: 'Utlämningsplats',
      noGroup: 'Ej tilldelad',
      assignGroup: 'Tilldela utlämningsplats',
      changeGroup: 'Ändra utlämningsplats',
      removeGroup: 'Ta bort tilldelning',
      keysInCabinet: 'Nycklar i skåpet',
      showKeys: 'Visa nycklar',
      hideKeys: 'Dölj nycklar',
      lists: 'Lister',
      listsShort: 'lister',
      keysShort: 'nycklar',
      keysIn: 'Nycklar inne',
      keysOut: 'Nycklar ute',
      inShort: 'inne',
      emptyShort: 'tomma',
      unusedSlots: 'Outnyttjade tappar',
      slotsPerList: 'tappar/list',
      empty: 'tomma',
      emptySlot: 'Tom tapp',
      backToOverview: 'Tillbaka till skåpöversikt',
      changeShort: 'Ändra',
      assignShort: 'Tilldela',
      linkedToCustomer: 'Knutet till kund',
      notLinkedToCustomer: 'Ej knutet till kund',
      linkCustomer: 'Knyt till kund',
      unlinkCustomer: 'Ta bort kundkoppling',
      linkCustomerConfirm: 'Knyt skåpet till en kund? SuperAdmin och LocalAdmin skapas som KeyWin-användare med skåpets tappar (ingen webbinloggning).',
      unlinkCustomerConfirm: 'Ta bort kundkopplingen? Utlämningsplats och LocalAdmin tas bort.',
      linkCustomerFirst: 'Knyt till kund först',
      localAdminPin: 'LocalAdmin-PIN',
      syncTags: 'Synka tappar',
      syncTagsHelp: 'Kopplar bara tappar som ligger i detta skåp till SuperAdmin och LocalAdmin. Ingen grupp skapas — KeyWin-knappsatsen går via User + tappar.',
    },
    key: {
      name: 'Namn',
      keyId: 'KeyId',
      cabinet: 'Skåp',
      slot: 'Plats',
      status: 'Status',
      available: 'Tillgänglig',
      vehicle: 'Fordon',
      noVehicle: 'Ej kopplad',
      assignVehicle: 'Koppla fordon',
      removeVehicle: 'Ta bort koppling',
      history: 'Kopplingshistorik',
      externalId: 'Externt ID',
      keyInfo: 'Nyckelinfo',
      linkedVehicle: 'Kopplat fordon',
    },
    status: {
      online: 'Online',
      offline: 'Offline',
      error: 'Fel',
      maintenance: 'Underhåll',
      in_cabinet: 'I skåpet',
      taken: 'Uttagen',
      lost: 'Förlorad',
    },
    assignment: {
      assignedAt: 'Tilldelad',
      assignedBy: 'Tilldelad av',
      unassignedAt: 'Borttagen',
      note: 'Anteckning',
      notePlaceholder: 'Valfri anteckning...',
      noAssignments: 'Inga aktiva kopplingar',
    },
    logs: {
      activityLog: 'Aktivitetslogg',
      keyHistory: 'Ut/in-historik',
      noEvents: 'Inga händelser',
      taken: 'Uttagen',
      returned: 'Återlämnad',
      alarm: 'Larm',
      alarmsExist: 'Okvitterade larm',
      linked: 'Kopplad till',
      unlinked: 'Avkopplad från',
      cabinetEvents: 'Skåphändelser',
      last24h: 'Senaste 24h',
      unacknowledgedAlarms: 'okvitterade larm',
      acknowledgeAll: 'Kvittera alla',
      filterAll: 'Alla',
      filterAlarms: 'Larm',
      filterKeys: 'Nycklar',
      filterSystem: 'System',
      noEventsToShow: 'Inga händelser att visa',
    },
    messages: {
      assignSuccess: 'Koppling skapad',
      unassignSuccess: 'Koppling borttagen',
      assignError: 'Kunde inte skapa koppling',
      unassignError: 'Kunde inte ta bort koppling',
      customerAssignSuccess: 'Skåpet knöts till kunden',
      customerUnassignSuccess: 'Kundkopplingen togs bort',
      customerAssignError: 'Kunde inte knyta skåpet till kunden',
      customerUnassignError: 'Kunde inte ta bort kundkopplingen',
      syncTagsSuccess: '{{count}} tappar kopplade till SuperAdmin och LocalAdmin',
      syncTagsEmpty: 'Inga tappar i skåpet ännu. Öppna med inbyggd SuperAdmin, sätt i tapparna och synka igen.',
      syncTagsError: 'Kunde inte synka tappar',
      missingKeyId: 'Nyckeln saknar KeyId (OnPrem-tapp). Den kan inte kopplas till ett fordon.',
      renameWarning: 'Fordonet kopplades, men namnet i skåpet kunde inte ändras till regnumret.',
      loadError: 'Kunde inte ladda data',
      confirmRemove: 'Är du säker på att du vill ta bort denna koppling?',
      alarmAcknowledged: 'Larm kvitterat',
      allAlarmsAcknowledged: 'Alla larm kvitterade',
      alarmError: 'Kunde inte kvittera larm',
    },
    filters: {
      allCabinets: 'Alla skåp',
      allStatuses: 'Alla statusar',
      searchPlaceholder: 'Sök på nyckelnamn...',
    },
    modal: {
      selectGroup: 'Välj utlämningsplats',
      selectVehicle: 'Välj fordon',
      registrationNumber: 'Registreringsnummer',
      searchVehicle: 'Sök regnr eller modell...',
      searchRegistration: 'Skriv regnummer, t.ex. ABC123',
      typeRegistrationHint: 'Skriv minst två tecken. Endast fordon utan nyckel eller Flinkey-box visas.',
      clickToSelect: 'Klicka på fordonet i listan för att välja det',
      noVehicleMatch: 'Inget ledigt fordon matchade sökningen',
      currentAssignment: 'Nuvarande koppling',
      noGroupSelected: 'Ingen utlämningsplats vald',
      selectCustomer: 'Välj kund',
      noCustomerSelected: 'Ingen kund vald',
      noEligibleCustomers: 'Inga kunder med skåp aktiverat. Aktivera skåp under Organisation → Skåpinställningar.',
      linkCustomerHelp: 'Välj vilken kund skåpet ska knytas till. SuperAdmin och LocalAdmin blir KeyWin-användare med skåpets tappar, utan webbinloggning.',
    },
  },

  // Assignments (Tilldelningar)
  assignments: {
    title: 'Tilldelningar',
    description: 'Hantera tilldelningar av uppgifter till personer',
    myAssignments: 'Mina tilldelningar',
    myAssignmentsHint: 'Uppgifter som är tilldelade dig',
    assigneeFilterMine: 'Tilldelade mig',
    assigneeFilterAll: 'Alla tilldelningar',
    create: 'Skapa tilldelning',
    category: 'Kategori',
    whatToDo: 'Vad ska göras',
    titlePlaceholder: 'Beskriv uppgiften kortfattat...',
    descriptionLabel: 'Beskrivning',
    assignedTo: 'Tilldelad till',
    assignedBy: 'Tilldelad av',
    assignedAt: 'Tilldelad',
    selectUser: 'Välj användare...',
    priorityLabel: 'Prioritet',
    priorityLow: 'Låg',
    priorityNormal: 'Normal',
    priorityHigh: 'Hög',
    priorityUrgent: 'Brådskande',
    vehicle: 'Fordon',
    vehicleIdPlaceholder: 'Fordon-ID (valfritt)',
    dueDate: 'Deadline',
    startWork: 'Påbörja',
    complete: 'Klarmarkera',
    cancel: 'Avbryt',
    completionNotes: 'Anteckning',
    completionNotesPlaceholder: 'Beskriv vad som gjorts...',
    startedAt: 'Påbörjad',
    completedAt: 'Klarmarkerad',
    allStatuses: 'Alla statusar',
    allCategories: 'Alla kategorier',
    noCategories: 'Inga kategorier tillgängliga (kör seed eller kontrollera API)',
    statusPending: 'Väntande',
    statusInProgress: 'Pågående',
    statusCompleted: 'Klar',
    statusCancelled: 'Avbruten',
    noAssignments: 'Inga tilldelningar hittades',
    noOpenAssignments: 'Inga öppna tilldelningar',
    open: 'öppna',
    viewAll: 'Visa alla tilldelningar',
    fillRequired: 'Fyll i alla obligatoriska fält',
    created: 'Tilldelning skapad',
    started: 'Tilldelning påbörjad',
    completed: 'Tilldelning klarmarkerad',
    cancelled: 'Tilldelning avbruten',
    confirmCancel: 'Är du säker på att du vill avbryta denna tilldelning?',
    assigned: 'tilldelade',
    assign: 'Tilldela',
    selectAll: 'Markera alla',
    assignSelected: 'Tilldela markerade',
    vehiclesSelected: 'fordon markerade',
    assignmentsCreated: 'tilldelningar skapade',
  },
  bookingWidget: {
    title: 'Mina bokningar',
    noBookings: 'Inga kommande bokningar',
    upcoming: 'kommande',
    booked: 'Bokad',
    checkedOut: 'Utcheckad',
    awaiting: 'Väntar',
    awaitingHandling: 'Väntar på hantering',
    noVehicleAssigned: 'Ingen bil tilldelad',
    previousVehicle: 'tidigare',
    openCalendar: 'Öppna bokningskalendern',
  },
  resourceTypesAdmin: {
    title: 'Resurstyper (system)',
    description: 'Hantera systemets resurstyper som kan tilldelas organisationer',
    code: 'Kod',
    nameSv: 'Namn (sv)',
    nameEn: 'Namn (en)',
    displayOrder: 'Sorteringsordning',
    addNew: 'Lägg till ny resurstyp',
    codePlaceholder: 't.ex. SCOOTER',
    nameSvPlaceholder: 't.ex. Elsparkcykel',
    nameEnPlaceholder: 't.ex. E-scooter',
    created: 'Resurstyp skapad',
    updated: 'Resurstyp uppdaterad',
    codeRequired: 'Kod och namn krävs',
  },
  equipment: {
    title: 'Fordonsutrustning',
    description: 'Hantera fordonsutrustning som kan tilldelas fordon',
    tagName: 'Namn',
    organization: 'Organisation',
    createUnderOrganization: 'Organisation',
    icon: 'Ikon',
    newTagPlaceholder: 'Ny fordonsutrustning…',
    iconPlaceholder: 'Ikon (valfritt)',
    noTags: 'Ingen fordonsutrustning. Lägg till en post för att börja.',
    vehicleEquipment: 'Fordonsutrustning',
    noEquipment: 'Ingen utrustning tilldelad detta fordon.',
    selectTag: 'Välj utrustning…',
    notesPlaceholder: 'Anteckning (valfritt)',
    removed: 'Utrustning borttagen',
  },
  flinkeyBoxes: {
    title: 'Flinkey Boxar',
    dashboardDescription: 'Hantera Flinkey digitala nyckelboxar och individtilldelningar',
    addBox: 'Lägg till box',
    search: 'Sök produkt-ID, serienummer...',
    productId: 'Produkt-ID',
    serialNumber: 'Serienummer',
    boxType: 'Typ',
    carName: 'Fordon',
    licensePlate: 'Regnummer',
    contractStart: 'Avtalsstart',
    contractState: 'Avtalsstatus',
    notes: 'Anteckningar',
    organization: 'Organisation',
    individuals: 'Individer',
    noBoxes: 'Inga boxar hittades',
    noOrg: 'Ingen organisation',
    editBox: 'Redigera box',
    linkVehicleTitle: 'Koppla fordon',
    searchVehicle: 'Sök fordon...',
    individualsDescription: 'Individer med tillgång till denna box',
    searchUser: 'Sök användare...',
    addUser: 'Lägg till',
    noUsers: 'Inga individer tillagda',
    vehicleLinked: 'Fordonet kopplat',
    vehicleLinkError: 'Fel vid koppling av fordon',
    linkVehicle: 'Koppla fordon',
    unlinkVehicle: 'Koppla loss fordon',
    vehicleUnlinked: 'Fordon bortkopplat',
    linkedVehicle: 'Kopplat fordon',
    confirmDelete: 'Är du säker på att du vill ta bort box {{id}}?',
    userAddError: 'Fel vid tillägg av individ',
    removeUser: 'Ta bort individ',
    confirmRemoveUser: 'Är du säker på att du vill ta bort {{name}}?',
    firmwareVersion: 'Firmware',
    importDeviaq: 'Importera Deviaq (Excel)',
    importDeviaqSuccess: 'Import klar: {{inserted}} nya, {{updated}} uppdaterade',
    importDeviaqError: 'Import misslyckades',
    deviaqDetailsTitle: 'Deviaq-rad',
    deviaqNoDetails: 'Ingen Deviaq-data sparad för denna box.',
    selectedBoxes: 'box(ar) valda',
    assignOrg: 'Tilldela organisation',
    assignOrgTitle: 'Tilldela organisation',
    assignOrgTopNode: 'Organisation (toppnod)',
    searchOrg: 'Sök organisation...',
    noOrgMatches: 'Inga träffar',
    battery: 'Batteri',
    batteryUnknown: 'Okänt',
    batteryCharging: 'Laddar',
    chargerDisconnected: 'Laddare frånkopplad',
    nfcTestMode: 'Testläge (kräv ej nyckel/kort vid återlämning)',
    nfcTestModeHint: 'När testläge är av krävs alltid att nyckeln finns i boxen. Ikryssat: ingen kontroll av nyckel eller kort.',
    nfcCardCheck: 'Kontrollera kort vid återlämning',
    nfcCardCheckHint: 'Valfritt. Aktivera om kunden även ska lägga tillbaka registrerat kort. Kräver att kortet är registrerat på boxen.',
    nfcDetectMode: 'Detektera kort i boxen',
    nfcDetectModeHint: 'Vid återlämning/öppning: om ett okänt NFC-kort hittas kan personal med behörighet registrera det på boxen.',
    permanentPower: 'Permanent laddkabel',
    permanentPowerHint: 'Varna om laddaren rapporteras frånkopplad.',
    nfcTagsTitle: 'Registrerade NFC-taggar (nyckel/tankkort)',
    nfcTagsHint: 'Registrering sker i mobilappen (nära boxen). Här kan taggar visas och tas bort.',
    noNfcTags: 'Inga NFC-taggar registrerade.',
    nfcRequired: 'Krävs',
    nfcLabelKey: 'Nyckel',
    nfcLabelCard: 'Tankkort',
    nfcTagDeleted: 'NFC-tagg borttagen',
    nfcTagDeleteError: 'Kunde inte ta bort NFC-tagg',
  },
  guide: {
    admin: {
      title: 'Guide Administration',
      description: 'Hantera onboarding-guider och turer',
      newTour: 'Ny tur',
      noTours: 'Inga turer skapade',
      inactive: 'Inaktiv',
      steps: 'Steg',
      preview: 'Förhandsgranska',
      deactivate: 'Inaktivera',
      activate: 'Aktivera',
      noSteps: 'Inga steg',
      noTitle: '(Ingen titel)',
      addStep: 'Lägg till steg',
      stepTitle: 'Stegtitel',
      stepTitlePlaceholder: 'T.ex. Välkommen till flottöversikten',
      stepOrder: 'Ordning',
      content: 'Innehåll',
      contentPlaceholder: 'Beskriv vad användaren ska göra i detta steg...',
      targetSelector: 'CSS-selektor (mål)',
      targetSelectorHint: 'T.ex. #fleet-map eller .vehicle-list. Lämna tomt för centrerad dialog.',
      placement: 'Placering',
      tourKey: 'Turnyckel',
      tourName: 'Turnamn',
      tourNamePlaceholder: 'T.ex. Introduktion till flottöversikten',
      tourDescription: 'Beskrivning',
      sortOrder: 'Sorteringsordning',
      confirmDeleteTour: 'Är du säker på att du vill ta bort denna tur?',
      confirmDeleteStep: 'Är du säker på att du vill ta bort detta steg?',
    },
  },
  carinfoOrgSync: {
    title: 'Carinfo Fordonsimport',
    dashboardDescription: 'Importera fordon från Car.info per organisationsnummer',
    orgNumber: 'Org.nr',
    customer: 'Kund',
    lastSync: 'Uppdaterad',
    syncCount: 'Synkar',
    vehicleCount: 'Antal',
    active: 'Aktiva',
    inactive: 'Inaktiva',
    source: 'Källa',
    actions: 'Funktion',
    sync: 'Uppdatera',
    log: 'Logg',
    syncResult: 'Synkresultat',
    resultFor: 'Resultat för',
    added: 'Tillagda',
    updated: 'Uppdaterade',
    unchanged: 'Oförändrade',
    inactivated: 'Inaktiverade',
    failed: 'Misslyckade',
    total: 'Totalt',
    vehicles: 'fordon',
    filialNumbersTitle: 'Upptäckta filialnummer',
    addFilialsAndSync: 'Lägg till valda och hämta fordon',
    syncLog: 'Synkhistorik',
    noLogEntries: 'Ingen synkhistorik finns',
    noOrgNumbers: 'Inga organisationsnummer konfigurerade. Lägg till org.nr via CRM-kundernas flik "Org.nr Fordon".',
    date: 'Datum',
  },

  themeSettings: {
    title: 'Tema & branding',
    description: 'Anpassa färger för ljust och mörkt läge. Förhandsvisningen uppdateras direkt — inget sparas förrän du klickar Spara.',
    tabGlobal: 'Global standard',
    tabPartner: 'Partner-tema',
    selectPartner: 'Välj partner',
    editMode: 'Redigera läge',
    editModeHint: 'Växla mellan ljust och mörkt — båda sparas vid Spara',
    lightTitle: 'Ljust läge',
    darkTitle: 'Mörkt läge',
    primary: 'Primärfärg',
    secondary: 'Sekundärfärg',
    sectionPrimary: 'Primärfärger',
    sectionBackground: 'Bakgrunder',
    sectionText: 'Textfärger',
    bgPage: 'Sidbakgrund',
    bgContainer: 'Container / sidopanel',
    bgElevated: 'Kort / yta',
    textDefault: 'Text huvud',
    textPrimary: 'Text accent',
    textSecondary: 'Text dämpad',
    textTertiary: 'Text svag (tertiär)',
    textDisabled: 'Text inaktiv',
    textDanger: 'Text fara/röd',
    textLight: 'Ljus text (på knappar)',
    previewTitle: 'Förhandsvisning',
    previewLight: 'Ljust',
    previewDark: 'Mörkt',
    previewNavActive: 'Aktiv meny',
    previewNavItem: 'Meny',
    previewHeader: 'Sidhuvud',
    previewCardTitle: 'Kortrubrik',
    previewBody: 'Brödtext som användare läser i gränssnittet.',
    previewLink: 'Accentlänk',
    previewMuted: 'Dämpad hjälptext',
    previewPrimaryBtn: 'Primär',
    previewSecondaryBtn: 'Sekundär',
    previewFormTitle: 'Formulär',
    previewTabsTitle: 'Flikar',
    previewTabOne: 'Översikt',
    previewTabTwo: 'Detaljer',
    previewTabThree: 'Historik',
    previewTabContent: 'Innehåll i aktiv flik — så här ser brödtext ut under fliknavigering.',
    previewBadgesTitle: 'Badges',
    previewBadgePrimary: 'Primär',
    previewBadgeNeutral: 'Neutral',
    previewBadgeOutline: 'Outline',
    previewBadgeSecondary: 'Sekundär',
    previewModalTitle: 'Modal',
    previewModalHeading: 'Bekräfta åtgärd',
    previewModalBody: 'Är du säker på att du vill fortsätta? Detta är en förhandsvisning av dialogrutan.',
    previewModalCancel: 'Avbryt',
    previewModalConfirm: 'Bekräfta',
    previewComboboxLabel: 'Kombobox',
    previewComboboxValue: 'Välj alternativ…',
    previewInputLabel: 'Textfält',
    previewInputPlaceholder: 'Ange värde…',
    previewGridTitle: 'Datagrid',
    previewColName: 'Namn',
    previewColStatus: 'Status',
    previewColDate: 'Datum',
    previewRowA: 'Fordon ABC123',
    previewRowB: 'Fordon XYZ789',
    previewRowC: 'Fordon DEF456',
    previewStatusActive: 'Aktiv',
    previewStatusPending: 'Väntande',
    previewStatusDone: 'Klar',
    contrastWarning: 'Varning: låg kontrast mellan text och bakgrund kan göra innehållet svårläst.',
    reset: 'Återställ',
    saveSuccess: 'Tema sparat',
    saveSuccessActivated: 'Tema sparat och aktiverat på hela webbappen',
    activate: 'Aktivera tema',
    reapply: 'Applicera om',
    saveError: 'Kunde inte spara tema',
    loadError: 'Kunde inte ladda tema',
    unsavedConfirm: 'Du har osparade ändringar. Vill du fortsätta utan att spara?',
    disabledBannerTitle: 'Dynamiskt tema är inte aktivt ännu',
    disabledBannerBody: 'Du kan redigera och förhandsgranska här. Klicka Aktivera för att aktivera det globala temat för alla användare (partners med eget aktiverat tema påverkas inte).',
    disabledBannerBodyPartner: 'Du kan redigera och förhandsgranska här. Klicka Aktivera för att aktivera temat enbart för den här partnerns användare — övriga och det globala temat påverkas inte.',
  },

  fotaMigration: {
    title: 'FOTA Konfigurering',
    description: 'Ladda upp en .cfg-fil och skicka den till enheter via Teltonika FOTA Web. Enheter hämtar konfigurationen nästa gång de checkar in mot FOTA Web — oavsett vilken server de pekar mot.',
    wakeupInfo: 'Obs: Utan SMS "web_connect" hämtar enheten konfigurationen vid nästa schemalagda FOTA-incheckning (typiskt inom 1–24 h). Klicka Uppdatera status för att se när det är klart.',
    // Flikar
    tabSend: 'Skicka konfiguration',
    tabStatus: 'Status',
    // Uppladdning
    uploadFile: 'Ladda upp config-fil (.cfg)',
    dropCfgHere: 'Dra och släpp .cfg-fil här, eller klicka för att välja',
    onlyCfgAllowed: 'Endast .cfg-filer är tillåtna',
    uploading: 'Laddar upp...',
    uploadSuccess: 'Filen "{name}" laddades upp till FOTA Web',
    uploadError: 'Kunde inte ladda upp filen',
    errorLoadingFiles: 'Kunde inte hämta config-filer från FOTA Web',
    // Filval
    selectConfigFile: 'Välj config-fil att skicka',
    configFilePlaceholder: 'Välj en config-fil...',
    deliveryType: 'Vad vill du skicka?',
    selectFirmwareFile: 'Välj firmware-fil att skicka',
    firmwareFilePlaceholder: 'Välj en firmware-fil...',
    firmwareWarning: 'Firmware-uppdatering ändrar enhetens programvara. Skicka endast firmware du verifierat är rätt för enhetsmodellen.',
    noFilesFound: 'Inga filer hittades i FOTA Web',
    selectFilFirst: 'Välj en config-fil först',
    // Filtyp-filter
    filterAll: 'Alla',
    kindConfig: 'Config',
    kindFirmware: 'Firmware',
    kindLog: 'Logg',
    kindOther: 'Övrigt',
    // Organisation
    selectOrganization: 'Välj organisation',
    organizationPlaceholder: 'Sök och välj organisation...',
    selectOrgFirst: 'Välj organisation först',
    // Förhandsgranskning
    previewBtn: 'Förhandsgranska enheter',
    previewing: 'Hämtar enheter...',
    vehiclesFound: 'fordon hittades med IMEI',
    vehiclesSelected: 'fordon valda',
    sendToAll: 'Alla',
    sendToSelected: 'Valda',
    selectAll: 'Markera alla',
    noVehiclesSelected: 'Inga fordon valda',
    noVehicles: 'Inga fordon med IMEI hittades i vald organisation',
    errorLoading: 'Kunde inte hämta enheter',
    // Sändning
    sendBtn: 'Skicka via FOTA',
    sending: 'Skickar...',
    errorSending: 'Kunde inte skicka konfiguration',
    successMessage: '{succeeded} av {total} tasks köades i FOTA Web',
    // Bekräftelse
    confirmTitle: 'Bekräfta FOTA-sändning',
    confirmMessage: 'Du är på väg att skicka "{file}" till {count} enheter via FOTA Web.',
    confirmWakeupNote: 'Enheten hämtar konfigurationen vid nästa FOTA-incheckning. Används SMS "web_connect" triggas det omedelbart.',
    // Resultat
    resultTitle: 'Resultat',
    succeeded: 'Köade',
    failed: 'Misslyckades',
    total: 'Totalt',
    // Taskstatus
    taskQueued: 'Köad',
    taskDownloading: 'Hämtas',
    taskApplied: 'Installerad',
    taskFailed: 'Fel',
    taskStatusTitle: 'FOTA-taskstatus per enhet',
    refreshStatus: 'Uppdatera status',
    lastUpdated: 'Senast uppdaterad',
    selectOrgForStatus: 'Välj en organisation på fliken "Skicka konfiguration" för att se status',
    clickRefreshToLoad: 'Klicka "Uppdatera status" för att hämta tasks',
    noTasksFound: 'Inga tasks hittades för vald organisation',
    errorLoadingStatus: 'Kunde inte hämta taskstatus',
    // Tabellkolumner
    registrationNumber: 'Reg.nr',
    vehicleName: 'Fordonsnamn',
    imei: 'IMEI',
    status: 'Status',
    taskId: 'Task-ID',
    errorMsg: 'Felmeddelande',
    configFile: 'Config-fil',
    columnSuccess: 'Köad',
    columnFailed: 'Fel',
    // Filhantering
    tabFiles: 'Filer',
    fileListTitle: 'Uppladdade config-filer i FOTA Web',
    deleteFile: 'Ta bort fil',
    confirmDelete: 'Säker?',
    fileDeleted: 'Filen "{name}" togs bort',
    fileDeleteError: 'Kunde inte ta bort filen',
    downloadFile: 'Ladda ner fil',
    fileDownloadError: 'Kunde inte ladda ner filen',
    // Legacy
    noImei: 'IMEI saknas',
    apiKeyMissing: 'FOTA Web API-nyckel saknas på servern',
    offlineInfo: 'Enheter som är offline (ej anslutna till DQFleet) kan inte nås utan SMS',
    responseLabel: 'Enhetssvar',
  },
  damageReports: {
    title: 'Skaderapporter',
    subtitle: 'Inkomna skaderapporter från mobilappen',
    filterStatus: 'Status',
    filterSeverity: 'Allvarlighetsgrad',
    filterFromDate: 'Från datum',
    filterToDate: 'Till datum',
    clearFilter: 'Rensa filter',
    noReports: 'Inga skaderapporter hittades',
    loading: 'Laddar...',
    vehicle: 'Fordon',
    reporter: 'Rapportör',
    severity: 'Allvarlighetsgrad',
    status: 'Status',
    date: 'Datum',
    images: 'Bilder',
    description: 'Beskrivning',
    adminNotes: 'Anteckningar (intern)',
    adminNotesPlaceholder: 'Lägg till interna anteckningar...',
    save: 'Spara ändringar',
    saving: 'Sparar...',
    saved: 'Rapport uppdaterad',
    saveError: 'Kunde inte spara',
    loadDetailError: 'Kunde inte ladda rapport',
    location: 'Plats',
    resolvedAt: 'Löst',
    handling: 'Hantering',
    statusPending: 'Väntande',
    statusInProgress: 'Pågående',
    statusResolved: 'Löst',
    statusClosed: 'Stängt',
    severityLow: 'Låg',
    severityMedium: 'Medel',
    severityHigh: 'Hög',
    severityCritical: 'Kritisk',
    statTotal: 'Totalt',
    statPending: 'Väntande',
    statInProgress: 'Pågående',
    statResolved: 'Lösta',
    statCritical: 'Kritiska',
    allStatuses: 'Alla statusar',
    allSeverities: 'Alla',
    totalCount: '{{total}} rapporter totalt',
    prev: 'Föregående',
    next: 'Nästa',
    fetchError: 'Kunde inte hämta skaderapporter',
    damageImage: 'Skadebild',
    reportTitle: 'Rapport #{{id}}',
    releaseBlock: 'Frigör blockering',
    releaseBlockUntil: 'Fordonet är blockerat till {{end}}',
    releaseBlockConfirm: 'Släppa blockeringen så att fordonet kan bokas igen?',
    releaseBlockSuccess: 'Blockeringen släpptes',
    releaseBlockError: 'Kunde inte släppa blockeringen',
  },

  tireAnalysis: {
    title: 'Däckanalys',
    update: 'Uppdatera',
    analysisDate: 'Analys genomförd {{date}} · Nästa säsong: {{season}}',
    loading: 'Analyserar däckdata...',
    loadError: 'Kunde inte ladda däckanalys',
    vehiclesWithData: 'Fordon med däckdata',
    ofTotal: 'av {{total}} totalt',
    criticalNow: 'Kritiska nu',
    belowMin: 'Under rekommenderat minimum',
    needsReplacement: 'Behöver bytas',
    nextSeasonLabel: 'Nästa: {{label}}',
    tiresToBuy: 'Däck att köpa in',
    totalPurchaseNeed: 'Totalt inköpsbehov',
    critical: 'Kritisk',
    warning: 'Varning',
    noCritical: 'Inga däck under rekommenderat minimum',
    noForecast: 'Inga däck förväntas behöva bytas nästa säsong',
    noProcurement: 'Inget inköpsbehov identifierat',
    stored: '📦 Lagrade',
    installed: '🔩 Monterade',
    currentTread: 'Nuvarande mönsterdjup',
    predictedTread: 'Beräknat vid säsongsslut',
    season: 'Säsong',
    wearRate: 'Slitage',
    threshold: 'Gräns',
    type: 'Typ',
    size: 'Storlek',
    count: 'Antal',
    level: 'Nivå',
    urgent: 'Akut',
    planned: 'Planerat',
    affectedVehicles: 'Berörda fordon:',
    orderList: '📋 Beställningslista (klicka för att expandera)',
    copyToOrder: 'Kopiera till inköpsorder:',
    totalTires: 'TOTALT: {{count}} däck',
    procurementSummary: 'Totalt {{count}} däck behöver köpas in ({{groups}} unika storlekar)',
    tabCritical: 'Kritiska nu',
    tabForecast: 'Prognos nästa säsong',
    tabProcurement: 'Inköpsplanering',
    criticalTitle: 'Kritiska däck – åtgärd behövs nu',
    criticalDesc: 'Monterade däck som är under rekommenderat minimum för sin typ. Vinterdäck ≥ 4 mm, snödäck ≥ 3 mm, sommardäck ≥ 3 mm. Lagstadgat minimum för alla: 1,6 mm.',
    forecastTitle: 'Prognos – nästa säsong: {{season}}',
    forecastDesc: 'Däck vars beräknade mönsterdjup vid säsongsslut riskerar att understiga rekommenderat minimum. Beräknas baserat på historiskt slitage per fordon.',
    procurementTitle: 'Inköpsplanering – grupperat per storlek',
    procurementDesc: 'Summering av alla däck som behöver köpas in – både akuta (kritiska nu) och planerade (prognos). Klicka på en rad för att se vilka fordon som berörs.',
    methodology: 'ℹ️ Hur beräknas prognoserna?',
    methodWear: 'Slitagegrad: Beräknas från historiska däckbyten i bytesloggen. Om historik saknas används ett standardvärde på 1 mm per 18 000 km.',
    methodSeason: 'Säsonglängd: Genomsnitt av körda km per säsong från bytesloggen. Fallback: 15 000 km per säsong.',
    methodForecast: 'Prognos: Nuvarande mönsterdjup minus (slitagegrad × uppskattad säsonglängd).',
    methodThresholds: 'Gränsvärden: Vinterdäck 4 mm (rekommenderat), dubbdäck 4 mm, snödäck 3 mm, sommardäck 3 mm. Lagstadgat minimum: 1,6 mm.',
    treadMin: 'Mönsterdjup (min)',
    thresholdLabel: 'Gräns: {{mm}} mm',
    seasonKm: '🛣️ Säsong: ~{{km}} km',
    wearRateLabel: '📉 Slitage: {{rate}}',
    thresholdMm: '🎯 Gräns: {{mm}} mm',
    wearRatePer10k: '{{rate}} mm/10 000 km',
  },

  bookingResources: {
    title: 'Bokningsresurser',
    description: 'Skapa egna resurstyper (t.ex. cykel, släp) och registrera bokningsbara resurser med unikt asset-ID.',
    organization: 'Organisation (kund)',
    tabTypes: 'Resurstyper',
    tabResources: 'Resurser',
    addType: 'Lägg till resurstyp',
    editType: 'Redigera resurstyp',
    addResource: 'Lägg till resurs',
    editResource: 'Redigera resurs',
    noTypes: 'Inga resurstyper ännu. Skapa minst en typ innan du registrerar resurser.',
    noResources: 'Inga resurser registrerade. Skapa resurstyper först och lägg sedan till resurser.',
    createTypeFirst: 'Skapa minst en aktiv resurstyp innan du lägger till resurser.',
    colCode: 'Kod',
    colName: 'Namn',
    colResourceCount: 'Antal resurser',
    colIdentity: 'Identitet (asset-ID)',
    colType: 'Resurstyp',
    colPool: 'Utlämningsplats',
    nameEn: 'Namn (engelska, valfritt)',
    confirmDeactivateType: 'Inaktivera denna resurstyp? Går inte om resurser eller bokningar är kopplade.',
    confirmDeactivateResource: 'Inaktivera denna resurs? Går inte om den har aktiv bokning eller ligger i en pool.',
  },

  travelPlanner: {
    title: 'Reseplanerare',
    modeCar: 'Bil',
    modeBicycle: 'Cykel',
    modeFoot: 'Gång',
    modeTransit: 'Kollektivtrafik',
    from: 'Från',
    to: 'Till',
    fromPlaceholder: 'Sök startadress...',
    toPlaceholder: 'Sök destination...',
    clickOnMap: 'Klicka på kartan',
    swap: 'Byt riktning',
    timeNow: 'Avgång nu',
    timeDeparture: 'Avgång kl.',
    timeArrival: 'Ankomst kl.',
    showAlternatives: 'Visa alternativa rutter',
    search: 'Sök resa',
    sendEmail: 'Skicka vägbeskrivning via e-post',
    emailPlaceholder: 'Din e-postadress',
    send: 'Skicka',
    routeAlternatives: 'Rutter',
    route: 'Rutt',
    transitAlternatives: 'Avgångar',
    transfers: 'byten',
    tripDetails: 'Resedetaljer',
    selectBothPoints: 'Välj både startpunkt och destination',
    noRouteFound: 'Ingen rutt hittades',
    noTripsFound: 'Inga avgångar hittades',
    transitNotConfigured: 'Kollektivtrafik är inte konfigurerad (ResRobot API-nyckel saknas på servern)',
    searchError: 'Sökning misslyckades',
    emailSent: 'Vägbeskrivning skickad!',
    emailError: 'Kunde inte skicka e-post',
  },

  pipeline: {
    newCase: 'Nytt case',
    caseType: 'Casetyp',
    caseTitle: 'Titel',
    typeInquiry: 'Kontakt / prospekt',
    typeProcurement: 'Upphandling',
    filterAll: 'Alla',
    estimatedValue: 'Uppskattat värde',
    calculatedValue: 'Beräknat värde',
    contractMonths: 'Avtalstid (månader)',
    referenceNumber: 'Referensnummer',
    submissionDeadline: 'Anbudsddeadline',
    procurementUrl: 'Upphandlingslänk',
    noCustomer: 'Ingen kund kopplad',
    tabOverview: 'Översikt',
    tabDocuments: 'Dokument',
    tabRequirements: 'Kravanalys',
    tabValue: 'Affärsvärde',
    contact: 'Kontakt',
    analysisStatus: 'Analysstatus',
    uploadDocument: 'Ladda upp dokument',
    uploadSuccess: 'Dokument uppladdat',
    uploadSuccessCount: '{{count}} dokument uppladdade',
    uploadPartial: '{{ok}} uppladdade, {{failed}} misslyckades',
    uploadFailed: 'Uppladdning misslyckades',
    uploadMultipleHint: 'Du kan välja flera filer samtidigt',
    noDocuments: 'Inga dokument ännu',
    runAnalysis: 'Kör AI-analys',
    runAnalysisAll: 'Analysera kravspecifikation',
    runAnalysisAllHint: 'Analyserar huvudfilen Kravspecifikation. Markera fler dokument och använd Analysera valda för övriga bilagor.',
    runAnalysisSelected: 'Analysera valda dokument',
    analyzeDocument: 'Analysera',
    analyzing: 'Analyserar...',
    analyzeStarting: 'Startar analys...',
    analyzeStartedBackground: 'Analys startad i bakgrunden. Du kan lämna sidan – vi uppdaterar status automatiskt när du är tillbaka.',
    analyzeAlreadyRunning: 'En analys pågår redan för detta case.',
    analyzeAlreadyRunningInfo: 'Analysen pågår redan i bakgrunden. Vänta tills den är klar, eller klicka Starta om analys.',
    analyzeStuckHint: 'Analysen verkar ha fastnat (t.ex. efter omstart). Du kan starta om den.',
    forceRestartAnalysis: 'Starta om analys',
    analysisRunningHint: 'AI-analys pågår i bakgrunden. Du kan navigera bort — resultatet visas här när analysen är klar.',
    analysisStatusNone: 'Ej analyserad',
    analyzeSlow: 'AI-analys pågår – kan ta några minuter vid stora upphandlingsdokument.',
    analyzeTimeout: 'Analysen tog för lång tid. Försök igen eller analysera färre bilagor åt gången.',
    analyzeSuccess: 'Analys klar',
    analyzeFailed: 'Analys misslyckades',
    requirementType: 'Typ',
    requirement: 'Krav',
    requirementText: 'Fullständig kravtext',
    matchStatus: 'Matchning',
    fulfilled: 'uppfyllda',
    skaCount: '{{count}} SKA-krav',
    borCount: '{{count}} BÖR-krav',
    systemHandles: 'Vad systemet hanterar',
    whatIsMissing: 'Vad som saknas',
    noCatalogMatch: 'Ingen kapabilitet matchad',
    noCoverageNotes: 'Ingen bedömning tillgänglig – kör om analysen för att få AI-förklaring',
    matchedCapability: 'Matchad kapabilitet',
    noGapNotes: 'Ingen bedömning tillgänglig',
    nothingMissing: 'Inget saknas – kravet är uppfyllt',
    confidence: 'Säkerhet',
    noRequirements: 'Inga krav analyserade ännu',
    createDevTask: 'Skapa utvecklingsuppgift',
    devTaskCreated: 'Utvecklingsuppgift skapad',
    handlingStatus: 'Handläggning',
    handlingNotSet: 'Ej satt',
    manualHandling: 'Manuell handläggning',
    assessment: 'Bedömning',
    reuseInOtherCases: 'Använd svaret i andra upphandlingar',
    reuseInOtherCasesHint: 'Sparar bedömningen så att liknande krav (t.ex. hämta fordonsuppgifter) automatiskt sätts till samma status.',
    comment: 'Kommentar',
    commentPlaceholder: 'Skriv en kommentar, t.ex. att fordonsuppgifter hämtas via Car.info...',
    handlingSaved: 'Handläggning sparad',
    handlingSavedReuse: 'Bedömningen sparad och återanvänds i andra upphandlingar',
    handling: {
      hanterat: 'Hanterat',
      utveckling: 'Utveckling',
      juridik: 'Juridik',
    },
    product: 'Produkt',
    selectProduct: 'Välj produkt',
    quantity: 'Antal',
    unitPrice: 'À-pris',
    lineTotal: 'Radsumma',
    addLine: 'Lägg till rad',
    monthlyTotal: 'Månadsvärde',
    caseNotFound: 'Case hittades inte',
    status: {
      fulfilled: 'Uppfyllt',
      partial: 'Delvis',
      missing: 'Saknas',
      unknown: 'Okänt',
      review: 'Granskning',
    },
    analysisStatusValues: {
      none: 'Ej analyserad',
      pending: 'Väntar',
      analyzing: 'Analyserar',
      completed: 'Analys klar',
      failed: 'Analys misslyckades',
    },
  },
  moten: {
    title: 'Möte',
    intro: 'Intern utskrift och sammanfattning. Supporten går före i kön.',
    titlePlaceholder: 'Mötestitel',
    upload: 'Ladda upp ljud eller Teams-fil',
    uploading: 'Laddar upp…',
    fileRequired: 'Välj en fil först.',
    uploadError: 'Kunde inte ladda upp filen.',
    loadError: 'Kunde inte hämta möten.',
    empty: 'Inga möten ännu.',
    delete: 'Ta bort',
    deleteConfirm: 'Ta bort mötet och filen?',
    deleteError: 'Kunde inte ta bort mötet.',
    summary: 'Sammanfattning',
    decisions: 'Beslutspunkter',
    ideas: 'Nya idéer',
    followUps: 'Att hantera',
    transcript: 'Utskrift',
    waiting: 'Väntar på utskrift.',
    statusQueued: 'I kö',
    statusUploading: 'Laddar upp',
    statusProcessing: 'Bearbetas',
    statusReady: 'Klar',
    statusFailed: 'Misslyckades',
    colTitle: 'Titel',
    colDate: 'Datum',
    colTime: 'Tid',
    colRecordedBy: 'Inspelad av',
    colStatus: 'Status',
    meetingTitle: 'Titel',
    backToList: 'Tillbaka till listan',
    formatBold: 'Fet',
    formatHeading: 'Rubrik',
    formatList: 'Lista',
    reformat: 'Formatera om',
    reformatError: 'Kunde inte formatera om texten.',
    save: 'Spara',
    saveError: 'Kunde inte spara anteckningen.',
    download: 'Spara fil',
    send: 'Skicka',
    sendHint: 'Skicka till en eller flera personer',
    sendError: 'Kunde inte skicka e-post.',
    recipientPlaceholder: 'namn@foretag.se',
    addRecipient: 'Lägg till',
    recipientsRequired: 'Ange minst en e-postadress.',
  },

  econKodverk: {
    title: 'Kodverk',
    description: 'Region Skånes Raindance-kodverk.',
    snapshot: 'Utdrag {date}',
    searchPlaceholder: 'Sök kod eller text',
    company: 'Bolag',
    department: 'Förvaltning',
    code: 'Kod',
    text: 'Text',
    passive: 'Passiv',
    validTo: 'Giltig till',
    empty: 'Inga rader matchar sökningen.',
    loadError: 'Kunde inte hämta kodverket',
    prev: 'Föregående',
    next: 'Nästa',
    page: 'Sida {page} av {pages} ({total} rader)',
    kind: {
      ansvar: 'Ansvar',
      konto: 'Konto',
      motpart: 'Motpart',
    },
  },

  eyeInventory: {
    title: 'EYE-lager',
    description: 'Ta in packlistan från Teltonika, uppdatera enheterna och fördela dem till en kund. En enhet som redan är tilldelad behåller sin kund.',
    import: 'Importera packlista',
    assign: 'Tilldela kund',
    assignTitle: 'Välj kund',
    assignHint: '{count} enheter läggs på kundens toppnod och syns i temperaturövervakningen.',
    search: 'Sök MAC, serienummer, namn eller kund',
    searchCustomer: 'Sök kund',
    all: 'Alla',
    stock: 'I lager',
    assignedFilter: 'Tilldelade',
    inStock: 'I lager',
    name: 'Namn',
    serial: 'Serienummer',
    box: 'Låda',
    firmware: 'Firmware',
    customer: 'Kund',
    tracker: 'Tracker',
    unassign: 'Ta tillbaka',
    selectAll: 'Markera alla på sidan',
    empty: 'Inga enheter matchar filtret. Importera en packlista för att fylla lagret.',
    loadError: 'Kunde inte hämta EYE-lagret',
    importError: 'Kunde inte importera filen',
    importDone: '{created} nya, {updated} uppdaterade',
    assigned: '{count} enheter tilldelade',
    unassigned: '{count} enheter tillbaka i lager',
    assignError: 'Kunde inte ändra tilldelningen',
    prev: 'Föregående',
    next: 'Nästa',
    page: 'Sida {page} av {pages} ({total} rader)',
    rowIssue: 'Rad {row}: {message}',
    errors: {
      INVALID_FILE: 'Filen är inte en Teltonika-packlista',
      NO_ROWS: 'Filen innehåller inga enheter',
      FILE_REQUIRED: 'Välj en xlsx-fil',
      INVALID_INPUT: 'Välj enheter och en kund',
      ORG_NOT_FOUND: 'Kunden hittades inte',
      INVALID_MAC: 'Ogiltig MAC-adress',
      MISSING_MAC: 'MAC-adress saknas',
      SERIAL_CONFLICT: 'Serienumret finns redan på en annan enhet',
      ROW_FAILED: 'Raden kunde inte sparas',
      NOT_FOUND: 'Enheten finns inte i lagret',
      ALREADY_LINKED: 'Enheten sitter på en tracker och kan inte flyttas',
      AMBIGUOUS_MAC: 'MAC-adressen finns på flera sensorer',
      PRODUCT_UNKNOWN: 'Produkttypen saknas i katalogen',
    },
  },
};

